import antdData from 'antd/lib/locale/en_US'
// import localeData from 'react-intl/locale-data/en'

const messages = {
  'text.choose': 'Choose {title}',
  'text.select': 'Select {title}',
  'text.please_choose': 'Please select {title}',
  'button.add_with_title': 'Add {title}',
  'report.name_with_title': 'Name {title}',
  'report.product_name_with_title': '{title} Name',
  'report.product_category_with_title': '{title} Category',
  'report.total_quantity_product_with_title': 'Total Quantity {title}',
  'report.finished_product_with_title': 'Finished {title}',
  'report.search_by_product_with_title': 'Search by {title}',
  'report.product_value_with_title': '{title} Value',
  'report.product_profitability_stock_tracking_product_with_title': 'Stock Tracking {title}',
  'report.product_profitability_non_stock_tracking_product_with_title':
    'Non Stock Tracking {title}',
  'report.product_profitability_bundle_product_with_title': 'Bundle {title}',
  'sales.product_sales_with_title': '{title} Sales',
  'sales.sales_contact_with_title': 'Sales Per {title}',
  'financeInvoices.product_type_with_title': '{title} Type',
  'financeInvoices.select_product_with_title': 'Select {title}',
  'financeInvoices.please_select_tag_with_title': 'Please select {title}',
  'financeWareHouses.total_products_with_title': 'Total {title}',
  'financeWareHouses.total_product_value_with_title': 'Total {title} Value',
  'financeWareHouses.ref_number_help_with_title':
    'Fill in the {title} for internal records and make searching easier.',
  'financeInvoices.used_to_create_transaction_categories_with_title':
    'Used to create transaction categories. You can also generate reports based on this {title}.',
  'financeWareHouses.please_select_a_product_with_title': 'Please select a {title}.',
  'financeWareHouses.header_column_hpp_help_with_title':
    'This is the cost of the {title}, or the purchase price.',
  'financeInvoices.product_code_that_not_exist_will_be_inserted_as_a_new_product_with_title':
    '{product} code that not exist will be inserted as a new {product}.',
  'financeProduct.available_stock_product_with_title': 'Available Stock {product}',
  'financeProduct.almost_empty_stock_product_with_title': 'Almost Empty Stock {product}',
  'financeProduct.empty_stock_product_with_title': 'Empty Stock {product}',
  'financeProduct.total_product_value_with_title': '{product} Value Total',
  'financeProduct.total_product_type_with_title': '{product} Type Total',
  'financeProduct.product_type_per_category_with_title': '{product} Type per Category',
  'financeProduct.product_availability_with_title': '{product} Availability',
  'financeProduct.product_image_with_title': '{product} Image',
  'financeProduct.show_product_image_with_title': 'Show {product} Image',
  'financeProduct.hide_product_image_with_title': 'Hide {product} Image',
  'financePurchaseOrders.please_select_a_product_with_title': 'Please select a {product}.',
  'financeProduct.package_product_items_with_title': 'The {product} package consists of :',
  'financeProduct.raw_material': 'Raw material:',
  'financeProduct.manufacture_product_items_with_title': 'The {product} manufacture consists of :',
  'financeProduct.qty_multiplier': 'Multiplier',
  'financeProduct.output_qty_default': 'Quantity',
  'priceRule.applies_to_the_following_customers_with_title': 'Applies to the Following {customer}',
  'priceRule.applies_to_the_following_products_with_title': 'Applies to the Following {product}',
  'priceRule.all_customer_with_title': 'All {customer}',
  'priceRule.customer_group_with_title': '{customer} Group',
  'priceRule.per_customer_with_title': 'Per {customer}',
  'priceRule.customer_groups_that_will_get_discount_with_title':
    '{customer} groups that will get {priceType}',
  'priceRule.customers_that_will_get_discount_with_title': '{customer} that will get {priceType}',
  'priceRule.all_product_with_title': 'All {product}',
  'priceRule.product_category_with_title': '{product} Category',
  'priceRule.per_product_with_title': 'Per {product}',
  'priceRule.discounted_product_category_with_title': '{priceType} {product} category',
  'priceRule.discounted_product_with_title': '{priceType} {product}',
  'posConnect.default_customer_with_title': 'Default {customer}',
  'posConnect.please_select_default_customer_with_title': 'Please select Default {customer}',
  'posConnect.transaction_from_pos_inputed_as_this_customer_with_title':
    'Transaction from POS will be inputed as transaction from this {customer}',
  'posConnect.service_charge_product_with_title': 'Service Charge {product}',
  'posConnect.please_select_service_charge_product_with_title':
    'Please select Service Charge {product}',
  'posConnect.if_service_charge_inputes_as_this_product_with_title':
    'If there is a service charge, will be inputed as a purchase on this {product}',
  'posConnect.custom_product_with_title': 'Custom {product}',
  'posConnect.please_select_custom_product_with_title': 'Please select Custom {product}',
  'posConnect.if_custom_product_inputes_as_this_product_with_title':
    'If there is a purchase on custom {product}, it will be inputed as this {product}',
  'emails.insert_tagsment_with_title': 'Insert {tag}',
  'layoutInvoice.show_product_with_title': 'Show {product}',
  'layoutInvoice.show_item_by_category': 'Show Item by Category',
  'layoutInvoice.show_ref_code_product_with_title': 'Show {product} SKU',
  'layoutInvoice.show_product_image_with_title': 'Show {product} Image',
  'layoutInvoice.show_tags_with_title': 'Show {tags}',
  'layoutInvoice.show_reference_with_title': 'Show {reference}',
  'businessFlow.hide_products_that_are_out_of_stock_with_title':
    'Hide {products} that are out of stock',
  'businessFlow.hide_products_that_are_out_of_stock_description_with_title':
    'Are out-of-stock {products} hidden when adding to a sales?',
  'businessFlow.product_price_dont_change_with_title': "{product} price can't changed",
  'businessFlow.wether_product_price_can_be_changed_when_add_invoice_with_title':
    'Wether {product} price can be changed when add invoice',
  'businessFlow.when_product_below_min_stock_email_notification_with_title':
    'When {product} stock below minimal stock, email notification will be sent',
  'businessFlow.use_fifo_method_desc_with_title':
    'Turn on to activate FIFO method to calculate COGS, or turn it off to use averaging method. You cannot change this setting after you have {product} with inventory tracking active. This settings only available on Elite Plan.',
  'businessFlow.auto_update_product_buy_price_with_title': 'Auto update {product} buy price',
  'businessFlow.auto_update_product_buy_price_desc_with_title':
    'When buying a {product}, the buy price is automatically updated to the product as the default buy price',
  'businessFlow.auto_update_product_sell_price_with_title': 'Auto update {product} selling price',
  'businessFlow.auto_update_product_sell_price_desc_with_title':
    'When selling a {product}, the selling price is automatically updated to the product as the default selling price',
  'businessFlow.decline_product_conv_if_stock_not_enough_with_title':
    'Decline {product} conversion if stok is not enough',
  'businessFlow.wether_decline_add_product_conv_if_stock_not_enough_with_title':
    'Wether decline add {product} conversion if stock not enough',
  'businessFlow.show_reference_with_title': 'Show {reference}',
  'businessFlow.show_reference_desc_with_title':
    'Wether show {reference} input when creating invoice',
  'bussinesFlow.desc_default_tracking_stock_with_title':
    'By default the track stock feature is active when creating a new {product}',
  'businessFlow.show_tag_with_title': 'Show {tag}',
  'businessFlow.show_tag_desc_with_title': 'Wether show {tag} input when creating invoice',
  'businessFlow.input_tag_is_required_with_title': 'Input {tag} is required',
  'businessFlow.product_reject_lower_sell_purchase_price':
    'Reject new products if the purchase price is higher than the selling price',
  'businessFlow.product_reject_lower_sell_purchase_price_desc':
    'Should new products be rejected if the product purchase price is higher than the product selling price?',
  'businessFlow.input_tag_is_required_desc_with_title':
    'Is the {tag} required when adding a sales transaction?',
  'businessFlow.manual_journal_input_tag_is_required_desc_with_title':
    'Is the {tag} required when adding a manual journal transaction?',
  'businessFlow.purchase_input_tag_is_required_desc_with_title':
    'Is the {tag} required when adding a purchase transaction?',
  'businessFlow.expense_input_tag_is_required_desc_with_title':
    'Is the {tag} required when adding a expense transaction?',
  'businessFlow.bank_input_tag_is_required_desc_with_title':
    'Is the {tag} required when adding a bank transaction?',
  'businessFlow.product_conversion_input_tag_is_required_desc_with_title':
    'Is the {tag} required when adding a product conversion transaction?',
  'businessFlow.stock_adjustment_input_tag_is_required_desc_with_title':
    'Is the {tag} required when adding a stock adjustment transaction?',
  'businessFlow.reference_multiline_with_title': 'Multiline {reference}',
  'businessFlow.reference_multiline_desc_with_title': 'Can {reference} be multiline?',
  'financeProduct.bundle_type_id_with_title': '{product} Type',
  'salesPerson.show_sales_person_with_title': 'Show {sales_person}',
  'salesPerson.hide_sales_person_with_title': 'Hide {sales_person}',
  'salesPerson.select_sales_person_with_title': 'Select {sales_person}',
  'salesPerson.faq_answer_give_different_commission_with_title':
    'You can set the amount of commission for each {sales_person} through the {here}. In addition, the commission can also be set differently for each product.',
  'businessFlow.wether_save_sales_person_to_sales_with_title':
    'Wether to save the {sales_person} to the sales?',
  'salesCommission.you_can_manage_sales_person_in_this_page_with_title':
    'You can manage sales commission for each {sales_person} in this page. If done, {link} to see the sales commission report.',
  'salesCommission.applies_to_the_following_sales_person_with_title':
    'Applies to the Following {sales_person}',
  'financeManualJournal.tag_is_required_with_title': '{tag} is required',
  'financeTag.who_can_access_this_tag_with_title': 'Who can access this {tag}?',
  'financeProduct.who_can_access_this_product_with_title': 'Who can access this {product}?',
  'financeInvoices.with_credit_payment_with_title': 'With {credit} Memo',
  'financeInvoices.with_debit_payment_with_title': 'With {debit} Memo',
  'financePurchaseInvoices.pay_with_credit_memo_with_title': 'Pay with {credit} memo',
  'financePurchaseInvoices.please_select_with_credit_memo_with_title':
    'Please select with {credit} memo',
  'financePurchaseInvoices.pay_with_debit_memo_with_title': 'Pay with {debit} memo',
  'financePurchaseInvoices.please_select_with_debit_memo_with_title':
    'Please select with {debit} memo',
  'financeContacts.your_net_debt_with_title': 'Your net debt',
  'financeContacts.you_owe_with_title': 'You {credit}',
  'financeContacts.they_owe_with_title': 'They {credit}',
  'financeContacts.your_due_debt_with_title': 'Your due {credit}',
  'financeContacts.their_due_debt_with_title': 'Their due {credit}',
  'financeContacts.debt_you_need_to_pay_with_title': '{credit} you need to pay',
  'financeContacts.max_payable_with_title': 'Max {credit}',
  'financeContacts.total_payable_is_calculated_from_purchase_invoices_with_title':
    'Total {credit} is calculated from purchase invoices, transaction costs and accounts {credit}. If the total {credit} exceeds the maximum, then when creating a new purchase invoice it will be rejected.',
  'financeContacts.max_receivable_with_title': 'Max {debit}',
  'financeContacts.total_accounts_receivable_is_calculated_from_sales_invoices_with_title':
    'Total accounts {debit} is calculated from sales invoices and accounts {debit} contacts. If the total {debit} exceeds the maximum, then when creating a new sales invoice it will be rejected.',
  'financeContacts.payable_account_with_title': '{credit} Account',
  'financeContacts.receivable_account_with_title': '{debit} Account',
  'financeContacts.awaiting_payment_with_title': '{debit} waiting for payment',
  'creditMemo.add_credit_memo_with_title': 'Add {credit} Memo',
  'creditMemo.detail_credit_memo_with_title': 'Detail {credit} Memo',
  'creditMemo.detail_title_with_title': '{credit} Memo {number}',
  'creditMemo.edit_credit_memo_with_title': 'Edit {credit} Memo',
  'debitMemo.add_debit_memo_with_title': 'Add {debit} Memo',
  'debitMemo.detail_debit_memo_with_title': 'Detail {debit} Memo',
  'debitMemo.detail_title_with_title': '{debit} Memo {number}',
  'debitMemo.edit_debit_memo_with_title': 'Edit {debit} Memo',
  'financeContacts.import_contact_transactions_with_title': 'Import {debit} {credit}',
  'financeContacts.follow_these_steps_to_import_your_contact_transactions_with_title':
    'Follow these steps to import your {credit} {debit}',
  'financeContacts.1_download_your_contact_transactions_template_file_with_title':
    '1. Download your {credit} {debit} template file',
  'financeContacts.start_by_downloading_our_contact_transactions_csv_with_title':
    'Start by downloading our accounts payable Excel template file. This file has the correct column headings Kledo needs to import details of your {credit} {debit}.',
  'financeContacts.2_copy_your_contact_transactions_into_the_template_with_title':
    '2. Copy your {credit} {debit} into the template',
  'financeContacts.import_contact_transactions_using_excel_or_another_spreadsheet_editor_with_title':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your {credit} {debit}. Make sure the {credit} {debit} details match the column headings provided in the template.',
  'financeInvoices.payment_with_credit_memo_with_title': 'Payment using {credit} Memo',
  'financeInvoices.payment_with_debit_memo_with_title': 'Payment using {debit} Memo',
  'financeInvoices.recurring_send_email_to_customer_with_title': 'Send email to {customer}',
  'text.and': 'and',
  'topBar.changeLanguage': 'Change Language',
  'topBar.latestKledoUpdate': 'Latest Kledo Update',
  'topBar.dataChangesTimeline': 'Data Changes Timeline',
  'topBar.issuesHistory': 'Issues History',
  'topBar.projectManagement': 'Project Management',
  'topBar.typeToSearch': 'Type to search...',
  'topBar.buyNow': 'Buy Now $24',
  'topBar.bitcoin': 'Bitcoin',
  'topBar.profileMenu.hello': 'Hello',
  'topBar.profileMenu.billingPlan': 'Billing Plan',
  'topBar.profileMenu.role': 'Role',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Phone',
  'topBar.profileMenu.logout': 'Logout',
  'topBar.billing.plan': 'Plan',
  'topBar.billing.forever': 'Forever',
  'topBar.billing.active_until': 'Active until',
  'notification.updates': 'Updates',
  'notification.timeline': 'Timeline',
  'notification.server_error': 'Server Error',
  'notification.something_went_wrong': 'Something went wrong, please contact our customer support.',
  'notification.install_kledo': 'Install Kledo App',
  'notification.kledo_is_now_on_google_play': 'Kledo is now available on Google Play',
  'notification.kledo_is_now_on_app_store': 'Kledo is now available on App Store',
  'notification.install_now': 'Install Now',
  'notification.later': 'Later',
  'notification.disable': 'Disable Notification',
  'notification.enable': 'Enable Notification',
  'notification.push_prompt_enable': 'Enable',
  'notification.low_stock': 'Low stock notification',
  'notification.marketplace_sync_done': 'Marketplace sync done notification',
  'notification.bank_sync_done': 'Bank sync done notification',
  'notification.monthly_financial_report_email': 'Monthly financial report email',
  'notification.show_nps_mute': 'Mute recommendation survey',
  'notification.update_title': 'A new version of Kledo is ready',
  'notification.update_description':
    'Reload to get the latest features and fixes. It only takes a few seconds.',
  'notification.update_description_form':
    'Save what you are working on first. The new version will be installed automatically when you move to another page.',
  'notification.update_data_safe': 'Your data is safe, this page will not reload by itself',
  'notification.update_reload': 'Reload',
  'notification.update_confirm_title': 'Reload now?',
  'notification.update_confirm_content': 'Unsaved data on this page will be lost.',
  'notification.update_confirm_ok': 'Reload anyway',
  'notification.update_installing': 'Installing the latest version…',
  'notification.update_installing_description':
    'The page will reload automatically in a few seconds.',
  'notification.update_installing_failed':
    'The latest version could not be loaded yet. Please click Try Again.',
  'notification.update_installing_offline':
    'You are offline. Connect to the internet, then click Try Again.',
  'notification.cache_guide_title': 'Clear your browser cache',
  'notification.cache_guide_intro':
    'The latest version still fails to load. Clear your browser cache with these steps.',
  'notification.cache_guide_step_open_in_browser':
    'Click the ⋮ menu at the top right of the app, then choose “Open in Chrome”. Do the next steps in the tab that opens.',
  'notification.cache_guide_step_shortcut_windows': 'Press Ctrl + Shift + Delete.',
  'notification.cache_guide_step_shortcut_mac': 'Press ⌘ Cmd + Shift + Delete.',
  'notification.cache_guide_step_range': 'In “Time range”, choose “All time”.',
  'notification.cache_guide_step_cache_only':
    'Tick only “Cached images and files”. Untick the others so you stay logged in.',
  'notification.cache_guide_step_delete': 'Click “Delete data”.',
  'notification.cache_guide_step_safari_develop':
    'Open the Safari menu → Settings → Advanced, then tick “Show features for web developers”.',
  'notification.cache_guide_step_safari_empty': 'Press Option + ⌘ Cmd + E to empty the cache.',
  'notification.cache_guide_step_mobile_settings': 'Open the browser settings on your phone.',
  'notification.cache_guide_step_mobile_cache':
    'Clear the cache or temporary files. Do not clear cookies, so you stay logged in.',
  'notification.cache_guide_footer': 'Then click Reload. If it still fails, contact Kledo support.',
  'notification.cache_guide_reload': 'Reload',
  'date.now': 'Now',
  'date.today': 'Today',
  'date.yesterday': 'Yesterday',
  'date.last_week': 'Last Week',
  'date.this_month': 'This Month',
  'date.last_month': 'Last Month',
  'date.last_7_days': 'Last 7 Days',
  'date.last_30_days': 'Last 30 Days',
  'date.last_365_days': 'Last 365 Days',
  'date.this_year': 'This Year',
  'date.last_year': 'Last Year',
  'date.tomorrow': 'Tomorrow',
  'date.next_week': 'Next Week',
  'date.next_month': 'Next Month',
  'date.next_year': 'Next Year',
  'date.daily': 'Daily',
  'date.monthly': 'Monthly',
  'date.yearly': 'Yearly',
  'date.day': 'Day',
  'date.days': 'Days',
  'date.hour': 'Hour',
  'date.hours': 'Hours',
  'date.minute': 'Minute',
  'date.minutes': 'Minutes',
  'date.week': 'Week',
  'date.weeks': 'Weeks',
  'date.month': 'Month',
  'date.months': 'Months',
  'date.year': 'Year',
  'date.years': 'Years',
  'date.same_date_last_month': 'Same date last month',
  'date.same_date_last_year': 'Same date last year',
  'date.last_year_value': '{value} Years Ago',
  'date.last_n_months': 'Last {count} months',
  'date.last_n_years': 'Last {count} years',
  'button.page': 'Page',
  'button.next': 'Next',
  'button.continue': 'Continue',
  'button.prev': 'Prev',
  'button.revert': 'Revert',
  'button.renew': 'Renew',
  'button.upgrade': 'Upgrade',
  'button.delete': 'Delete',
  'button.archive': 'Archive',
  'button.unarchive': 'Unarchive',
  'button.add': 'Add',
  'button.edit': 'Edit',
  'button.back': 'Back',
  'button.search': 'Search',
  'button.save': 'Save',
  'button.save_add_new': 'Save & Add New',
  'button.cancel': 'Cancel',
  'button.print': 'Print',
  'button.retry': 'Retry',
  'loadError.title': 'Data failed to load',
  'loadError.description':
    'Check your internet connection, then try again. If it still fails, contact our customer support.',
  'button.filter': 'Filter',
  'button.clear_filter': 'Clear Filter',
  'button.year': 'Year',
  'button.month': 'Month',
  'button.close': 'Close',
  'button.open_settings': 'Open Settings',
  'button.return': 'Return',
  'button.hello_can_i_help': 'Hello, can I help you?',
  'button.schedule_now': 'Schedule Now',
  'button.error_data_': 'Error data!',
  'button.create_something': 'Create {title}',
  'input.placeholder.search': 'Search',
  'input.placeholder.searchWarehouse': 'Search name or warehouse code',
  'popconfirm.title.delete': 'Are you sure to delete?',
  'popconfirm.title.archive': 'Are you sure to archive?',
  'popconfirm.title.unarchive': 'Are you sure to unarchive?',
  'popconfirm.title.reset': 'Are you sure to reset?',
  'popconfirm.title.void': 'Are you sure to void this transaction?',
  'popconfirm.title.unvoid': 'Are you sure to unvoid this transaction?',
  'popconfirm.title.logout': 'Are you sure you want to logout?',
  'suggestion.not_found': 'Data not found',
  'spinner.loading': 'Loading...',
  'app.loading.title': 'Setting up your workspace',
  'app.loading.description': 'Please wait a moment while we load your company data.',
  'app.loading.page': 'Loading page...',
  'pos.loading': 'Loading...',
  'pos.saving_order': 'Saving order...',
  'pos.saving_invoice': 'Saving invoice...',
  'pos.checking_shift': 'Checking active shift...',
  'pos.process_invoice': 'Process Invoice',
  'pos.payment_connect': 'Payment Connect',
  'pos.save_invoice': 'Save Invoice',
  'pos.order_fully_paid_hint':
    'This order is fully paid. Add products if the customer orders more.',
  'pos.total_below_down_payment': 'Total cannot be less than the amount already paid ({amount})',
  'button.yes': 'Yes',
  'button.no': 'No',
  'button.pdf': 'PDF',
  'button.print_pdf': 'Print PDF',
  'button.print_label': 'Print Label',
  'button.print_payment': 'Print Payment Recap',
  'button.print_tax': 'Print Tax Invoice',
  'button.print_partial': 'Print Partial',
  'button.copy_link': 'Copy Link',
  'button.copy': 'Copy',
  'button.send_email': 'Send Email',
  'button.send_sms': 'Send SMS',
  'button.send_wa': 'Send Whatsapp',
  'button.send_thank_you_email': 'Send Thank You Email',
  'button.send_email_payment': 'Email Payment Recap',
  'button.send_wa_payment': 'Whatsapp Payment Recap',
  'button.send_sms_payment': 'SMS Payment Recap',
  'button.download': 'Download',
  'button.download_word': 'Download MsWord',
  'button.download_xls': 'Download XLS',
  'button.download_csv': 'Download CSV',
  'button.download_now': 'Download Now',
  'button.upload': 'Upload',
  'button.send': 'Send',
  'button.share': 'Share',
  'button.duplicate': 'Duplicate',
  'button.guide': 'Guide',
  'button.tour': 'Tour',
  'button.video': 'Video',
  'button.article': 'Article',
  'button.import': 'Import',
  'button.export': 'Export',
  'button.view_journal_entries': 'View Journal Entries',
  'button.add_more': 'Add more',
  'button.change_layout': 'Change Layout',
  'button.reset': 'Reset',
  'button.copy_to_clipboard': 'Copy Link to Clipboard',
  'button.select_all': 'Select All',
  'button.deselect_all': 'Remove All',
  'button.change_order': 'Change Order',
  'button.sell': 'Sell',
  'button.buy': 'Buy',
  'message.cannot_update_data': 'Cannot update data.',
  'message.cannot_return_data': 'Data is not returnable.',
  'message.link_has_been_copied': 'Link has been copied.',
  'message.on': 'on',
  'link.show_more': 'Show more',
  'link.show_less': 'Show less',
  'link.payment': '{payment} Payment',
  'link.more': 'more',
  'link.add_email': 'Add email',
  'link.add_shipping_address': 'Add shipping address',
  'companies.company_list': 'Company List',
  'companies.add_company': 'Add Company',
  'companies.created_on': 'Created on ',
  'companies.as': 'As',
  'companies.are_you_sure_to_delete_this_company':
    'Are You sure to delete this company?\nAfter deleted, the data cannot be returned',
  'companies.choose_package': 'Choose a Package',
  'companies.full_name': 'Full Name',
  'companies.please_input_full_name': 'Please input full name',
  'companies.company_name': 'Company Name',
  'companies.please_input_company_name': 'Please input Company Name',
  'companies.role_on_company': 'Role on Company as',
  'companies.please_input_role_on_company': 'Please input role on company',
  'companies.number_of_employee': 'Number of Employee',
  'companies.please_input_number_of_employee': 'Please input number of company',
  'companies.please_input_email': 'Please input email',
  'companies.please_input_phone_number': 'Please input phone number',
  'companies.phone_number_must_08': 'Phone number must begin with 08',
  'companies.next_per_month': 'Next {price}/month',
  'companies.free_forever': 'Free Forever',
  'table.number': 'No',
  'table.show_data': 'Show Data',
  'table.rows_selected': '{count} rows selected',
  'table.min_one_column': 'Minimum show one column',
  'table.data_empty': 'Nothing here yet',
  'table.data_x_empty': 'No {name} yet',
  'table.lets_create_your_first_x': 'Get started by adding a new {name}.',
  'table.no_results_found': 'No results found',
  'table.no_results_hint': 'Try adjusting your keywords or resetting the filters.',
  'table.reset_filter': 'Reset filter',
  'nps.how_likely_you_recommend': 'How likely is that you would recommend Kledo to a friend?',
  'nps.not_likely': 'Not at all likely',
  'nps.very_likely': 'Very likely',
  'nps.please_mention_another':
    'Please mention something else you would like to say through comment box below',
  'nps.cannot_hide_nps': 'Cannot hide NPS',
  'nps.cannot_send_nps': 'Cannot send NPS',
  'nps.thank_you_your_input':
    'Thank you, your input is very meaningful. We analyze every input that comes in.',
  'nps.happy_to_hear':
    'We are happy to hear that! Would you like to leave a review on our Google Business Profile?',
  'nps.review_on_google': 'Review on Google',
  'sms.cannot_send_wa': 'Cannot send Whatsapp.',
  'sms.cannot_send_sms': 'Cannot send SMS.',
  'sms.destination_number': 'Destination Number',
  'sms.sms_has_been_sent_to': 'SMS has been sent to',
  'sms.sms_content': 'SMS Content',
  'sms.wa_content': 'Whatsapp Content',
  'sms.please_input_content': 'Please input SMS content.',
  'sms.please_input_wa_content': 'Please input Whatsapp content.',
  'sms.please_input_phone': 'Please input phone number.',
  'email.to': 'To',
  'email.from': 'From',
  'email.subject': 'Subject',
  'email.message': 'Message',
  'email.please_input_subject': 'Please input subject.',
  'email.please_input_message': 'Please input message.',
  'email.cannot_send_email': 'Cannot send email.',
  'email.email_has_been_sent_to': 'Email has been sent to',
  'email.please_confirm_email': 'Please confirm your email {email} before you can send an email.',
  'email.send_confirmation_email': 'Send Confirmation Email',
  'email.resend_confirmation_email': 'Resend Confirmation Email',
  'email.we_have_sent_confirmation_email':
    'We have sent a confirmation email to {email}. Please check the inbox and confirm your email to proceed.',
  'email.email_confirmation': 'Email Confirmation',
  'email.email_has_been_verified': 'Email {email} has been verified.',
  'email.cannot_verify_email': 'Cannot verify email.',
  'email.email_verification_failed': 'Email {email} verification failed.',
  'email.email_template': 'Email Template',
  'emails.edit_email_template': 'Edit Email Template',
  'emails.are_you_sure_revert_to_default': 'Are you sure to revert template to default?',
  'emails.revert_to_default': 'Revert to Default',
  'emails.please_input_the_email_template_name': 'Please input the email template name.',
  'emails.email_template_name': 'Email Template name',
  'emails.please_input_the_email_template_subject': 'Please input the email template subject',
  'emails.please_input_unique_email_address': 'Email {email} has been registered.',
  'emails.subject': 'Subject',
  'emails.email_successfully_updated': 'Email successfully updated.',
  'emails.error_cannot_update_email_template': 'Cannot update email template.',
  'emails.email_successfully_reverted_to_default': 'Email successfully reverted to default.',
  'emails.error_cannot_revert_email_template': 'Cannot revert email template.',
  'emails.reply_email_address_successfully_updated': 'Reply email address successfully updated.',
  'emails.error_cannot_update_reply_email_address': 'Cannot update reply email address.',
  'emails.email_templates': 'Email Templates',
  'emails.reply_email_address': "Sender's Email Address",
  'emails.body': 'Body',
  'emails.rdw_tags_wrapper': 'rdw-tags-wrapper',
  'emails.insert_tagsment': 'Insert Tags',
  'emails.template_name': 'Template Name',
  'emails.when_an_agent_or_guest_replies_to_an_email,_this_is_the_email_their_reply_will_be_sent_to':
    "When you send an email, the following email will be used as sender's email:",
  'emails.please_input_the_display_name': 'Please input the display name.',
  'emails.max_20_characters': 'Max 20 characters.',
  'emails.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'emails.display_name': 'Display name',
  'emails.email_address': 'Email Address',
  'emails.please_input_the_email_address': 'Please input the email address.',
  'emails.max_100_characters': 'Max 100 characters.',
  'emails.invalid_email_address_format': 'Invalid email address format.',
  'email.you_can_resend_an_email_after': 'You can resend confirmation email after {countDown}.',
  'emails.invoice_attachment_file': 'Invoice File',
  'emails.order_attachment_file': 'Order File',
  'emails.delivery_attachment_file': 'Delivery File',
  'emails.order_attachment_unavailable': 'No related order',
  'emails.delivery_attachment_unavailable': 'No related delivery',
  'wa.wa_template': 'Whatsapp Template',
  'wa.edit_wa_template': 'Edit Whatsapp Template',
  'wa.change_template': 'Change Template',
  'wa.error_cannot_update_template': 'Cannot change Whatsapp template',
  'wa.error_cannot_revert_template': 'Cannot revert Whatsapp template',
  'multiCurrency.multi_currency': 'Multi Currency',
  'multiCurrency.base_currency_cannot_changed_after_enabled':
    'Base currency cannot be changed after enabling multi currency',
  'multiCurrency.activate_multi_currency': 'Activate multi currency',
  'multiCurrency.set_rate_source': 'Set rate source',
  'multiCurrency.change_daily_rate': 'Change daily rate',
  'multiCurrency.add_currency': 'Add currency',
  'multiCurrency.in': 'In',
  'multiCurrency.rate': 'Rate',
  'multiCurrency.source': 'Source',
  'multiCurrency.base_currency': 'Base currency',
  'multiCurrency.currency': 'Currency',
  'multiCurrency.select_currency': 'Select currency',
  'multiCurrency.rate_source': 'Rate source',
  'multiCurrency.select_rate_source': 'Select rate source',
  'multiCurrency.edit_rate_for_date': 'Edit rate for date',
  'multiCurrency.input_date': 'Input date',
  'multiCurrency.rate_value': 'Rate value',
  'multiCurrency.rate_value_must_more_0': 'Rate value must more than 0',
  'multiCurrency.select_rate_value': 'Input rate value',
  'multiCurrency.rate_reference': 'Rate reference',
  'multiCurrency.please_select_base_currency_to_enable_multi':
    'Please select base currency to enable multi currency',
  'multiCurrency.please_select_currency_first': 'Please select currency first',
  'multiCurrency.change_rate_value': 'Change rate value',
  'multiCurrency.transaction_currency': 'Transaction currency',
  'multiCurrency.reset_rate': 'Reset rate',
  'multiCurrency.rate_not_found': 'Rate not found',
  'referral.referral': 'Referral',
  'referral.read_more': 'Read more',
  'referral.referral_history': 'Referral History',
  'referral.your_referral_code': 'Your Referral Code',
  'referral.company': 'Company',
  'referral.code': 'Code',
  'referral.copy_code': 'Copy Code',
  'referral.add_code': 'Tambah Code',
  'referral.register': 'Register',
  'referral.paid': 'Paid',
  'referral.transfered': 'Transfered',
  'referral.approved': 'Approved',
  'referral.lead': 'Lead',
  'referral.cannot_get_referral': 'Cannot get referral',
  'referral.cannot_add_referral': 'Cannot add referral',
  'referral.cannot_delete_referral': 'Cannot delete referral',
  'referral.invite_your_friends': 'Invite Your Friends to Use Kledo',
  'referral.get_millions_per_month':
    'Get millions of rupiah per month by sharing your referral code.',
  'referral.share_your_referral_code': 'Share your referral code',
  'referral.share_via_sosmed_or_anything':
    'Share via sosmed, email, whatsapp, or anything to your friends',
  'referral.discount_for_your_friends': '{discount}% Discount for your friends',
  'referral.your_friends_will_get_discount':
    'Your friends will get {discount}% discount if register for 1 year',
  'referral.reward_per_referral': 'Reward Rp {rewardAmount}k per referral',
  'referral.get_reward_per_referral': 'Get reward of Rp {rewardAmount}k per referral',
  'referral.referral_program': 'Kledo Referral Program',
  'referral.share_code_to_get_reward': 'Share this code or link to start earning rewards.',
  'referral.track_referral_progress': 'Track the progress and rewards of each referral.',
  'referral.waiting_to_be_processed': 'Waiting to be processed',
  'referral.has_paid': 'Has paid',
  'referral.reward_approved': 'Reward approved',
  'referral.already_disbursed': 'Already disbursed',
  'customColumn.you_can_add_custom_column_on_invoice':
    'You can add custom column on invoice transaction data',
  'customColumn.name': 'Name',
  'customColumn.please_input_name': 'Please input Name',
  'customColumn.name_allowed_chars':
    'Only letters, numbers, spaces, dot (.), and slash (/) are allowed',
  'customColumn.data_type': 'Data Type',
  'customColumn.please_input_data_type': 'Please input data type',
  'customColumn.transaction_field': 'Transaction Field',
  'customColumn.item_field': 'Item Field',
  'customColumn.contact_field': 'Contact Field',
  'customColumn.active': 'Active',
  'customColumn.option': 'Option',
  'customColumn.default_selected': 'Default Selected',
  'customColumn.please_input_option': 'Please input option',
  'customColumn.min_1_option': 'Minimal 1 option',
  'customColumn.add_more': 'Add more',
  'customColumn.what_difference_of_transaction_and_item_field':
    'What is the difference of transaction field and item field? Click here.',
  'customColumn.please_select_custom_column': 'Please select custom field',
  'customColumn.show_custom_column': 'Show Custom Field',
  'customColumn.hide_custom_column': 'Hide Custom Field',
  'customColumn.with_custom_fields_you_can_add_data_to_the_bill':
    "With custom fields, you can add data to the bill, or also add a column to the billing item according to your company's needs.",
  'marketplaceConnect.status': 'Status',
  'marketplaceConnect.status_error_message':
    'The {shopName} marketplace connection has been lost. Product and transaction data cannot be synchronized with Kledo while the connection is lost. Please reconnect that marketplace.',
  'marketplaceConnect.lazada_reconnect_title': 'Reconnect your Lazada shop',
  'marketplaceConnect.lazada_reconnect_description':
    "To manage Lazada products from Kledo, this shop needs to be authorised again. You'll sign in to Lazada once more. Your order history and connection settings stay as they are, and order sync keeps running.",
  'marketplaceConnect.lazada_reconnect_banner':
    'You have {count} Lazada shop(s) that need to be reconnected to enable product management. {reconnect}',
  'marketplaceConnect.lazada_reconnect_button': 'Reconnect',
  'marketplaceConnect.lazada_reconnect_confirm': 'Reconnect',
  'marketplaceConnect.lazada_reconnect_cancel': 'Cancel',
  'marketplaceConnect.lazada_callback_connecting': 'Connecting your Lazada shop...',
  'marketplaceConnect.lazada_callback_invalid':
    'The authorization code from Lazada was not found. Please repeat the shop connection process from Lazada.',
  'marketplaceConnect.marketplace': 'Marketplace',
  'marketplaceConnect.store': 'Shop',
  'marketplaceConnect.store_url': 'Store Url',
  'marketplaceConnect.integration_with_tokopedia': 'Integration with Tokopedia',
  'marketplaceConnect.integration_with_tokopedia_help_text':
    "With this integration, transactions from Tokopedia that have joined TikTok can still be entered into Kledo using Tokopedia's marketplace connect preferences.",
  'marketplaceConnect.please_select_tokopedia_marketplace_connect':
    'Please Select Tokopedia Marketplace Connect',
  'marketplaceConnect.data_integration_schedule': 'Data Integration Schedule',
  'marketplaceConnect.created_at': 'Created At',
  'marketplaceConnect.last_data_integrated': 'Last Data Sync',
  'marketplaceConnect.action': 'Action',
  'marketplaceConnect.choose_marketplace_to_connect_to_kledo':
    'Choose a marketplace to connect to Kledo',
  'marketplaceConnect.marketplace_not_supported_yet': 'This marketplace is not supported yet',
  'marketplaceConnect.setting': 'Setting',
  'marketplaceConnect.store_name': 'Store Name',
  'marketplaceConnect.delete_connection': 'Delete Connection',
  'marketplaceConnect.sync_now': 'Sync Now',
  'marketplaceConnect.sync_interval': 'Data Sync Interval',
  'marketplaceConnect.please_select_sync_interval': 'Please Select Data Sync Interval',
  'marketplaceConnect.pos_product_linking_strategy': 'Product Linking Strategy',
  'marketplaceConnect.please_select_pos_product_linking_strategy':
    'Please Select Product Linking Strategy',
  'marketplaceConnect.pos_product_linking_strategy_tooltip':
    'Controls how far automatic sync may go when linking marketplace products to Kledo products. Products that are never linked will not take part in stock sync.',
  'marketplaceConnect.pos_product_linking_strategy_create_missing':
    'Link and create new products when missing',
  'marketplaceConnect.pos_product_linking_strategy_existing_only': 'Link only to existing products',
  'marketplaceConnect.pos_product_linking_strategy_none': 'Do not link automatically',
  'marketplaceConnect.pos_product_linking_strategy_none_hint':
    'Marketplace products will not be linked to Kledo products. You can still link them manually or use the Generate Product action on the marketplace products list.',
  'marketplaceConnect.pos_product_linking_strategy_existing_only_hint':
    'Marketplace products will only be linked to existing Kledo products. Unmatched products will stay unlinked — use the Generate Product action to create new Kledo products from them.',
  'marketplaceConnect.payment_bank_account': 'Payment Bank Account',
  'marketplaceConnect.please_select_payment_bank_account': 'Please Select Payment Bank Account',
  'marketplaceConnect.shipping_cost_account': 'Shipping Cost Account',
  'marketplaceConnect.shipping_cost_account_tooltip':
    'Every transaction that the customer is paid shipping cost to marketplace, expense transaction will be created automatically.',
  'marketplaceConnect.start_pulling_data': 'Start pulling data',
  'marketplaceConnect.start_pulling_data_tooltip':
    'When is the start date for pulling data from the marketplace to Kledo? Withdraw data a maximum of 1 week from the current date.',
  'marketplaceConnect.start_pulling_data_minimum_date_message':
    'The minimum data withdrawal start date is now.',
  'marketplaceConnect.start_pulling_data_maximum_date_message':
    'The maximum data withdrawal start date is now.',
  'marketplaceConnect.please_select_shipping_cost_account': 'Please Select Shipping Cost Account',
  'marketplaceConnect.admin_cost_account': 'Admin Cost Account',
  'marketplaceConnect.admin_cost_account_tooltip':
    'Every transaction that has admin cost by marketplace, expense transaction will be created automatically.',
  'marketplaceConnect.please_select_admin_cost_account': 'Please Select Admin Cost AccountAdmin',
  'marketplaceConnect.pph22_account': 'PPh 22 Account (Prepaid Tax)',
  'marketplaceConnect.please_select_pph22_account': 'Please Select PPh 22 Account',
  'marketplaceConnect.pph22_account_tooltip':
    'Account to record PPh 22 withholding (0.5%) deducted by marketplace from sales revenue. Leave empty to use the default account.',
  'marketplaceConnect.warehouse': 'Warehouse',
  'marketplaceConnect.please_select_warehouse': 'Please Select Warehouse',
  'marketplaceConnect.tag': 'Tag',
  'marketplaceConnect.default_contact_with_title': 'Default {customer} Contact',
  'marketplaceConnect.default_contact_help':
    'If filled, all synced transactions will use this contact and will not create a new contact based on buyer data.',
  'marketplaceConnect.record_shipping_cost': 'Record Shipping Cost',
  'marketplaceConnect.is_shipping_cost_will_be_recorded_on_kledo':
    'Is shipping cost will be recorded on Kledo?',
  'marketplaceConnect.every_hour': 'Every {hour} hour',
  'marketplaceConnect.please_input_shop_name': 'Please input shop url',
  'marketplaceConnect.yeah_successful': 'Hurray successful!',
  'marketplaceConnect.next_activation_step_will_be_contacted':
    'For the next activation step, You will be contacted by out customer success team on work day and hour, by whatapp and email. Please wait.',
  'marketplaceConnect.if_product_not_track_empty_warehouse':
    'If your product is without stock tracking, please empty this warehouse field',
  'marketplaceConnect.using_marketplace_connect_shop_transaction_automatic_on_kledo':
    'By using marketplace connect, your shop transaction in marketplace will be automatically added to Kledo data, great right? Lets connect your marketplace with Kledo.',
  'marketplaceConnect.tutorial_video': 'Tutorial Video',
  'marketplaceConnect.record_transaction': 'Record Transaction',
  'marketplaceConnect.please_select_record_transaction': 'Please select Record Transaction',
  'marketplaceConnect.on_transaction_done': 'On transaction done',
  'marketplaceConnect.start_on_item_sent': 'Start on item sent',
  'marketplaceConnect.record_transaction_help':
    "If recorded on item sent, then on item's status on sent in kledo order transaction and the delivery will be recorded. And when transaction done, sales invoice transaction and the payment will be created. If recorded on transaction done, then transaction will be inputed only when transaction status in marketplace is done.",
  'posConnect.choose_pos_to_connect_to_kledo': 'Choose a POS to connect to Kledo',
  'posConnect.please_input_client_id': 'Please input Client ID',
  'posConnect.please_input_client_secret': 'Please input Client Secret',
  'posConnect.olsera_credential_hint':
    'Click {link} to get your App ID and Secret Key from Olsera.',
  'posConnect.click_here_to_get_client_id_secret': 'Click {link} to get Client ID and Secret',
  'posConnect.payment_transaction_input_this_coa_account':
    'Payment transaction will be inputed in this COA account',
  'posConnect.default_customer': 'Default Customer',
  'posConnect.please_select_default_customer': 'Please select Default Customer',
  'posConnect.transaction_from_pos_inputed_as_this_customer':
    'Transaction from POS will be inputed as transaction from this customer',
  'posConnect.service_charge_product': 'Service Charge Product',
  'posConnect.please_select_service_charge_product': 'Please select Service Charge Product',
  'posConnect.if_service_charge_inputes_as_this_product':
    'If there is a service charge, will be inputed as a purchase on this product',
  'posConnect.custom_product': 'Custom Product',
  'posConnect.please_select_custom_product': 'Please select Custom Product',
  'posConnect.if_custom_product_inputes_as_this_product':
    'If there is a purchase on custom product, it will be inputed as this product',
  'posConnect.your_pos_has_been_connected':
    'Your POS has been connected to Kledo. Data from POS will automatically sync to Kledo periodically',
  'consolidation.you_must_have_more_than_one_companies':
    'To enable consolidation feature, you must have more than one companies with adimistrator access.',
  'consolidation.if_you_have_more_companies_you_may_activate':
    'If you have more than one companies, you may activate consolidation feature. This feature will automatically compile report from each companies into a consolidation report.',
  'consolidation.you_must_have_admin_each_companies':
    'You must have Administrator access in each companies that will be compiled.',
  'consolidation.please_select_companies_that_will_be_compiled':
    'Please select companies that will be compiled to consolidation report',
  'consolidation.please_select_coa_accounts':
    'Please select COA accounts to be compiled in to consolidation reports',
  'consolidation.please_select_all_companies_that_will_be_compiled':
    'Please select all companies that will be compiled to consolidation report',
  'consolidation.must_enable_2_companies': 'You must enable at least 2 companies',
  'consolidation.cannot_select_company': 'Cannot select company',
  'consolidation.add_company': 'Add Company',
  'consolidation.automatic_compilation': 'Automatic Compilation',
  'consolidation.compile': 'Compile',
  'consolidation.cannot_compile': 'Cannot Compile',
  'consolidation.code': 'Code',
  'consolidation.name': 'Name',
  'consolidation.category': 'Category',
  'consolidation.account': 'Account',
  'consolidation.account_total': 'Account Total',
  'consolidation.activate_consolidation_feature': 'Activate consolidation feature',
  'consolidation.cannot_activate_consolidation': 'Cannot activate consolidation feature',
  'consolidation.compilation_saved':
    'Account compilation saved, click button below to go to consolidation report',
  'consolidation.see_report': 'See Report',
  'consolidation.confirm_auto_compile':
    'Auto compile will automatically compile account with the same code to consolidation account. Are you sure to auto compile?',
  'consolidation.code_already_exist': 'Code already exist, please change to another',
  'translation.translation': 'Translation',
  'translation.title.reset': 'Are you sure to reset?',
  'translation.reset': 'Reset Translation',
  'translation.error_cannot_edit': 'Cannot Edit Translation',
  'audit.audit': 'Audit',
  'audit.show_audit': 'Show Audit',
  'audit.date': 'Date',
  'audit.description': 'Description',
  'audit.ip': 'IP',
  'audit.by': ' by ',
  'audit.user': 'User',
  'audit.item': 'Item',
  'audit.all_item': 'All items',
  'audit.filter': 'Filter Audit',
  'audit.allow_users_view_audit_detail_transaction':
    'Allow users to view audits of transaction details',
  'audit.allow_users_view_audit_detail_transaction_help_text':
    'If active then the menus "{menuName1}" and "{menuName2}" will be displayed',
  'appSetting.apps': 'Apps',
  'appSetting.date_created': 'Date Created',
  'appSetting.app_name': 'App Name',
  'appSetting.client_id': 'Client ID',
  'appSetting.client_id_has_been_copied': 'Client ID has been copied',
  'appSetting.secret_has_been_copied': 'Secret has been copied',
  'appSetting.endpoint_has_been_copied': 'API Endpoint URL has been copied',
  'appSetting.documentation_has_been_copied': 'API Documentation has been copied',
  'appSetting.api_documentation_endpoint': 'API Documentation Endpoint',
  'appSetting.please_input_name': 'Please input app name',
  'appSetting.please_redirect_uri': 'Please input redirect URI',
  'appSetting.please_valid_uri': 'Please input valid URL',
  'appSetting.error_cannot_get': 'Cannot get apps',
  'appSetting.error_cannot_create': 'Cannot create apps',
  'appSetting.error_cannot_edit': 'Cannot edit apps',
  'appSetting.error_cannot_delete': 'Cannot delete apps',
  'appSetting.app_has_been_created_make_sure_save_secret':
    'New app has been created, please please save secret code below before going to another page.',
  'appSetting.secret_code_just_shown_once':
    'Secret code just shown once. Save this code, because after this you cannot see this secret code again.',
  'appSetting.integrate_your_app_with_kledo': 'Integrate your application with Kledo',
  'appSetting.now_app_can_be_integrated_with_kledo':
    'Now your application, website, or software can be integrated with Kledo.',
  'appSetting.for_more_details_lets_see_the_video': 'For more details, lets watch the video',
  'appSetting.watch_video': 'Watch video',
  'settings.shipping_comps': 'Manage shipping companies',
  'settings.failed_to_save': 'Failed to save settings. Please try again.',
  'settings.businessflow': 'Manage your business flow',
  'settings.company': "Company's data and logo",
  'settings.taxes': 'Manage taxes',
  'settings.terms': 'Manage payment terms',
  'settings.billing': 'Upgrade and renew Kledo plan',
  'settings.automatic_sequencing': 'Manage invoice automatic sequencing',
  'settings.lock_date': 'Lock transaction data on specific date',
  'settings.layout_invoice': 'Manage invoice layout',
  'settings.layout_reporting': 'Manage finance print layout',
  'settings.users': 'Invite staff and colleagues to use Kledo',
  'settings.roles': 'Manage users role',
  'settings.transaction_age_limit': 'Limit access to old transactions for certain roles',
  'settings.my_profile': 'Manage profile and change password',
  'settings.setup': 'Remove demo data and start from scratch',
  'settings.translation': "Change language on Kledo's menu",
  'settings.audits': 'Watch data log',
  'settings.units': 'Manage product units',
  'settings.product_variants': 'Manage product variants',
  'settings.product_modifiers': 'Manage product modifiers',
  'settings.consolidation': 'Manage companies and account for consolidation reportings',
  'settings.tags': 'Manage tag to separate branch/department/division reporting',
  'settings.email_template': 'Manage email layouts',
  'settings.apps': 'Connect your Apps with Kledo API',
  'settings.account_mappings': 'CoA Account mapping for transactions on Kledo',
  'settings.marketplace_connect': 'Automatically sync Shopee, Tokopedia, and Lazada to Kledo',
  'settings.whatsapp_template': 'Manage default template invoice delivery via Whatsapp',
  'settings.notification': 'Manage notification that will be sent to your email',
  'settings.notification_title': 'Notification',
  'settings.custom_columns': 'Custom data on your invoice',
  'settings.woocommerce': 'Automatically sync Wordpress & Woocommerce to Kledo',
  'settings.pos_connect': 'Automatically sync POS to Kledo',
  'settings.multi_currency': 'Manage multi currency usage',
  'settings.price_forecast': 'Manage material price increase scenarios',
  'settings.sales_commission': 'Manage sales commission each sales team',
  'settings.zap_route': 'Manage and organize delivery routes for distribution',
  'settings.zap_user': 'Manage users in the distribution system',
  'settings.zap_fleet': 'Manage delivery vehicle fleet',
  'settings.section.profile_subscription': 'Profile & Subscription',
  'settings.section.flow_transaction': 'Flow & Transactions',
  'settings.section.finance_accounting': 'Finance & Accounting',
  'settings.section.data_system': 'Data & System',
  'settings.section.document': 'Documents',
  'settings.section.communication': 'Communication',
  'settings.section.auto_email': 'Automated Emails',
  'settings.section.user_management': 'User Management',
  'settings.section.my_account': 'My Account',
  'settings.section.transaction_payment': 'Transactions & Payments',
  'settings.section.product_shipping': 'Products & Shipping',
  'settings.section.organization_data': 'Organization & Data',
  'settings.section.sales_marketplace': 'Sales & Marketplace',
  'settings.section.payment': 'Payments',
  'settings.section.notification_collaboration': 'Notifications & Collaboration',
  'settings.section.developer_security': 'Developer & Security',
  'settings.section.distribution': 'Distribution',
  'settings.section.others': 'Others',
  'settings.section.search_result': 'Search Results',
  'settings.category_desc.company': 'Manage your company data and Kledo subscription',
  'settings.category_desc.business_flow': 'Configure business flows to fit your company needs',
  'settings.category_desc.layout_template':
    'Customize document layouts, email templates, and app language',
  'settings.category_desc.user_account': 'Manage users, permissions, and your account preferences',
  'settings.category_desc.master_data': 'Manage master data such as taxes, terms, units, and tags',
  'settings.category_desc.integration': 'Connect Kledo with marketplaces, payments, and other apps',
  'settings.category_desc.distribution': 'Manage distribution routes, fleets, and users',

  'billing.error_cannot_upgrade': 'Cannot upgrade',
  'billing.error_cannot_renew': 'Cannot renew',
  'billing.error_cannot_delete': 'Cannot delete',
  'billing.error_cannot_get_addon': 'Cannot get addon',
  'billing.error_cannot_add_addon': 'Cannot add addon',
  'billing.account_expired': 'Your account has expired, please renew now',
  'billing.current_expired_date': 'Current expiry date',
  'billing.1.expiration_date_after_renewal': 'Expiration date after renewal',
  'billing.2.expiration_date_after_renewal':
    'The expiry date after renewal is calculated from the current expiry date, not calculated from the payment date.',
  'billing.expired': 'Your account has expired, {setup} to renew',
  'billing.expired_link': 'click here',
  'billing.billing': 'Billing',
  'billing.thankyou': 'Thankyou',
  'billing.upgrade': 'Upgrade',
  'billing.renew': 'Renew',
  'billing.addon': 'Addon',
  'billing.show_addon': 'Show Addon',
  'billing.add_addon': 'Add Addon',
  'billing.hide_addon': 'Hide Addon',
  'billing.upgrade_now': 'Upgrade Now',
  'billing.renew_now': 'Renew Now',
  'billing.order_now': 'Order Now',
  'billing.upgrade_plan': 'Upgrade Plan',
  'billing.renew_plan': 'Renew Plan',
  'billing.subscription_plan': 'Subscription Plan',
  'billing.billing_detail': 'Billing Detail',
  'billing.plan_quota': 'Plan Quota',
  'billing.plan_quota_group_capacity': 'Capacity',
  'billing.plan_quota_group_services': 'Services & Documents (Top-up)',
  'billing.plan_quota_users': 'Users',
  'billing.plan_quota_warehouses': 'Warehouse',
  'billing.plan_quota_stamp': 'E-Stamp',
  'billing.plan': 'Plan',
  'billing.forever': 'Forever',
  'billing.payment_history': 'Payment History',
  'billing.active_until': 'Active until',
  'billing.order_date': 'Order Date',
  'billing.description': 'Description',
  'billing.period': 'Period',
  'billing.payment_date': 'Payment Date',
  'billing.total': 'Total',
  'billing.status': 'Status',
  'billing.select_plan': 'Select a plan',
  'billing.select_contract_duration': 'Select the contract duration',
  'billing.total_bill': 'Total bill',
  'billing.please_add_an_addon': 'Please add one of the addon',
  'billing.please_select_a_plan': 'Please select a plan',
  'billing.please_select_the_contract_duration': 'Please select the contract duration',
  'billing.get_x_discount_for_1_year_payment_and_x_discount_for_6_months':
    'Discount {discountFor1Year} for 1 year payment and {discountFor6Months} discount for 6 months payment',
  'billing.bill_email_has_been_sent_to_your_email':
    'Bill email has been sent to your email address.',
  'billing.please_make_a_payment_of': 'Please make a payment of',
  'billing.by_click_button_below': 'by clicking button below',
  'billing.pay_now': 'Pay Now',
  'billing.pay': 'Pay',
  'billing.processing_payment': 'Processing Payment',
  'billing.payment_failed': 'Payment Failed',
  'billing.please_contact_kledo_if_difficulity_on_payment':
    'Please contact tim Hebat Kledo if you have a difficulity on payment.',
  'billing.payment_success': 'Payment Succeed',
  'billing.your_account_activated_thanks': 'Your account has been activated. Thank You.',
  'billing.payment_pending': 'Waiting for Payment',
  'billing.your_account_wiil_be_active_after_payment':
    'Your account will be active after payment. If you have made a payment, please click the following button. Thank You.',
  'billing.to': 'to',
  'billing.bank': 'Bank',
  'billing.account_number': 'Account Number',
  'billing.after_make_a_payment_please_confirm_via_whatsapp':
    'After make a payment, please confirm via whatsapp at',
  'billing.back_to_billing': 'Back to Billing',
  'billing.feature_available_in_pro_plan': '{feature} feature available in PRO plan',
  'billing.feature_can_only_be_use_on_pro_plan': '{feature} can only be accessed on the PRO plan',
  'billing.pro_plan_features': 'Pro Plan Features',
  'billing.feature_available_in_elite_plan': '{feature} feature available in Elite plan',
  'billing.feature_can_only_be_use_on_elite_plan':
    '{feature} can only be accessed on the Elite plan',
  'billing.elite_plan_features': 'Elite Plan Features',
  'billing.feature_available_in_champion_plan': '{feature} feature available in Champion plan',
  'billing.feature_can_only_be_use_on_champion_plan':
    '{feature} can only be accessed on the Champion plan',
  'billing.champion_plan_features': 'Champion Plan Features',
  'billing.quota_is_exhausted_add_an_addon':
    'Your {feature} quota is exhausted, please add an addon',
  'billing.quota_is_exhausted_upgrade_plan':
    'Your {feature} quota is exhausted, please upgrade your plan to add an addon',
  'billing.marketplace_connect_available_in_elite':
    '{feature} Available in Elite Package, Please Upgrade',
  'billing.paid_plan_features': 'Paid Plan Features',
  'billing.feature_can_only_be_accessed_on_paid_plan':
    '{feature} can only be accessed on the Paid plan',
  'billing.warehouse_and_inventory': 'Warehouse & Inventory',
  'billing.track_product': 'Track product',
  'billing.attachment': 'Attachment',
  'billing.dashboard_layout_setting': 'Dashboard layout setting',
  'billing.feature_locked': 'Feature Locked',
  'billing.your_free_trial_active': 'Your Free Trial account has been activated.',
  'billing.account_will_active_until': 'The account will be active until',
  'billing.token_required_to_make_payment': 'Token is required to make a payment',
  'dashboard.hello_name': 'Hello {name},',
  'dashboard.schedule_a_demo_and_consult':
    "Let's schedule a free online demo and consultation with tim hebat Kledo.",
  'dashboard.demo_online_with_zoom':
    'The demo will be conducted online using Zoom 1 on 1 for 45 minutes.',
  'dashboards.dashboard': 'Dashboard',
  'dashboards.select_company': 'Select a Company: ',
  'dashboards.gross_profit': 'Gross profit',
  'dashboards.net_profit': 'Net Profit',
  'dashboards.net_profit_for_this_year': 'Net profit for this year',
  'dashboards.sales_value_this_year': 'Sales value this year',
  'dashboards.sales': 'Sales',
  'dashboards.awaiting_payment': 'Awaiting payment',
  'dashboards.overdue': 'Overdue',
  'dashboards.sales_this_day': 'Sales this day',
  'dashboards.sales_this_month': 'Sales this month',
  'dashboards.sales_this_year': 'Sales this year',
  'dashboards.this_month': 'This month',
  'dashboards.ytd': 'YTD',
  'dashboards.total': 'Total',
  'dashboards.are_you_sure_delete': 'Are you sure delete?',
  'dashboards.modif': 'Modif',
  'dashboards.exit': 'Exit',
  'dashboards.select_account': 'Select account',
  'dashboards.please_select_account': 'Please select account',
  'dashboards.in': 'In',
  'dashboards.out': 'Out',
  'dashboards.net': 'Net',
  'dashboards.edit': 'Edit',
  'dashboards.other': 'Other',
  'dashboards.the_first_date_end_higger_than_second_date_start':
    'The start of the second date must be a date after the end of the first date',
  'breadcrumb.sales': 'Sales',
  'breadcrumb.purchases': 'Purchase',
  'breadcrumb.conversionbalances': 'Conversion Balances',
  'breadcrumb.conversiondate': 'Conversion Date',
  'breadcrumb.add': 'Add',
  'breadcrumb.edit': 'Edit',
  'breadcrumb.detail': 'Detail',
  'payments.add_a_payment_method': 'Add A Payment Method',
  'payments.delete_a_payment_method': 'Delete A Payment Method',
  'payments.are_you_sure_delete': 'Are you sure to delete?',
  'payments.payment_metod': 'Payment Metod',
  'payments.please_select_a_payment_to_delete': 'Please select a payment to delete',
  'payments.select_a_payment_method': 'Select a payment method',
  'payments.edit_payment_method': 'Edit Payment Method',
  'payments.payment_method': 'Payment Method',
  'payments.please_input_the_payment_name': 'Please input the payment name.',
  'payments.max_20_characters': 'Max 20 characters.',
  'payments.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'payments.name': 'Name',
  'payments.payment': 'Payment',
  'payments.payment_methods': 'Payment Methods',
  'payments.successfully_added': 'successfully added.',
  'payments.error_cannot_add': 'Cannot add payment',
  'payments.successfully_deleted': 'successfully deleted.',
  'payments.error_cannot_delete': 'Cannot delete payment.',
  'payments.payment_successfully_updated': 'Payment successfully updated.',
  'payments.error_cannot_update_payment': 'Cannot update payment.',
  'payments.payment_moved_successfully': 'Payment moved successfully.',
  'payments.error_cannot_move_the_payment': 'Cannot move the payment.',
  'payments.change_status_payment_successfully': 'Change status payment successfully.',
  'payments.error_cannot_change_status_the_payment': 'Cannot change status the payment.',
  'payments.must_have_active_payment': 'Must have at least one active payment.',
  'profile.profile': 'Profile',
  'profile.image_profile': 'Profile Image',
  'profile.my_profile': 'My Profile',
  'profile.old_password': 'Old Password',
  'profile.please_input_the_old_password': 'Please input the old password.',
  'profile.new_password': 'New Password',
  'profile.please_input_the_new_password': 'Please input the new password.',
  'profile.max_100_characters': 'Max 100 characters.',
  'profile.confirm_new_password': 'Confirm New Password',
  'profile.please_input_the_confirm_new_password': 'Please input the confirm new password.',
  'profile.email_or_username': 'Email / Username',
  'profile.please_input_the_email/username': 'Please input the email/username.',
  'profile.the_input_is_not_valid-e-mail': 'The input is not valid E-mail.',
  'profile.please_input_the_full_name': 'Please input the full name.',
  'profile.0nly_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'profile.full_name': 'Full Name',
  'profile.please_input_the_phone_number': 'Please input the phone number.',
  'profile.max_20_characters': 'Max 20 characters.',
  'profile.only_number_allowed': 'Only number allowed.',
  'profile.phone_number': 'Phone Number',
  'profile.user_profile_successfully_updated': 'User profile successfully updated.',
  'profile.error_cannot_update_user_profile': 'Cannot update user profile.',
  'profile.user_password_successfully_updated': 'User password successfully updated.',
  'profile.error_cannot_update_user_password': 'Cannot update user password.',
  'profile.change_password': 'Change Password',
  'profile.two_passwords_that_you_enter_is_inconsistent_':
    'Two passwords that you enter is inconsistent.',
  'profile.password_atleast_8_characters_atleast_1_uppercase_and_atleast_1_digit':
    'Password atleast 8 characters, atleast 1 uppercase and atleast 1 digit.',
  'profile.password_atleast_6_characters': 'Password atleast 6 characters.',
  'profile.password_atleast_8_characters': 'Password atleast 8 characters.',
  'profile.password_pattern_minimum_1_capital_and_1_lowercase_letter':
    'Minimum 1 capital letter and 1 lowercase letter.',
  'profile.password_pattern_minimum_1_number': 'Minimum 1 number.',
  'profile.logout_from_all_device': 'Logout from all device',
  'profile.cannot_logout_from_all_device': 'Cannot logout from all device',
  'transactionAgeLimit.scope': 'Sales Invoices only',
  'transactionAgeLimit.description':
    'Block certain roles from sales invoices dated beyond the age limit.',
  'transactionAgeLimit.roles': 'Roles',
  'transactionAgeLimit.roles_placeholder': 'Select roles',
  'transactionAgeLimit.roles_required': 'Select at least one role.',
  'transactionAgeLimit.age_value': 'Age',
  'transactionAgeLimit.age_value_required': 'Enter an age of at least 1.',
  'transactionAgeLimit.age_unit': 'Unit',
  'transactionAgeLimit.restrict': 'This role cannot',
  'transactionAgeLimit.restrict_view': 'View',
  'transactionAgeLimit.restrict_modify': 'Modify',
  'transactionAgeLimit.restrict_backdate': 'Backdate',
  'transactionAgeLimit.restrict_view_blocked_hint':
    'This role cannot open invoices dated beyond the age limit.',
  'transactionAgeLimit.restrict_modify_blocked_hint':
    'This role cannot edit, delete, or void invoices dated beyond the age limit.',
  'transactionAgeLimit.restrict_backdate_blocked_hint':
    'This role cannot create an invoice, or change an invoice date, to a date beyond the age limit.',
  'transactionAgeLimit.restrict_view_allowed_hint':
    'This role can open invoices dated beyond the age limit.',
  'transactionAgeLimit.restrict_modify_allowed_hint':
    'This role can edit, delete, or void invoices dated beyond the age limit.',
  'transactionAgeLimit.restrict_backdate_allowed_hint':
    'This role can create an invoice, or change an invoice date, to a date beyond the age limit.',
  'transactionAgeLimit.rules_section': 'Restriction rules',
  'transactionAgeLimit.rule_number': 'Rule {number}',
  'transactionAgeLimit.remove_rule_confirm':
    'Remove this rule? The roles in it will be free to access old transactions.',
  'transactionAgeLimit.remove_rule_number': 'Remove rule {number}',
  'transactionAgeLimit.add_rule': 'Add rule',
  'transactionAgeLimit.remove_rule': 'Remove rule',
  'transactionAgeLimit.exception_users': 'Exception users',
  'transactionAgeLimit.exception_users_placeholder': 'Select users',
  'transactionAgeLimit.exception_users_tooltip':
    'These users can still access all invoices, even when their role is blocked.',
  'transactionAgeLimit.print_count_setting_warning':
    'Your role cannot change old transactions. The receipt print count does not increase for transactions older than the access age limit.',
  'transactionAgeLimit.print_count_not_updated':
    'The receipt print count cannot be updated because the transaction is older than the access age limit.',
  'transactionAgeLimit.cannot_modify':
    'This transaction is older than the age limit, your role cannot change it.',
  'transactionAgeLimit.load_failed': 'Settings failed to load',
  'transactionAgeLimit.cannot_backdate_before':
    'Transaction date cannot be before {date}. Your role is limited.',
  'roles.add_role': 'Add Role',
  'roles.delete_role': 'Delete Role',
  'roles.select_role_to_delete': 'Select Role to Delete',
  'roles.please_select_a_role': 'Please select a role.',
  'roles.select_role': 'Select role',
  'roles.edit_role': 'Edit Role',
  'roles.role': 'Role',
  'roles.roles': 'Roles',
  'roles.please_input_the_role_name': 'Please input the role name.',
  'roles.max_100_characters': 'Max 100 characters.',
  'roles.superadmin': 'Superadmin',
  'roles.error_cannot_get_roles': 'Cannot get Roles.',
  'roles.successfully_added': 'successfully added.',
  'roles.error_cannot_add': 'Cannot add',
  'roles.role_successfully_updated': 'Role successfully updated.',
  'roles.error_cannot_update_role': 'Cannot update role.',
  'roles.successfully_deleted': 'successfully deleted.',
  'roles.error_cannot_delete': 'Cannot delete',
  'roles.role_moved_successfully': 'Role moved successfully.',
  'roles.error_cannot_move_the_channel': 'Cannot move the channel.',
  'roles.search_by_role_name': 'Search by role name',
  'roles.name': 'Role name',
  'roles.invoices_payment': 'Payment',
  'roles.orders_payment': 'Payment',
  'roles.purchase_invoices_payment': 'Payment',
  'roles.purchase_orders_payment': 'Payment',
  'roles.product_show_purchase_price': 'Show Purchase Price',
  'roles.product_show_sale_price': 'Show Sale Price',
  'roles.product_show_hpp': 'Show COGS',
  'roles.inventory_show_hpp': 'Show Price',
  'roles.reports_finance': 'Finance',
  'roles.reports_accounting': 'Accounting',
  'roles.reports_sales': 'Sales',
  'roles.reports_purchases': 'Purchases',
  'roles.reports_expenses': 'Expenses',
  'roles.reports_taxes': 'Taxes',
  'roles.reports_inventory': 'Inventory',
  'roles.reports_fixed_assets': 'Fixed Assets',
  'roles.reports_budget': 'Budget',
  'roles.reports_consolidation': 'Consolidation',
  'roles.apikeys': 'API Keys',
  'roles.sales_other_user_access': 'Other User Access',
  'roles.purchase_other_user_access': 'Other User Access',
  'roles.expenses_other_user_access': 'Other User Access',
  'roles.product_show_manufacture_raw': 'Show Manufacture Raw Materials',
  'roles.show_purchase_price': 'Show Purchase Price',
  'roles.show_sales_price': 'Show Sales Price',
  'roles.show_cogs': 'Show COGS',
  'roles.show_manufaktur_materials': 'Show Manufaktur Materials',
  'roles.users_with_this_role': 'Users with this role',
  'roles.click_here_to_set_users': '{clickHere} to set users.',
  'roles.role_not_found': 'Role with id {id} not found',
  'shipComp.shipping_company': 'Shipping Companies',
  'shipComp.name': 'Name',
  'shipComp.status': 'Status',
  'shipComp.error_cannot_move': 'Cannot add shipping company.',
  'shipComp.error_cannot_add': 'Cannot add shipping company.',
  'shipComp.error_cannot_update': 'Cannot update shipping company.',
  'shipComp.error_cannot_delete': 'Cannot delete shipping company.',
  'shipComp.error_cannot_change_status': 'Cannot change status shipping company.',
  'shipComp.please_select_to_delete': 'Please select a Shipping Company to delete',
  'shipComp.select': 'Select a Shipping Company',
  'shipComp.please_input_the_name': 'Please input the shipping company name.',
  'shipComp.must_have_active_shipcomp': 'Must have at least one active shipping company.',
  'report.processing_the_data': 'Processing the Data',
  'report.access_denied': 'Access Denied',
  'report.open_from_list_price_rule':
    'Invalid report detail. Please open from the sales per price rule report list.',
  'report.back_to_list': 'Back to report list',
  'report.pos_sales_price_rule': 'Sales per Price Rule',
  'report.pos_sales_price_rule.product_count': 'Product Count',
  'report.pos_sales_price_rule.total_discount_tooltip':
    'Accumulated total discount / markup from all transactions',
  'report.pos_sales_price_rule.item_total_tooltip': 'Total discount / markup applied to this item',
  'report.pos_shift': 'POS Shift',
  'report.select_pos_shift': 'Select shift',
  'report.item_count': 'Item Count',
  'report.total_discount_amount': 'Total Discount',
  'report.profitability_per_invoice': 'Profitability per Invoice',
  'report.show_account': 'Show Account',
  'report.show_zero_account_balance': 'Show zero account balance',
  'report.show_zero_income': 'Show zero income',
  'report.profitloss_show_zero': 'Show zero values',
  'report.account_not_compiled':
    'Some accounts are not compiled yet, please {link} to compile the accounts',
  'report.month': 'Month',
  'report.date': 'Date',
  'report.general_ledger_reporting': 'General Ledger',
  'report.account': 'Account',
  'report.account_list': 'Account List',
  'report.general_ledger': 'General Ledger',
  'report.source': 'Source',
  'report.please_select_source': 'Please Select Source',
  'report.description': 'Description',
  'report.reference': 'Reference',
  'report.debit': 'Debit',
  'report.credit': 'Credit',
  'report.ytd_debit': 'YTD Debit',
  'report.ytd_credit': 'YTD Credit',
  'report.running_balance': 'Running Balance',
  'report.opening_balance': 'Opening Balance',
  'report.closing_balance': 'Closing Balance',
  'report.next_n_months': 'Next {count} Months',
  'report.cash_flow_projection_label': 'Description',
  'report.cash_flow_projection_opening_balance': 'Opening Cash & Bank Balance',
  'report.cash_flow_projection_receivable_receipts': 'Receivable Receipts',
  'report.cash_flow_projection_payable_payments': 'Bill/Payable Payments',
  'report.cash_flow_projection_closing_balance': 'Projected Closing Balance',
  'report.cash_flow_projection_opening_balance_date': 'Opening balance as of {date}',
  'report.cash_flow_projection_note':
    'Receipts and payments are calculated from the unpaid balance of invoices based on their due dates. Overdue invoices and payments already made during the current month are not included.',
  'report.total': 'Total',
  'report.total_this_page': 'Total This Page',
  'report.total_all_page': 'Total All Page',
  'report.customer_receivable_snapshot': 'Customer Receivable Snapshot',
  'report.payment_connect_kledo_transaction': 'Kledo Payment Gateway Transaction',
  'report.customer_debt_snapshot': 'Supplier Vendor Snapshot',
  'report.customer_receivable_snapshot_detail': 'Customer Receivable Snapshot Detail',
  'report.customer_debt_snapshot_detail': 'Supplier Vendor Snapshot Detail',
  'report.customer_snapshot_amount': 'Amount',
  'report.customer_snapshot_outstanding': 'Outstanding',
  'report.customer_snapshot_export_summary': 'Summary',
  'report.customer_snapshot_export_detail': 'Summary + Detail',
  'report.posted_on': 'Posted on',
  'report.no_data': 'No Data',
  'report.journal_reporting': 'Journal',
  'report.journal_report': 'Journal',
  'report.journal': 'Journal',
  'report.account_transaction_reporting': 'Account Transaction',
  'report.bank_summary': 'Bank Summary',
  'report.bank_account': 'Bank Account',
  'report.cash_received': 'Cash Received',
  'report.cash_spent': 'Cash Spent',
  'report.net_cash_flow': 'Net Cash Flow',
  'report.sales_tax': 'Sales Tax',
  'report.net': 'Net',
  'report.tax': 'Tax',
  'report.customer_invoice': 'Customer Invoice',
  'report.invoice_number': 'Invoice Number',
  'report.customer_payment_recap': 'Customer Payment Recap',
  'report.fee': 'Fee',
  'report.payment_amount': 'Payment Amount',
  'report.note': 'Note',
  'report.to': 'To',
  'report.from': 'From',
  'report.due_date': 'Due Date',
  'report.date_and_time': 'Date & time',
  'report.invoice_date': 'Invoice Date',
  'report.paid': 'Paid',
  'report.due': 'Due',
  'report.all': 'All',
  'report.ktp': 'ID Card',
  'report.npwp': 'Tax Number',
  'report.with_id_card': 'With ID Card',
  'report.without_id_card': 'Without ID Card',
  'report.with_tax_number': 'With Tax Number',
  'report.without_tax_number': 'Without Tax Number',
  'report.exclude_return': 'Exclude Return',
  'report.status': 'Status',
  'report.product_status': 'Product Status',
  'report.active': 'Active',
  'report.income_per_customer': 'Income Per Customer',
  'report.customer': 'Customer',
  'report.income': 'Income',
  'report.total_paid': 'Total Paid',
  'report.total_unpaid': 'Total Unpaid',
  'report.sales_per_product': 'Sales Per Product',
  'report.order_per_product': 'Order Per Product',
  'report.product_name': 'Product Name',
  'report.current_unit_price': 'Current Unit Price',
  'report.quantity_sold': 'Quantity Sold',
  'report.product_quantity_sold_not_sent_yet': 'Product Quantity Sold Not Sent Yet',
  'report.quantity_bought': 'Quantity Bought',
  'report.average': 'Average',
  'report.average_tooltip':
    'Average is the average sales value per {product}, calculated with the formula Total ÷ Quantity Sold. Example: if Total is {total} and Quantity Sold is 3, the Average value is {average}.',
  'report.purchases': 'Purchases',
  'report.purchases_per_vendor': 'Purchases Per Vendor',
  'report.purchases_per_product': 'Purchases Per Product',
  'report.expense_per_contact': 'Expense Per Contact',
  'report.supplier': 'Supplier',
  'report.supplier_invoice': 'Supplier Invoice',
  'report.purchase_value': 'Purchase Value',
  'report.aged_receivable': 'Aged Receivable',
  'report.aged_receivable_not_yet_due': 'Not Yet Due',
  'report.aged_receivable_aged_trans': 'Age of Transaction',
  'report.aged_receivable_aged_due': 'Age of Due',
  'report.aged_receivable_aged_trans_help':
    'Number of days from the transaction date of the oldest invoice to the report date.',
  'report.aged_receivable_aged_due_help':
    'Number of days since the longest overdue due date to the report date. Fully paid invoices are not counted.',
  'report.aged_receivable_detail': 'Aged Receivable Detail',
  'report.aged_payable': 'Aged Payable',
  'report.aged_payable_detail': 'Aged Payable Detail',
  'report.expense_claim': 'Expense Claim',
  'report.expense_claim_detail': 'Expense Claim Detail',
  'report.trial_balance': 'Trial Balance',
  'report.profit_and_loss': 'Profit and Loss',
  'report.other_revenue': 'Other Revenue',
  'report.cost_of_sales': 'Cost of Sales',
  'report.total_cost_of_sales': 'Total Cost of Sales',
  'report.expenses': 'Expenses',
  'report.operating_expenses': 'Operating Expenses',
  'report.total_operating_expenses': 'Total Operating Expenses',
  'report.other_expenses': 'Other Expenses',
  'report.trading_income': 'Trading Income',
  'report.total_trading_income': 'Total Trading Income',
  'report.profitloss_comprehensive_income': 'Profit/Loss Comprehensive Income',
  'report.profitloss_all_encompassing': 'All encompassing',
  'report.profitloss_one_of': 'One of',
  'report.profitloss_filter_by_tags': 'Filter by tags',
  'report.profitloss_filter_currency': 'Select Currency',
  'report.profitloss_currency': 'Currency',
  'report.total_comprehensive_income_this_period': 'Total Comprehensive Income This Period',
  'report.reports': 'Reports',
  'report.financial': 'Financial',
  'report.balance_sheet': 'Balance Sheet',
  'report.compare': 'Compare',
  'report.period': 'Period',
  'report.cash_summary': 'Cash Summary',
  'report.executive_summary': 'Executive Summary',
  'report.sales_tax_report': 'Sales Tax',
  'report.accounting': 'Accounting',
  'report.aged_receivables': 'Aged Receivables',
  'report.customer_invoice_report': 'Customer Invoice',
  'report.aged_payables': 'Aged Payables',
  'report.supplier_invoice_report': 'Supplier Invoice',
  'report.purchases_per_supplier': 'Purchases per Supplier',
  'report.cash_flow': 'Cash Flow',
  'report.net_cash_flows_from_': 'Net cash flows from ',
  'report.direct_method': 'Direct Method',
  'report.indirect_method': 'Indirect Method',
  'report.please_select': 'Please select',
  'report.cash_and_cash_equivalent': 'Cash and Cash Equivalent',
  'report.cash_and_cash_equivalent_at_beginning_period':
    'Cash and cash equivalent at beginning of period',
  'report.cash_and_cash_equivalent_at_end_period': 'Cash and cash equivalent at end of period',
  'report.net_change_in_cash_for_period': 'Net change in cash for period',
  'report.net_cash_flows': 'Net cash flows',
  'report.equity_movement': 'Movement in Equity',
  'report.beginning': 'Beginning',
  'report.ending': 'Ending',
  'report.net_movement': 'Net Movement',
  'report.expense_claim_customer': 'Customer',
  'report.spend': 'Expenses',
  'report.to_customer': 'To',
  'report.account_transactions': 'Account Transactions',
  'report.account_transactions_title': '{account} Transactions',
  'report.fixed_asset': 'Fixed Asset',
  'report.fixed_asset_detail': 'Fixed Asset Detail',
  'report.fixed_asset_summary': 'Fixed Asset Summary',
  'report.fixed_asset_summary_purchase_date_from': 'Purchase date from',
  'report.fixed_asset_summary_include_disposed': 'Include disposed assets',
  'report.asset_name': 'Asset Name',
  'report.number': 'Number',
  'report.purchase_date': 'Purchase Date',
  'report.purchase_price': 'Purchase Price',
  'report.depreciation': 'Depreciation',
  'report.book_value': 'Book Value',
  'report.witholding_tax': 'Witholding Tax',
  'report.inventory': 'Inventory',
  'report.inventory_summary': 'Inventory Summary',
  'report.inventory_stock_movement': 'Inventory Stock Movement',
  'report.warehouse_stock_summary': 'Warehouse Stock Summary',
  'report.warehouse_stock_movement': 'Warehouse Stock Movement',
  'report.all_warehouses': 'All warehouses',
  'report.product_conversion': '{title} conversion',
  'report.warehouse': 'Warehouse',
  'report.export_warehouse_per_sheet_hint':
    'Each selected warehouse will be exported as a separate sheet in one Excel file. The row ranges below count all selected warehouses combined, not per warehouse.',
  'report.export_per_range_note':
    'Data is downloaded in separate files of up to 1,000 {title} each.',
  'report.export_all_warehouses_label': 'All warehouses',
  'report.category': 'Category',
  'report.stats_button': 'Statistics',
  'report.customer_purchase_stats': 'Purchase pattern statistics',
  'report.stats_period': 'Period {date_from} – {date_to}',
  'report.stats_trans_range': 'Transactions {first} – {last}',
  'report.stats_group_pattern': 'Purchase pattern',
  'report.stats_group_value': 'Transaction value',
  'report.stats_frequency': 'Transaction count',
  'report.stats_average_interval_days': 'Average interval (days)',
  'report.stats_recency_days': 'Last purchase (days ago)',
  'report.stats_average_order_value': 'Average order value',
  'report.stats_total_amount': 'Total value',
  'report.stats_empty': 'No transactions in this period',
  'report.stats_help_label_formula': 'Formula',
  'report.stats_help_label_example': 'Example',
  'report.stats_help_label_note': 'Note',
  'report.stats_help_average_interval_days_desc':
    'How often, on average, this customer makes a purchase.',
  'report.stats_help_average_interval_days_formula':
    'Days from the first to the last transaction ÷ (number of distinct transaction days − 1)',
  'report.stats_help_average_interval_days_example':
    'Transactions on Sep 1, 5, and 11. Sep 1 to Sep 11 = 10 days, distinct transaction days = 3. So 10 ÷ (3 − 1) = 5 days.',
  'report.stats_help_average_interval_days_note':
    'Two invoices on the same day count as one transaction day. Empty if the customer only transacted on a single day.',
  'report.stats_help_average_order_value_desc': 'Average value per invoice (AOV).',
  'report.stats_help_average_order_value_formula': 'Total transaction value ÷ number of invoices',
  'report.stats_help_average_order_value_example':
    '2 invoices with a total transaction value of Rp 1,000,000. So 1,000,000 ÷ 2 = Rp 500,000.',
  'report.stats_help_average_order_value_note':
    'The total transaction value already excludes returns. Empty if there are no transactions in this period.',
  'report.stats_help_total_amount_desc': 'Net purchase total for this customer in the period.',
  'report.stats_help_total_amount_formula': 'Sum of all invoice values − sum of all returns',
  'report.stats_help_total_amount_example':
    'Invoices of Rp 1,000,000 and Rp 1,000,000, with a Rp 1,000,000 return. So (1,000,000 + 1,000,000) − 1,000,000 = Rp 1,000,000.',
  'report.select_category': 'Select Category',
  'report.code': 'Code',
  'report.qty': 'Quantity',
  'report.opening_qty': 'Opening Quantity',
  'report.qty_movement': 'Quantity Movement',
  'report.closing_qty': 'Closing Quantity',
  'report.balance_filtered_tooltip':
    'When a transaction-type filter is active, the opening and closing balances still show the real totals across all transactions, while the movement columns are calculated only from the selected transaction types. As a result, the closing balance may not equal opening balance + movement.',
  'report.opening_value': 'Opening Value',
  'report.value_movement': 'Value Movement',
  'report.value': 'Value',
  'report.closing_value': 'Closing Value',
  'report.avg_cost': 'Average Cost',
  'report.avg_cost2': 'Average Cost',
  'report.unit_price': 'Unit Price',
  'report.product_value': 'Product Value',
  'report.product_stock': 'Product Stock',
  'report.product': 'Product',
  'report.until': 'until',
  'report.budget': 'Budget',
  'report.actual': 'Actual',
  'report.movement': 'Movement',
  'report.price': 'Price',
  'report.unpaid': 'Unpaid',
  'report.grand_total': 'Grand Total',
  'report.delivery': 'Delivery',
  'report.please_input_name': 'Please input name',
  'report.start_period': 'Start Period',
  'report.please_input_start_period': 'Please input start period',
  'report.no_of_period': 'No. of Period',
  'report.last_period': 'Last Period',
  'report.last_n_period': 'Last {count} Period',
  'report.cannot_save_budget': 'Cannot save budget',
  'report.cannot_delete_budget': 'Cannot delete budget',
  'report.interval': 'Interval',
  'report.apply': 'Apply',
  'report.delete_figures_this_column': 'Delete all figures from this column',
  'report.apply_figures_to_following_month':
    'Apply the figures from this month to the following months',
  'report.adjust_figures_each_month_amount':
    'Adjust the figures for each subsequent month to this amount',
  'report.adjust_figures_each_month_percent':
    'Adjust the figures for each subsequent month with this percentage',
  'report.max_n_period_to_print': 'Maximum {count} period to print',
  'report.total_income': 'Total Income',
  'report.gross_profit': 'Gross Profit',
  'report.operating_costs': 'Operating Costs',
  'report.net_profit': 'Net Profit',
  'report.search_by_product': 'Search by product',
  'report.shipping_amount': 'Shipping Amount',
  'report.invoice_total': 'Invoice Total',
  'report.shipping_cost_total': 'Shipping Cost Total',
  'report.shipping_cost': 'Shipping Cost',
  'report.dpp': 'DPP',
  'report.ppn': 'PPN',
  'report.witholding': 'Witholding',
  'report.shipping_cost_per_expedition': 'Shipping Cost per Expedition',
  'report.sales_per_sales_person': 'Sales per Sales Person',
  'report.production_report': 'Production Report',
  'report.finished_product': 'Finished Product',
  'report.percentage': 'Percentage',
  'report.transaction_total': 'Transaction Total',
  'report.receivable_payable_contact': 'Receivable Payable per Contact',
  'report.sort_by': 'Sort by',
  'subsidiaryLedger.without_contact': '(No Contact)',
  'subsidiaryLedger.deleted': 'Deleted',
  'subsidiaryLedger.total_note':
    'TOTAL is the balance of all accounts, it does not follow the contact filter',
  'subsidiaryLedger.order_by': 'Order direction',
  'subsidiaryLedger.ascending': 'Ascending',
  'subsidiaryLedger.descending': 'Descending',
  'report.invoice_payment': 'Invoice Payment',
  'report.purchase_invoice_payment': 'Purchase Invoice Payment',
  'report.first_payment_date': 'First Payment Date',
  'report.paid_date': 'Paid Date',
  'report.product_profitability': 'Product Profitability',
  'report.total_profit': 'Total Profit',
  'report.profit_margin': 'Profit Margin',
  'report.avg_sell_price': 'Avg Sell Price',
  'report.hpp_per_unit': 'COGS Per Unit',
  'report.avg_cogs': 'Avg COGS',
  'report.stock_in': 'Stock In',
  'report.stock_out': 'Stock Out',
  'report.sales_per_period': 'Sales Per Period',
  'report.purchases_per_period': 'Purchases Per Period',
  'report.product_sales_per_customer': 'Product Sales Per Customer',
  'report.product_purchase_per_supplier': 'Product Purchase Per Supplier',
  'report.total_quantity_product': 'Total Quantity Product',
  'report.product_purchases_per_vendor': 'Product Purchases per Vendor',
  'report.vendor': 'Vendor',
  'report.sales_per_product_category': 'Sales Per Product Category',
  'report.favorite': 'Favorite',
  'report.remove_favorite': 'Remove from favorite menu',
  'report.add_favorite': 'Add from favorite menu',
  'report.total_price': 'Total Price',
  'report.view_price': 'View Price',
  'report.include_unit_conversion': 'Show unit conversions',
  'report.hide_zero_qty': 'Hide zero qty',
  'trialBalance.show_balance': 'Show Balance',
  'attachment.file_name': 'File Name',
  'attachment.search_by_file_name': 'Search by file name',
  'reportsImport.amount_of_success_import': 'Amount of success import',
  'reportsImport.detail': 'Import Detail',
  'reportsImport.status': 'Import Status',
  'reportsImport.failed_to_import': 'Failed to import',
  'reportsImport.successful_import': 'Successful import',
  'reportsImport.import_type': 'Import Type',
  'reportsImport.import_time': 'Import Time',
  'reportsImport.transaction_status': 'Transaction Status',
  'reportsImport.download_file_import': 'Download file import',
  'reportsImport.download_file_error': 'Download file error',
  'reportsImport.sub_account_code': 'Sub Account Code (Parent)',
  'reportsImport.sub_account_name': 'Sub Account Name (Parent)',
  'reportsImport.imported_by': 'Imported by',
  'setup.demo_data_successfully_cleared': 'Demo data successfully cleared.',
  'setup.error_demo_data_failure_to_cleared_': 'Failed to clear demo data.',
  'setup.demo_data_successfully_finished': 'Setup finished successfully.',
  'setup.error_demo_data_failure_to_finished': 'Failed to finish setup.',
  'setup.setup_clear_demo_data': 'Setup Clear Demo Data',
  'setup.you_are_using_a_demo_of_kledo_at_the_moment':
    'You are using a demo of kledo at the moment.',
  'setup.click_button_below_to_clear_the_test_data_and_start_setting_up_your_property':
    'Click button below to clear the test data and start setting up your company',
  'setup.are_you_sure_that_you_want_to_clear_demo_': 'Are you sure to clear demo data?',
  'setup.this_will_remove_all_rooms_room_types_rates_and_bookings':
    'This will remove all data, and cannot be undone.',
  'setup.clear_test_data_and_setup': 'Clear test data and setup',
  'setup.clear_demo_data': 'Clear demo data',
  'setup.delete_all_data_now': 'Delete all data now',
  'setup.continue_deleting_data': 'Continue deleting data',
  'setup.1_waring': 'This setup page will only appear to admins with Administrator privileges.',
  'setup.2_waring':
    'This page will disappear automatically 1 month after the registration date on Kledo.',
  'setup.finish': 'Finish',
  'setup.finish_setup': 'Finish setup',
  'setup.demo': 'The data presented here is dummy data. When ready, {setup} to reset the data.',
  'setup.demo_link': 'click here',
  'setup.trial': 'Your free trial access will be ended in {days} days. {setup}.',
  'setup.trial_one_day': 'Your free trial access will expire in {hour} hours. {setup}.',
  'setup.trial_zero_days': 'Your free trial access has ended. {setup}.',
  'setup.subscription': 'Your subscription package will expire in {days} days. {setup}.',
  'setup.subscription_one_day': 'Your subscription will expire in {hour} hours. {setup}.',
  'setup.subscription_zero_days': 'Your subscription has ended. {setup}.',
  'setup.go_to_dashboard': 'Go to dashboard',
  'setup.setup_complete':
    'Demo data has been deleted and setup is complete, now you can start using Kledo.',
  'setup.input_your_cash_and_account_bank_name': 'Enter your company cash & bank account name',
  'setup.input_your_company_name': 'Enter your company data',
  'setup.company_logo': 'Company Logo',
  'setup.cash': 'Cash',
  'setup.bca_account': 'BCA Account',
  'setup.mandiri_account': 'Mandiri Account',
  'setup.please_input_bank_account_name_or_delete_this_field':
    'Input bank account name or delete this field.',
  'accountMapping.account_mappinng': 'Account Mapping',
  'users.hello_please_select_company_to_proceed':
    'Hello {name}, please select a company to proceed',
  'users.please_select_company_to_proceed': 'please select a company to proceed',
  'users.hello': 'Hello',
  'users.you_are_invited_to_join': 'You are invited to join',
  'users.do_you_agree_to_join': 'Do You agree to join',
  'users.all_users': 'All users',
  'users.select_user': 'Select user',
  'users.yes': 'Yes',
  'users.no': 'No',
  'users.add_user': 'Add User',
  'users.delete_user': 'Delete User',
  'users.only_displays_users_other_than_you': 'Only displays users other than you',
  'users.please_select_a_user': 'Please select a user.',
  'users.select_user_to_delete': 'Select User to Delete',
  'users.edit_user': 'Edit User',
  'users.name': 'Name',
  'users.email': 'Email',
  'users.role': 'Role in the company as',
  'users.roles': 'Roles',
  'users.resending': 'Resending',
  'users.resending_help':
    'To confirm, please open your email inbox, and click the link sent by Kledo.',
  'users.success_resending': 'Successfully Sending Invitations',
  'users.success_resending_desc':
    'Invitation successfully resent to email {email}. Please open your email inbox, and click on the link that has been sent by Kledo.',
  'users.waiting_for_confirmation': 'Waiting for confirmation',
  'users.please_input_the_email_address': 'Please input the email address.',
  'users.max_100_characters': 'Max 100 characters.',
  'users.invalid_email_address_format': 'Invalid email address format.',
  'users.please_select_a_role': 'Please select a role.',
  'users.select_roles': 'Select roles',
  'users.pending_invitation': '(Pending invitation)',
  'users.user': 'User',
  'users.successfully_added': 'successfully added.',
  'users.error_cannot_add': 'Cannot add',
  'users.user_successfully_updated': 'User successfully updated.',
  'users.error_cannot_update_user': 'Cannot update user.',
  'users.successfully_deleted': 'successfully deleted.',
  'users.error_cannot_delete': 'Cannot delete',
  'users.search_by_name_or_email': 'Search by name or email',
  'users.restore_password': 'Restore Password',
  'users.enter_the_email_address_associated_with_your_account_and_well_email_you_a_link_to_reset_your_password':
    "Enter the email address associated with your account, and we'll email you a link to reset your password",
  'users.back_to_login': 'Back to login',
  'users.send_reset_link': 'Send Reset Link',
  'users.please_check_your_email_inbox_and_follow_the_instruction_to_reset_your_password_if_email_hasnt_received_please_check_the_bulk_and_spam_folder':
    "Please check your email inbox and follow the instruction to reset your password. If email hasn't received please check the bulk and spam folder",
  'users.please_input_your_email': 'Please input your email',
  'users.the_input_is_not_valid_email_': 'The input is not valid E-mail.',
  'users.welcome_to_kledo': 'WELCOME TO KLEDO',
  'users.welcome_to2': 'Welcome to ',
  'users.phone': 'Phone',
  'users.password': 'Password',
  'users.confirm_new_password': 'Confirm New Password',
  'users.activate': 'Activate',
  'users.invalid_invitation_token': 'Invalid invitation token',
  'users.your_invitation_token_is_invalid_please_check_it_again_and_reload_the_page':
    'Please check it again and reload the page',
  'users.please_fill_the_register_form': 'Please fill the register form',
  'users.please_input_your_email_address': 'Please input your e-mail address',
  'users.please_input_your_name': 'Please input your name',
  'users.please_input_your_phone': 'Please input your phone',
  'users.only_number_allowed': 'Only number allowed.',
  'users.please_input_new_password': 'Please input New Password',
  'users.min_8_characters': 'Min 8 characters.',
  'users.password_atleast_8_characters_atleast_1_uppercase_and_atleast_1_digit':
    'Password atleast 8 characters, atleast 1 uppercase and atleast 1 digit.',
  'users.two_passwords_that_you_enter_is_inconsistent_':
    'Two passwords that you enter is inconsistent.',
  'users.welcome_to': 'WELCOME TO',
  'users.please_log_in': 'Please log in',
  'users.you_have_logged_out_automatically':
    'You have been logged out automatically, please continue to proceed.',
  'users.remember_me': 'Remember me',
  'users.forgot_password_': 'Forgot password?',
  'users.login': 'Login',
  'users.login_with_google': 'Sign in with Google',
  'users.login_failed': 'Login Failed',
  'users.go_back_to_home_page': 'Go back to the home page',
  'users.failed_to_connect_to_kledo': 'Failed to connect to Kledo server',
  'users.please_check_your_internet_connection_please_contact_wa':
    'Please check your internet connection. If you still have a problem, please contact via Whatsapp on 6285232300100',
  'network.no_internet_title': 'No internet connection',
  'network.no_internet_description': 'Please check your internet connection, then click Retry.',
  'users.please_input_your_password': 'Please input your password',
  'users.profile': 'Profile',
  'users.reset_password': 'Reset Password',
  'users.request_new_password_reset': 'Request new password reset',
  'users.new_password': 'New Password',
  'users.invalid_password_reset_token': 'Invalid password reset token',
  'users.your_password_reset_token_is_invalid_please_check_it_again_and_reload_the_page':
    'Your password reset token is invalid, please check it again and reload the page',
  'users.users': 'Users',
  'users.information': 'Information',
  'users.information_invitation_email':
    "A invitation email already sent to {email} . Please ask your colleague to follow the instruction in the email to activate the account. If email hasn't received please check the bulk and spam folder.",
  'users.create_kledo_accounts': 'Create Kledo Accounts',
  'users.congratulation_': 'Congratulation!',
  'users.registration_failed': 'Registration Failed',
  'users.your_kledo_account_successfully_created': 'Your Kledo account successfully created.',
  'users.your_username_and_password_already_sent_to_your_email':
    'Your username and password already sent to your email',
  'users.kledo_app_url': 'Kledo App Url',
  'users.kledo_app_url_is_required': 'Kledo App Url is required',
  'users.kledo_app_arl_must_be_at_least_3_characters':
    'Kledo App Url must be at least 3 characters',
  'users.kledo_app_url_cannot_be_longer_than_20_characters':
    'Kledo App Url cannot be longer than 20 characters',
  'users.name_is_required': 'Name is required',
  'users.name_must_be_at_least_5_characters': 'Name must be at least 5 characters',
  'users.name_cannot_be_longer_than_20_characters': 'Name cannot be longer than 20 characters',
  'users.property_name': 'Company Name',
  'users.property_name_is_required': 'Company Name is required',
  'users.property_name_must_be_at_least_5_characters': 'Company Name must be at least 5 characters',
  'users.property_name_cannot_be_longer_than_20_characters':
    'Company Name cannot be longer than 20 characters',
  'users.role_is_required': 'Role is required',
  'users.role_must_be_at_least_3_characters': 'Role must be at least 3 characters',
  'users.role_cannot_be_longer_than_20_characters': 'Role cannot be longer than 20 characters',
  'users.phone_number': 'Phone Number',
  'users.phone_number_is_required': 'Phone Number is required',
  'users.no_phone_number_worng': 'Phone Number worng',
  'users.phone_number_must_be_at_least_5_characters': 'Phone Number must be at least 5 characters',
  'users.phone_number_cannot_be_longer_than_20_characters':
    'Phone Number cannot be longer than 20 characters',
  'users.email_is_required': 'Email is required',
  'users.email_is_not_a_valid_email': 'Email is not a valid email',
  'users.register_now': 'Register Now',
  'users.login_now': 'Login Now',
  'users.domain_value_app_kledo_com_already_used_please_use_another_name':
    'Domain {value}.app.kledo.com already used, please use another name',
  'users.please_contact_hello_kledo_com_for_more_info':
    'Please contact hello@kledo.com for more info.',
  'users.registration_completed': 'Regsitration completed!',
  'users.password_has_been_sent_to_email_sms':
    'Password has been sent to your email and sms, please check it out',
  'users.click_here_to_set_roles': '{clickHere} to set roles.',
  'report.point_of_sale': 'Point Of Sale',
  'report.net_sales_per_product_category': 'Net Sales per Product Category',
  'report.volume_per_product_category': 'Volume per Product Category',
  'report.product_category': 'Product Category',
  'report.gross_sales': 'Gross Sales',
  'report.net_sales': 'Net Sales',
  'report.discount': 'Discount',
  'report.gratuity': 'Gratuity',
  'report.collected': 'collected',
  'report.total_collected': 'Total Collected',
  'report.all_outlets': 'All',
  'report.payment': 'Payment',
  'report.day_of_the_week_sales': 'Day Of The Week Sales',
  'report.sales': 'Sales',
  'report.sales_summary': 'Sales Summary',
  'report.invoice': 'Invoice',
  'report.transactions': 'Transactions',
  'posReport.reports_menu': 'Reports',
  'posReport.omzet': 'Revenue',
  'posReport.all_outlets': 'All Outlets',
  'posReport.outlet': 'Outlet',
  'posReport.invoices': 'invoices',
  'posReport.vs_previous': 'vs previous period',
  'posReport.omzet_per_outlet': 'Revenue per Outlet',
  'posReport.outlet_unit': 'outlets',
  'posReport.summary': 'Summary',
  'posReport.hourly_sales': 'Hourly Sales',
  'posReport.hourly_empty': 'Hourly sales data is not available yet',
  'posReport.empty': 'No revenue in this period yet',
  'posReport.peak': 'Peak',
  'posReport.need_connection': 'Reports require an internet connection',
  'posReport.preset.today': 'Today',
  'posReport.preset.yesterday': 'Yesterday',
  'posReport.preset.7d': '7 Days',
  'posReport.preset.this_month': 'This Month',
  'posReport.card.total_sales': 'Total Sales',
  'posReport.card.total_transactions': 'Total Transactions',
  'posReport.card.total_products': 'Total Products',
  'posReport.card.payment_received': 'Payments Received',
  'posReport.card.refund': 'Refund',
  'posReport.orders.title': 'Order & Invoice Breakdown',
  'posReport.orders.order_open': 'Open Order',
  'posReport.orders.invoice_unpaid': 'Unpaid',
  'posReport.orders.invoice_paid': 'Paid',
  'posReport.orders.remaining': 'Remaining',
  'posReport.orders.unit_order': 'order',
  'posReport.orders.unit_invoice': 'invoice',
  'report.transactions_type': 'Transactions Type',
  'report.choose_transactions_type': 'Choose transactions type',
  'report.buy_sell_price': 'Buy/Sell Price',
  'report.hpp': 'COGS',
  'report.avg_per_transaction': 'Avg. Net Sale Per Transactions',
  'report.name': 'Name',
  'report.volume': 'Volume',
  'report.top_products': 'Top Products',
  'report.pos': 'Pos',
  'report.pos_reports': 'Pos Reports',
  'report.outlets': 'Outlets',
  'financeAccounts.add_account': 'Add Account',
  'financeAccounts.financeAccounts': 'Account',
  'financeAccounts.all_accounts': 'All accounts',
  'financeAccounts.category': 'Category',
  'financeAccounts.select_category': 'Select category',
  'financeAccounts.successfully_added': 'successfully added.',
  'financeAccounts.error_cannot_add': 'Cannot add account.',
  'financeAccounts.error_cannot_update': 'Cannot update account.',
  'financeAccounts.error_cannot_move': 'Cannot move the account.',
  'financeAccounts.error_cannot_change_status': 'Cannot change status the account.',
  'financeAccounts.edit_account': 'Edit Account',
  'financeAccounts.please_input_the_account_name': 'Please input the account name.',
  'financeAccounts.please_input_the_code': 'Please input the code.',
  'financeAccounts.account_name': 'Name',
  'financeAccounts.account_name_note': 'If EN is blank, the system automatically uses ID',
  'financeAccounts.copy_name': 'Copy account name',
  'financeAccounts.name_copied': 'Account name copied',
  'financeAccounts.name_copy_failed': 'Failed to copy account name',
  'financeAccounts.show_archived': 'Show archived accounts',
  'financeAccounts.archive_cascade_note': 'All sub-accounts of this account will also be archived.',
  'financeAccounts.unarchive_cascade_warning':
    'All sub-accounts of this account will also be restored, including sub-accounts that were archived on their own. Each child’s individual archive status will be lost permanently.',
  'financeAccounts.code': 'Code',
  'financeAccounts.desc': 'Description',
  'financeAccounts.please_select_a_category': 'Please select a category.',
  'financeAccounts.max_20_characters': 'Max 20 characters.',
  'financeAccounts.max_100_characters': 'Max 100 characters.',
  'financeAccounts.min_2_characters': 'Min 2 characters.',
  'financeAccounts.balance': 'Balance',
  'financeAccounts.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeAccounts.select_account': 'Select account',
  'financeAccounts.set_conversion_balances': 'Conversion Balances',
  'financeAccounts.error_get_conversion_balances': 'Error check conversion balances',
  'financeAccounts.set_manual_journal': 'Manual Journal',
  'financeAccounts.error_cannot_load_data': 'Cannot load data account.',
  'financeAccounts.all_category': 'All category',
  'financeAccounts.error_cannot_delete': 'Cannot delete account.',
  'financeAccounts.error_cannot_search': 'Cannot search account.',
  'financeAccounts.follow_these_steps_to_import_your_account':
    'Follow these steps to import your account',
  'financeAccounts.1_download_your_account_template_file': '1. Download your account template file',
  'financeAccounts.start_by_downloading_our_account_csv':
    'Start by downloading our accounts Excel template file. This file has the correct column headings Kledo needs to import details of your accounts.',
  'financeAccounts.download_template_file': 'Download Template File',
  'financeAccounts.download_template_data_example_file': 'Download template data example file',
  'financeAccounts.import': 'Import Account',
  'financeAccounts.2_copy_your_account_into_the_template':
    '2. Copy your accounts into the template',
  'financeAccounts.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your accounts. Make sure the product details match the column headings provided in the template.',
  'financeAccounts.important': 'IMPORTANT',
  'financeAccounts.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeAccounts.upload': 'Upload',
  'financeAccounts.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeAccounts.a_maximum_of_500_account_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data.',
  'financeAccounts.import_actions_only_insert_new_account_cannot_update_or_delete':
    'When importing, Kledo creates new accounts. If "Update Duplicate Account Code" is on, accounts with an existing code are updated; if off, those rows fail. No data is deleted.',
  'financeAccounts.update_duplicate_account_code': 'Update Duplicate Account Code',
  'financeAccounts.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeAccounts.account_successfully_imported': '{rowCount} account imported successfully.',
  'financeAccounts.go_to_account_list': 'Go to account list',
  'financeAccounts.sub_account_from': 'Sub Account from',
  'financeClosing.closing': 'Closing',
  'financeClosing.period': 'Period',
  'financeClosing.note': 'Note',
  'financeClosing.profit_loss': 'Profit/Loss',
  'financeClosing.choose_period': 'Choose Period',
  'financeClosing.set_worksheet': 'Set Worksheet',
  'financeClosing.worksheet': 'Worksheet',
  'financeClosing.done': 'Done',
  'financeClosing.please_select_period': 'Please select closing period',
  'financeClosing.please_select_date': 'Please select date',
  'financeClosing.please_select_account': 'Please select account',
  'financeClosing.closing_report': 'Closing Report',
  'financeClosing.closing_period_to_has_been_saved': 'Closing period {from} to {to} has been saved',
  'financeClosing.period_from_to': 'Period: {from} - {to}',
  'financeClosing.see_closing_report': 'See Closing Report',
  'financeClosing.error_get_start_date': 'Cannot get start date',
  'financeClosing.error_get_closing_data': 'Cannot get closing data',
  'financeClosing.error_create_closing_data': 'Cannot create closing data',
  'financeClosing.error_delete_closing_data': 'Cannot delete closing data',
  'financeClosing.debit': 'Debit',
  'financeClosing.credit': 'Credit',
  'financeClosing.net_profit_loss': 'Net Profit/Loss',
  'financeClosing.tax_expense': 'Tax Expense',
  'financeClosing.tax_expense_account': 'Tax Expense Account',
  'financeClosing.tax_payable_account': 'Tax Payable Account',
  'financeClosing.tax_amount': 'Tax Amount',
  'financeClosing.tax_percent': 'Tax Percentage',
  'financeClosing.net_profit_loss_after_tax': 'Net Profit/Loss After Tax',
  'financeClosing.retained_earnings_account': 'Retained Earnings Account',
  'financeClosing.tax_cannot_be_negative': 'Cannot be negative',
  'financeClosing.tax_cannot_fill_when_loss':
    'Tax cannot be filled when net profit/loss is negative',
  'financeClosing.early_period': 'Early Period',
  'financeContacts.paid_status': 'Paid Status',
  'financeContacts.transaction_number': 'Transaction Number',
  'financeContacts.payment_note': 'Payment Note',
  'financeContacts.payment_account_code': 'Payment Account Code',
  'financeContacts.photo': 'Photo',
  'financeContacts.show_photo': 'Show Photo',
  'financeContacts.hide_photo': 'Hide Photo',
  'financeContacts.add_contact': 'Add Contact',
  'financeContacts.financeContacts': 'Contact',
  'financeContacts.contact_type': 'Contact Type',
  'financeContacts.select_contact_type': 'Select contact type',
  'financeContacts.error_cannot_add': 'Cannot add contact.',
  'financeContacts.error_cannot_update': 'Cannot update contact.',
  'financeContacts.edit_contact': 'Edit Contact',
  'financeContacts.please_input_the_contact_name': 'Please input the contact name.',
  'financeContacts.please_select_a_contact_type': 'Please select a contact type.',
  'financeContacts.please_select_a_required_contact_type':
    'The contact type {contacts} must be selected.',
  'financeContacts.please_select_a_contact_type_with_minimal':
    'Please select the type of contact, at least 1 type of contact.',
  'financeContacts.contact_group': 'Contact Group',
  'financeContacts.please_select_a_contact_group': 'Please select a contact group.',
  'financeContacts.contact_name': 'Name',
  'financeContacts.max_characters': 'Max {value} characters.',
  'financeContacts.min_characters': 'Min {value} characters.',
  'financeContacts.balance': 'Balance',
  'financeContacts.company': 'Company',
  'financeContacts.address': 'Address',
  'financeContacts.email': 'Email',
  'financeContacts.add_email': 'Add Email',
  'financeContacts.alternative_email': 'Alternative Email',
  'financeContacts.email_cannot_be_the_same': 'Email cannot be the same',
  'financeContacts.phone': 'Phone',
  'financeContacts.secondary_phone': 'Secondary phone',
  'financeContacts.npwp': 'Tax Number',
  'financeContacts.only_number_allowed': 'Only number allowed.',
  'financeContacts.invalid_email_address_format': 'Invalid email address format.',
  'financeContacts.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeContacts.all_contact_type': 'All contact type',
  'financeContacts.error_cannot_search': 'Cannot search contact.',
  'financeContacts.group': 'Group',
  'financeContacts.all_group': 'All Group',
  'financeContacts.add_group': 'Add Group',
  'financeContacts.edit_group': 'Edit Group',
  'financeContacts.delete_group': 'Delete Group',
  'financeContacts.only_group_that_not_assigned_in_contact_could_be_deleted':
    'Note: Only group that not assigned in contact could be deleted.',
  'financeContacts.billing_address': 'Billing Address',
  'financeContacts.shipping_address': 'Shipping Address',
  'financeContacts.account_mapping': 'Account Mapping',
  'financeContacts.section.profile': 'Contact Profile',
  'financeContacts.section.additional_contact': 'Additional Contact Details',
  'financeContacts.section.tax_legal': 'Tax & Legal Identity',
  'financeContacts.section.operating_hours': 'Operating Hours',
  'financeContacts.section.custom_columns': 'Custom Fields',
  'financeContacts.section.additional_info': 'Additional Information',
  'financeContacts.show_phone_detail': 'Show phone details',
  'financeContacts.hide_phone_detail': 'Hide phone details',
  'financeContacts.show_account_mapping': 'Show account mapping',
  'financeContacts.hide_account_mapping': 'Hide account mapping',
  'financeContacts.payable_account': 'Payable Account',
  'financeContacts.receivable_account': 'Receivable Account',
  'financeContacts.transactions': 'Transactions',
  'financeContacts.successfully_deleted': 'successfully deleted.',
  'financeContacts.successfully_added': 'successfully added.',
  'financeContacts.error_cannot_delete': 'Cannot delete contact group.',
  'financeContacts.error_cannot_add_group': 'Cannot add contact group.',
  'financeContacts.error_cannot_update_group': 'Cannot update contact group.',
  'financeContacts.error_cannot_move': 'Cannot move the contact group.',
  'financeContacts.error_cannot_change_status': 'Cannot change status the contact group.',
  'financeContacts.error_cannot_load_can_be_deleted_group': 'Cannot load contact group.',
  'financeContacts.follow_these_steps_to_import_your_contact':
    'Follow these steps to import your contact',
  'financeContacts.1_download_your_contact_template_file': '1. Download your contact template file',
  'financeContacts.start_by_downloading_our_contact_csv':
    'Start by downloading our contacts Excel template file. This file has the correct column headings Kledo needs to import details of your contacts.',
  'financeContacts.download_template_file': 'Download Template File',
  'financeContacts.download_template_data_example_file': 'Download template data example file',
  'financeContacts.import': 'Import Contact',
  'financeContacts.2_copy_your_contact_into_the_template':
    '2. Copy your contacts into the template',
  'financeContacts.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your contacts. Make sure the contacts details match the column headings provided in the template.',
  'financeContacts.important': 'IMPORTANT',
  'financeContacts.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeContacts.upload': 'Upload',
  'financeContacts.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeContacts.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeContacts.a_maximum_of_1000_contact_can_be_imported_at_a_time':
    'A maximum of 1.000 contacts can be imported at a time.',
  'financeContacts.a_maximum_of_3000_contact_transactions_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data. Every row is counted, including contact transaction rows and item rows.',
  'financeContacts.import_benefit_with_update':
    'You can also use the imported file to update all your contacts, saving time and effort over updating contacts one by one through the browser.',
  'financeContacts.warning_update_contact_using_import':
    'The import process will use the contact name, company, and contact type to determine whether a contact already exists in Kledo or not, if the contact already exists, the contact will be updated, whereas if the contact does not exist, a new contact will be created. Contacts will not be deleted, so you can safely update only some of your contacts without worrying about losing data on other contacts.',
  'financeContacts.contact_successfully_imported': '{rowCount} contact imported successfully.',
  'financeContacts.go_to_contact_list': 'Go to contact list',
  'financeContacts.mass_delete_info':
    '**Contact that have a transaction cannot be deleted, can only be archived',
  'financeContacts.want_to_use_this_contact': 'Would like to use this contact ?',
  'financeContacts.are_you_sure_to_archive': 'Are you sure to archive this contact?',
  'financeContacts.are_you_sure_to_unarchive': 'Are you sure to unarchive this contact?',
  'financeContacts.your_net_debt': 'Your net debt',
  'financeContacts.you_owe': 'You owe',
  'financeContacts.they_owe': 'They owe',
  'financeContacts.payment_received': 'Payment received',
  'financeContacts.your_due_debt': 'Your due debt',
  'financeContacts.their_due_debt': 'Their due debt',
  'financeContacts.payment_sent': 'Payment sent',
  'financeContacts.awaiting_payment': 'Awaiting payments',
  'financeContacts.debt_you_need_to_pay': 'Debt you need to pay',
  'financeContacts.money_in_out': 'Money In Out',
  'financeContacts.money_in': 'Money In',
  'financeContacts.money_out': 'Money Out',
  'financeContacts.bank_accounts': 'Bank Accounts',
  'financeContacts.bank': 'Bank',
  'financeContacts.branch': 'Branch',
  'financeContacts.holder_name': 'Holder Name',
  'financeContacts.account_number': 'Account Number',
  'financeContacts.required': 'Required',
  'financeContacts.select_shipping_address': 'Select Shipping Address',
  'financeContacts.revert_to_default_address': 'Revert to default address',
  'financeContacts.max_payable': 'Max Payable',
  'financeContacts.total_payable_is_calculated_from_purchase_invoices':
    'Total payable is calculated from purchase invoices, transaction costs and accounts payable. If the total debt exceeds the maximum, then when creating a new purchase invoice it will be rejected.',
  'financeContacts.max_receivable': 'Max Receivable',
  'financeContacts.total_accounts_receivable_is_calculated_from_sales_invoices':
    'Total accounts receivable is calculated from sales invoices and accounts receivable contacts. If the total receivable exceeds the maximum, then when creating a new sales invoice it will be rejected.',
  'financeContacts.country': 'Country',
  'financeContacts.province': 'Province',
  'financeContacts.city': 'City',
  'financeContacts.district': 'District',
  'financeContacts.village': 'Village',
  'financeContacts.postal_code': 'Postal Code',
  'financeContacts.postal_code_invalid': 'Please enter a valid 5-digit postal code',
  'financeContacts.latitude': 'Latitude',
  'financeContacts.latitude_invalid': 'Please enter a valid latitude (-90 to 90)',
  'financeContacts.latitude_placeholder': 'e.g., -6.2088',
  'financeContacts.longitude': 'Longitude',
  'financeContacts.longitude_invalid': 'Please enter a valid longitude (-180 to 180)',
  'financeContacts.longitude_placeholder': 'e.g., 106.8456',
  'financeContacts.id_card_type': 'ID Card Type',
  'financeContacts.id_card_number': 'ID Card Number',
  'financeContacts.please_select_id_card_type': 'Please select a ID card type',
  'financeExpenseTerms.delete_expenseTerm': 'Delete Expense Term',
  'financeExpenseTerms.are_you_sure_delete': 'Are you sure to delete?',
  'financeExpenseTerms.select_expenseTerm': 'Select an Expense Term',
  'financeExpenseTerms.please_select_expenseTerm_to_delete':
    'Please select an Expense Term to delete',
  'financeExpenseTerms.add_expenseTerm': 'Add Expense Term',
  'financeExpenseTerms.financeExpenseTerms': 'Expense Term',
  'financeExpenseTerms.successfully_deleted': 'successfully deleted.',
  'financeExpenseTerms.successfully_added': 'successfully added.',
  'financeExpenseTerms.error_cannot_delete': 'Cannot delete expense term.',
  'financeExpenseTerms.error_cannot_add': 'Cannot add expense term.',
  'financeExpenseTerms.error_cannot_update': 'Cannot update expense term.',
  'financeExpenseTerms.error_cannot_move': 'Cannot move the expense term.',
  'financeExpenseTerms.error_cannot_change_status': 'Cannot change status the expense term.',
  'financeExpenseTerms.edit_expenseTerm': 'Edit Expense Term',
  'financeExpenseTerms.please_input_the_expenseTerm_name': 'Please input the expense term name.',
  'financeExpenseTerms.please_input_the_days': 'Please input the days.',
  'financeExpenseTerms.expenseTerm_name': 'Name',
  'financeExpenseTerms.length': 'Length',
  'financeExpenseTerms.days': 'Days',
  'financeExpenseTerms.max_characters': 'Max {value} characters.',
  'financeExpenseTerms.min_characters': 'Min {value} characters.',
  'financeExpenseTerms.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeExpenseTerms.only_number_allowed': 'Only number allowed.',
  'financeExpenseTerms.only_0_-_1000_allowed': 'Only 0 - 1000 allowed',
  'financeExpenseTerms.only_0_-_10000_allowed': 'Only 0 - 10.000 allowed',
  'financeExpenseTerms.must_have_active_termin': 'Must have at least one active term.',
  'financeTaxes.add_tax': 'Add Tax',
  'financeTaxes.financeTaxes': 'Tax',
  'financeTaxes.successfully_added': 'successfully added.',
  'financeTaxes.error_cannot_add': 'Cannot add tax.',
  'financeTaxes.error_cannot_update': 'Cannot update tax.',
  'financeTaxes.error_cannot_move': 'Cannot move the tax.',
  'financeTaxes.error_cannot_change_status': 'Cannot change status the tax.',
  'financeTaxes.edit_tax': 'Edit Tax Term',
  'financeTaxes.please_input_the_tax_name': 'Please input the tax name.',
  'financeTaxes.please_input_the_effective_rates': 'Please input the effective rate.',
  'financeTaxes.please_select_a_sell_tax_account': 'Please select a sell tax account.',
  'financeTaxes.please_select_a_buy_tax_account': 'Please select a buy tax account.',
  'financeTaxes.select_buy_tax_account': 'Select buy tax account',
  'financeTaxes.select_sell_tax_account': 'Select sell tax account',
  'financeTaxes.tax_name': 'Name',
  'financeTaxes.effective_rates': 'Effective Rate',
  'financeTaxes.is_withholding': 'With Holding',
  'financeTaxes.buy_tax_account': 'Buy Tax Account',
  'financeTaxes.sell_tax_account': 'Sell Tax Account',
  'financeTaxes.max_characters': 'Max {value} characters.',
  'financeTaxes.min_characters': 'Min {value} characters.',
  'financeTaxes.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeTaxes.only_number_allowed': 'Only number allowed.',
  'financeTaxes.effective_rate_%': 'Effective Rate %',
  'financeTaxes.must_have_active_tax': 'Must have at least one active tax.',
  'financeTaxes.witholding': 'Witholding',
  'financeTaxes.error_cannot_load_data_detail': 'Cannot load data detail tax.',
  'financeTaxes.delete_tax': 'Delete Tax',
  'financeTaxes.are_you_sure_delete': 'Are you sure to delete?',
  'financeTaxes.select_tax': 'Select a Tax',
  'financeTaxes.please_select_tax_to_delete': 'Please select a Tax to delete',
  'financeTaxes.successfully_deleted': 'successfully deleted.',
  'financeTaxes.error_cannot_delete': 'Cannot delete tax.',
  'financeTaxes.manually_edit_tax_amount_allowed': 'Manually edit tax amount allowed',
  'financeTaxes.allow_manual': 'Allow manual',
  'financeTaxes.compound': 'Compound',
  'financeTaxes.compound_help_text':
    'Double tax will be applied to the total after the previous tax has been applied. By tax order.',
  'financeTaxes.tax_type': 'Tax Type',
  'financeTaxes.one': 'One',
  'financeTaxes.consist_of': 'Consist of',
  'financeTaxes.consist_of_is_required': 'Minimum 1 selected tax.',
  'financeTaxes.effective_percentage': 'Effective Percentage',
  'financeTaxes.error_effective_percentage': 'Unable to get effective percentage',
  'financeTaxes.tax_group': 'Tax Group',
  'financeUnits.error_cannot_move': 'Cannot move unit',
  'financeUnits.name': 'Name',
  'financeUnits.max_characters': 'Max {value} characters.',
  'financeUnits.min_characters': 'Min {value} characters.',
  'financeUnits.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeUnits.please_input_the_unit_name': 'Please input the tax name.',
  'financeUnits.error_cannot_add': 'Cannot add unit.',
  'financeUnits.error_cannot_update': 'Cannot update unit.',
  'financeUnits.error_cannot_delete': 'Cannot delete unit.',
  'financeUnits.please_select_unit_to_delete': 'Please select a Unit to delete',
  'financeUnits.select_unit': 'Select a Unit',
  'financeUnits.unit': 'Unit',
  'financeExpenses.add_expense': 'Add Expense',
  'financeExpenses.financeExpenses': 'Expense',
  'financeExpenses.successfully_added': 'successfully added.',
  'financeExpenses.error_cannot_add': 'Cannot add expense.',
  'financeExpenses.create_expense': 'Create Expense',
  'financeExpenses.related_invoice': 'Invoice Number',
  'financeExpenses.related_purchase_invoice': 'Purchase Invoice Number',
  'financeExpenses.related_transaction': 'Related Transactions',
  'financeExpenses.error_cannot_update': 'Cannot update expense.',
  'financeExpenses.error_cannot_move': 'Cannot move the expense.',
  'financeExpenses.error_cannot_change_status': 'Cannot change status the expense.',
  'financeExpenses.edit_expense': 'Edit Expense',
  'financeExpenses.please_input_the_expense_name': 'Please input the expense name.',
  'financeExpenses.please_input_the_effective_rates': 'Please input the effective rate.',
  'financeExpenses.please_select_a_sell_expense_account': 'Please select a sell expense account.',
  'financeExpenses.please_select_a_buy_expense_account': 'Please select a buy expense account.',
  'financeExpenses.select_buy_expense_account': 'Select buy expense account',
  'financeExpenses.select_sell_expense_account': 'Select sell expense account',
  'financeExpenses.expense_name': 'Name',
  'financeExpenses.effective_rates': 'Effective Rate',
  'financeExpenses.is_withholding': 'With Holding',
  'financeExpenses.buy_expense_account': 'Buy expense account',
  'financeExpenses.sell_expense_account': 'Sell expense account',
  'financeExpenses.max_characters': 'Max {value} characters.',
  'financeExpenses.min_characters': 'Min {value} characters.',
  'financeExpenses.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeExpenses.only_number_allowed': 'Only number allowed.',
  'financeExpenses.expense_account': 'Expense Account',
  'financeExpenses.select_expense_account': 'Select account',
  'financeExpenses.description': 'Description',
  'financeExpenses.tax': 'Tax',
  'financeExpenses.select_tax': 'Select tax',
  'financeExpenses.amount': 'Amount',
  'financeExpenses.pay_from': 'Pay From',
  'financeExpenses.please_select_a_pay_from': 'Please select a pay from',
  'financeExpenses.select_pay_from': 'Select pay from',
  'financeExpenses.pay_later': 'Pay Later',
  'financeExpenses.please_activate_pay_later': 'Please activate pay later',
  'financeExpenses.benefeciary': 'Benefeciary',
  'financeExpenses.please_select_a_benefeciary': 'Please select a benefeciary',
  'financeExpenses.select_benefeciary': 'Select benefeciary',
  'financeExpenses.add_contact': 'Add contact',
  'financeExpenses.all_contacts': 'All contact',
  'financeExpenses.contact_filter_show': 'Show',
  'financeExpenses.contact_filter_all': 'All',
  'financeExpenses.contact_filter_employee': 'Employee',
  'financeExpenses.contact_filter_vendor': 'Vendor',
  'financeExpenses.transaction_date': 'Transaction Date',
  'financeExpenses.please_select_transaction_date': 'Please select transaction date',
  'financeExpenses.due_date': 'Due Date',
  'financeExpenses.please_select_due_date': 'Please select due date',
  'financeExpenses.term': 'Term',
  'financeExpenses.select_term': 'Select term',
  'financeExpenses.add_term': 'Add term',
  'financeExpenses.price_include_tax': 'Price include tax',
  'financeExpenses.add_more': 'Add more',
  'financeExpenses.payment_method': 'Payment Method',
  'financeExpenses.please_select_a_payment_method': 'Please select a payment method',
  'financeExpenses.select_payment_method': 'Select payment method',
  'financeExpenses.number': 'Number',
  'financeExpenses.please_input_the_number': 'Please input the number.',
  'financeExpenses.memo': 'Memo',
  'financeExpenses.date': 'Date',
  'financeExpenses.category': 'Category',
  'financeExpenses.status': 'Status',
  'financeExpenses.balance_due': 'Balance Due',
  'financeExpenses.total': 'Total',
  'financeExpenses.please_select_a_term': 'Please select a term.',
  'financeExpenses.search_by_memo': 'Search',
  'financeExpenses.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financeExpenses.detail_title': '{status} Expense',
  'financeExpenses.pay_bill': 'Pay Bill',
  'financeExpenses.detail_expense': 'Detail Expense',
  'financeExpenses.total_amount_must_greater_than_total_payment':
    'Total amount must greater than or equal to total payment.',
  'financeExpenses.all': 'All',
  'financeExpenses.unpaid': 'Unpaid',
  'financeExpenses.partial': 'Partial',
  'financeExpenses.closed': 'Closed',
  'financeExpenses.follow_these_steps_to_import_your_expenses':
    'Follow these steps to import your expenses',
  'financeExpenses.1_download_your_expenses_template_file':
    '1. Download your expenses template file',
  'financeExpenses.start_by_downloading_our_expenses_csv':
    'Start by downloading our expenses Excel template file. This file has the correct column headings Kledo needs to import details of your expenses.',
  'financeExpenses.download_template_file': 'Download Template File',
  'financeExpenses.download_template_data_example_file': 'Download template data example file',
  'financeExpenses.import': 'Import Expenses',
  'financeExpenses.2_copy_your_expenses_into_the_template':
    '2. Copy your expenses into the template',
  'financeExpenses.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your expenses. Make sure the product details match the column headings provided in the template.',
  'financeExpenses.important': 'IMPORTANT',
  'financeExpenses.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeExpenses.upload': 'Upload',
  'financeExpenses.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeExpenses.a_maximum_of_500_expenses_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data. Every row is counted, including expense rows and item rows.',
  'financeExpenses.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Contact name that not exist will be inserted as a new contact.',
  'financeExpenses.import_actions_only_insert_new_expenses_cannot_update_or_delete':
    'Import actions only insert new data, cannot update nor delete.',
  'financeExpenses.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeExpenses.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financeExpenses.upload_file': 'Upload File',
  'financeExpenses.check_the_imported_data': 'Check Data',
  'financeExpenses.please_check_the_imported_data': 'Please check the imported data',
  'financeExpenses.import_expenses_done': 'Import Success',
  'financeExpenses.error_upload_file': 'Upload failed.',
  'financeExpenses.file_not_found': 'File not found',
  'financeExpenses.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'financeExpenses.contact_name': 'Contact name',
  'financeExpenses.email': 'Email',
  'financeExpenses.address': 'Address',
  'financeExpenses.phone': 'Phone',
  'financeExpenses.expense_date': 'Expense Date',
  'financeExpenses.expense_number': 'Expense Number',
  'financeExpenses.reference': 'Reference',
  'financeExpenses.account_code': 'Account Code',
  'financeExpenses.tax_inclusive': 'Tax Inclusive',
  'financeExpenses.paid': 'Paid',
  'financeExpenses.paid_account': 'Paid To Account',
  'financeExpenses.row_imported': '{imported} of {total} rows imported',
  'financeExpenses.expenses_successfully_imported': '{rowCount} expense imported successfully.',
  'financeExpenses.view_detail': 'View detail',
  'financeExpenses.import_another_file': 'Import another file',
  'financeExpenses.go_to_expenses_list': 'Go to expense list',
  'financeExpenses.success': 'Success',
  'financeExpenses.failed': 'Failed',
  'financeExpenses.error_cannot_import': 'Import failed',
  'financeExpenses.error': 'Error',
  'financeExpenses.import_expenses_in_progress': 'Import in progress',
  'financeExpenses.import_expenses_is_still_in_progress': 'Import is still in progress',
  'financeExpenses.its_ok_to_close_this_page':
    "It's OK to close this page or import another file. When import done, you will be notified via email.",
  'financePurchaseOrders.message': 'Message',
  'financePurchaseOrders.show_message': 'Show Message',
  'financePurchaseOrders.hide_message': 'Hide Message',
  'financePurchaseOrders.show_attachment': 'Show Attachment',
  'financePurchaseOrders.hide_attachment': 'Hide Attachment',
  'financePurchaseOrders.account': 'Account',
  'financePurchaseOrders.debit': 'Debit',
  'financePurchaseOrders.credit': 'Credit',
  'financePurchaseOrders.journal_report': 'Journal Report',
  'financePurchaseOrders.add_purchaseorder': 'Add Purchase Order',
  'financePurchaseOrders.financePurchaseOrders': 'Purchase Order',
  'financePurchaseOrders.successfully_added': 'successfully added.',
  'financePurchaseOrders.error_cannot_add': 'Cannot add purchase order.',
  'financePurchaseOrders.error_cannot_print_pdf': 'Cannot print pdf purchase order.',
  'financePurchaseOrders.error_cannot_update': 'Cannot update purchase order.',
  'financePurchaseOrders.error_cannot_move': 'Cannot move the purchase order.',
  'financePurchaseOrders.error_cannot_change_status': 'Cannot change status the purchase order.',
  'financePurchaseOrders.edit_purchaseorder': 'Edit Purchase Order',
  'financePurchaseOrders.max_characters': 'Max {value} characters.',
  'financePurchaseOrders.min_characters': 'Min {value} characters.',
  'financePurchaseOrders.only_number_allowed': 'Only number allowed.',
  'financePurchaseOrders.description': 'Description',
  'financePurchaseOrders.tax': 'Tax',
  'financePurchaseOrders.dpp': 'DPP',
  'financePurchaseOrders.select_tax': 'Select tax',
  'financePurchaseOrders.amount': 'Amount',
  'financePurchaseOrders.please_select_a_contact': 'Please select a contact',
  'financePurchaseOrders.select_contact': 'Select contact',
  'financePurchaseOrders.add_contact': 'Add contact',
  'financePurchaseOrders.all_contacts': 'All contact',
  'financePurchaseOrders.transaction_date': 'Transaction Date',
  'financePurchaseOrders.please_select_transaction_date': 'Please select transaction date',
  'financePurchaseOrders.due_date': 'Due Date',
  'financePurchaseOrders.please_select_due_date': 'Please select due date',
  'financePurchaseOrders.term': 'Term',
  'financePurchaseOrders.select_term': 'Select term',
  'financePurchaseOrders.add_term': 'Add term',
  'financePurchaseOrders.price_include_tax': 'Price include tax',
  'financePurchaseOrders.auto_add_item': 'Auto add row',
  'financePurchaseOrders.add_more': 'Add more',
  'financePurchaseOrders.number': 'Number',
  'financePurchaseOrders.import_quote_number': 'Purchase Quote Number',
  'financePurchaseOrders.please_input_the_number': 'Please input the number.',
  'financePurchaseOrders.memo': 'Memo',
  'financePurchaseOrders.date': 'Date',
  'financePurchaseOrders.status': 'Status',
  'financePurchaseOrders.balance_due': 'Balance Due',
  'financePurchaseOrders.please_select_a_term': 'Please select a term.',
  'financePurchaseOrders.search_by_memo': 'Search',
  'financePurchaseOrders.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financePurchaseOrders.detail_title': 'Purchase Order {number}',
  'financePurchaseOrders.vendor': 'Vendor',
  'financePurchaseOrders.reference': 'Reference',
  'financePurchaseOrders.product': 'Product',
  'financePurchaseOrders.qty': 'Qty',
  'financePurchaseOrders.unit': 'Unit',
  'financePurchaseOrders.price': 'Price',
  'financePurchaseOrders.add_product': 'Add Product',
  'financePurchaseOrders.select_product': 'Select product',
  'financePurchaseOrders.attachments': 'Attachments',
  'financePurchaseOrders.save_&_approve': 'Save & approve',
  'financePurchaseOrders.save_&_approve_add_new': 'Save & approve & Add New',
  'financePurchaseOrders.save_as_draft': 'Save as draft',
  'financePurchaseOrders.save_as_draft_add_new': 'Save as draft & Add New',
  'financePurchaseOrders.save_&_submit_for_approval': 'Save & submit for approval',
  'financePurchaseOrders.save_&_submit_for_approval_add_new':
    'Save & submit for approval & Add New',
  'financePurchaseOrders.please_select_a_product': 'Please select a product.',
  'financePurchaseOrders.please_input_the_qty': 'Please input the qty.',
  'financePurchaseOrders.please_input_the_price': 'Please input the price.',
  'financePurchaseOrders.please_input_the_amount': 'Please input the amount.',
  'financePurchaseOrders.approve': 'Approve',
  'financePurchaseOrders.are_you_sure_to_approve': 'Are you sure to approve ?',
  'financePurchaseOrders.submit_for_approval': 'Submit for approval',
  'financePurchaseOrders.are_you_sure_to_submit_for_approval':
    'Are you sure to submit for approval ?',
  'financePurchaseOrders.create_invoice': 'Create Invoice',
  'financePurchaseOrders.must_greater_than_0': 'Must greater than 0.',
  'financePurchaseOrders.must_be_smaller_than_bill': 'Must be smaller than bill.',
  'financePurchaseOrders.follow_these_steps_to_import_your_purchase_orders':
    'Follow these steps to import your purchase orders',
  'financePurchaseOrders.1_download_your_purchase_orders_template_file':
    '1. Download your purchase orders template file',
  'financePurchaseOrders.start_by_downloading_our_purchase_orders_csv':
    'Start by downloading our purchase orders Excel template file. This file has the correct column headings Kledo needs to import details of your orders.',
  'financePurchaseOrders.download_template_file': 'Download Template File',
  'financePurchaseOrders.download_template_data_example_file':
    'Download template data example file',
  'financePurchaseOrders.import': 'Import Purchase Orders',
  'financePurchaseOrders.2_copy_your_purchase_orders_into_the_template':
    '2. Copy your purchase orders into the template',
  'financePurchaseOrders.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your purchase orders. Make sure the product details match the column headings provided in the template.',
  'financePurchaseOrders.important': 'IMPORTANT',
  'financePurchaseOrders.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financePurchaseOrders.upload': 'Upload',
  'financePurchaseOrders.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financePurchaseOrders.a_maximum_of_500_purchase_orders_can_be_imported_at_a_time':
    'A single import supports up to 2.500 rows of Excel data. Every row is counted, including purchase order rows and item rows.',
  'financePurchaseOrders.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Contact name that not exist will be inserted as a new contact.',
  'financePurchaseOrders.import_actions_only_insert_new_purchase_orders_cannot_update_or_delete':
    'Import actions only insert new purchase orders, cannot update nor delete.',
  'financePurchaseOrders.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financePurchaseOrders.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financePurchaseOrders.upload_file': 'Upload File',
  'financePurchaseOrders.check_the_imported_data': 'Check Data',
  'financePurchaseOrders.please_check_the_imported_data': 'Please check the imported data',
  'financePurchaseOrders.import_purchase_orders_done': 'Import Success',
  'financePurchaseOrders.error_upload_file': 'Upload failed.',
  'financePurchaseOrders.file_not_found': 'File not found',
  'financePurchaseOrders.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'financePurchaseOrders.valid': 'Valid',
  'financePurchaseOrders.invalid': 'Invalid',
  'financePurchaseOrders.total': 'Total',
  'financePurchaseOrders.import_now': 'Import Now',
  'financePurchaseOrders.contact_name': 'Contact name',
  'financePurchaseOrders.email': 'Email',
  'financePurchaseOrders.address': 'Address',
  'financePurchaseOrders.phone': 'Phone',
  'financePurchaseOrders.purchase_order_date': 'Purchase Order Date',
  'financePurchaseOrders.purchase_order_number': 'Purchase Order Number',
  'financePurchaseOrders.product_name': 'Product name',
  'financePurchaseOrders.code_sku': 'Kode/SKU',
  'financePurchaseOrders.tax_inclusive': 'Tax Inclusive',
  'financePurchaseOrders.inventory_account': 'Inventory Account',
  'financePurchaseOrders.purchase_orders_successfully_imported':
    '{rowCount} pesanan pembelian imported successfully.',
  'financePurchaseOrders.view_detail': 'View detail',
  'financePurchaseOrders.import_another_file': 'Import another file',
  'financePurchaseOrders.go_to_purchase_order_list': 'Go to purchase order list',
  'financePurchaseOrders.success': 'Success',
  'financePurchaseOrders.failed': 'Failed',
  'financePurchaseOrders.error_cannot_import': 'Import failed',
  'financePurchaseOrders.error': 'Error',
  'financePurchaseOrders.tax_manual': 'Manual Tax',
  'financePurchaseOrders.tax_manual_must_less_than_amount': 'Manual tax must less than amount.',
  'financePurchaseOrders.discount': 'Discount',
  'financePurchaseOrders.additional_discount': 'Additional Discount',
  'financePurchaseOrders.discount_per_item': 'Discount per item',
  'financePurchaseOrders.total_discount': 'Total Discount',
  'financePurchaseOrders.total_cannot_be_negative': 'Due cannot be negative.',
  'financePurchaseOrders.product_not_found': 'Product not found',
  'financePurchaseOrders.product_has_been_added': 'Product has been added',
  'financePurchaseOrders.discount_per_quantity': 'Discount per quantity',
  'financePurchaseOrders.discount_type': 'Discount type',
  'salesCommission.sales_commission': 'Sales Commission',
  'salesCommission.commission': 'Commission',
  'salesCommission.commission_required': 'Commission is required',
  'salesCommission.commission_name': 'Commission Name',
  'salesCommission.commission_name_required': 'Commission Name is required',
  'salesCommission.commission_amount_by': 'Commission Amount By',
  'salesCommission.commission_amount': 'Commission Amount',
  'salesCommission.target_amount': 'Turnover Target',
  'salesCommission.target_amount_required': 'Turnover Target is required',
  'salesCommission.min_transaction_per_month': 'Minimum transaction per month',
  'salesCommission.min_transaction_per_month_required': 'Minimum transaction is required',
  'salesCommission.cannot_get_commission_type': 'Cannot get commission type',
  'salesCommission.cannot_get_commission': 'Cannot get commission',
  'salesCommission.sales_person_required': 'Sales person is required',
  'salesCommission.all_sales': 'All Sales',
  'salesCommission.not_due_only':
    'Commission is only for transactions whose payment is not past due',
  'salesCommission.not_due_only_desc':
    'Sales transactions that are due will not be calculated as a commission',
  'salesCommission.invalid_format_commission_amount': 'Invalid format commission amount.',
  'salesCommission.commission_is_only_for_transactions_that_have_been_paid':
    'Commission is only for transactions that have been paid',
  'salesCommission.commission_is_only_for_transactions_that_have_been_paid_desc':
    'Unpaid bills are not counted as commissions.',
  'salesCommission.commission_type_id_help_text_1':
    'If based on "{commissionTypeName}", then the commission is calculated based on the number of sales transactions each month. For example, one sales person makes 5 invoices. Then the sales are counted as having made 5 transactions.',
  'salesCommission.commission_type_id_help_text_2':
    'If based on "{commissionTypeName}", then the commission is calculated based on the nominal sales money in rupiah. For example, a salesperson makes 5 invoices, with a total bill of Rp. 5 million. Then the sales are calculated to have made a nominal sales of IDR 5 million.',
  'salesCommission.commission_type_id_help_text_3':
    'If based on "{commissionTypeName}", then the commission is calculated based on the total quantity of products sold. For example, a sales person makes 5 invoices, where each invoice sells 100 products. Then the sales are calculated to have sold 500 pcs of products.',
  'salesCommission.commission_type_id_help_text_4':
    'If based on "{commissionTypeName}", then the commission is only calculated from the sales amount that exceeds the minimum target, not from the total sales amount. For example, a minimum target of IDR 1 million with a 5% commission. Then, in that month, the sales person books a sales amount of IDR 1.2 million, so the commission earned is 5% x (IDR 1.2 million - IDR 1 million) = IDR 10 thousand. If the sales amount has not reached the target, the commission is IDR 0.',
  'salesCommission.commission_type_id_help_text_5':
    'If based on "{commissionTypeName}", then the commission is calculated based on the sales amount accumulated over one calendar quarter (Jan-Mar, Apr-Jun, Jul-Sep, Oct-Dec), not per month.',
  'priceRule.price_rule': 'Price Rule',
  'priceRule.rule_name': 'Rule Name',
  'priceRule.rule_name_required': 'Rule name is required',
  'priceRule.discount': 'Discount',
  'priceRule.discount_required': 'Discount is required',
  'priceRule.min_buy': 'Applies if the customer purchases with:',
  'priceRule.min_qty': 'Minimal Quantity',
  'priceRule.min_qty_required': 'Minimal buy is required',
  'priceRule.min_qty_tooltip':
    'What is the minimum quantity of products a customer must purchase for the discount to apply?',
  'priceRule.min_qty_mode':
    'Calculate minimum quantity from the combined total of all products (not per product)',
  'priceRule.min_qty_mode_tooltip':
    'When checked, the minimum quantity is counted from the combined total of all products in one transaction (mix of different products allowed), not per product. A nominal discount or markup applies per unit to every product that meets the rule, not once per transaction.',
  'priceRule.min_qty_mode_tooltip_list':
    'The minimum quantity is counted from the combined total of all products in one transaction (mix of different products allowed), not per product.',
  'priceRule.min_qty_mode_label': 'Combined',
  'priceRule.min_qty_mode_product_required':
    'Select a specific category or {product} because the minimum quantity is calculated from the combined total.',
  'priceRule.customer_scope_desc': 'Choose which {customer} are eligible for this price rule.',
  'priceRule.product_scope_desc': 'Choose which {product} this price rule applies to.',
  'priceRule.outlet_scope_desc': 'Choose which POS outlets this price rule applies to.',
  'priceRule.ojol_scope_desc': 'Choose which online delivery services this price rule applies to.',
  'priceRule.min_amount': 'Minimal Buy',
  'priceRule.min_amount_tooltip':
    'What is the minimum purchase amount for the discount to apply to customers? Calculated from the total purchase of all products in one invoice.',
  'priceRule.effective_date': 'Effective Date',
  'priceRule.forever': 'Forever',
  'priceRule.date': 'Date',
  'priceRule.date_start': 'Start Date',
  'priceRule.date_end': 'End Date',
  'priceRule.date_is_required': 'Date is required',
  'priceRule.until': 'until',
  'priceRule.applies_to_the_following_customers': 'Applies to the Following Customers',
  'priceRule.customer': 'Customer',
  'priceRule.all_customer': 'All Customer',
  'priceRule.customer_group': 'Customer Group',
  'priceRule.customer_groups_that_will_get_discount': 'Customer groups that will get discount',
  'priceRule.add_group': 'Add group',
  'priceRule.select_group': 'Select group',
  'priceRule.per_customer': 'Per Customer',
  'priceRule.customers_that_will_get_discount': 'Customers that will get discount',
  'priceRule.add_customer': 'Add customer',
  'priceRule.name': 'Name',
  'priceRule.company': 'Company',
  'priceRule.applies_to_the_following_products': 'Applies to the Following Products',
  'priceRule.product': 'Product',
  'priceRule.all_product': 'All Product',
  'priceRule.product_category': 'Product Category',
  'priceRule.discounted_product_category': 'Discounted product category',
  'priceRule.add_category': 'Add category',
  'priceRule.per_product': 'Per Product',
  'priceRule.discounted_product': 'Discounted Product',
  'priceRule.add_product': 'Add product',
  'priceRule.status': 'Status',
  'priceRule.active': 'Active',
  'priceRule.inactive': 'Inactive',
  'priceRule.rule_mode': 'Rule Type',
  'priceRule.rule_mode_discount': 'Discount',
  'priceRule.rule_mode_reward': 'Buy X Get Y',
  'priceRule.rule_mode_reward_short': 'Free Product',
  'priceRule.reward_products': 'Reward Products',
  'priceRule.reward_products_desc':
    'Choose which {product} are granted as rewards when the purchase requirement is met. A 100% discount means the reward is free.',
  'priceRule.discount_desc': 'Price discount or markup applied to the selected {product}.',
  'priceRule.reward_mode_desc': 'Set the purchase requirement, then the reward {product} received.',
  'priceRule.tab_outlet_pos': 'POS Outlet',
  'priceRule.tab_summary_min_qty': 'min. {value} qty',
  'priceRule.tab_summary_min_amount': 'min. {value}',
  'priceRule.tab_summary_rewards': '{count} reward products',
  'priceRule.tab_summary_selected': '{count} selected',
  'priceRule.tab_summary_not_selected': 'not selected',
  'priceRule.reward_product_required': 'Please select a reward product',
  'priceRule.reward_products_min_one': 'At least 1 reward product is required',
  'priceRule.duplicate_reward_product': 'Duplicate reward product is not allowed',
  'priceRule.reward_discount': 'Reward Discount',
  'priceRule.reward_max_qty_per_product': 'Max Qty',
  'priceRule.reward_max_qty': 'Max Total Rewards per Transaction',
  'priceRule.reward_max_qty_tooltip': 'Combined cap of all reward products in one transaction.',
  'priceRule.is_repeatable': 'Applies per Multiple',
  'priceRule.is_repeatable_tooltip':
    'When checked, rewards multiply for every multiple of the purchase minimum. Example: buy 2 get 1 free, then buy 4 get 2 free.',
  'priceRule.free': 'Free',
  'priceRule.free_n_products': '{n} free products',
  'priceRule.select_price_rule': 'Select price rule',
  'priceRule.to_use_the_pricing_rules_please_first_activate_the_sales_discount_option':
    'To use the pricing rules, please first activate the Sales Discount option from the Settings Business Flow menu.',
  'financeProduct.cannot_delete_current_photo': 'Tidak bisa menghapus foto ini.',
  'financeProduct.search_in': 'Search in',
  'financeProduct.available': 'Available',
  'financeProduct.almost_empty': 'Almost Empty',
  'financeProduct.empty': 'Empty',
  'lowStock.attention_title': 'Some products need your attention',
  'lowStock.summary_almost_empty': '{count} products low on stock',
  'lowStock.summary_empty': '{count} products out of stock',
  'lowStock.chip_empty': 'Out of stock',
  'lowStock.view_detail': 'View detail',
  'lowStock.view': 'View',
  'lowStock.drawer_title': 'Products need attention',
  'lowStock.drawer_subtitle': '{total} products need follow-up — as of today',
  'lowStock.min_stock': 'Min. stock',
  'lowStock.see_all_products': 'View all in Products menu',
  'lowStock.no_data': 'No data',
  'lowStock.search_placeholder': 'Search product name or code',
  'lowStock.no_search_result': 'No products match “{search}”',
  'lowStock.showing_count': 'Showing {shown} of {total} products',
  'reportLowStock.search_placeholder': 'Search product name or code',
  'reportLowStock.filter_all': 'All',
  'reportLowStock.filter_empty': 'Out of Stock',
  'reportLowStock.filter_almost_empty': 'Almost Empty',
  'reportLowStock.column_unit': 'Unit',
  'reportLowStock.column_qty': 'Current Stock',
  'reportLowStock.column_buffer_qty': 'Minimum Threshold',
  'reportLowStock.column_shortage': 'Shortage',
  'reportLowStock.column_status': 'Status',
  'reportLowStock.status_empty': 'Out of Stock',
  'reportLowStock.status_almost_empty': 'Almost Empty',
  'reportLowStock.summary_empty': 'Out of Stock Products',
  'reportLowStock.summary_almost_empty': 'Almost Empty Products',
  'reportLowStock.summary_total': 'Total Low Stock Products',
  'reportLowStock.summary_shortage': 'Total Shortage',
  'reportWarehouseProductQuota.search_placeholder': 'Search product name or code',
  'reportWarehouseProductQuota.filter_all': 'All',
  'reportWarehouseProductQuota.filter_unfulfilled': 'Unfulfilled',
  'reportWarehouseProductQuota.filter_fulfilled': 'Fulfilled',
  'reportWarehouseProductQuota.filter_over': 'Over Quota',
  'reportWarehouseProductQuota.column_unit': 'Unit',
  'reportWarehouseProductQuota.column_warehouse': 'Warehouse',
  'reportWarehouseProductQuota.column_quota': 'Quota',
  'reportWarehouseProductQuota.column_qty': 'Current Stock',
  'reportWarehouseProductQuota.column_fulfillment': 'Fulfillment',
  'reportWarehouseProductQuota.column_shortage': 'Shortage',
  'reportWarehouseProductQuota.column_status': 'Status',
  'reportWarehouseProductQuota.status_unfulfilled': 'Unfulfilled',
  'reportWarehouseProductQuota.status_fulfilled': 'Fulfilled',
  'reportWarehouseProductQuota.status_over': 'Over Quota',
  'reportWarehouseProductQuota.summary_unfulfilled': 'Unfulfilled Products',
  'reportWarehouseProductQuota.summary_fulfilled': 'Fulfilled Products',
  'reportWarehouseProductQuota.summary_shortage': 'Total Shortage',
  'financeProduct.stock_per_category': 'Stock per Category',
  'financeProduct.warehouse_location': 'Warehouse Location',
  'financeProduct.total_stock': 'Stock Total',
  'financeProduct.total_avg_base_price': 'COGS Total',
  'financeProduct.total_sales': 'Sales Total',
  'financeProduct.total_purchase': 'Purchases Total',
  'financeProduct.product': 'Product',
  'financeProduct.sell_or_purchase': 'Sell or Purchase',
  'financeProduct.for_sale': 'For sale',
  'financeProduct.bought': 'Bought',
  'financeProduct.track_stock': 'Track Stock',
  'financeProduct.not_track_stock': 'Not Track Stock',
  'financeProduct.code_sku_tooltip':
    'SKU (Stock Keeping Unit) code is a unique code for each product. The code will be generated automatically, or you can change it.',
  'financeProduct.conversion_detail_title': 'Product Conversion {number}',
  'financeProduct.row': 'Row',
  'financeProduct.avg_base_price': 'COGs',
  'financeProduct.all_stock': 'All stock',
  'financeProduct.all_products': 'All products',
  'financeProduct.detail_product': 'Detail Product',
  'financeProduct.category': 'Category',
  'financeProduct.product_name': 'Product Name',
  'financeProduct.code_sku': 'Code/SKU',
  'financeProduct.cost_price': 'Cost Price',
  'financeProduct.purchase_price_must_not_exceed_sale_price':
    'Purchase price must not be higher than the sale price.',
  'financeProduct.sale_price': 'Sale Price',
  'financeProduct.min_sell_price': 'Minimum Sale Price',
  'financeProduct.price_must_not_below_min_sell_price': 'Minimum sale price {value}',
  'financeProduct.quantity': 'Quantity',
  'financeProduct.products_and_services': 'Products & Services',
  'financeProduct.add_category': 'Add Category',
  'financeProduct.sub_category': 'Sub Category',
  'financeProduct.name_category_required': 'Name category required',
  'financeProduct.name_category_must_be_at_least_2_characters':
    'name category must be at least 2 characters',
  'financeProduct.edit_category': 'Edit Category',
  'financeProduct.edit_product': 'Edit Product',
  'financeProduct.edit_product_title': 'Edit product {name}',
  'financeProduct.image': 'Image',
  'financeProduct.choose_category': 'Choose Category',
  'financeProduct.choose_category_required': 'choose category required',
  'financeProduct.additional_category': 'Additional Categories',
  'financeProduct.choose_additional_category': 'Choose additional categories',
  'financeProduct.product_name_required': 'product name required',
  'financeProduct.product_name_must_be_at_least_2_characters':
    'product name must be at least 2 characters',
  'financeProduct.product_name_max_400_characters': 'product name maximal 400 characters',
  'financeProduct.code_sku_must_be_at_least_2_characters': 'Code/SKU must be at least 2 characters',
  'financeProduct.i_purchase_this_item': 'I purchase this item',
  'financeProduct.price': 'Price',
  'financeProduct.per': 'as of',
  'financeProduct.sell_currency_can_differ': 'Can differ from the purchase price currency',
  'financeProduct.currency_follow_sell_price':
    'Currency follows the selling price — not a separate choice',
  'financeProduct.average_price_base_currency_hint':
    'Inventory value always uses the tenant base currency, not the product currency.',
  'financeProduct.price_rule_nominal_base_currency_hint':
    'Nominal values are written in the base currency. For products in another currency, this value is automatically converted using the transaction date exchange rate.',
  'financeProduct.purchase_currency': 'Purchase Price Currency',
  'financeProduct.sell_currency': 'Sell Price Currency',
  'financeProduct.price_after_discount_tooltip':
    'The listed price is the price after the discount is applied',
  'financeProduct.price_required': 'Price required',
  'financeProduct.extra_price_must_greather_than_ziro': 'Extra price must greather than 0.',
  'financeProduct.tax': 'Tax',
  'financeProduct.choose_tax_required': 'choose tax required',
  'financeProduct.select_tax_rate': 'Select Tax Rate',
  'financeProduct.i_sell_this_item': 'I sell this item',
  'financeProduct.i_track_this_item': 'I track this item',
  'financeProduct.this_treats_your_item_as_a_tracked_inventory':
    'This treats your item as a tracked inventory asset.',
  'financeProduct.date': 'Date',
  'financeProduct.add_adjustment': 'Add Adjustment',
  'financeProduct.quantity_on_hand': 'Quantity On Hand',
  'financeProduct.total_value': 'Total Value',
  'financeProduct.purchase': 'Purchase',
  'financeProduct.tax_rate': 'Tax Rate',
  'financeProduct.sales': 'Sales',
  'financeProduct.inventory': 'Inventory',
  'financeProduct.inventory_asset_account': 'Inventory Asset Account',
  'financeProduct.decrease_quantity': 'Decrease quantity',
  'financeProduct.revolution': 'Revolution',
  'financeProduct.new_adjustment': 'New Adjustment',
  'financeProduct.adjustment_type': 'Adjustment Type',
  'financeProduct.adjustment_type_required': 'adjustment type required',
  'financeProduct.select_adjustment_type': 'Select Adjustment Type',
  'financeProduct.date_required': 'date required',
  'financeProduct.current_qty': 'Current qty',
  'financeProduct.qty_required': 'qty required',
  'financeProduct.avg_cost': 'Avg cost',
  'financeProduct.avg_cost_required': 'avg cost required',
  'financeProduct.total_value_required': 'total value required',
  'financeProduct.adjustment': 'Adjustment',
  'financeProduct.adjustment_required': 'adjustment required',
  'financeProduct.cost_price_required': 'cost price required',
  'financeProduct.new_qty_on_hand': 'New qty on hand',
  'financeProduct.new_qty_on_hand_required': 'new qty on hand required',
  'financeProduct.account': 'Account',
  'financeProduct.choose_account_required': 'choose account required',
  'financeProduct.select_account': 'Select Account',
  'financeProduct.note': 'Note',
  'financeProduct.note_required': 'note required',
  'financePurchaseOrders.detail_purchaseorder': 'Detail Purchase Order',
  'financeProduct.error_cannot_add': 'Cannot add product',
  'financeProduct.error_cannot_add_categorie': 'Cannot add product categorie',
  'financeProduct.recent_transactions': 'Recent Transactions',
  'financeProduct.manufacture': 'Manufacture',
  'financeProduct.package': 'Package',
  'financeProduct.conversion': 'Conversion',
  'financeProduct.conversion_description': 'Description',
  'financeProduct.follow_these_steps_to_import_your_products':
    'Follow these steps to import your products',
  'financeProduct.follow_these_steps_to_import_your_conversion_units':
    'Follow these steps to import your conversion units',
  'financeProduct.1_download_your_products_template_file':
    '1. Download your products template file',
  'financeProduct.1_download_your_conversion_units_template_file':
    '1. Download your conversion units template file',
  'financeProduct.start_by_downloading_our_products_csv':
    'Start by downloading our products Excel template file. This file has the correct column headings Kledo needs to import details of your products.',
  'financeProduct.start_by_downloading_our_conversion_units_csv':
    'Start by downloading our conversion units Excel template file. This file has the correct column headings Kledo needs to import details of your conversion units.',
  'financeProduct.download_template_file': 'Download Template File',
  'financeProduct.download_template_data_example_file': 'Download template data example file',
  'financeProduct.import': 'Import Products',
  'financeProduct.2_copy_your_products_into_the_template':
    '2. Copy your products into the template',
  'financeProduct.2_copy_your_conversion_units_into_the_template':
    '2. Copy your conversion units into the template',
  'financeProduct.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your products. Make sure the product details match the column headings provided in the template.',
  'financeProduct.using_excel_or_another_spreadsheet_editor_conversion_unit':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your conversion units. Make sure the conversion unit details match the column headings provided in the template.',
  'financeProduct.important': 'IMPORTANT',
  'financeProduct.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeProduct.upload': 'Upload',
  'financeProduct.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeProduct.a_maximum_of_1000_products_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data.',
  'financeProduct.a_maximum_of_1000_product_packages_can_be_imported_at_a_time':
    'A maximum of 1.000 products can be imported at a time.',
  'financeProduct.a_maximum_of_1000_product_conversions_can_be_imported_at_a_time':
    'A maximum of 1.000 products can be imported at a time.',
  'financeProduct.a_maximum_of_1000_product_manufactures_can_be_imported_at_a_time':
    'A maximum of 1.000 products can be imported at a time.',
  'financeProduct.a_maximum_of_1000_conversion_units_can_be_imported_at_a_time':
    'A maximum of 1.000 conversion units can be imported at a time.',
  'financeProduct.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step. You can also use a previously exported CSV of your products to update all your products in one go, saving you the effort of having to individually update all your products through the browser. The import will use the item code to determine whether a product exist and should be updated, or does not exist and should be created. Products cannot and will not be deleted using this import so you can safely update a subset of your products without fear of losing the others.',
  'financeProduct.dont_change_the_column_heading_in_the_template_file_conversion_unit':
    'Do not change the column headings in the template file. These need to be unchanged for the import to work in the next step.',
  'financeProduct.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financeProduct.upload_file': 'Upload File',
  'financeProduct.check_the_imported_data': 'Check Data',
  'financeProduct.please_check_the_imported_data': 'Please check the imported data',
  'financeProduct.import_product_done': 'Import Success',
  'financeProduct.import_conversion_unit_done': 'Import Conversion Unit Success',
  'financeProduct.conversion_units_successfully_imported':
    '{rowCount} conversion units successfully imported.',
  'financeProduct.error_upload_file': 'Upload failed.',
  'financeProduct.file_not_found': 'File not found',
  'financeProduct.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'financeProduct.valid': 'Valid',
  'financeProduct.invalid': 'Invalid',
  'financeProduct.total': 'Total',
  'financeProduct.import_now': 'Import Now',
  'financeProduct.status': 'Status',
  'financeProduct.name': 'Name',
  'productPopover.type_regular': 'Regular Product',
  'productPopover.type_package': 'Package Product',
  'productPopover.type_manufacture': 'Manufacture Product',
  'productPopover.stock': 'Stock',
  'productPopover.unit': 'Unit',
  'productPopover.used_in_packages': 'Component of packages',
  'productPopover.used_in_manufactures': 'Raw material of',
  'productPopover.variant_of': 'Variant of',
  'productPopover.package_contents': 'Package contents',
  'productPopover.manufacture_materials': 'Raw materials',
  'productPopover.variant_children': 'Variants',
  'productPopover.product': 'Product',
  'productPopover.qty': 'Quantity',
  'productPopover.category': 'Category',
  'productPopover.unit_conversion': 'Unit conversion',
  'warehousePopover.code': 'Code',
  'warehousePopover.total_stock': 'Total Stock',
  'accountPopover.category': 'Category',
  'accountPopover.balance': 'Balance',
  'journalPopover.account': 'Account',
  'journalPopover.debit': 'Debit',
  'journalPopover.credit': 'Credit',
  'journalPopover.total': 'Total',
  'fixedAssetPopover.date': 'Date',
  'fixedAssetPopover.memo': 'Memo',
  'fixedAssetPopover.amount': 'Amount',
  'returnPopover.invoice_qty': 'Invoice Qty',
  'returnPopover.return_qty': 'Return Qty',
  'financeProduct.purchase_price': 'Purchase Price',
  'financeProduct.purchase_account': 'Purchase Account',
  'financeProduct.purchase_tax': 'Purchase Tax',
  'financeProduct.sell_price': 'Sell Price',
  'financeProduct.product_name_or_code': '{product} Name/Code',
  'financeProduct.unit_amount': 'Unit Amount',
  'financeProduct.sell_account': 'Sell Account',
  'financeProduct.sell_tax': 'Sell Tax',
  'financeProduct.track_account': 'Tracking Account',
  'financeProduct.product_bundle': 'Product Bundle',
  'financeProduct.product_bundle_qty': 'Product Bundle Qty',
  'financeProduct.product_bundle_account': 'Product Bundle Account',
  'financeProduct.product_bundle_account_cost': 'Product Bundle Account Cost',
  'financeProduct.account_cost': 'Account Cost',
  'financeProduct.inventory_account': 'Inventory Account',
  'financeProduct.products_successfully_imported': '{rowCount} products imported successfully.',
  'financeProduct.view_detail': 'View detail',
  'financeProduct.import_another_file': 'Import another file',
  'financeProduct.go_to_product_list': 'Go to product list',
  'financeProduct.success': 'Success',
  'financeProduct.failed': 'Failed',
  'financeProduct.error_cannot_import': 'Import failed',
  'financeProduct.error_cannot_export': 'Export failed',
  'financeProduct.error': 'Error',
  'financeProduct.please_input_the_code_sku': 'Please input the code/SKU.',
  'financeProduct.code_sku_maximal_150_characters': 'Code/SKU maximal 150 characters.',
  'financeProduct.please_choose_at_least_a_product_action':
    'Please choose at least a product action (Sell/Purchase/Inventory).',
  'financeProduct.name_category_already_exist':
    'Nama kategori sudah digunakan, silakan pilih yang lain',
  'financeProduct.please_choose_this_action':
    'You must activate purchase while you track the product inventory!',
  'financeProduct.please_choose_the_unit': 'Please choose the unit.',
  'financeProduct.show_qty_per_warehouse': 'Show qty per warehouse',
  'financeProduct.select_category': 'Select category',
  'financeProduct.qty': 'Qty',
  'financeProduct.min_qty': 'Minimum Qty',
  'financeProduct.min_qty_must_less': 'Qty must less than next qty',
  'financeProduct.min_qty_must_greater': 'Qty must greater than previous qty',
  'financeProduct.wholesale_price': 'Wholesale Price',
  'financeProduct.wholesale_qty': 'Wholesale Qty',
  'financeProduct.show_wholesale_price': 'Show Wholesale Price',
  'financeProduct.hide_wholesale_price': 'Hide Wholesale Price',
  'financeProduct.warehouses': 'Warehouses',
  'financeProduct.warehouse': 'Warehouse',
  'financeProduct.set_stock_quota': 'Set Quota',
  'financeProduct.stock_quota_per_warehouse': 'Stock Quota per Warehouse',
  'financeProduct.stock_quota_hint': 'Leave empty or fill 0 if the warehouse has no quota limit.',
  'financeProduct.stock_quota_short': '{qty} short of quota',
  'financeProduct.stock_quota_exceeded': 'Exceeds quota by {qty}',
  'financeProduct.transaction': 'Transaction',
  'financeProduct.description': 'Description',
  'financeProduct.type': 'Type',
  'financeProduct.stock_movement': 'Stock Movement',
  'financeProduct.sell_price_history': 'Sell Price History',
  'financeProduct.warehouse_movement': 'Warehouse Movement',
  'financeProduct.stock': 'Stock',
  'financeProduct.initial_stock': 'Initial Stock',
  'financeProduct.initial_stock_toggle_hint': 'If this product has an initial stock',
  'financeProduct.initial_stock_qty_required': 'Quantity is required',
  'financeProduct.select_stock': 'Select Stock',
  'financeProduct.error_load_stock': 'Error cannot load stock',
  'financeProduct.show_accounts_and_taxes_setting': 'Show account and taxes setting',
  'financeProduct.hide_accounts_and_taxes_setting': 'Hide account and taxes setting',
  'financeProduct.categories': 'Manage Categories',
  'financeProduct.error_cannot_move': 'Cannot move the category.',
  'financeProduct.please_select_a_category_to_delete': 'Please select a category to delete.',
  'financeProduct.delete_a_product_category': 'Delete A Product Category',
  'financeProduct.error_cannot_delete_category': 'Cannot delete product category.',
  'financeProduct.error_cannot_update_category': 'Cannot update product category.',
  'financeProduct.error_cannot_update': 'Cannot update product.',
  'financeProduct.error_cannot_load_can_be_deleted_category': 'Cannot load product category.',
  'financeProduct.only_category_that_not_assigned_in_product_could_be_deleted':
    'Note: Only category that not assigned in product could be deleted.',
  'financeProduct.reference': 'Reference',
  'financeProduct.error_load_product': 'Error cannot load product.',
  'financeProduct.add_product': 'Add {title}',
  'financeProduct.add_product_package': 'Add {title} Package',
  'financeProduct.duplicate_product_package': 'Duplicate {title} Package',
  'financeProduct.duplicate_product_manufacture': 'Duplicate {title} Manufacture',
  'financeProduct.add_product_manufacture': 'Add {title} Manufacture',
  'financeProduct.add_mass_conversion': 'Add {title} Conversion',
  'financeProduct.mass_conversion_title': 'Mass {title} Conversion',
  'financeProduct.mass_conversion_add_row': 'Add Conversion',
  'financeProduct.mass_conversion_min_one': 'Add at least one {title} conversion',
  'financeProduct.mass_conversion_select_product': 'Select a {title} to convert',
  'financeProduct.mass_conversion_success': 'Mass {title} conversion saved successfully',
  'financeProduct.edit_product_package': 'Edit {title} Package',
  'financeProduct.edit_product_manufacture': 'Edit {title} Manufacture',
  'financeProduct.package_product_items': 'The product package consists of',
  'financeProduct.manufacture_product_items': 'The product manufacture consists of',
  'financeProduct.error_load_product_detail': 'Error load product detail.',
  'financeProduct.cost_of_production': 'The production costs consist of',
  'financeProduct.product_conversion': 'Product Conversion',
  'financeProduct.total_cost': 'Total cost',
  'financeProduct.total_cost_conversion': 'Total cost of conversion',
  'financeProduct.cost_per_unit': 'Cost per unit',
  'financeProduct.error_cannot_conversion_product': 'Error cannot conversion product',
  'financeProduct.conversion_title': '{title} Conversion {name}',
  'financeProduct.amount': 'Amount',
  'financeProduct.conversion_date': 'Conversion Date',
  'financeProduct.error_load_conversion_product_detail': 'Error load conversion product detail',
  'financeProduct.error_cannot_delete_conversion_product': 'Error cannot delete conversion product',
  'financeProduct.multiplier': 'Multiplier',
  'financeProduct.please_input_the_multiplier': 'Please input the multiplier',
  'financeProduct.per_pcs': 'Per Pcs',
  'financeProduct.unit_conversion': 'Unit Conversion',
  'financeProduct.unit': 'Unit',
  'financeProduct.other_units': 'Other Units',
  'financeProduct.other_units_compact': 'Other Units Compact',
  'financeProduct.product_unit': '{product} Unit',
  'financeProduct.base_unit': 'Base Unit',
  'financeProduct.add_unit_conversion': 'Add unit conversion',
  'financeProduct.edit_unit_conversion': 'Edit unit conversion',
  'financeProduct.please_input_unit': 'Please input unit',
  'financeProduct.please_input_unit_conv': 'Please input unit conversion',
  'financeProduct.unit_cannot_same': 'Unit cannot be the same',
  'financeProduct.unit_cannot_same_as_conversion': 'Unit cannot be the same as unit conversion',
  'financeProduct.cannot_edit_unit_conversion': 'Cannot edit unit conversion',
  'financeProduct.mass_delete_info':
    '**Product that have a transaction cannot be deleted, can only be archived',
  'financeProduct.archive': 'Archive',
  'financeProduct.show_archive': 'Show Archive',
  'financeProduct.unarchive': 'Unarchive',
  'financeProduct.archived': 'Archived',
  'financeProduct.membership_entity_info': 'This product comes from the Membership module ({type})',
  'financeProduct.membership_entity_open': 'Open in Membership module',
  'financeProduct.membership_entity_here': 'here.',
  'financeProduct.membership_entity_type_plan': 'plan',
  'financeProduct.membership_entity_type_addon': 'add-on',
  'financeProduct.membership_entity_type_benefit': 'benefit',
  'financeProduct.without_archive': 'Without archive',
  'financeProduct.with_archive': 'with archive',
  'financeProduct.archive_only': 'Archive only',
  'financeProduct.are_you_sure_to_archive': 'Are you sure to archive this product?',
  'financeProduct.are_you_sure_to_unarchive': 'Are you sure to unarchive this product?',
  'financeProduct.future_transactions': 'Future transactions',
  'financeProduct.all_transactions': 'All transactions',
  'financeProduct.current_transaction_will_not_be_modified':
    'Current transactions will not be modified, Only affect future transactions.',
  'financeProduct.current_transaction_and_future_will_be_modified':
    'Current transactions and future transactions will be modified.',
  'financeProduct.purchase_account_cannot_be_modified_for_future_transactions':
    'Purchase account cannot be modified for future transactions, because this product already has transactions.',
  'financeProduct.purchase_account_cannot_be_modified_for_all_transactions':
    'Purchase account cannot be modified for all transactions, because this product already has transactions before lock date or before book closing.',
  'financeProduct.sell_account_cannot_be_modified': 'Sell account cannot be modified.',
  'financeProduct.sell_account_cannot_be_modified_for_all_transactions':
    'Sell account cannot be modified for all transactions, because this product already has transactions before lock date or before book closing.',
  'financeProduct.track_account_cannot_be_modified':
    'Track account cannot be modified because this product already has transactions before lock date or before book closing.',
  'financeProduct.please_choose_account_update_past': 'Please choose account update past setting!',
  'financeProduct.same_as_business_flow': 'Same as business flow setting',
  'financeProduct.please_input_buffer_qty': 'Please input minimum stock',
  'financeProduct.data_is_being_processed': 'Data is being processed',
  'financePurchaseInvoices.import_purchase_invoice_status': 'Import Purchase Invoice Status',
  'financePurchaseInvoices.message': 'Message',
  'financePurchaseInvoices.add_purchaseInvoice': 'Add Purchase Invoice',
  'financePurchaseInvoices.financePurchaseInvoices': 'Purchase Invoice',
  'financePurchaseInvoices.successfully_added': 'successfully added.',
  'financePurchaseInvoices.error_cannot_add': 'Cannot add purchase invoice.',
  'financePurchaseInvoices.error_cannot_print_pdf': 'Cannot print pdf purchase invoice.',
  'financePurchaseInvoices.error_cannot_update': 'Cannot update purchase invoice.',
  'financePurchaseInvoices.error_cannot_move': 'Cannot move the purchase invoice.',
  'financePurchaseInvoices.error_cannot_change_status':
    'Cannot change status the purchase invoice.',
  'financePurchaseInvoices.edit_purchaseInvoice': 'Edit Purchase invoice',
  'financePurchaseInvoices.max_characters': 'Max {value} characters.',
  'financePurchaseInvoices.min_characters': 'Min {value} characters.',
  'financePurchaseInvoices.only_number_allowed': 'Only number allowed.',
  'financePurchaseInvoices.description': 'Description',
  'financePurchaseInvoices.tax': 'Tax',
  'financePurchaseInvoices.dpp': 'DPP',
  'financePurchaseInvoices.select_tax': 'Select tax',
  'financePurchaseInvoices.amount': 'Amount',
  'financePurchaseInvoices.please_select_a_contact': 'Please select a contact',
  'financePurchaseInvoices.select_contact': 'Select contact',
  'financePurchaseInvoices.add_contact': 'Add contact',
  'financePurchaseInvoices.all_contacts': 'All contact',
  'financePurchaseInvoices.transaction_date': 'Transaction Date',
  'financePurchaseInvoices.please_select_transaction_date': 'Please select transaction date',
  'financePurchaseInvoices.payment_date': 'Payment Date',
  'financePurchaseInvoices.please_select_payment_date': 'Please select payment date',
  'financePurchaseInvoices.due_date': 'Due Date',
  'financePurchaseInvoices.please_select_due_date': 'Please select due date',
  'financePurchaseInvoices.term': 'Term',
  'financePurchaseInvoices.select_term': 'Select term',
  'financePurchaseInvoices.add_term': 'Add term',
  'financePurchaseInvoices.price_include_tax': 'Price include tax',
  'financePurchaseInvoices.add_more': 'Add more',
  'financePurchaseInvoices.number': 'Number',
  'financePurchaseInvoices.please_input_the_number': 'Please input the number.',
  'financePurchaseInvoices.memo': 'Memo',
  'financePurchaseInvoices.date': 'Date',
  'financePurchaseInvoices.status': 'Status',
  'financePurchaseInvoices.balance_due': 'Balance Due',
  'financePurchaseInvoices.please_select_a_term': 'Please select a term.',
  'financePurchaseInvoices.search_by_memo': 'Search',
  'financePurchaseInvoices.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financePurchaseInvoices.the_payment_date_max_higger_than_transaction_date':
    'The payment date must same or after transaction date',
  'financePurchaseInvoices.detail_title': 'Purchase Invoice {number}',
  'financePurchaseInvoices.vendor': 'Vendor',
  'financePurchaseInvoices.reference': 'Reference',
  'financePurchaseInvoices.product': 'Product',
  'financePurchaseInvoices.qty': 'Qty',
  'financePurchaseInvoices.price': 'Price',
  'financePurchaseInvoices.add_product': 'Add Product',
  'financePurchaseInvoices.select_product': 'Select product',
  'financePurchaseInvoices.attachments': 'Attachments',
  'financePurchaseInvoices.save_&_approve': 'Save & approve',
  'financePurchaseInvoices.save_as_draft': 'Save as draft',
  'financePurchaseInvoices.save_&_submit_for_approval': 'Save & submit for approval',
  'financePurchaseInvoices.please_select_a_product': 'Please select a product.',
  'financePurchaseInvoices.please_input_the_qty': 'Please input the qty.',
  'financePurchaseInvoices.please_input_the_price': 'Please input the price.',
  'financePurchaseInvoices.please_input_the_amount': 'Please input the amount.',
  'financePurchaseInvoices.approve': 'Approve',
  'financePurchaseInvoices.are_you_sure_to_approve': 'Are you sure to approve ?',
  'financePurchaseInvoices.submit_for_approval': 'Submit for approval',
  'financePurchaseInvoices.are_you_sure_to_submit_for_approval':
    'Are you sure to submit for approval ?',
  'financePurchaseInvoices.create_invoice': 'Create Invoice',
  'financePurchaseInvoices.amount_paid': 'Amount Paid',
  'financePurchaseInvoices.paid_from': 'Paid From',
  'financePurchaseInvoices.add_payment': 'Add Payment',
  'financePurchaseInvoices.select_paid_from': 'Select paid from',
  'financePurchaseInvoices.please_select_a_paid_from': 'Please select a paid from.',
  'payment.no_bank_access_title': 'No Cash/Bank Account Access',
  'payment.no_bank_access_description':
    'You do not have access to any cash/bank account to make a payment. Please contact your admin to be granted access.',
  'financePurchaseInvoices.paid_to': 'Paid To',
  'financePurchaseInvoices.select_paid_to': 'Select paid to',
  'financePurchaseInvoices.please_select_a_paid_to': 'Please select a paid to.',
  'financePurchaseInvoices.error_cannot_add_payment': 'Cannot add payment.',
  'financePurchaseInvoices.payment': 'Payment',
  'financePurchaseInvoices.detail_purchaseInvoice': 'Detail Purchase Invoice',
  'financePurchaseInvoices.number_po': 'PO Number',
  'financePurchaseInvoices.follow_these_steps_to_import_your_purchase_invoices':
    'Follow these steps to import your purchase invoices',
  'financePurchaseInvoices.1_download_your_purchase_invoices_template_file':
    '1. Download your purchase invoices template file',
  'financePurchaseInvoices.start_by_downloading_our_purchase_invoices_csv':
    'Start by downloading our purchase invoices Excel template file. This file has the correct column headings Kledo needs to import details of your invoices.',
  'financePurchaseInvoices.download_template_file': 'Download Template File',
  'financePurchaseInvoices.download_template_data_example_file':
    'Download template data example file',
  'financePurchaseInvoices.import': 'Import Purchase Invoices',
  'financePurchaseInvoices.2_copy_your_purchase_invoices_into_the_template':
    '2. Copy your purchase invoices into the template',
  'financePurchaseInvoices.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your invoices. Make sure the product details match the column headings provided in the template.',
  'financePurchaseInvoices.important': 'IMPORTANT',
  'financePurchaseInvoices.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financePurchaseInvoices.upload': 'Upload',
  'financePurchaseInvoices.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financePurchaseInvoices.a_maximum_of_1000_purchase_invoices_can_be_imported_at_a_time':
    'A maximum of 1.000 purchase invoices can be imported at a time.',
  'financePurchaseInvoices.a_single_import_supports_up_to_n_rows':
    'A single import supports up to 3.000 rows of Excel data.',
  'financePurchaseInvoices.a_single_import_supports_up_to_n_rows_including_invoice_and_item':
    'A single import supports up to 2.500 rows of Excel data. Every row is counted, including purchase invoice rows and item rows.',
  'financePurchaseInvoices.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Contact name that not exist will be inserted as a new contact.',
  'financePurchaseInvoices.import_actions_only_insert_new_purchase_invoices_cannot_update_or_delete':
    'Import actions only insert new purchase invoices, cannot update nor delete.',
  'financePurchaseInvoices.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financePurchaseInvoices.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financePurchaseInvoices.upload_file': 'Upload File',
  'financePurchaseInvoices.check_the_imported_data': 'Check Data',
  'financePurchaseInvoices.please_check_the_imported_data': 'Please check the imported data',
  'financePurchaseInvoices.import_purchase_invoices_done': 'Import Success',
  'financePurchaseInvoices.error_upload_file': 'Upload failed.',
  'financePurchaseInvoices.file_not_found': 'File not found',
  'financePurchaseInvoices.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'financePurchaseInvoices.valid': 'Valid',
  'financePurchaseInvoices.invalid': 'Invalid',
  'financePurchaseInvoices.total': 'Total',
  'financePurchaseInvoices.import_now': 'Import Now',
  'financePurchaseInvoices.contact_name': 'Contact name',
  'financePurchaseInvoices.email': 'Email',
  'financePurchaseInvoices.address': 'Address',
  'financePurchaseInvoices.phone': 'Phone',
  'financePurchaseInvoices.invoice_date': 'Purchase Invoice Date',
  'financePurchaseInvoices.invoice_number': 'Purchase Invoice Number',
  'financePurchaseInvoices.import_order_number': 'Purchase Order Number',
  'financePurchaseInvoices.product_name': 'Product name',
  'financePurchaseInvoices.code_sku': 'Kode/SKU',
  'financePurchaseInvoices.tax_inclusive': 'Tax Inclusive',
  'financePurchaseInvoices.paid': 'Paid',
  'financePurchaseInvoices.paid_account': 'Paid Account',
  'financePurchaseInvoices.copy_link': 'Copy Purchase Invoice Link',
  'financePurchaseInvoices.send_email': 'Send Purchase Invoice Email',
  'financePurchaseInvoices.send_sms': 'Send Purchase Invoice SMS',
  'financePurchaseInvoices.pay_with_credit_memo': 'Pay with credit memo',
  'financePurchaseInvoices.please_select_with_credit_memo': 'Please select with credit memo',
  'financePurchaseInvoices.pay_with_debit_memo': 'Pay with debit memo',
  'financePurchaseInvoices.please_select_with_debit_memo': 'Please select with debit memo',
  'financeInvoices.sales_person': 'Sales Person',
  'financeInvoices.set_paid': 'Set Paid',
  'financeInvoices.mass_payment': 'Mass Payment',
  'financeInvoices.cannot_mass_payment': 'Cannot mass payment',
  'financeInvoices.can_be_paid': 'Can be paid',
  'financeInvoices.cannot_be_paid': 'Cannot be paid',
  'financeInvoices.data_progress_paid': '{count} out of {total} data has been paid',
  'financeInvoices.data_has_been_paid': 'Total {count} data has been paid',
  'financeInvoices.create_mass_trans': 'Create Mass {title}',
  'financeInvoices.can_be_created_to': 'Can be created to {title}',
  'financeInvoices.cannot_be_created_to': 'Cannot created to {title}',
  'financeInvoices.data_progress_create_trans': '{count} out of {total} {title} has been created',
  'financeInvoices.data_has_been_create_trans': 'Total {count} {title} has been created',
  'financeInvoices.mass_create_result_more': 'and {count} more',
  'financeInvoices.data_partial_create_trans': '{count} of {total} transactions have been created',
  'financeInvoices.please_select_tag': 'Please select tag',
  'financeInvoices.recurring_invoice': 'Recurring Invoice',
  'financeInvoices.1_download_your_invoices_recurring_template_file':
    '1. Download the recurring invoice template file',
  'financeInvoices.start_by_downloading_our_invoices_recurring_csv':
    'Start by downloading the recurring invoice Excel template file. This file has the header fields that Kledo needs to import the details of your recurring invoices.',
  'financeInvoices.2_copy_your_invoices_recurring_into_the_template':
    '2. Copy recurring invoice details into template',
  'financeInvoices.invoice_recurring_using_excel_or_another_spreadsheet_editor':
    'Using Excel or other spreadsheet software, enter recurring invoice details into a template file from Kledo. Make sure the recurring invoice details match the header fields in the template.',
  'financeInvoices.amount_after_discount': 'Amount after discount',
  'financeInvoices.cannot_upload_this_photo': 'Cannot upload this photo.',
  'financeInvoices.import_invoice_return': 'Import Invoice Return',
  'financeInvoices.invoice_return_number': 'Invoice Return Number',
  'financeInvoices.import_return_product_name_or_code': '{product} Name atau Code/SKU',
  'financeInvoices.1_download_your_invoices_return_template_file':
    '1. Download the return invoice template file',
  'financeInvoices.start_by_downloading_our_invoices_return_csv':
    'Start by downloading the return invoice Excel template file. This file has the header fields that Kledo needs to import the details of your return invoices.',
  'financeInvoices.2_copy_your_invoices_return_into_the_template':
    '2. Copy return invoice details into template',
  'financeInvoices.invoice_return_using_excel_or_another_spreadsheet_editor':
    'Using Excel or other spreadsheet software, enter return invoice details into a template file from Kledo. Make sure the return invoice details match the header fields in the template.',
  'financeInvoices.follow_these_steps_to_import_your_invoices_return':
    'Follow these steps to import your invoices return',
  'financePurchaseInvoices.inventory_account': 'Inventory Account',
  'financePurchaseInvoices.purchase_invoices_successfully_imported':
    '{rowCount} purchase invoice imported successfully.',
  'financePurchaseInvoices.view_detail': 'View detail',
  'financePurchaseInvoices.import_another_file': 'Import another file',
  'financePurchaseInvoices.go_to_purchase_invoice_list': 'Go to Purchase invoice list',
  'financePurchaseInvoices.success': 'Success',
  'financePurchaseInvoices.failed': 'Failed',
  'financePurchaseInvoices.error_cannot_import': 'Import failed',
  'financePurchaseInvoices.error': 'Error',
  'financePurchaseInvoices.make_a_payment': 'Send a payment',
  'financeQuotes.message': 'Message',
  'financeQuotes.add_quote': 'Add Quote',
  'financeQuotes.financeQuotes': 'Quote',
  'financeQuotes.quote_accepted': 'Accepted quote',
  'financeQuotes.quote_open': 'Open quote',
  'financeQuotes.successfully_added': 'successfully added.',
  'financeQuotes.error_cannot_add': 'Cannot add quote.',
  'financeQuotes.error_cannot_print_pdf': 'Cannot print pdf quote.',
  'financeQuotes.error_cannot_update': 'Cannot update quote.',
  'financeQuotes.error_cannot_move': 'Cannot move the quote.',
  'financeQuotes.error_cannot_change_status': 'Cannot change status the quote.',
  'financeQuotes.edit_quote': 'Edit Quote',
  'financeQuotes.max_characters': 'Max {value} characters.',
  'financeQuotes.min_characters': 'Min {value} characters.',
  'financeQuotes.only_number_allowed': 'Only number allowed.',
  'financeQuotes.description': 'Description',
  'financeQuotes.tax': 'Tax',
  'financeQuotes.select_tax': 'Select tax',
  'financeQuotes.amount': 'Amount',
  'financeQuotes.please_select_a_contact': 'Please select a contact',
  'financeQuotes.select_contact': 'Select contact',
  'financeQuotes.add_contact': 'Add contact',
  'financeQuotes.all_contacts': 'All contact',
  'financeQuotes.transaction_date': 'Transaction Date',
  'financeQuotes.please_select_transaction_date': 'Please select transaction date',
  'financeQuotes.due_date': 'Expiry',
  'financeQuotes.please_select_due_date': 'Please select expiry',
  'financeQuotes.term': 'Term',
  'financeQuotes.select_term': 'Select term',
  'financeQuotes.add_term': 'Add term',
  'financeQuotes.price_include_tax': 'Price include tax',
  'financeQuotes.add_more': 'Add more',
  'financeQuotes.number': 'Number',
  'financeQuotes.please_input_the_number': 'Please input the number.',
  'financeQuotes.memo': 'Memo',
  'financeQuotes.date': 'Date',
  'financeQuotes.status': 'Status',
  'financeQuotes.balance_due': 'Balance Due',
  'financeQuotes.please_select_a_term': 'Please select a term.',
  'financeQuotes.search_by_memo': 'Search',
  'financeQuotes.the_due_date_max_higger_than_transaction_date':
    'The expiry date must same or after transaction date',
  'financeQuotes.detail_title': 'Quote {number}',
  'financeQuotes.customer': 'Customer',
  'financeQuotes.reference': 'Reference',
  'financeQuotes.product': 'Product',
  'financeQuotes.qty': 'Qty',
  'financeQuotes.price': 'Price',
  'financeQuotes.add_product': 'Add Product',
  'financeQuotes.select_product': 'Select product',
  'financeQuotes.attachments': 'Attachments',
  'financeQuotes.save_as_draft': 'Save as draft',
  'financeQuotes.save_as_draft_add_new': 'Save as draft & Add New',
  'financeQuotes.save_&_submit_for_approval': 'Save & submit for approval',
  'financeQuotes.please_select_a_product': 'Please select a product.',
  'financeQuotes.please_input_the_qty': 'Please input the qty.',
  'financeQuotes.please_input_the_price': 'Please input the price.',
  'financeQuotes.please_input_the_amount': 'Please input the amount.',
  'financeQuotes.mark_as_sent': 'Mark as sent',
  'financeQuotes.are_you_sure_to_mark_as_sent': 'Are you sure to mark as sent ?',
  'financeQuotes.mark_as_accepted': 'Mark as accepted',
  'financeQuotes.are_you_sure_to_mark_as_accepted': 'Are you sure to mark as accepted ?',
  'financeQuotes.mark_as_declined': 'Mark as declined',
  'financeQuotes.are_you_sure_to_mark_as_declined': 'Are you sure to mark as declined ?',
  'financeQuotes.create_invoice': 'Create Invoice',
  'financeQuotes.send': 'Send',
  'financeQuotes.send_add_new': 'Send & Add New',
  'financeQuotes.detail_quote': 'Detail Quote',
  'financeQuotes.create_order': 'Create Order',
  'financeQuotes.follow_these_steps_to_import_your_quotes':
    'Follow these steps to import your quotes',
  'financeQuotes.1_download_your_quotes_template_file': '1. Download your quotes template file',
  'financeQuotes.start_by_downloading_our_quotes_csv':
    'Start by downloading our quotes Excel template file. This file has the correct column headings Kledo needs to import details of your quotes.',
  'financeQuotes.download_template_file': 'Download Template File',
  'financeQuotes.download_template_data_example_file': 'Download template data example file',
  'financeQuotes.import': 'Import Quotes',
  'financeQuotes.2_copy_your_quotes_into_the_template': '2. Copy your quotes into the template',
  'financeQuotes.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your quotes. Make sure the product details match the column headings provided in the template.',
  'financeQuotes.important': 'IMPORTANT',
  'financeQuotes.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeQuotes.upload': 'Upload',
  'financeQuotes.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeQuotes.a_maximum_of_500_quotes_can_be_imported_at_a_time':
    'A single import supports up to 2.500 rows of Excel data. Every row is counted, including quote rows and item rows.',
  'financeQuotes.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Contact name that not exist will be inserted as a new contact.',
  'financeQuotes.import_actions_only_insert_new_quotes_cannot_update_or_delete':
    'Import actions only insert new quotes, cannot update nor delete.',
  'financeQuotes.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeQuotes.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financeQuotes.upload_file': 'Upload File',
  'financeQuotes.check_the_imported_data': 'Check Data',
  'financeQuotes.please_check_the_imported_data': 'Please check the imported data',
  'financeQuotes.import_quotes_done': 'Import Success',
  'financeQuotes.error_upload_file': 'Upload failed.',
  'financeQuotes.file_not_found': 'File not found',
  'financeQuotes.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'financeQuotes.valid': 'Valid',
  'financeQuotes.invalid': 'Invalid',
  'financeQuotes.total': 'Total',
  'financeQuotes.total_after_additional_discount': 'Total After Discount',
  'financeQuotes.import_now': 'Import Now',
  'financeQuotes.contact_name': 'Contact name',
  'financeQuotes.email': 'Email',
  'financeQuotes.address': 'Address',
  'financeQuotes.phone': 'Phone',
  'financeQuotes.quote_date': 'Quote Date',
  'financeQuotes.quote_number': 'Quote Number',
  'financeQuotes.product_name': 'Product name',
  'financeQuotes.code_sku': 'Kode/SKU',
  'financeQuotes.tax_inclusive': 'Tax Inclusive',
  'financeQuotes.paid': 'Paid',
  'financeQuotes.paid_account': 'Paid To Account',
  'financeQuotes.copy_link': 'Copy Quote Link',
  'financeQuotes.send_email': 'Send Quote Email',
  'financeQuotes.send_sms': 'Send Quote SMS',
  'financeQuotes.send_wa': 'Send Quote Whatsapp',
  'financeQuotes.inventory_account': 'Inventory Account',
  'financeQuotes.quotes_successfully_imported': '{rowCount} quote imported successfully.',
  'financeQuotes.view_detail': 'View detail',
  'financeQuotes.import_another_file': 'Import another file',
  'financeQuotes.go_to_quote_list': 'Go to quote list',
  'financeQuotes.success': 'Success',
  'financeQuotes.failed': 'Failed',
  'financeQuotes.error_cannot_import': 'Import failed',
  'financeQuotes.error': 'Error',
  'financeQuotes.print_quote': 'Print Quotation',
  'pos.pos': 'POS',
  'pos.pos_activity': 'POS Activity',
  'pos.transfer_to_room': 'Transfer to Room',
  'pos.please_choose_a_table': 'please choose a table!',
  'pos.failed_list_item_null': 'failed list item null!',
  'pos.harga_item': 'Harga item',
  'pos.activity': 'Activity',
  'pos.saved_bill': 'Saved Bill',
  'pos.items': 'Items',
  'pos.total_harga_item': 'Total harga item',
  'pos.discount': 'Discount',
  'pos.tax': 'Tax',
  'pos.total': 'Total',
  'pos.pay': 'Pay',
  'pos.save_bill': 'Save Bill',
  'pos.list_save_bill': 'List Save Bill',
  'pos.table': 'Table',
  'pos.select_table': 'select table',
  'pos.receipt_number': 'Receipt Number',
  'pos.details': 'Details',
  'pos.payment': 'Payment',
  'pos.date_range': 'Date Range',
  'pos.unpaid': 'unpaid',
  'pos.paid_cashier': 'paid cashier',
  'pos.order_cannot_contain_serial_products':
    'Saving as an order cannot include serial-number products. Remove or change those lines, or save as invoice instead.',
  'pos.transfer_to_room_': 'transfer to room',
  'pos.please_select_date_range': 'please select date range',
  'pos.select': 'Select',
  'pos.room': 'Room',
  'pos.name': 'Name',
  'pos.checking': 'Checking',
  'pos.transfer': 'Transfer',
  'pos.new_sale': 'New Sale',
  'pos.transfer_to': 'Transfer To',
  'pos.guest_name': 'Guest Name',
  'pos.pos_outlets': 'POS Outlets',
  'pos.category': 'Category',
  'pos.variant_name': 'Variant Name',
  'pos.modify_variant': 'Modify Variant',
  'pos.variant_of': 'Variant of',
  'pos.add_variant_category': 'Add Variant Category',
  'pos.add_variant': 'Add Variant',
  'pos.product_name': 'Product Name',
  'pos.enable_table_for_this_outlet': 'Enable table for this outlet',
  'pos.add_product': 'Add Product',
  'pos.add_category': 'Add Category',
  'pos.product': 'Product',
  'pos.settings': 'Settings',
  'pos.name_category_required': 'Name category required',
  'pos.edit_category': 'Edit Category',
  'pos.category_name': 'Category Name',
  'pos.change_multi_required': 'change multi required',
  'pos.one_variant_per_product_sale': 'One Variant per product sale',
  'pos.multiple_variant_per_product_sale': 'Multiple Variant per product sale',
  'pos.edit_variant_category': 'Edit Variant Category',
  'pos.add_tables': 'Add Tables',
  'pos.name_table_required': 'name table required',
  'pos.tables': 'Tables',
  'pos.edit_tables': 'Edit Tables',
  'pos.name_required': 'name required',
  'pos.tax_required': 'tax required',
  'pos.service_charge': 'Service Charge',
  'pos.service_charge_required': 'service charge required',
  'pos.auto_fees.title': 'Additional Fee Rules',
  'pos.auto_fees.note':
    'Add fee rules that will be automatically applied based on the transaction type (Takeaway, Ojol, etc.) for this outlet.',
  'pos.auto_fees.add': 'Add Rule',
  'pos.auto_fees.empty': 'No rules yet. Click "Add Rule" to create one.',
  'pos.auto_fees.master_fee': 'Master Fee',
  'pos.auto_fees.invoice_type': 'Transaction Type',
  'pos.auto_fees.value_type': 'Value Type',
  'pos.auto_fees.value': 'Value',
  'pos.auto_fees.include_tax': 'Include Tax',
  'pos.auto_fees.include_tax_short': 'Tax',
  'pos.auto_fees.ojol_filter': 'Ojol Filter (optional)',
  'pos.auto_fees.ojol_filter_placeholder': 'Empty = applies to all ojol',
  'pos.auto_fees.confirm_delete': 'Delete this rule?',
  'pos.auto_fees.add_title': 'Add Fee Rule',
  'pos.auto_fees.edit_title': 'Edit Fee Rule',
  'pos.auto_fees.value_required': 'Value is required',
  'pos.auto_fees.master_fee_required': 'Master fee is required',
  'pos.auto_fees.invoice_type_required': 'Transaction type is required',
  'pos.cashier_settings.search_placeholder': 'Search settings, e.g. discount, receipt, queue…',
  'pos.cashier_settings.expand_all': 'Expand all',
  'pos.cashier_settings.collapse_all': 'Collapse all',
  'pos.cashier_settings.count': '{count} settings',
  'pos.cashier_settings.result_count': '{count} results',
  'pos.cashier_settings.no_result': 'No settings match “{query}”',
  'pos.cashier_settings.clear_search': 'Clear search',
  'pos.cashier_settings.device_only': 'This device',
  'pos.cashier_settings.group.shift.title': 'Shift & Cash',
  'pos.cashier_settings.group.shift.description': 'Opening/closing cash and cash-out limit',
  'pos.cashier_settings.group.pricing.title': 'Pricing & Discounts',
  'pos.cashier_settings.group.pricing.description':
    'Discounts, manual price, per-item tax, and service charge',
  'pos.cashier_settings.group.order_type.title': 'Order Types & Fees',
  'pos.cashier_settings.group.order_type.description':
    'Cashier order types and automatic fees per order type',
  'pos.cashier_settings.group.receipt.title': 'Receipt & Payment',
  'pos.cashier_settings.group.receipt.description':
    'Receipt display, print count, and auto transfer',
  'pos.cashier_settings.group.queue.title': 'Queue & Authorization',
  'pos.cashier_settings.group.queue.description': 'Queue number and manager authorization',
  'pos.cashier_settings.group.performance.title': 'Cashier Performance',
  'pos.cashier_settings.group.performance.description':
    'Zero-Loading mode and transaction sync history',
  'pos.zero_loading.title': 'Zero-Loading Cashier Mode (Beta)',
  'pos.zero_loading.note':
    'When enabled, products & promos are fetched once and stored in this browser, and every sale/order is saved instantly then synced to the server in the background — the cashier never waits even when the server is busy. Turning it on syncs the catalog first.',
  'pos.zero_loading.unsupported': 'This browser does not support Zero-Loading mode yet',
  'pos.zero_loading.badge': 'Zero-Loading mode active',
  'pos.zero_loading.enabled': 'Zero-Loading mode enabled',
  'pos.zero_loading.disabled': 'Zero-Loading mode disabled',
  'pos.zero_loading.disable_pending':
    '{count} transactions are not synced yet. Sync them first before turning off Zero-Loading mode.',
  'pos.zero_loading.sync_catalog': 'Sync Catalog',
  'pos.zero_loading.sync_catalog_note':
    'Fetch the latest product & promo changes from the server to this browser.',
  'pos.zero_loading.catalog_last_synced': 'Last synced {time}',
  'pos.zero_loading.catalog_synced': 'Catalog synced successfully',
  'pos.zero_loading.catalog_sync_failed': 'Failed to sync catalog',
  'pos.catalog_sync.title': 'Preparing the cashier…',
  'pos.catalog_sync.description':
    'Downloading the product & promo catalog to this browser so the cashier can transact without waiting for the server.',
  'pos.catalog_sync.step.products': 'Products',
  'pos.catalog_sync.step.price_rules': 'Promos & pricing',
  'pos.catalog_sync.step.done': 'Done',
  'pos.catalog_sync.fetching.products': 'Fetching products…',
  'pos.catalog_sync.fetching.price_rules': 'Fetching promos & pricing…',
  'pos.catalog_sync.fetching.done': 'Finishing…',
  'pos.catalog_sync.success': 'Catalog is ready',
  'pos.catalog_sync.error_offline': 'No internet connection. Connect first to fetch cashier data.',
  'pos.catalog_sync.error_generic': 'Failed to sync catalog. Please try again.',
  'pos.catalog_sync.retry': 'Try again',
  'pos.catalog_sync.skip': 'Skip (continue without promo)',
  'pos.catalog_sync.disable': 'Turn off Zero-Loading Mode',
  'pos.sync_history.title': 'Sync Center',
  'pos.sync_history.note':
    'See the sync status of transactions stored in this browser (waiting, succeeded, or failed), and resend the failed ones.',
  'pos.sync_history.open': 'Open History',
  'pos.sync_history.status_failed': '{count} failed',
  'pos.sync_history.status_waiting': '{count} waiting',
  'pos.sync_history.status_synced': 'All synced',
  'pos.sync_history.toast.offline': 'No internet connection',
  'pos.sync_history.storage_warning':
    'This browser has not granted persistent storage. Unsynced transactions may be lost if browser data is cleared — do not clear site data before all transactions are synced.',
  'pos.sync_history.other_users':
    '{count} transactions from other cashiers in this browser will be sent when that cashier logs in again.',
  'pos.sync_history.disabled': 'Zero-Loading mode is not active in this browser.',
  'pos.sync_center.today': 'Today',
  'pos.sync_center.yesterday': 'Yesterday',
  'pos.sync_center.sync_now': 'Sync Now',
  'pos.sync_center.resolve': 'Resolve',
  'pos.sync_center.type.invoice': 'Sale',
  'pos.sync_center.type.order': 'Order',
  'pos.sync_center.type.other': 'Transaction type {id}',
  'pos.sync_center.action.update': 'edit',
  'pos.sync_center.action.pay': 'pay',
  'pos.sync_center.action.close': 'close',
  'pos.sync_center.action.void': 'void',
  'pos.sync_center.status.pending': 'Waiting',
  'pos.sync_center.status.sent': 'Syncing',
  'pos.sync_center.status.done': 'Recorded',
  'pos.sync_center.status.failed': 'Needs action',
  'pos.sync_center.status.blocked': 'Waiting on another transaction',
  'pos.sync_center.status.discarded': 'Cancelled',
  'pos.sync_center.filter.action': 'Needs Action',
  'pos.sync_center.filter.progress': 'In Progress',
  'pos.sync_center.filter.done': 'Finished',
  'pos.sync_center.filter.all': 'All',
  'pos.sync_center.hero.action': '{count} transactions need action',
  'pos.sync_center.hero.progress': '{count} transactions syncing',
  'pos.sync_center.hero.synced': 'All transactions synced',
  'pos.sync_center.hero.also_progress': '{count} syncing',
  'pos.sync_center.hero.refresh': 'Reload from server',
  'pos.sync_center.hero.last_synced': 'Updated {time}',
  'pos.sync_center.empty.action.title': 'Nothing needs your attention',
  'pos.sync_center.empty.action.desc': 'Every offline transaction reached the server.',
  'pos.sync_center.empty.progress.title': 'Nothing is syncing',
  'pos.sync_center.empty.progress.desc': 'New transactions show up here while they sync.',
  'pos.sync_center.empty.done.title': 'No finished transactions yet',
  'pos.sync_center.empty.done.desc': 'Recorded or cancelled transactions show up here.',
  'pos.sync_center.empty.all.title': 'All transactions synced',
  'pos.sync_center.empty.all.desc': 'The sync queue is empty.',
  'pos.sync_center.step.created': 'Created',
  'pos.sync_center.step.sent': 'Sent',
  'pos.sync_center.step.processed': 'Processed',
  'pos.sync_center.step.result': 'Result',
  'pos.sync_center.step.done': 'Recorded',
  'pos.sync_center.step.failed': 'Failed',
  'pos.sync_center.step.blocked': 'Blocked',
  'pos.sync_center.step.discarded': 'Cancelled',
  'pos.sync_center.detail.items': 'Items ({count})',
  'pos.sync_center.detail.paid': 'Paid ({count} payments)',
  'pos.sync_center.detail.total': 'Total',
  'pos.sync_center.detail.product_deleted': 'Deleted product',
  'pos.sync_center.detail.saved_as': 'Saved on the server (ID {id})',
  'pos.sync_center.detail.empty_title': 'Select a transaction',
  'pos.sync_center.detail.empty_subtitle':
    'Details, the failure reason and how to fix it appear here.',
  'pos.sync_center.issue.server_message': 'Server message',
  'pos.sync_center.issue.technical_detail': 'Technical details',
  'pos.sync_center.issue.attempts': 'Tried {count}× · last at {time}',
  'pos.sync_center.issue.missing_product.title': 'Product was deleted',
  'pos.sync_center.issue.missing_product.desc':
    'Line {row} uses a product that was deleted while the device was offline. Recreate it or switch to another product.',
  'pos.sync_center.issue.missing_contact.title': 'Customer was deleted',
  'pos.sync_center.issue.missing_contact.desc':
    'Customer #{contact_id} on this transaction no longer exists. Recreate it or choose another customer.',
  'pos.sync_center.issue.locked_trans_date.title': 'Accounting period is closed',
  'pos.sync_center.issue.locked_trans_date.desc':
    'The transaction synced late and its date falls in a period accounting has locked.',
  'pos.sync_center.issue.locked_trans_date.sold_on': 'Sold on',
  'pos.sync_center.issue.locked_trans_date.closed_until': 'Books closed through',
  'pos.sync_center.issue.locked_trans_date.will_book':
    'If moved, the sale is booked on {date} (first open date).',
  'pos.sync_center.issue.target_not_found.title': 'Waiting on another transaction',
  'pos.sync_center.issue.target_not_found.desc':
    'The referenced transaction (#{ref}) is not on the server. If it has synced since, press Try Again; if the ID is wrong, point to the right transaction.',
  'pos.sync_center.issue.duplicate_transaction.title': 'Possible duplicate',
  'pos.sync_center.issue.duplicate_transaction.desc':
    'This looks like a transaction already on the server (same number and items). Compare them before deciding.',
  'pos.sync_center.issue.duplicate_transaction.open_invoice': 'Open invoice #{id} to compare',
  'pos.sync_center.issue.business_rule.title': 'Rejected by a business rule',
  'pos.sync_center.issue.business_rule.desc':
    'The server rejected this transaction. Fix it according to the message below.',
  'pos.sync_center.issue.internal_error.title': 'Server problem',
  'pos.sync_center.issue.internal_error.desc':
    "Not the cashier's fault — the server failed to process it and nothing was recorded. Safe to retry.",
  'pos.sync_center.issue.upload_failed.title': 'Could not reach the server',
  'pos.sync_center.issue.upload_failed.desc':
    'The server has not received this transaction after several attempts.',
  'pos.sync_center.issue.unsupported.title': 'No longer supported',
  'pos.sync_center.issue.unsupported.desc':
    'The server no longer supports this kind of change. It can only be cancelled.',
  'pos.sync_center.issue.unknown.title': 'Server could not process it',
  'pos.sync_center.issue.unknown.desc': 'The server could not process this transaction.',
  'pos.sync_center.choice.retry_as_is': 'Try Again',
  'pos.sync_center.choice.retry_as_is_desc':
    'Resend unchanged (e.g. after an admin fixed the data)',
  'pos.sync_center.choice.create_product': 'Recreate Product',
  'pos.sync_center.choice.create_product_desc': 'Create a new product, then resend',
  'pos.sync_center.choice.create_contact': 'Recreate Customer',
  'pos.sync_center.choice.create_contact_desc': 'Create a new customer, then resend',
  'pos.sync_center.choice.shift_trans_date': 'Move to Open Period',
  'pos.sync_center.choice.shift_trans_date_desc': 'Book on the first open date',
  'pos.sync_center.choice.retarget': 'Point to Another Transaction',
  'pos.sync_center.choice.retarget_desc': 'Enter the correct server transaction ID',
  'pos.sync_center.choice.edit_transaction': 'Edit Transaction',
  'pos.sync_center.choice.edit_transaction_desc': 'Open in the cashier, fix it, then resend',
  'pos.sync_center.choice.discard': 'Cancel transaction',
  'pos.sync_center.choice.other_options': 'Other options',
  'pos.sync_center.choice.danger_zone': 'Danger zone',
  'pos.sync_center.choice.missing_permission':
    'Some actions are hidden because this account needs: {permissions}. Ask a supervisor.',
  'pos.sync_center.choice.duplicate_heading': 'Is this sale already recorded?',
  'pos.sync_center.choice.duplicate_hint':
    'Compare the total and payments with the invoice above, then choose one.',
  'pos.sync_center.choice.duplicate_discard': 'Already recorded — cancel this copy',
  'pos.sync_center.choice.duplicate_discard_desc': 'This copy will not be recorded',
  'pos.sync_center.choice.duplicate_retry_as_is': 'Different sale — send anyway',
  'pos.sync_center.choice.duplicate_retry_as_is_desc': 'Record it as a separate sale',
  'pos.sync_center.choice.duplicate_edit_transaction': 'Edit it first',
  'pos.sync_center.choice.duplicate_edit_transaction_desc':
    'Open it in the cashier before resending',
  'pos.sync_center.confirm.discard.title': 'Cancel this transaction?',
  'pos.sync_center.confirm.discard.desc': 'The transaction will never be recorded in Kledo.',
  'pos.sync_center.confirm.discard.submit': 'Cancel Transaction',
  'pos.sync_center.confirm.discard.warning':
    'This cannot be undone. If the customer already paid, make sure the sale is recorded elsewhere.',
  'pos.sync_center.confirm.discard.ack': 'I understand this transaction will not be recorded',
  'pos.sync_center.confirm.shift_trans_date.title': 'Move to the open period?',
  'pos.sync_center.confirm.shift_trans_date.desc':
    'The server moves the date to the first day after the lock date and notes the original date in the memo. The sale will be booked later than it happened.',
  'pos.sync_center.confirm.shift_trans_date.submit': 'Move & Resend',
  'pos.sync_center.confirm.duplicate_retry.title': 'Send as a separate sale?',
  'pos.sync_center.confirm.duplicate_retry.desc':
    'Make sure this really is a different sale. If not, it will be recorded twice.',
  'pos.sync_center.confirm.duplicate_retry.submit': 'Yes, Send Anyway',
  'pos.sync_center.confirm.retry.title': 'Resend?',
  'pos.sync_center.confirm.retry.desc': 'The transaction is resent unchanged.',
  'pos.sync_center.confirm.retry.submit': 'Resend',
  'pos.sync_center.form.back': 'Back',
  'pos.sync_center.form.cancel': 'Cancel',
  'pos.sync_center.form.search': 'Search...',
  'pos.sync_center.form.create_and_retry': 'Create & Resend',
  'pos.sync_center.form.create_product_desc':
    'The product on line {row} is replaced with this new product on every line that uses it.',
  'pos.sync_center.form.product_name': 'Product name',
  'pos.sync_center.form.product_name_placeholder': 'e.g. Iced Coffee',
  'pos.sync_center.form.category': 'Category',
  'pos.sync_center.form.category_placeholder': 'Choose a category',
  'pos.sync_center.form.unit_price': 'Selling price',
  'pos.sync_center.form.name_required': 'Name is required',
  'pos.sync_center.form.category_required': 'Choose a category',
  'pos.sync_center.form.price_required': 'Selling price is required',
  'pos.sync_center.form.create_contact_desc':
    'The new customer replaces customer #{id} on this transaction.',
  'pos.sync_center.form.contact_name': 'Customer name',
  'pos.sync_center.form.contact_name_placeholder': 'e.g. Jane Doe',
  'pos.sync_center.form.contact_type': 'Contact type',
  'pos.sync_center.form.contact_type_customer': 'Customer',
  'pos.sync_center.form.retarget_desc':
    'Enter the server transaction ID (numeric). Device-created transactions that have not synced cannot be referenced.',
  'pos.sync_center.form.retarget_submit': 'Point & Resend',
  'pos.sync_center.form.ref_id': 'Server transaction ID',
  'pos.sync_center.form.ref_id_required': 'Transaction ID is required',
  'pos.sync_center.form.ref_id_numeric': 'Transaction ID must be a number',
  'pos.sync_center.form.note_required_label': 'Reason (required)',
  'pos.sync_center.form.note_optional_label': 'Note (optional)',
  'pos.sync_center.form.note_placeholder': 'Write a reason for the audit trail',
  'pos.sync_center.form.note_required': 'A reason is required',
  'pos.sync_center.form.note_max': 'Up to 255 characters',
  'pos.sync_center.form.ack_required': 'Tick the confirmation to continue',
  'pos.sync_center.form.duplicate_note': 'duplicate of #{id}',
  'pos.sync_center.toast.queued': 'Resent — waiting for the server',
  'pos.sync_center.toast.discarded': 'Transaction cancelled',
  'pos.sync_center.toast.failed': 'Could not resolve the transaction',
  'pos.sync_center.toast.uploaded': '{count} transactions sent',
  'pos.sync_center.toast.resent': '{count} transactions resent',
  'pos.sync_center.toast.offline': 'No internet connection',
  'pos.sync_center.toast.all_synced': 'Everything is synced',
  'pos.sync_center.toast.needs_decision': '{count} transactions need your decision',
  'pos.sync_center.toast.no_device': 'This device is not registered',
  'pos.sync_center.toast.sync_failed': 'Sync failed, try again',
  'pos.sync_center.correction.loading': 'Loading transaction...',
  'pos.sync_center.correction.load_failed': 'Could not load the transaction into the cashier',
  'pos.sync_center.correction.banner_title': 'Correcting {ref}',
  'pos.sync_center.correction.banner_original': 'Original total {amount}',
  'pos.sync_center.correction.banner_current': 'now {amount}',
  'pos.sync_center.correction.cancel': 'Cancel correction',
  'pos.sync_center.correction.cancel_title': 'Cancel the correction?',
  'pos.sync_center.correction.cancel_message':
    'The cart is cleared. The transaction stays failed in the Sync Center and can be corrected later.',
  'pos.sync_center.correction.cancel_ok': 'Yes, Cancel',
  'pos.sync_center.correction.cancelled': 'Correction cancelled',
  'pos.sync_center.correction.sent': 'Correction sent — waiting for the server',
  'pos.sync_center.correction.not_resolvable':
    'This transaction can no longer be corrected (its status changed)',
  'pos.sync_center.correction.missing_permission':
    'This account needs {permissions} to send the correction',
  'pos.sync_center.correction.no_deferred': 'Corrections cannot use QRIS / payment gateway',
  'pos.sync_center.correction.use_pay': 'Correct this transaction with the Pay button',
  'pos.sync_center.correction.use_save': 'Correct this order with the Save button',
  'pos.sync_center.close_shift.title': 'Sync queue is not finished',
  'pos.sync_center.close_shift.message':
    'Finish it first so the shift totals on the server are complete.',
  'pos.sync_center.close_shift.action': 'Needs action',
  'pos.sync_center.close_shift.progress': 'Syncing',
  'pos.sync_center.close_shift.open': 'Open Sync Center',
  'pos.sync_center.close_shift.later': 'Later',
  'pos.sync_center.issue.shift_closed.title': 'Shift already closed',
  'pos.sync_center.issue.shift_closed.desc':
    'Shift #{shift} this sale belongs to was closed (usually from the web or another device) before it synced. It needs to move to a shift that is still open, or be recorded in its original shift.',
  'pos.sync_center.choice.move_shift': 'Move to an Open Shift',
  'pos.sync_center.choice.move_shift_desc': 'Record it in a running shift; the sale date stays',
  'pos.sync_center.choice.bypass_shift_closed': 'Record in the Original Shift',
  'pos.sync_center.choice.bypass_shift_closed_desc':
    'The closed shift report and cash handover change',
  'pos.sync_center.confirm.bypass_shift_closed.title': 'Record in the closed shift?',
  'pos.sync_center.confirm.bypass_shift_closed.desc':
    'The sale is recorded in its original shift, then that shift is recalculated.',
  'pos.sync_center.confirm.bypass_shift_closed.submit': 'Record in Original Shift',
  'pos.sync_center.confirm.bypass_shift_closed.ack': 'I approve changing the closed shift',
  'pos.sync_center.form.move_shift_desc':
    'Choose a shift that is still open in the same outlet. The sale date does not change.',
  'pos.sync_center.form.move_shift_submit': 'Move & Resend',
  'pos.sync_center.form.move_shift_mine': 'Your current shift',
  'pos.sync_center.form.move_shift_recommended': 'Recommended',
  'pos.sync_center.form.move_shift_opened': 'Shift #{id} · opened {time}',
  'pos.sync_center.form.move_shift_load_failed':
    'Could not load other shifts in this outlet. Tap to retry.',
  'pos.sync_center.form.move_shift_note_placeholder': 'e.g. late sync, goes to the evening shift',
  'pos.sync_center.confirm.discard_local.title': 'Cancel an unsent transaction?',
  'pos.sync_center.confirm.discard_local.desc':
    'The server never confirmed this transaction, so the device stops sending it.',
  'pos.sync_center.confirm.discard_local.submit': 'Cancel Transaction',
  'pos.sync_center.confirm.discard_local.warning':
    'If the network dropped earlier, the transaction may still have reached the server. Check the sales list in Kledo before cancelling.',
  'pos.sync_center.edit_confirm.title': 'Open this transaction in the cashier?',
  'pos.sync_center.edit_confirm.desc':
    'The transaction is loaded into the cashier. Edit it, then press Pay / Save to send the correction. The original number, date and shift are kept — no new transaction is created.',
  'pos.sync_center.edit_confirm.submit': 'Open in Cashier',
  'pos.sync_center.edit_confirm.cart_cleared': 'The current cart ({count} items) will be cleared.',
  'pos.sync_center.edit_confirm.other_correction':
    'The correction in progress for {ref} will be cancelled.',
  'pos.sync_center.edit_confirm.repay': 'Payment must be entered again. Previously paid: {amount}.',
  'pos.sync_center.correction.banner_paid': 'Previously paid {amount}',
  'pos.sync_center.title': 'Sync Center',
  'pos.sync_center.subtitle':
    'Monitor offline transactions in this browser and resolve the ones the server rejected.',
  'pos.sync_center.detail.close': 'Close',
  'pos.sync_center.correction.cart_not_empty':
    'The cashier cart still has items. Clear or finish it before correcting a transaction.',
  'pos.close_shift.devices_title': 'Other devices still have this shift open',
  'pos.close_shift.devices_desc':
    'Close the shift on the following devices first so the shift data is complete.',
  'pos.close_shift.unnamed_device': 'Unnamed device',
  'pos.close_shift.this_browser': 'This browser',
  'pos.close_shift.device_id': 'ID',
  'pos.close_shift.force_close': 'Force Close',
  'pos.close_shift.force_title': 'Force close this shift?',
  'pos.close_shift.force_subtitle':
    'The shift will be closed without waiting for other devices. Understand the risks before continuing.',
  'pos.close_shift.force_risk_unsynced':
    'Unsent transactions on other devices will not be included in this shift recap.',
  'pos.close_shift.force_risk_rejected':
    "Transactions sent by other devices after the shift is closed may be rejected and need to be handled in that device's Sync Center.",
  'pos.close_shift.force_risk_recap':
    'Cash differences or the shift recap need to be checked and corrected manually.',
  'pos.close_shift.force_zero_loading_title': 'Using Zero-Loading Mode?',
  'pos.close_shift.force_zero_loading_desc':
    'Transactions are stored on the device first before being sent to the server. Check in Kledo that all transactions from the devices above have arrived before force closing.',
  'pos.close_shift.force_acknowledge': 'I have checked and understand the risks',
  'pos.close_shift.force_confirm': 'Yes, Force Close',
  'pos.shift.closed_on_server':
    'This shift has already been closed (by the system or another device). Please open a new shift.',
  'pos.shift.closed_by_system':
    'This shift has been closed automatically by the system. Please open a new shift.',
  'pos.device.checking': 'Checking device…',
  'pos.device.checking_desc':
    'One moment, we are making sure this browser is registered as a cashier device.',
  'pos.device.register_title': 'Register this browser',
  'pos.device.register_desc':
    'This browser is not registered as a cashier device yet. Give it a name so it is easy to recognize when several devices share the same shift.',
  'pos.device.nickname': 'Device name',
  'pos.device.nickname_placeholder': 'e.g. Front Cashier',
  'pos.device.nickname_required': 'Device name is required',
  'pos.device.register': 'Register',
  'pos.device.register_success': 'Device registered successfully',
  'pos.device.register_failed': 'Failed to register device',
  'pos.device.device_id': 'Device ID',
  'pos.logout.pending_title': 'Unsynced transactions',
  'pos.logout.pending_desc':
    '{count} transactions are not synced yet. They will only be sent when you log in again in this browser.',
  'pos.logout.sync_first': 'Sync first',
  'pos.logout.logout_anyway': 'Log out anyway',
  'pos.zero_loading.share_after_sync':
    'Sending the receipt via WA/Email is available once the transaction is synced to the server.',
  'pos.zero_loading.saved_offline': 'Saved, syncing to the server',
  'pos.web_order_payment.title': 'Direct Payment for POS Web Order',
  'pos.web_order_payment.note': 'If enabled, orders placed via POS Web Order can be paid directly.',
  'pos.invoice_types.title': 'Order Types',
  'pos.invoice_types.note':
    'Manage which order types cashiers can pick. Hidden types do not appear at the cashier; past transactions stay intact. Changes apply on other cashier devices after the page is reloaded.',
  'pos.invoice_types.visible_count': '{visible} of {total} shown at cashier',
  'pos.invoice_types.built_in': 'Built-in',
  'pos.invoice_types.custom': 'Custom',
  'pos.invoice_types.shown': 'Shown at cashier',
  'pos.invoice_types.hidden': 'Hidden',
  'pos.invoice_types.add': 'Add Order Type',
  'pos.invoice_types.add_title': 'Add Order Type',
  'pos.invoice_types.edit_title': 'Edit Order Type',
  'pos.invoice_types.name': 'Order type name',
  'pos.invoice_types.name_placeholder': 'Example: Catering',
  'pos.invoice_types.name_required': 'Order type name is required',
  'pos.invoice_types.rename_note':
    'The new name will also appear on past transactions and reports that use this order type.',
  'pos.invoice_types.custom_empty':
    'No custom order types yet. Add ones that fit your business, such as Catering or Pre-order.',
  'pos.invoice_types.confirm_delete': 'Delete this order type?',
  'pos.invoice_types.cannot_delete_title': 'Order type cannot be deleted',
  'pos.invoice_types.hide_instead':
    'Hide it from the cashier instead so it can no longer be picked. Past transactions stay intact.',
  'pos.invoice_types.hide': 'Hide',
  'pos.invoice_types.load_failed': 'Failed to load order types.',
  'pos.invoice_types.retry': 'Try again',
  'pos.invoice_types.edit': 'Edit',
  'pos.invoice_types.delete': 'Delete',
  'pos.invoice_types.save_failed': 'Failed to save order type.',
  'pos.invoice_types.delete_failed': 'Failed to delete order type.',
  'pos.product_image': 'Product Image',
  'pos.product_image_required': 'Product Image required',
  'pos.choose_category_required': 'choose category required',
  'pos.choose_category': 'Choose Category',
  'pos.product_name_required': 'product name required',
  'pos.price': 'Price',
  'pos.price_required': 'price required',
  'pos.extra_price_must_greather_than_0': 'Extra price must greather than 0.',
  'pos.base_price': 'Base Price',
  'pos.base_price_required': 'Base Price required',
  'pos.description': 'Description',
  'pos.description_required': 'Description required',
  'pos.edit_product': 'Edit Product',
  'pos.variant': 'Variant',
  'pos.variant_name_required': 'variant name required',
  'pos.edit_variant': 'Edit Variant',
  'financeInvoices.order_payment': 'Order Payment',
  'financeInvoices.builtin_notes_for_easy_searching': 'Built-in notes for easy searching.',
  'financeInvoices.the_number_will_be_automatically_generated_by_the_system':
    'The number will be automatically generated by the system, but you can also change it here.',
  'financeInvoices.you_can_set_the_format_of_this_number':
    'You can set the format of this number {link}.',
  'financeInvoices.used_to_create_transaction_categories':
    'Used to create transaction categories. You can also generate reports based on this tag.',
  'financeInvoices.message': 'Message',
  'financeInvoices.show_more_detail': 'Show more detail',
  'financeInvoices.show_less_detail': 'Hide detail',
  'financeInvoices.here': 'here',
  'financeInvoices.add_invoice': 'Add Invoice',
  'financeInvoices.financeInvoices': 'Invoice',
  'financeInvoices.witholding': 'Witholding',
  'financeInvoices.select_holding_from': 'Select holding from',
  'financeInvoices.please_select_a_holding_from': 'Please select a holding from',
  'financeInvoices.successfully_added': 'successfully added.',
  'financeInvoices.error_cannot_add': 'Cannot add invoice.',
  'financeInvoices.error_cannot_print_pdf': 'Cannot print pdf invoice.',
  'financeInvoices.error_cannot_export_receipt': 'Export receipt failed',
  'financeInvoices.error_cannot_update': 'Cannot update invoice.',
  'financeInvoices.error_cannot_move': 'Cannot move the invoice.',
  'financeInvoices.error_cannot_change_status': 'Cannot change status the invoice.',
  'financeInvoices.edit_invoice': 'Edit Invoice',
  'financeInvoices.max_characters': 'Max {value} characters.',
  'financeInvoices.min_characters': 'Min {value} characters.',
  'financeInvoices.only_number_allowed': 'Only number allowed.',
  'financeInvoices.description': 'Description',
  'financeInvoices.tax': 'Tax',
  'financeInvoices.tax_amount': 'Amount',
  'financeInvoices.more_taxes': '{count} more taxes',
  'financeInvoices.dpp': 'DPP',
  'financeInvoices.select_tax': 'Select tax',
  'financeInvoices.no_tax': 'No Tax',
  'financeInvoices.please_select_a_contact': 'Please select a contact',
  'financeInvoices.select_contact': 'Select contact',
  'financeInvoices.add_contact': 'Add contact',
  'financeInvoices.all_contacts': 'All contact',
  'financeInvoices.transaction_date': 'Transaction Date',
  'financeInvoices.transaction': 'Transaction',
  'financeInvoices.please_select_transaction_date': 'Please select transaction date',
  'financeInvoices.due_date': 'Due Date',
  'financeInvoices.please_select_due_date': 'Please select due date',
  'financeInvoices.term': 'Term',
  'financeInvoices.select_term': 'Select term',
  'financeInvoices.add_term': 'Add term',
  'financeInvoices.price_include_tax': 'Price include tax',
  'financeInvoices.add_more': 'Add more',
  'financeInvoices.number': 'Number',
  'financeInvoices.import_order_number': 'Order Number',
  'financeInvoices.import_previous_trans_number_is_optional':
    'The {column} column is optional. When it is filled, the imported transaction is automatically linked to that transaction, the same as using the Continue process. When it is left empty, the transaction is created without a reference.',
  'financeInvoices.please_input_the_number': 'Please input the number.',
  'financeInvoices.memo': 'Memo',
  'financeInvoices.date': 'Date',
  'financeInvoices.payment_date': 'Payment Date',
  'financeInvoices.action': 'Action',
  'financeInvoices.paid_date': 'Paid Date',
  'financeInvoices.show_payment_amount': 'Show payment amount',
  'financeInvoices.hide_payment_amount': 'Hide payment amount',
  'financeInvoices.edit_total_payment':
    'Edit total payment. The amount is automatically allocated to each invoice from top to bottom.',
  'financeInvoices.status': 'Status',
  'financeInvoices.payment_status': 'Payment Status',
  'financeInvoices.balance_due': 'Balance Due',
  'financeInvoices.billed_to': 'Billed To',
  'financeInvoices.payment_summary': 'Payment Summary',
  'financeInvoices.total_paid': 'Amount Paid',
  'financeInvoices.percentage_paid': '{percent}% paid',
  'financeInvoices.transaction_detail': 'Transaction Details',
  'financeInvoices.please_select_a_term': 'Please select a term.',
  'financeInvoices.search_by_memo': 'Search',
  'financeInvoices.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financeInvoices.detail_title': ' Invoice {number}',
  'financeInvoices.customer': 'Customer',
  'financeInvoices.reference': 'Reference',
  'financeInvoices.product': 'Product',
  'financeInvoices.qty': 'Qty',
  'financeInvoices.price': 'Price',
  'financeInvoices.add_product': 'Add Product',
  'financeInvoices.select_product': 'Select product',
  'financeInvoices.attachments': 'Attachments',
  'financeInvoices.save_&_approve': 'Save & approve',
  'financeInvoices.save_as_draft': 'Save as draft',
  'financeInvoices.save_&_submit_for_approval': 'Save & submit for approval',
  'financeInvoices.please_select_a_product': 'Please select a product.',
  'financeInvoices.please_input_the_qty': 'Please input the qty.',
  'financeInvoices.please_input_the_price': 'Please input the price.',
  'financeInvoices.please_input_the_amount': 'Please input the amount.',
  'financeInvoices.approve': 'Approve',
  'financeInvoices.are_you_sure_to_approve': 'Are you sure to approve ?',
  'financeInvoices.submit_for_approval': 'Submit for approval',
  'financeInvoices.are_you_sure_to_submit_for_approval': 'Are you sure to submit for approval ?',
  'financeInvoices.create_invoice': 'Create Invoice',
  'financeInvoices.amount_paid': 'Amount Paid',
  'financeInvoices.add_payment': 'Receive Payment',
  'financeInvoices.receive_a_payment': 'Receive a payment',
  'financeInvoices.error_cannot_add_payment': 'Cannot add payment.',
  'financeInvoices.payment': 'Payment',
  'financeInvoices.detail_invoice': 'Detail  Invoice',
  'financeInvoices.number_quotes': 'Quotes Number',
  'financeInvoices.amount': 'Amount',
  'financeInvoices.tax_code': 'Tax Code',
  'financeInvoices.please_input_the_tax_code': 'Please input the tax code.',
  'financeInvoices.error_cannot_change_tax_code': 'Cannot change tax code.',
  'financeInvoices.order': 'Order Number',
  'financeInvoices.quote': 'Quote Number',
  'financeInvoices.purchase_request': 'Purchase Request Number',
  'financeInvoices.delivery': 'Delivery Number',
  'financeInvoices.please_select_deliveries': 'Please select at least one delivery',
  'financeInvoices.cannot_greather_than_order': 'Cannot greather than order.',
  'financeInvoices.down_payment': 'Down payment',
  'financeInvoices.already_paid': 'Paid',
  'financeInvoices.print_invoice': 'Invoice',
  'financeInvoices.whoever_have_this_link_can_see_pdf':
    'Whoever has this link can see the invoice as PDF format.',
  'financeInvoices.copy_link': 'Copy Invoice Link',
  'financeInvoices.send_email': 'Send Invoice Email',
  'financeInvoices.send_sms': 'Send Invoice SMS',
  'financeInvoices.send_wa': 'Send Invoice Whatsapp',
  'financeInvoices.on': 'on',
  'financeInvoices.last_printed_by': 'Last printed by',
  'financeInvoices.last_modified_by': 'Last modified by',
  'financeInvoices.log': 'Log',
  'financeInvoices.last_sent_email_on': 'Last sent this email on {date}',
  'financeInvoices.last_sent_whatsapp_on': 'Last sent this WhatsApp on {date}',
  'financeInvoices.last_sent_email_recap_on': 'Last sent this recap email on {date}',
  'financeInvoices.last_sent_sms_recap_on': 'Last sent this recap SMS on {date}',
  'financeInvoices.preorder_number': 'PO Number',
  'financeInvoices.total_before_tax': 'Total Before Tax',
  'financeInvoices.printStatus': 'Print Status',
  'financeInvoices.deliveryPrintStatus': 'Delivery Note Print Status',
  'financeInvoices.print_status_printed': 'Done',
  'financeInvoices.print_status_unprinted': 'Not Yet',
  'financeInvoices.import_new_invoice': 'Import New Invoice',
  'financeInvoices.import_invoice_status': 'Import Invoice Status',
  'financeInvoices.import_recurring_invoice': 'Recurring Invoice Import',
  'financeInvoices.print_partial': 'Partial Invoice',
  'financeInvoices.print_partial_with_stamp': 'Print and Attach E-Stamp Duty',
  'financeInvoices.print_delivery_label': 'Delivery Label',
  'financeInvoices.print_delivery': 'Delivery Order',
  'financeInvoices.print_payment': 'Payment Recap',
  'financeInvoices.print_tax': 'Tax Invoice',
  'financeInvoices.download_word': 'Invoice MsWord',
  'financeInvoices.default_label_term': 'Term Invoice I',
  'financeInvoices.please_input_label': 'Please input the label',
  'financeInvoices.insufficient_stock': 'Insufficient Stock',
  'financeInvoices.insufficient_stock_confirm':
    'There is a product that has insufficient stock, Will you still make this bill ?',
  'financeInvoices.insufficient_stock_warning':
    'Cannot add to the bill, because there are products that have insufficient stock.',
  'financeInvoices.sales': 'Sales',
  'financeInvoices.print_receipt': 'Print Invoices Receipt',
  'financeInvoices.download': 'Download',
  'financeInvoices.download_sales_report': 'Download Sales Report',
  'financeInvoices.my_order': 'My Order',
  'financeInvoices.all': 'All',
  'financeInvoices.export': 'Export',
  'financeInvoices.orders': 'Orders',
  'financeInvoices.order_review': 'Order Review',
  'financeInvoices.manage_order': 'Manage Order',
  'financeInvoices.download_order': 'Download Order',
  'financeInvoices.export_all_order': 'Export All Order',
  'financeInvoices.delivery_list': 'Delivery List',
  'financeInvoices.done': 'Done',
  'financeInvoices.export_invoice': 'Export E-Invoice',
  'financeInvoices.choose_template': 'Choose Template',
  'financeInvoices.import_with_kledo_template': 'Import with Excel template format from Kledo',
  'financeInvoices.marketplace_connect_sync_automatic_from_marketplace_without_import':
    'Marketplace Connect: Sync data automatically from marketplace to Kledo, without import',
  'financeInvoices.import_with_marketplace_template':
    'Import with Excel template format from Marketplace',
  'financeInvoices.export_sales_data_from_tokopedia': '1. Export Sales Data from Tokopedia',
  'financeInvoices.export_sales_data_from_shopee': '1. Export Sales Data from Shopee',
  'financeInvoices.export_sales_data_from_bukalapak': '1. Export Sales Data from Bukalapak',
  'financeInvoices.export_sales_data_from_lazada': '1. Export Sales Data from Lazada',
  'financeInvoices.export_sales_data_from_tiktok': '1. Export Sales Data from Tiktok Shop',
  'financeInvoices.export_sales_data_from_olsera': '1. Export sales data from Olsera dashboard',
  'financeInvoices.export_sales_data_record_shipping_cost_to_bill': 'Record Shipping Cost To Bill',
  'financeInvoices.upload_excel_from_tokopedia': '2. Upload Excel File from Tokopedia Here',
  'financeInvoices.upload_excel_from_shopee': '2. Upload Excel File from Shopee Here',
  'financeInvoices.upload_excel_from_bukalapak': '2. Upload Excel File from Bukalapak Here',
  'financeInvoices.upload_excel_from_lazada': '2. Upload Excel File from Lazada Here',
  'financeInvoices.upload_excel_from_tiktok': '2. Upload Excel File from Tiktok Shop Here',
  'financeInvoices.upload_excel_from_olsera': '2. Upload Excel File from Olsera Here',
  'financeInvoices.set_import_option': '3. Set Import Option',
  'financeInvoices.1a_tokopedia':
    'a. Log in to the TikTok seller center application, then click the Manage Orders menu. Click the "all" tab if you want to retrieve all transactions. Click the "completed" tab if you only want to retrieve transactions with completed status',
  'financeInvoices.1b_tokopedia':
    'b. Click "Filter" to select the time range for the costs you want to download in the "Created Time" Data Period column. If you want to separate TikTok and Tokopedia sales transactions for cash and bank account mapping and tags, click "Ordered in" and export the data from TikTok and Tokopedia.',
  'financeInvoices.1a_shopee':
    'a. Log in to the Shopee Seller Center application, then click the My Orders menu.',
  'financeInvoices.1b_shopee':
    'b. Click the "all" tab if you want to retrieve all transactions and click the "completed" tab if you only want to retrieve transactions with completed status',
  'financeInvoices.1c_shopee':
    'c. Click Export then Filter the time range of the sales report you want to download.',
  'financeInvoices.1d_shopee': 'd. Click download history to download the export data results.',
  'financeInvoices.1a_bukalapak': 'a. On Home page, click {transaction} tab',
  'financeInvoices.1b_bukalapak': 'b. Click {downloadTransaction} button',
  'financeInvoices.1c_bukalapak':
    'c. Filter time range and sales report transaction that you want to download, then click {downloadTransaction} button. Save the recently downloaded Excel file',
  'financeInvoices.1a_lazada': 'a. On Home page, click {orders} tab, then click {orderReview} tab',
  'financeInvoices.1b_lazada': 'b. Click {export} button, then click {exportAllOrder}',
  'financeInvoices.1c_lazada':
    'c. For sales report that you want to download, click {download} button, then click {done}. Save the recently downloaded Excel file',
  'financeInvoices.1a_tiktok': 'a. Click {order} - {manageOrder} menu',
  'financeInvoices.1b_tiktok': 'b. Click {done} tab',
  'financeInvoices.1c_tiktok': 'c. Click {downloadOrder} menu',
  'financeInvoices.1d_tiktok': 'd. Select Excel download format',
  'financeInvoices.1e_tiktok': 'e. Check {deliveryList} on {chooseTemplate}',
  'financeInvoices.1f_tiktok': 'f. Click {download} button',
  'financeInvoices.1a_olsera': 'a. Click the "Reports" menu',
  'financeInvoices.1b_olsera': 'b. Click the "Sales Reports" menu',
  'financeInvoices.1c_olsera': 'c. Click the "Sales By Date" menu',
  'financeInvoices.1d_olsera': 'd. Select payment status has been paid',
  'financeInvoices.1e_olsera':
    'e. Click the Excel button. Save the Excel file you just downloaded.',
  'financeInvoices.this_import_will_change_status':
    'This import feature will change invoice status that has not paid to paid.',
  'financeInvoices.data_will_not_change_even_if_different':
    'Invoice data will not be changed on this import, even if the data on the kledo system with the data on the excel file is different.',
  'financeInvoices.follow_these_steps_to_import_your_invoices':
    'Follow these steps to import your invoices',
  'financeInvoices.1_download_your_invoices_template_file':
    '1. Download your invoices template file',
  'financeInvoices.start_by_downloading_our_invoices_csv':
    'Start by downloading our invoices Excel template file. This file has the correct column headings Kledo needs to import details of your invoices.',
  'financeInvoices.download_template_file': 'Download Template File',
  'financeInvoices.download_template_data_example_file': 'Download template data example file',
  'financeInvoices.import': 'Import Invoices',
  'financeInvoices.2_copy_your_invoices_into_the_template':
    '2. Copy your invoices into the template',
  'financeInvoices.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your invoices. Make sure the product details match the column headings provided in the template.',
  'financeInvoices.important': 'IMPORTANT',
  'financeInvoices.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeInvoices.upload': 'Upload',
  'financeInvoices.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeInvoices.a_maximum_of_n_invoices_can_be_imported_at_a_time':
    'A maximum of {max} invoices can be imported at a time.',
  'financeInvoices.a_single_import_supports_up_to_n_rows':
    'A single import supports up to {max} rows of Excel data.',
  'financeInvoices.a_single_import_supports_up_to_n_rows_including_invoice_and_item':
    'A single import supports up to {max} rows of Excel data. Every row is counted, including invoice rows and item rows.',
  'financeInvoices.a_maximum_of_2500_invoices_can_be_imported_at_a_time':
    'A single import process supports up to 2,500 rows of Excel data. Every row is counted, including both invoice and item rows.',
  'financeInvoices.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Contact name that not exist will be inserted as a new contact.',
  'financeInvoices.import_actions_only_insert_new_invoices_cannot_update_or_delete':
    'Import actions only insert new invoices, cannot update nor delete.',
  'financeInvoices.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeInvoices.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financeInvoices.upload_file': 'Upload File',
  'financeInvoices.check_the_imported_data': 'Check Data',
  'financeInvoices.please_check_the_imported_data': 'Please check the imported data',
  'financeInvoices.import_invoices_done': 'Import Success',
  'financeInvoices.error_upload_file': 'Upload failed.',
  'financeInvoices.file_not_found': 'File not found',
  'financeInvoices.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'financeInvoices.valid': 'Valid',
  'financeInvoices.invalid': 'Invalid',
  'financeInvoices.total': 'Total',
  'financeInvoices.import_now': 'Import Now',
  'financeInvoices.contact_name': 'Contact name',
  'financeInvoices.email': 'Email',
  'financeInvoices.address': 'Address',
  'financeInvoices.phone': 'Phone',
  'financeInvoices.invoice_date': 'Invoice Date',
  'financeInvoices.date_same_as_the_original_transaction':
    'The date is the same as the original transaction',
  'financeInvoices.invoice_number': 'Invoice Number',
  'financeInvoices.product_name': 'Product name',
  'financeInvoices.code_sku': 'Kode/SKU',
  'financeInvoices.tax_inclusive': 'Tax Inclusive',
  'financeInvoices.paid': 'Paid',
  'financeInvoices.paid_account': 'Paid To Account',
  'financeInvoices.row_imported': '{imported} of {total} rows imported',
  'financeInvoices.inventory_account': 'Inventory Account',
  'financeInvoices.invoices_successfully_imported': '{rowCount} invoice imported successfully.',
  'financeInvoices.view_detail': 'View detail',
  'financeInvoices.import_another_file': 'Import another file',
  'financeInvoices.go_to_invoice_list': 'Go to invoice list',
  'financeInvoices.success': 'Success',
  'financeInvoices.failed': 'Failed',
  'financeInvoices.error_cannot_import': 'Import failed',
  'financeInvoices.error': 'Error',
  'financeInvoices.import_invoices_in_progress': 'Import in progress',
  'financeInvoices.import_invoices_is_still_in_progress': 'Import is still in progress',
  'financeInvoices.import_warehouse_help_text':
    'If when importing data from the marketplace you fill in the warehouse column, then the product formed as a result of the imported transaction will automatically "track stock". However, if the product is not stocked in the warehouse, the product will automatically "not track stock".',
  'financeInvoices.its_ok_to_close_this_page':
    "It's ok OK to close this page or import another file. When import done, you will be notified via email.",
  'financeInvoices.duplicate_to_trans': 'Duplicate to transaction',
  'financeInvoices.you_can_only_upload_up_to': 'You can only upload up to {count} files',
  'financeInvoices.cash_payment': 'Cash Payment',
  'financeInvoices.with_credit_payment': 'With Credit Memo',
  'financeInvoices.with_debit_payment': 'With Debit Memo',
  'financeInvoices.payment_with_credit_memo': 'Payment using Credit Memo',
  'financeInvoices.payment_with_debit_memo': 'Payment using Debit Memo',
  'financeBanks.edit_bank_statement': 'Edit Bank Statement',
  'financeBanks.are_you_sure_to_revert': 'Are you sure to revert ?',
  'financeBanks.error_cannot_revert': 'Cannot revert',
  'financeBanks.add_bank': 'Add Bank',
  'financeBanks.financeBanks': 'Cash & Bank Accounts',
  'financeBanks.manage_account': 'Manage Account',
  'financeBanks.statement_balance': 'Statement Balance',
  'financeBanks.balance_in_kledo': 'Balance in kledo',
  'financeBanks.successfully_added': 'successfully added.',
  'financeBanks.error_cannot_add': 'Cannot add bank.',
  'financeBanks.error_cannot_update': 'Cannot update bank.',
  'financeBanks.error_cannot_move': 'Cannot move the bank.',
  'financeBanks.error_cannot_change_status': 'Cannot change status the bank.',
  'financeBanks.edit_bank': 'Edit  bank',
  'financeBanks.only_number_allowed': 'Only number allowed.',
  'financeBanks.description': 'Description',
  'financeBanks.max_characters': 'Max {value} characters.',
  'financeBanks.min_characters': 'Min {value} characters.',
  'financeBanks.tax': 'Tax',
  'financeBanks.select_tax': 'Select tax',
  'financeBanks.amount': 'Amount',
  'financeBanks.please_select_a_contact': 'Please select a contact',
  'financeBanks.select_contact': 'Select contact',
  'financeBanks.add_contact': 'Add contact',
  'financeBanks.all_contacts': 'All contact',
  'financeBanks.contact': 'Contact',
  'financeBanks.transaction_date': 'Transaction Date',
  'financeBanks.please_select_transaction_date': 'Please select transaction date',
  'financeBanks.payment_date': 'Payment Date',
  'financeBanks.please_select_payment_date': 'Please select payment date',
  'financeBanks.due_date': 'Due Date',
  'financeBanks.please_select_due_date': 'Please select due date',
  'financeBanks.term': 'Term',
  'financeBanks.select_term': 'Select term',
  'financeBanks.add_term': 'Add term',
  'financeBanks.price_include_tax': 'Price include tax',
  'financeBanks.add_more': 'Add more',
  'financeBanks.number': 'Number',
  'financeBanks.please_input_the_number': 'Please input the number.',
  'financeBanks.memo': 'Memo',
  'financeBanks.date': 'Date',
  'financeBanks.status': 'Status',
  'financeBanks.balance_due': 'Balance Due',
  'financeBanks.please_select_a_account': 'Please select a account.',
  'financeBanks.search_by_memo': 'Search',
  'financeBanks.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financeBanks.detail_title': ' Transaction: {transTypeName}',
  'financeBanks.customer': 'Customer',
  'financeBanks.reference': 'Reference',
  'financeBanks.attachments': 'Attachments',
  'financeBanks.save_&_approve': 'Save & approve',
  'financeBanks.save_as_draft': 'Save as draft',
  'financeBanks.save_&_submit_for_approval': 'Save & submit for approval',
  'financeBanks.please_input_the_amount': 'Please input the amount.',
  'financeBanks.approve': 'Approve',
  'financeBanks.are_you_sure_to_approve': 'Are you sure to approve ?',
  'financeBanks.submit_for_approval': 'Submit for approval',
  'financeBanks.are_you_sure_to_submit_for_approval': 'Are you sure to submit for approval ?',
  'financeBanks.create_bank': 'Create Bank',
  'financeBanks.amount_paid': 'Amount Paid',
  'financeBanks.paid_from': 'Paid From',
  'financeBanks.add_payment': 'Add Payment',
  'financeBanks.make_a_payment': 'Make a payment',
  'financeBanks.select_paid_from': 'Select paid from',
  'financeBanks.please_select_a_paid_from': 'Please select a paid from.',
  'financeBanks.error_cannot_add_payment': 'Cannot add payment.',
  'financeBanks.payment': 'Payment',
  'financeBanks.detail_bank': 'Detail  Bank',
  'financeBanks.spent': 'Spent',
  'financeBanks.received': 'Received',
  'financeBanks.balance': 'Balance',
  'financeBanks.transfer_money': 'Transfer Money',
  'financeBanks.spend_money': 'Spend Money',
  'financeBanks.receive_money': 'Receive Money',
  'financeBanks.receive_multi_invoice_payment': 'Receive Combined Payment',
  'financeBanks.spend_multi_purchase_payment': 'Pay Combined (Purchase)',
  'multiInvoicePayment.bank_account': 'Bank Account',
  'multiInvoicePayment.number': 'Number',
  'multiInvoicePayment.select_invoices': 'Select invoices to settle',
  'multiInvoicePayment.select_customer_first': 'Select a customer first to load invoices',
  'multiInvoicePayment.no_invoice': 'Invoice No.',
  'multiInvoicePayment.date': 'Date',
  'multiInvoicePayment.remaining_due': 'Remaining Due',
  'multiInvoicePayment.paid': 'Paid',
  'multiInvoicePayment.fees_title': 'Fees / difference (optional)',
  'multiInvoicePayment.fee_type': 'Fee Type',
  'multiInvoicePayment.nominal': 'Amount',
  'multiInvoicePayment.add_fee_row': 'Add fee row',
  'multiInvoicePayment.subtotal_allocation': 'Allocation subtotal',
  'multiInvoicePayment.total_transfer': 'Total transfer',
  'multiInvoicePayment.min_one_invoice': 'Select at least one invoice',
  'multiInvoicePayment.amount_required': 'Enter the paid amount',
  'multiInvoicePayment.amount_exceeds_due': 'Amount exceeds remaining due',
  'multiInvoicePayment.different_currency':
    'Invoices with a different rate must be paid separately',
  'multiInvoicePayment.please_select_fee': 'Select a fee type',
  'multiInvoicePayment.fee_value_required': 'Enter the fee amount',
  'multiInvoicePayment.fee_value_not_zero': 'Fee amount cannot be 0',
  'multiInvoicePayment.max_fee_rows': 'Maximum 5 fee rows',
  'multiInvoicePayment.max_invoice_rows': 'Maximum 50 invoices',
  'multiInvoicePayment.saved': 'Combined payment saved',
  'multiInvoicePayment.no_unpaid_invoice': 'No unpaid invoices for this customer',
  'financeBanks.auto_import_bank_statement': 'Auto Import Bank Statement',
  'financeBanks.manually_import_bank_statement': 'Manually Import Bank Statement',
  'financeBanks.from': 'From',
  'financeBanks.to': 'To',
  'financeBanks.bank_account': 'Bank Account',
  'financeBanks.account_transactions': 'Account Transactions',
  'financeBanks.bank_statements': 'Bank Statements',
  'financeBanks.reconcile': 'Reconcile',
  'financeBanks.reconcile_mass_reconcile_title': 'Mass Reconciliation',
  'financeBanks.reconcile_mass_can_be_reconcile': 'Can be reconciled',
  'financeBanks.reconcile_mass_cannot_be_reconcile': 'Cannot be reconciled',
  'financeBanks.reconcile_mass_reconcile_are_you_sure':
    'Are you sure you want to reconcile {count} transaction data?',
  'financeBanks.reconcile_data_progress_deleted':
    '{count} data from total {total} has been reconciled',
  'financeBanks.search_by_reference': 'Search',
  'financeBanks.please_select_a_from_account': 'Please select a from account',
  'financeBanks.please_select_a_to_account': 'Please select a to account',
  'financeBanks.transfer': 'Transfer',
  'financeBanks.edit_account_transaction': 'Edit Account Transaction',
  'financeBanks.error_cannot_transfer_money': 'Error cannot transfer money',
  'financeBanks.the_to_account_cannot_be_same_with_from_account':
    'The to account cannot be same with from account.',
  'financeBanks.the_from_account_cannot_be_same_with_to_account':
    'The from account cannot be same with to account.',
  'financeBanks.new_transaction': 'New Transaction',
  'financeBanks.source': 'Source',
  'financeBanks.confirm_delete_bank_statement_p1': 'This will change your bank statement balance.',
  'financeBanks.confirm_delete_bank_statement_p2':
    'Usually this action only taken to delete duplicate transaction.',
  'financeBanks.follow_these_steps_to_import_your_transactions':
    'Follow these steps to import your transactions',
  'financeBanks.import_bank_transactions': 'Import Bank Transactions',
  'financeBanks.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financeBanks.upload_file': 'Upload',
  'financeBanks.set_import_options': 'Set Options',
  'financeBanks.import_statement_done': 'Done',
  'financeBanks.error_upload_file': 'Error upload file.',
  'financeBanks.file_not_found': 'File not found.',
  'financeBanks.statement_heading': 'Statement Heading',
  'financeBanks.statement_value': 'Statement Value',
  'financeBanks.assign_to': 'Assign To',
  'financeBanks.please_select_a_assign_to': 'Please select a assign to.',
  'financeBanks.select_assign_to': 'Select assign to',
  'financeBanks.rows_uploaded_set_the_import_options':
    '{rowCount} rows uploaded. Set the import options below and click Import Now button to continue.',
  'financeBanks.please_select_a_date_format': 'Please select a date format.',
  'financeBanks.select_date_format': 'Select date format',
  'financeBanks.dont_import_the_first_line':
    "Don't import the first line because they are column headings.",
  'financeBanks.import_now': 'Import Now',
  'financeBanks.date_format': 'Date Format',
  'financeBanks.error_cannot_import': 'Error cannot import.',
  'financeBanks.1_in_a_new_window': '1. In a new window, go to your bank web site.',
  'financeBanks.2_download_your_bank_statement': '2. Download your bank statement.',
  'financeBanks.file_type_must_be_csv': 'File type must be CSV',
  'financeBanks.3_upload_the_bank_statement_here': '3. Upload the bank statement here.',
  'financeBanks.download_our_csv_template': 'Download our CSV template',
  'financeBanks.to_create_your_own_bank_statement_file': ' to create your own bank statement file.',
  'financeBanks.import_maximum_of_1000_bank_statement_line_at_a_time':
    'Import a maximum of 1000 bank statement line at a time.',
  'financeBanks.drop_the_file_to_upload': 'Drop the file to upload',
  'financeBanks.transaction_lines_successfully_imported':
    '{rowCount} transaction lines successfully imported.',
  'financeBanks.view_detail': 'View detail',
  'financeBanks.import_another_file': 'Import another file',
  'financeBanks.go_to_reconciliation': 'Go to reconciliation',
  'financeBanks.success': 'Success',
  'financeBanks.failed': 'Failed',
  'financeBanks.invalid_date': 'Invalid Date',
  'financeBanks.invalid_transaction_type': 'Invalid Transaction Type',
  'financeBanks.invalid_amount': 'Invalid Amount',
  'financeBanks.total': 'Total',
  'financeBanks.review_your_bank_statement': 'Review your bank statement...',
  'financeBanks.then_match_with_your_transactions_in_kledo':
    '...then match with your transactions in Kledo',
  'financeBanks.bank_statement': 'Bank Statement',
  'financeBanks.go': 'Go',
  'financeBanks.show_received_item': 'Show Received Items',
  'financeBanks.find_&_match': 'Find & Match',
  'financeBanks.kledo_transaction': 'Kledo Transaction',
  'financeBanks.journal_not_available': 'Journal details are not available yet, try again later',
  'financeBanks.subtotal': 'Subtotal',
  'financeBanks.must_match': 'Must Match',
  'financeBanks.difference': 'Difference',
  'financeBanks.find_&_select_matching_transactions': '1. Find & select matching transactions',
  'financeBanks.error_cannot_reconcile': 'Error cannot reconcile.',
  'financeBanks.are_you_sure_to_reconcile': 'Are you sure to reconcile ?',
  'financeBanks.reconcile_date_mismatch_confirm':
    'The bank transaction date and your Kledo transaction date are not the same. Are you sure you want to continue?',
  'financeBanks.difference_must_be_zero': 'Difference must be 0.',
  'financeBanks.view_your_selected_transactions':
    '2. View your selected transactions, Add new transactions, as needed.',
  'financeBanks.the_sum_of_your_selected_transactions_must_match_the_money_spent':
    '3. The sum of your selected transactions must match the money spent. Make adjustments, as needed.',
  'financeBanks.show_spent_item': 'Show Spent Items',
  'financeBanks.to_reconcile': 'To',
  'financeBanks.transactions': 'Transactions',
  'financeBanks.minimal_value': 'Minimal value is {value}',
  'financeBanks.maximal_value': 'Maximal value is {value}',
  'financeBanks.error_cannot_print_pdf': 'Cannot print pdf bank.',
  'financeBanks.print_receipt': 'Print Receipt',
  'financeBanks.print_remittance_advice': 'Print Remittance Advice',
  'financeBanks.print_cash_receipt': 'Print Cash Receipt',
  'financeBanks.print_expense_slip': 'Print Expense Slip',
  'financeBanks.print_purchase_payment': 'Print Remittance Advice',
  'financeBanks.print_transfer': 'Print Transfer',
  'financeBanks.copy_link_receipt': 'Copy Receipt Link',
  'financeBanks.copy_link_remittance_advice': 'Copy Remittance Advice Link',
  'financeBanks.copy_link_cash_receipt': 'Copy Cash Receipt Link',
  'financeBanks.copy_link_expense_slip': 'Copy Expense Slip Link',
  'financeBanks.copy_link_purchase_payment': 'Copy Remittance Advice Link',
  'financeBanks.copy_link_transfer': 'Copy Transfer Link',
  'financeBanks.send_email_receipt': 'Send Receipt Email',
  'financeBanks.send_email_remittance_advice': 'Send Remittance Advice Email',
  'financeBanks.send_email_cash_receipt': 'Send Cash Receipt Email',
  'financeBanks.send_email_expense_slip': 'Send Expense Slip Email',
  'financeBanks.send_email_purchase_payment': 'Send Remittance Advice Email',
  'financeBanks.send_sms_receipt': 'Send Receipt SMS',
  'financeBanks.send_sms_remittance_advice': 'Send Remittance Advice SMS',
  'financeBanks.send_sms_cash_receipt': 'Send Cash Receipt SMS',
  'financeBanks.send_sms_expense_slip': 'Send Expense Slip SMS',
  'financeBanks.send_sms_purchase_payment': 'Send Remittance Advice SMS',
  'financeBanks.send_wa_receipt': 'Send Receipt Whatsapp',
  'financeBanks.send_wa_remittance_advice': 'Send Remittance Advice Whatsapp',
  'financeBanks.send_wa_cash_receipt': 'Send Cash Receipt Whatsapp',
  'financeBanks.send_wa_expense_slip': 'Send Expense Slip Whatsapp',
  'financeBanks.send_wa_purchase_payment': 'Send Remittance Advice Whatsapp',
  'financeBanks.receipt_will_be_sent_via': 'Receipt will be sent via',
  'financeBanks.1_download_your_bankStatement_template_file':
    '1. Download your bank statement template file',
  'financeBanks.start_by_downloading_our_bankStatement_csv':
    'Start by downloading our bank statements Excel template file. This file has the correct column headings Kledo needs to import details of your bank statements.',
  'financeBanks.2_copy_your_bankStatement_into_the_template':
    '2. Copy your bank statements into the template',
  'financeBanks.a_maximum_of_500_bankStatement_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data.',
  'financeBanks.import_actions_only_insert_new_bankStatement_cannot_update_or_delete':
    'Import actions only insert new bank statements, cannot update nor delete.',
  'financeBanks.bankStatement_successfully_imported':
    '{rowCount} bank statement imported successfully.',
  'financeBanks.reconciliation_detail': 'Reconciliation Detail',
  'financeBanks.detail': 'Detail',
  'financeBanks.mutasi_bank': 'Bank Mutation',
  'financeBanks.transactions_on_kledo': 'Transaction on Kledo',
  'financeBanks.error_load_data': 'Error on get list bank statement',
  'financeBanks.bank_connect': 'Bank Connect',
  'financeBanks.bank_connect_not_found': 'Bank Connect not found',
  'financeBanks.bank_connect_fallback': 'Go back to the Bank Connect',
  'financeBanks.add_bank_connect': 'Add Bank Connect',
  'financeBanks.edit_bank_connect': 'Edit Bank Connect',
  'financeBanks.choose_bank': 'Choose bank that will be connected to Kledo',
  'financeBanks.bank_connected': 'Bank connected to Kledo',
  'financeBanks.account': 'Account',
  'financeBanks.fill_out_the_form': 'Fill Out the Form',
  'financeBanks.under_review': 'Under Review',
  'financeBanks.signature_and_send': 'Signature & Send',
  'financeBanks.activation': 'Activation',
  'financeBanks.submission': 'Submission',
  'financeBanks.review': 'Review',
  'financeBanks.active': 'Active',
  'financeBanks.cannot_add_bank_connect': 'Cannot add bank connect',
  'financeBanks.cannot_delete_bank_connect': 'Cannot delete bank connect',
  'financeBanks.please_select_account': 'Please select account',
  'financeBanks.send_submission': 'Send Submission',
  'financeBanks.connect_to_account': 'Connect to Account',
  'financeBanks.connect_company_desc_1':
    'To be able to connect to a BCA Business Account, it is necessary to activate the BCA API feature in your BCA account.',
  'financeBanks.connect_company_desc_2': 'Following are the steps for activating the BCA API:',
  'financeBanks.connect_company_desc_3': '- Enter your data in the form on this page.',
  'financeBanks.connect_company_desc_4':
    '- The Kledo Great Team will contact you via WhatsApp for confirmation and other data collection.',
  'financeBanks.connect_company_desc_5':
    '- The BCA API activation application form will be sent by the Great Kledo Team to BCA Bank.',
  'financeBanks.connect_company_desc_6':
    '- BCA API is active, and your account mutation will be automatically downloaded to Kledo.',
  'financeBanks.connect_company_desc_7': 'A few things you need to know:',
  'financeBanks.connect_company_desc_8':
    "- For BCA API connection, a fee from BCA is Rp. 50,000 per month. From Kledo's side there is no charge at all",
  'financeBanks.connect_company_desc_9':
    '- The activation application process takes about 2-4 weeks.',
  'financeBanks.connect_company_desc_10':
    '- The BCA API connection that is connected to Kledo only takes mutation data, not to transfer funds. So that your account is guaranteed security.',
  'financeBanks.account_information': 'Bank Account Information',
  'financeBanks.bank_account_type': 'Bank Account Type',
  'financeBanks.internet_banking_username': 'Internet Banking Username',
  'financeBanks.internet_banking_password': 'Internet Banking Password',
  'financeBanks.repeat_internet_banking_password': 'Repeat Internet Banking Password',
  'financeBanks.please_input_ib_username': 'Please input internet banking username',
  'financeBanks.please_input_ib_password': 'Please input internet banking password',
  'financeBanks.last_get_data': 'Last Get Data',
  'financeBanks.account_owner_name': 'Bank Account Owner Name',
  'financeBanks.account_number': 'Bank Account Number',
  'financeBanks.please_input_account_owner_name': 'Please input account owner name',
  'financeBanks.please_input_account_number': 'Please input account number',
  'financeBanks.scan_bank_book': 'Scan/Photo of Bank Book',
  'financeBanks.please_input_scan_bank_book': 'Please input scan/photo of bank book',
  'financeBanks.identity_card_information': 'Identity Card Information',
  'financeBanks.company_information': 'Company Information',
  'financeBanks.trade_name': 'Trade Name',
  'financeBanks.please_input_trade_name': 'Please input Trade Name',
  'financeBanks.website': 'Website',
  'financeBanks.please_input_website': 'Please input Website',
  'financeBanks.company_email': 'Company Email',
  'financeBanks.please_input_company_email': 'Please input Company Email',
  'financeBanks.please_input_a_valid_format_email': 'Please input a valid format email',
  'financeBanks.company_tax_number': 'Company Tax Number',
  'financeBanks.please_input_company_tax_number': 'Please input Company Tax Number',
  'financeBanks.company_account_number': 'Company Account Number',
  'financeBanks.please_input_company_account_number': 'Please input Company Account Number',
  'financeBanks.office_address': 'Office Address',
  'financeBanks.please_input_office_address': 'Please input Office Address',
  'financeBanks.corp_id': 'Corporation ID',
  'financeBanks.please_input_corp_id': 'Please input Corporation ID',
  'financeBanks.main_pic': 'Main PIC',
  'financeBanks.secondary_pic': 'Secondary PIC',
  'financeBanks.position': 'Position',
  'financeBanks.please_input_position': 'Please input Position',
  'financeBanks.id_number': 'ID Number',
  'financeBanks.please_input_id_number': 'Please input ID Number',
  'financeBanks.please_input_email': 'Please input Email',
  'financeBanks.phone_number': 'Phone Number',
  'financeBanks.please_input_phone_number': 'Please input Phone Number',
  'financeBanks.address_according_to_id_card': 'Address according to ID Card',
  'financeBanks.please_input_address': 'Please input Address',
  'financeBanks.name_on_bank_account_owner_card': 'Name on Bank Account Owner Identity Card',
  'financeBanks.identity_card_number': 'Identity Card Number',
  'financeBanks.scan_identity_card': 'Scan/Photo of Identity Card',
  'financeBanks.please_input_name_on_bank_account_owner_card': 'Please input name',
  'financeBanks.please_input_identity_card_number': 'Please input identity card number',
  'financeBanks.please_input_scan_identity_card': 'Please input scan/photo of identity card',
  'financeBanks.note': 'Note',
  'financeBanks.follow_these_steps_to_import_your_bankTrans':
    'Follow these steps to import your bank transaction',
  'financeBanks.1_download_your_bankTrans_template_file':
    '1. Download your bank transaction template file',
  'financeBanks.start_by_downloading_our_bankTrans_csv':
    'Start by downloading our bank transactions Excel template file. This file has the correct column headings Kledo needs to import details of your bank transactions.',
  'financeBanks.download_template_file': 'Download Template File',
  'financeBanks.download_template_data_example_file': 'Download template data example file',
  'financeBanks.import_bankTrans': 'Import Bank Transaction',
  'financeBanks.2_copy_your_bankTrans_into_the_template':
    '2. Copy your bank transactions into the template',
  'financeBanks.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your bank transactions. Make sure the product details match the column headings provided in the template.',
  'financeBanks.important': 'IMPORTANT',
  'financeBanks.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeBanks.upload': 'Upload',
  'financeBanks.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeBanks.a_maximum_of_500_bankTrans_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data. Every row is counted, including bank transaction rows and item rows.',
  'financeBanks.import_actions_only_insert_new_bankTrans_cannot_update_or_delete':
    'Import actions only insert new bank transactions, cannot update nor delete.',
  'financeBanks.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeBanks.bankTrans_successfully_imported': '{rowCount} bankTrans imported successfully.',
  'financeBanks.go_to_bankTrans_list': 'Go to bankTrans list',
  'financeBanks.revert_reconciliation': 'Revert Reconciliation',
  'financeBanks.view_reconciliation': 'View Reconciliation',
  'financeBanks.import_with_bank_template': 'Import with template format from Bank',
  'financeBanks.import_bca_1': '1. Login to your BCA Business internet banking',
  'financeBanks.import_bca_2': '2. Click Account Information menu - Account Mutation',
  'financeBanks.import_bca_3': '3. Select CSV download format, and click download button',
  'financeBanks.import_mandiri_1': '1. Login to Kopra Mandiri',
  'financeBanks.import_mandiri_2': '2. Select the Statement Report menu',
  'financeBanks.import_mandiri_3':
    '3. Click Report Type then select “Account Statement” and select the period.',
  'financeBanks.import_mandiri_4': '4. Click Generate Report',
  'financeBanks.import_mandiri_5': '5. Click Download',
  'financeBanks.import_mandiri_6': '6. Select File Type CSV',
  'financeBanks.import_mandiri_7': '7. Click the check mark and download on the selected file.',
  'financeBanks.upload_downloaded_excel_on_form_below':
    '8. Upload downloaded Excel file on form below',
  'financeBanks.the_one_of_accounts_must_be_base_currency':
    'The one of selected accounts must be base currency',
  'financeBanks.data_has_been_reconciled': 'Data has been reconciled succesfully.',
  'financeBanks.empty_bank_reconcile_data_message':
    'To reconcile bank transactions, please import<br/>bank transactions first',
  'financeBanks.bank_reconcile_click_here_to_import': 'Click here to import bank transactions!',
  'financeBanks.search_bank_statement_at_kledo':
    'Search for bank mutations that match transactions at Kledo',
  'financeBanks.your_selected_transactions':
    'Your selected transactions, Add new transactions, as needed.',
  'financeBanks.total_transaction_on_kledo_and_bank_mutation_must_be_same':
    'The total transactions on Kledo must be the same as the total transactions',
  'financeBanks.total_transaction_on_kledo': 'Total transactions on Kledo',
  'financeBanks.total_mutations': 'Total mutations',
  'purchases.purchases': 'Purchases Overview',
  'purchases.purchases_invoices': 'Purchases Invoices',
  'purchases.awaiting_payment': 'Awaiting Payment',
  'purchases.overdue': 'Overdue',
  'purchases.purchases_total_last_30_days': 'Purchases Total Last 30 Days',
  'purchases.purchases_total': 'Purchases Total',
  'purchases.product': 'Product',
  'purchases.qty': 'Qty',
  'purchases.value': 'Value',
  'purchases.payment_made': 'Payment Made',
  'purchases.purchases_orders': 'Purchases Orders',
  'purchases.draft': 'Draft',
  'purchases.awaiting_approval': 'Awaiting Approval',
  'purchases.approved': 'Approved',
  'sales.sales': 'Sales Overview',
  'sales.invoices': 'Invoices',
  'sales.awaiting_payment': 'Awaiting Payment',
  'sales.overdue': 'Overdue',
  'sales.purchases_total_last_30_days': 'Sales Total Last 30 Days',
  'sales.product_sales_last_30_days': 'Product Sales Last 30 Days',
  'sales.product_sales': 'Product Sales',
  'sales.sales_contact': 'Sales Per Customer',
  'sales.purchases_vendor': 'Purchases Per Vendor',
  'sales.payments.received': 'Payments Received',
  'sales.draft': 'Draft',
  'sales.sent': 'Sent',
  'sales.quotes': 'quotes',
  'sales.accepted': 'Accepted',
  'financeNumbers.automatic_sequencing': 'Automatic Sequencing',
  'financeNumbers.automatic_sequencing_billing': '{title} Numbering',
  'financeNumbers.define_the_number_to_be_used':
    'Define the number to be used when creating your invoice, or purchase order expense. The number will automatically increment with each new document you create.',
  'financeNumbers.section_desc': 'Set the automatic numbering format for {name}',
  'financeNumbers.prefix': 'Prefix',
  'financeNumbers.suffix': 'Suffix',
  'financeNumbers.sequence': 'Current Number',
  'financeNumbers.please_input_the_next_number': 'Please input the current number',
  'financeNumbers.sequence_error': 'Error create sequence.',
  'financeNumbers.error_edit': 'Error edit sequence.',
  'financeNumbers.error_check_exist': 'Error check number.',
  'financeNumbers.number_is_used': 'Number is used, {link} to get new number.',
  'financeNumbers.number_format': 'Number Format',
  'financeNumbers.automatic_numbering_output_example': 'Automatic Numbering Output Example',
  'financeNumbers.reset_number_every': 'Reset Number Every',
  'financeNumbers.never_reset': 'Never reset',
  'financeNumbers.every_day': 'Every day',
  'financeNumbers.every_month': 'Every month',
  'financeNumbers.every_year': 'Every year',
  'financeNumbers.on_date': 'On date',
  'financeNumbers.add_numbering_code': 'Add Numbering Code',
  'financeNumbers.please_input_format': 'Please input the number format',
  'financeNumbers.please_input_date': 'Please input the date',
  'financeNumbers.please_input_month': 'Please input the month',
  'financeNumbers.trans_number_same_as_original_trans':
    'Set transaction number same as original transaction',
  'financeNumbers.trans_number_same_as_original_trans_desc':
    'If active, when create invoice from order, the number will be same as order. Likewise for other transaction.',
  'financeNumbers.auto_numbering_lock':
    'The transaction number is locked so that it cannot be changed',
  'financeNumbers.auto_numbering_lock_desc':
    'If it is active, the transaction number will follow the Kledo system, it cannot be changed by the user.',
  'financeNumbers.default_settings': 'Default Settings',
  'financeNumbers.add_setting': 'Add Setting',
  'financeNumbers.setting_name': 'Setting Name',
  'financeNumbers.setting_name_is_required': 'Setting Name is required!',
  'financeNumbers.valid_for_bank_accounts': 'Valid for bank accounts',
  'financeNumbers.bank_account_is_required': 'Bank Account is required!',
  'financeNumbers.select_bank_account': 'Select Bank Account',
  'financeNumbers.last_reset_number_log':
    'The last reset was on {date}, [{clickHere}] to view the log',
  'financeNumbers.reset_number_automatic': 'Automatic Reset Number',
  'financeConversion.your_opening_balances_will_be_set_as_at':
    'Your opening balances will be set at {date}',
  'financeConversion.conversion_date': 'Conversion Date',
  'financeConversion.error_cannot_save_conversion_date': 'Error cannot save conversion date.',
  'financeConversion.show_zero_balances': 'Show zero balances',
  'financeConversion.conversion_balances': 'Conversion Balances',
  'financeConversion.add_comparative_balances': 'Add Comparative Balances',
  'financeConversion.error_cannot_add_comparative_balances':
    'Error cannot add comparative balances.',
  'financeConversion.error_cannot_save_comparative_balances':
    'Error cannot save comparative balances.',
  'financeConversion.are_you_sure': 'Are you sure ?',
  'financeConversion.warning': 'Warning',
  'financeConversion.reversal_detail': 'Reversal Detail',
  'financeConversion.opening_balance': 'Opening Balance',
  'financeConversion.error_cannot_delete_comparative_balances':
    'Error cannot delete conversion balances.',
  'financeConversion.confirm_balances': 'Confirm your {endDate} account balances.',
  'financeConversion.cannot_set_conversion_date':
    'Tidak dapat set tanggal konversi, karena telah dilakukan tutup buku pada bulan ini.',
  'financeConversion.your_debit_and_credit_total_must_be_balanced':
    'Your debit and credit total must be balanced. If you wish to publish anyway, differences of {diff} will be posted into Opening Balance Equity account.',
  'financeConversion.enter_the_date_that_you_began_processing':
    "Enter the date that you began processing all your transactions in Kledo. It's easiest when you set your conversion date to be the start of a Tax period.",
  'financeConversion.back_to_account_list': 'Back to account list',
  'financeConversion.follow_these_steps_to_import_your_conversion_balance':
    'Follow these steps to import your conversion balance',
  'financeConversion.1_download_your_conversion_balance_template_file':
    '1. Download your conversion balance template file',
  'financeConversion.start_by_downloading_our_conversion_balance_csv':
    'Start by downloading our conversion balances Excel template file. This file has the correct column headings Kledo needs to import details of your conversion balances.',
  'financeConversion.download_template_file': 'Download Template File',
  'financeConversion.download_template_data_example_file': 'Download template data example file',
  'financeConversion.import': 'Import Conversion Balance',
  'financeConversion.2_copy_your_conversion_balance_into_the_template':
    '2. Copy your conversion balances into the template',
  'financeConversion.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your conversion balances. Make sure the product details match the column headings provided in the template.',
  'financeConversion.important': 'IMPORTANT',
  'financeConversion.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeConversion.upload': 'Upload',
  'financeConversion.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeConversion.a_maximum_of_500_conversion_balance_can_be_imported_at_a_time':
    'A maximum of 1.000 conversion balances can be imported at a time.',
  'financeConversion.import_actions_only_insert_new_conversion_balance_cannot_update_or_delete':
    'Import actions only insert new conversion balances, cannot update nor delete.',
  'financeConversion.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeConversion.conversion_balance_successfully_imported':
    '{rowCount} conversion balance imported successfully.',
  'financeConversion.go_to_conversion_balance_list': 'Go to conversion balance list',
  'financeManualJournal.add_manual_journal': 'Add Manual Journal',
  'financeManualJournal.financeManualJournal': 'Manual Journal',
  'financeManualJournal.successfully_added': 'successfully added.',
  'financeManualJournal.error_cannot_add': 'Cannot add manual journal.',
  'financeManualJournal.error_cannot_update': 'Cannot update manual journal.',
  'financeManualJournal.edit_manual_journal': 'Edit Manual Journal',
  'financeManualJournal.max_characters': 'Max {value} characters.',
  'financeManualJournal.min_characters': 'Min {value} characters.',
  'financeManualJournal.only_number_allowed': 'Only number allowed.',
  'financeManualJournal.description': 'Description',
  'financeManualJournal.tax': 'Tax',
  'financeManualJournal.select_tax': 'Select tax',
  'financeManualJournal.amount': 'Amount',
  'financeManualJournal.transaction_date': 'Transaction Date',
  'financeManualJournal.please_select_transaction_date': 'Please select transaction date',
  'financeManualJournal.due_date': 'Expiry',
  'financeManualJournal.please_select_due_date': 'Please select expiry',
  'financeManualJournal.price_include_tax': 'Price include tax',
  'financeManualJournal.add_more': 'Add more',
  'financeManualJournal.number': 'Number',
  'financeManualJournal.please_input_the_number': 'Please input the number.',
  'financeManualJournal.memo': 'Memo',
  'financeManualJournal.date': 'Date',
  'financeManualJournal.total': 'Total',
  'financeManualJournal.search_by_memo': 'Search',
  'financeManualJournal.detail_title': 'Manual Journal {number}',
  'financeManualJournal.reference': 'Reference',
  'financeManualJournal.attachments': 'Attachments',
  'financeManualJournal.please_input_the_amount': 'Please input the amount.',
  'financeManualJournal.account': 'Account',
  'financeManualJournal.debit': 'Debit',
  'financeManualJournal.credit': 'Credit',
  'financeManualJournal.select_account': 'Select Account',
  'financeManualJournal.diff': 'Total is out by {diff}',
  'financeManualJournal.total_debits_must_equal_total_credits':
    'Total debits must equal total credits.',
  'financeManualJournal.debit_or_credit_must_greater_than_0':
    'Debit or credit must greather than 0.',
  'financeManualJournal.total_debit': 'Total Debit',
  'financeManualJournal.total_credit': 'Total Credit',
  'financeManualJournal.detail_manual_journal': 'Detil Jurnal Manual',
  'financeManualJournal.follow_these_steps_to_import_your_manualJournal':
    'Follow these steps to import your manual journal',
  'financeManualJournal.1_download_your_manualJournal_template_file':
    '1. Download your manual journal template file',
  'financeManualJournal.start_by_downloading_our_manualJournal_csv':
    'Start by downloading our manual journals Excel template file. This file has the correct column headings Kledo needs to import details of your manual journals.',
  'financeManualJournal.download_template_file': 'Download Template File',
  'financeManualJournal.download_template_data_example_file': 'Download template data example file',
  'financeManualJournal.import': 'Import Manual Journal',
  'financeManualJournal.2_copy_your_manualJournal_into_the_template':
    '2. Copy your manual journals into the template',
  'financeManualJournal.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your manual journals. Make sure the product details match the column headings provided in the template.',
  'financeManualJournal.important': 'IMPORTANT',
  'financeManualJournal.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeManualJournal.upload': 'Upload',
  'financeManualJournal.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeManualJournal.a_maximum_of_500_manualJournal_can_be_imported_at_a_time':
    'A maximum of 1.000 manual journals can be imported at a time.',
  'financeManualJournal.import_actions_only_insert_new_manualJournal_cannot_update_or_delete':
    'Import actions only insert new manual journals, cannot update nor delete.',
  'financeManualJournal.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeManualJournal.manualJournal_successfully_imported':
    '{rowCount} manual journal imported successfully.',
  'financeManualJournal.go_to_manualJournal_list': 'Go to manual journal list',
  'financeFixedAssets.register': 'Register',
  'financeFixedAssets.fixed_assets': 'Fixed Assets',
  'financeFixedAssets.add_fixed_asset': 'Add Fixed Asset',
  'financeFixedAssets.asset_name': 'Asset Name',
  'financeFixedAssets.purchase_invoice': 'Purchase Invoice',
  'financeFixedAssets.purchase_date': 'Purchase Date',
  'financeFixedAssets.purchase_price': 'Purchase Price',
  'financeFixedAssets.book_value': 'Book Value',
  'financeFixedAssets.init_cost': 'Initial Cost',
  'financeFixedAssets.disposal_date': 'Disposal Date',
  'financeFixedAssets.disposal_price': 'Disposal Price',
  'financeFixedAssets.gain': 'Gain/Losses',
  'financeFixedAssets.number': 'Number',
  'financeFixedAssets.purchase_price_from': 'From',
  'financeFixedAssets.purchase_price_to': 'To',
  'financeFixedAssets.details': 'Details',
  'financeFixedAssets.please_input_the_asset_name': 'Please input the asset name.',
  'financeFixedAssets.max_characters': 'Max {value} characters.',
  'financeFixedAssets.min_characters': 'Min {value} characters.',
  'financeFixedAssets.only_alphanumeric_and_special_characters_allowed':
    'Only letters, numbers, spaces, and special characters -/().&_\'" are allowed.',
  'financeFixedAssets.please_select_purchase_date': 'Please select purchase date.',
  'financeFixedAssets.please_input_the_purchase_price': 'Please input the purcahse price. ',
  'financeFixedAssets.fixed_asset_account': 'Fixed Asset Account',
  'financeFixedAssets.please_select_a_fixed_asset_account': 'Please select a fixed asset account.',
  'financeFixedAssets.select_fixed_asset_account': 'Select fixed asset account',
  'financeFixedAssets.credited_from_account': 'Credited From Account',
  'financeFixedAssets.please_select_a_credit_from_account': 'Please select a credited from account',
  'financeFixedAssets.select_credit_from_account': 'Select credit from account',
  'financeFixedAssets.description': 'Description',
  'financeFixedAssets.must_greater_than_0': 'Must greater than 0.',
  'financeFixedAssets.depreciation': 'Depreciation',
  'financeFixedAssets.with_depreciation': 'With depreciation',
  'financeFixedAssets.no_depreciation': 'No depreciation',
  'financeFixedAssets.accumulated_depreciation_account': 'Accumulated Depreciation Account',
  'financeFixedAssets.select_accumulated_depreciation_account':
    'Select accumulated depreciation account',
  'financeFixedAssets.depreciation_expense_account': 'Depreciation Expense Account',
  'financeFixedAssets.select_depreciation_expense_account': 'Select depreciation expense account',
  'financeFixedAssets.depreciation_method': 'Depreciation Method',
  'financeFixedAssets.select_depreciation_method': 'Select depreciation method',
  'financeFixedAssets.rate': 'Rate',
  'financeFixedAssets.effective_life': 'Effective Life',
  'financeFixedAssets.show_more_options': 'Show more options',
  'financeFixedAssets.depreciation_start_date': 'Depreciation start date',
  'financeFixedAssets.accumulated_depreciation': 'Accumulated Depreciation',
  'financeFixedAssets.cost_limit': 'Cost Limit',
  'financeFixedAssets.residual_value': 'Residual Value',
  'financeFixedAssets.hide_more_options': 'Hide more options',
  'financeFixedAssets.please_select_a_accumulated_depreciation_account':
    'Please select a accumulated depreciation account.',
  'financeFixedAssets.please_select_a_depreciation_expense_account':
    'Please select a depreciation expense account.',
  'financeFixedAssets.please_select_a_depreciation_method': 'Please select a depreciation method.',
  'financeFixedAssets.must_equal_or_smaller_than_cost_limit_minus_residual_value':
    'Must equal or smaller than (cost limit) - (residual value).',
  'financeFixedAssets.must_equal_or_smaller_than_purchase_price':
    'Must equal or smaller than purchase price.',
  'financeFixedAssets.must_equal_or_smaller_than_cost_limit':
    'Must equal or smaller than cost limit.',
  'financeFixedAssets.transactions': 'Transactions',
  'financeFixedAssets.detail_fixed_asset': 'Detail Fixed Asset',
  'financeFixedAssets.detail_title': 'Fixed Asset {detail}',
  'financeFixedAssets.date': 'Date',
  'financeFixedAssets.reference': 'Reference',
  'financeFixedAssets.debit': 'Debit',
  'financeFixedAssets.credit': 'Credit',
  'financeFixedAssets.undo_dispose': 'Undo Dispose',
  'financeFixedAssets.dispose': 'Dispose',
  'financeFixedAssets.rollback_depreciation': 'Rollback Depreciation',
  'financeFixedAssets.error_cannot_add': 'Error cannot add fixed asset.',
  'financeFixedAssets.error_cannot_update': 'Error cannot update fixed asset.',
  'financeFixedAssets.error_cannot_delete': 'Error cannot delete fixed asset.',
  'financeFixedAssets.edit_title': 'Edit Fixed Asset {detail}',
  'financeFixedAssets.dispose_fixed_asset': 'Dispose Fixed Asset',
  'financeFixedAssets.dispose_title': 'Dispose {title}',
  'financeFixedAssets.last_depreciation': 'Last Depreciation',
  'financeFixedAssets.sale_price': 'Sale Price',
  'financeFixedAssets.journal_entries': 'Journal Entries',
  'financeFixedAssets.name': 'Name',
  'financeFixedAssets.account': 'Account',
  'financeFixedAssets.acquisition_const': 'Acquisition cost',
  'financeFixedAssets.gain_on_disposal': 'Gain on disposal',
  'financeFixedAssets.loss_on_disposal': 'Loss on disposal',
  'financeFixedAssets.please_select_disposal_date': 'Please select disposal date.',
  'financeFixedAssets.please_input_the_sale_price': 'Please input the sale price.',
  'financeFixedAssets.deposit_to': 'Deposit to',
  'financeFixedAssets.deposit_to_account': 'Deposit to account',
  'financeFixedAssets.please_select_a_deposit_to_account': 'Please select a deposit to account.',
  'financeFixedAssets.must_equal_or_higher_than_purchase_date_and_last_depreciation_date':
    'Must equal or higher than purchase date and last depreciation date.',
  'financeFixedAssets.must_equal_or_higher_than_purchase_date':
    'Must equal or higher than purchase date.',
  'financeFixedAssets.register_fixed_asset': 'Register Fixed Asset',
  'financeFixedAssets.run_depreciation': 'Depreciation',
  'financeFixedAssets.period': 'Period',
  'financeFixedAssets.method': 'Method',
  'financeFixedAssets.depreciation_amount': 'Depreciation Amount',
  'financeFixedAssets.error_cannot_run_depreciation': 'Error cannot run depreciation.',
  'financeFixedAssets.please_select_at_least_a_depreciation':
    'Please select at least a depreciation.',
  'financeFixedAssets.depreciation_executed_successfully': 'Depreciation executed successfully.',
  'financeFixedAssets.back_to_asset_list': 'Back to asset list',
  'financeFixedAssets.apply_depreciation': 'Apply Depreciation',
  'financeFixedAssets.are_u_sure_to_undo_dispose': 'Are you sure to undo dispose ?',
  'financeFixedAssets.error_cannot_undo_dispose': 'Error cannot undo dispose.',
  'financeFixedAssets.error_cannot_rollback_depreciation': 'Error cannot rollback depreciation.',
  'financeFixedAssets.are_u_sure_to_rollback_depreciation':
    'Are you sure to rollback depreciation ?',
  'financeFixedAssets.please_input_the_number': 'Please input the number.',
  'financeFixedAssets.select_deposit_to_account': 'Select deposit to account',
  'financeFixedAssets.edit_fixed_asset': 'Edit Fixed Asset',
  'financeFixedAssets.detail_fixed_asset_transaction': 'Detail Fixed Asset Transaction',
  'financeFixedAssets.dispose_detail': 'Dispose',
  'financeFixedAssets.follow_these_steps_to_import_your_fixedAsset':
    'Follow these steps to import your fixed asset',
  'financeFixedAssets.1_download_your_fixedAsset_template_file':
    '1. Download your fixed asset template file',
  'financeFixedAssets.start_by_downloading_our_fixedAsset_csv':
    'Start by downloading our fixed assets Excel template file. This file has the correct column headings Kledo needs to import details of your fixed assets.',
  'financeFixedAssets.download_template_file': 'Download Template File',
  'financeFixedAssets.download_template_data_example_file': 'Download template data example file',
  'financeFixedAssets.import': 'Import Fixed Asset',
  'financeFixedAssets.2_copy_your_fixedAsset_into_the_template':
    '2. Copy your fixed assets into the template',
  'financeFixedAssets.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your fixed assets. Make sure the product details match the column headings provided in the template.',
  'financeFixedAssets.important': 'IMPORTANT',
  'financeFixedAssets.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeFixedAssets.upload': 'Upload',
  'financeFixedAssets.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeFixedAssets.a_maximum_of_500_fixedAsset_can_be_imported_at_a_time':
    'A single import supports up to 2.500 rows of Excel data.',
  'financeFixedAssets.import_actions_only_insert_new_fixedAsset_cannot_update_or_delete':
    'Import actions only insert new fixed assets, cannot update nor delete.',
  'financeFixedAssets.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeFixedAssets.fixedAsset_successfully_imported':
    '{rowCount} fixed asset imported successfully.',
  'financeFixedAssets.go_to_fixedAsset_list': 'Go to fixed asset list',
  'financeFixedAssets.the_date_this_asset_was_purchased_or_acquired':
    'The date this asset was purchased or acquired.',
  'financeFixedAssets.the_total_cost_of_acquiring_this_asset':
    'The total cost of acquiring this asset, tax exempt.',
  'financeFixedAssets.account_to_hold_the_balance_of_this_fixed_asset':
    'Account to hold the balance of this fixed asset.',
  'financeFixedAssets.account_for_crediting_the_purchase_of_fixed_asset':
    'Account for crediting the purchase of fixed assets. For example Cash, Loans or Capital.',
  'financeFixedAssets.an_expense_account_to_record_monthly_depreciation':
    'An expense account to record monthly depreciation.',
  'financeFixedAssets.accounts_for_contra_assets_to_accommodate_accumulated_depreciation':
    'Accounts for contra assets to accommodate accumulated depreciation.',
  'financeFixedAssets.percent_depreciation_value_each_year':
    'Percent depreciation value each year.',
  'financeFixedAssets.the_longevity_of_the_asset_since_purchase':
    'The longevity of the asset since purchase.',
  'financeFixedAssets.method_of_calculating_assets_each_months':
    'Method of calculating assets each month {br}Straight Line = Depreciation on average over the useful life of the asset.{br}For example, if the purchase price of an asset is 1000 and the depreciation value is 20%, then the depreciation per year is 1000 * 20 % = 200{br}Declining Balance 100% = Depreciation with a greater rate of decline at the beginning of the asset is life.{br}For example, if the asset purchase price is 1000 and the depreciation value is 20%, then{br}First Year Depreciation = 1000 x 20% = 200{br}Depreciation in the Second Year = (1000 - 200) x 20% = 160{br}Depreciation in Third Year = (800 - 160) x 20% = 128<br />Declining Balance 150% calculates the depreciation by the depreciation value multiplied by 150%{br}200 % Declining Balance calculates the depreciation by the depreciation value multiplied by 200%',
  'financeFixedAssets.the_commencement_date_of_the_accumulated_depreciation_account_opening_balance':
    'The commencement date of the accumulated depreciation account opening balance. Can be filled with the same as the date of purchase of assets, or better to use the start date of the period or the date of migration.',
  'financeFixedAssets.beginning_balance_for_accumulated_depreciation_accounts':
    'Beginning balance for accumulated depreciation accounts from past books or records.',
  'financeFixedAssets.the_upper_limit_on_the_value_of_the_depreciated_assets':
    'The upper limit on the value of the depreciated assets. For example, if an asset is purchased at a price of IDR 1,000, then the cost limit is set at IDR 600, so only IDR 600 is depreciated.',
  'financeFixedAssets.the_residual_value_is_the_minimum_amount_of_assets':
    'The residual value is the minimum amount of assets that cannot be depreciated. For example, if an asset is purchased at a price of Rp1,000, then the residual value is set at Rp. 200. So when the asset is depreciated every month, and the final asset value is only Rp. 200, the asset is not depreciated.',
  'financeFixedAssets.image': 'Fixed Asset Image',
  'financeFixedAssets.show_image': 'Show fixed asset image',
  'financeFixedAssets.hide_image': 'Hide fixed asset image',
  'financeLockDate.lock_date': 'Lock Date',
  'financeLockDate.lock_date_will_stop_data_from_being_changed':
    'Lock date will stop data from being changed for a specific period. You can change these at any time.',
  'financeLockDate.stop_all_users_making_changes_on_and_before':
    'Stop all users making changes on and before',
  'financeLockDate.please_select_a_date': 'Please select a date.',
  'financeLockDate.error_cannot_set_lock_date': 'Error cannot set lock date.',
  'financeLockDate.cannot_higher_than_now': 'Cannot higher than now.',
  'financeLockDate.cannot_select_before_lock_date': 'Cannot select before lock date.',
  'financeLockDate.this_transaction_is_locked': 'This transaction is locked.',
  'financeLockDate.click_button_below_to_remove_the_lock_date':
    'Click button below to remove the lock date',
  'financeLockDate.remove_lock_date': 'Remove Lock Date',
  'financeLockDate.error_cannot_delete': 'Error cannot remove lock date.',
  'property.property': 'Property',
  'property.company': 'Company',
  'property.property_details': 'Property Details',
  'property.company_details': 'Company Details',
  'property.tax_details': 'Tax Details',
  'property.system_settings': 'System Settings',
  'property.property_logo': 'Property Logo',
  'property.company_logo': 'Company Logo',
  'property.error_cannot_update_tax_details': 'Cannot update tax details.',
  'property.property_details_successfully_updated': 'Property details successfully updated.',
  'property.company_details_successfully_updated': 'Company details successfully updated.',
  'property.error_cannot_update_property_details': 'Cannot update property details.',
  'property.error_cannot_update_company_details': 'Cannot update company details.',
  'property.system_details_successfully_updated': 'System details successfully updated.',
  'property.error_cannot_update_system_details': 'Cannot update system details.',
  'property.tax_details_successfully_updated': 'Tax details successfully updated.',
  'property.property_name': 'Name',
  'property.company_name': 'Name',
  'property.please_input_the_property_name': 'Please input the property name.',
  'property.please_input_the_company_name': 'Please input the company name.',
  'property.max_100_characters': 'Max 100 characters.',
  'property.emai_address': 'Emai Address',
  'property.invalid_email_address_format': 'Invalid email address format.',
  'property.phone_number': 'Phone Number',
  'property.max_20_characters': 'Max 20 characters.',
  'property.only_number_allowed': 'Only number allowed.',
  'property.address': 'Billing Address',
  'property.address_delivery': 'Delivery Address',
  'property.country': 'Country',
  'property.tax_number': 'Tax Number',
  'property.please_select_the_country': 'Please select the country.',
  'property.select_country': 'Select country',
  'property.arrival_time': 'Arrival Time',
  'property.departure_time': 'Departure Time',
  'property.image_file_size_maximal': 'Image file size maximal',
  'property.language': 'Language',
  'property.select_time_region': 'Select time region',
  'property.timezone': 'Timezone',
  'property.please_select_the_language': 'Please select the language.',
  'property.select_timezone': 'Select timezone',
  'property.please_select-the_timezone': 'Please select the timezone.',
  'property.date_format': 'Date Format',
  'property.please_select_the_date_format': 'Please select the date format.',
  'property.select_date_format': 'Select date format',
  'property.time_format': 'Time Format',
  'property.please_select_the_time_format': 'Please select the time format.',
  'property.select_time_format': 'Select time format',
  'property.Currency_Format': 'Currency Format',
  'property.please_select_the_currency_format': 'Please select the currency format.',
  'property.select_currency_format': 'Select currency format',
  'property.country_tax_identifier_name': 'Country Tax Identifier Name',
  'property.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'property.company_tax_number': 'Company Tax Number',
  'property.tax_name': 'Tax Name',
  'property.tax_rate': 'Tax Rate',
  'property.image_file_dimension_maximal': 'Image file dimension maximal',
  'property.click_or_drag_file_to_this_area_to_upload': 'Click or drag file to this area to upload',
  'property.paste_image_from_clipboard': 'Paste image from clipboard',
  'property.no_image_in_clipboard': 'No image in clipboard',
  'property.clipboard_read_failed':
    'Failed to read clipboard. Make sure the browser allows clipboard access.',
  'property.preview': 'Preview',
  'property.file_uploaded_successfully': 'file uploaded successfully.',
  'property.file_upload_failed': 'file upload failed.',
  'property.you_can_only_upload_jpg_or_png_file_': 'You can only upload JPG/PNG file.',
  'property.image_must_smaller_than': 'Image must smaller than',
  'property.image_width_must_smaller_than': 'Image width must smaller than',
  'property.image_height_must_smaller_than': 'Image height must smaller than',
  'property.image_dimension_must_be_at_least': 'Image width and height must be at least',
  'property.currency': 'Currency',
  'property.please_select_the_currency': 'Please select the currency.',
  'property.select_currency': 'Select currency',
  'property.number_after_comma': 'Number after comma',
  'property.please_select_the_number_after_comma': 'Please select number after comma.',
  'property.select_number_after_comma': 'Select number after comma',
  'financeWareHouses.add_warehouse': 'Add Warehouse',
  'financeWareHouses.financeWareHouses': 'Warehouse',
  'financeWareHouses.warehouse_per_item': 'Per-item Warehouse',
  'financeWareHouses.warehouse_name': 'Warehouse Name',
  'financeWareHouses.successfully_added': 'successfully added.',
  'financeWareHouses.error_cannot_add': 'Cannot add warehouse.',
  'financeWareHouses.error_cannot_update': 'Cannot update warehouse.',
  'financeWareHouses.error_cannot_move': 'Cannot move the warehouse.',
  'financeWareHouses.error_cannot_delete': 'Cannot delete the warehouse.',
  'financeWareHouses.error_cannot_change_status': 'Cannot change status the warehouse.',
  'financeWareHouses.rack.management': 'Rack Management',
  'financeWareHouses.rack.add': 'Add Rack',
  'financeWareHouses.rack.max_reached': 'Maximum {max} racks per warehouse.',
  'financeWareHouses.rack.edit': 'Edit Rack',
  'financeWareHouses.rack.name': 'Rack Name',
  'financeWareHouses.rack.code': 'Rack Code',
  'financeWareHouses.rack.desc': 'Rack Description',
  'financeWareHouses.rack.is_active': 'Active Status',
  'financeWareHouses.rack.active': 'Active',
  'financeWareHouses.rack.inactive': 'Inactive',
  'financeWareHouses.rack.no_rack': 'No Rack',
  'financeWareHouses.rack.please_input_name': 'Please input the rack name.',
  'financeWareHouses.rack.name_placeholder': 'Enter rack name',
  'financeWareHouses.rack.code_placeholder': 'Enter rack code',
  'financeWareHouses.rack.desc_placeholder': 'Enter rack description',
  'financeWareHouses.rack.select_rack': 'Select Rack',
  'financeWareHouses.rack.picker_placeholder': 'Select rack',
  'financeWareHouses.rack.delete_confirm': 'Are you sure you want to delete this rack?',
  'financeWareHouses.rack.successfully_added': 'Rack successfully added.',
  'financeWareHouses.rack.successfully_updated': 'Rack successfully updated.',
  'financeWareHouses.rack.successfully_deleted': 'Rack successfully deleted.',
  'financeWareHouses.rack.error_cannot_add': 'Cannot add the rack.',
  'financeWareHouses.rack.error_cannot_update': 'Cannot update the rack.',
  'financeWareHouses.rack.error_cannot_delete': 'Cannot delete the rack.',
  'financeWareHouses.rack.error_parent_invalid':
    'A rack cannot be created under another rack. Racks can only be placed directly under a parent warehouse.',
  'financeWareHouses.rack.error_not_empty':
    'This rack still has stock movement. Move the stock first before deleting.',
  'financeWareHouses.rack.error_not_found': 'Rack not found or does not belong to this warehouse.',
  'financeWareHouses.rack.error_role_not_allowed':
    'Access settings do not apply to racks. Racks inherit access from their parent warehouse.',
  'financeWareHouses.rack.per_rack': 'Per Rack',
  'financeWareHouses.rack.column_title': 'Rack',
  'financeWareHouses.rack.without_rack': 'Without Rack',
  'financeWareHouses.error_cannot_load_warehouses': 'Cannot load warehouses.',
  'financeWareHouses.edit_warehouse': 'Edit Warehouse',
  'financeWareHouses.please_input_the_name': 'Please input the name.',
  'financeWareHouses.please_input_the_code': 'Please input the code.',
  'financeWareHouses.name': 'Name',
  'financeWareHouses.code': 'Code',
  'financeWareHouses.max_characters': 'Max {value} characters.',
  'financeWareHouses.min_characters': 'Min {value} characters.',
  'financeWareHouses.total_qty': 'Total Quantity',
  'financeWareHouses.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeWareHouses.desc': 'Description',
  'financeWareHouses.is_canvas_warehouse': 'Canvassing warehouse',
  'financeWareHouses.total_value': 'Total Value',
  'financeWareHouses.stock_adjustment': 'Stock Adjustment',
  'financeWareHouses.warehouse_transfer': 'Warehouse Transfer',
  'financeWareHouses.import_warehouse_transfer': 'Import Warehouse Transfer',
  'financeWareHouses.transfer_in': 'Transfer In',
  'financeWareHouses.transfer_out': 'Transfer Out',
  'financeWareHouses.qty': 'Quantity',
  'financeWareHouses.value': 'Value',
  'financeWareHouses.detail_warehouse': 'Detail Warehouse',
  'financeWareHouses.show_transactions': 'Show Transactions',
  'financeWareHouses.hide_transactions': 'Hide Transactions',
  'financeWareHouses.purchase_&_sale': 'Purchase & Sale',
  'financeWareHouses.transactions': 'Transactions',
  'financeWareHouses.date': 'Date',
  'financeWareHouses.type': 'Type',
  'financeWareHouses.number': 'Number',
  'financeWareHouses.debit': 'Debit',
  'financeWareHouses.credit': 'Credit',
  'financeWareHouses.from': 'From',
  'financeWareHouses.to': 'To',
  'financeWareHouses.adjustment_type': 'Adjustment Type',
  'financeWareHouses.please_select_date': 'Please select date',
  'financeWareHouses.warehouse_transfer_out': 'Warehouse Transfer Out',
  'financeWareHouses.warehouse_transfer_in': 'Warehouse Transfer In',
  'financeWareHouses.qty_before': 'Qty Before',
  'financeWareHouses.qty_after': 'Qty After',
  'financeWareHouses.transfer_qty': 'Transfer Qty',
  'financeWareHouses.add_more': 'Add more',
  'financeWareHouses.attachments': 'Attachments',
  'financeWareHouses.select_warehouse': 'Select warehouse',
  'financeWareHouses.from_and_to_cannot_be_same': 'Source and destination cannot be the same.',
  'financeWareHouses.please_input_the_transfer_qty': 'Please input the transfer qty.',
  'financeWareHouses.please_select_a_warehouse': 'Please select a warehouse.',
  'financeWareHouses.must_greater_than_0': 'Must greater than 0.',
  'financeWareHouses.detail_transfer': 'Warehouse Transfer {number}',
  'financeWareHouses.detail_transfer_title': 'Warehouse Transfer Detail',
  'financeWareHouses.detail_transfer_group': 'Combined Transfer {number}',
  'financeWareHouses.detail_transfer_group_title': 'Combined Warehouse Transfer Detail',
  'financeWareHouses.print_blocked_title': 'Transfer cannot be printed yet',
  'financeWareHouses.print_blocked_waiting_approval':
    'This transfer is still waiting for approval. You do not have access to approve it. You can print it after it is approved.',
  'financeWareHouses.print_blocked_rejected':
    'This transfer was rejected, so it cannot be printed.',
  'financeWareHouses.warehouse_transfer_group': 'Combined Warehouse Transfer',
  'financeWareHouses.add_warehouse_transfer_group': 'Add Combined Warehouse Transfer',
  'financeWareHouses.edit_warehouse_transfer_group': 'Edit Combined Warehouse Transfer',
  'financeWareHouses.transfer_group_serial_not_supported':
    'Serial number products are temporarily not supported in combined warehouse transfers. Please select another product.',
  'financeWareHouses.transfer_group_detail_load_failed':
    'Some transfer details failed to load. Reload before saving to avoid losing data.',
  'financeWareHouses.add_transfer_to_group': 'Add Transfer',
  'financeWareHouses.min_one_transfer': 'At least 1 transfer is required.',
  'financeWareHouses.group_validation_error':
    'Some data is invalid. Please check the marked fields below.',
  'financeWareHouses.failed_save_group': 'Failed to save the combined warehouse transfer.',
  'financeWareHouses.warehouse_from_to_must_differ':
    'Source and destination warehouses must differ.',
  'financeWareHouses.product': 'Product',
  'financeWareHouses.unit': 'Unit',
  'financeWareHouses.qty_max': 'Qty must be at most {value}.',
  'financeWareHouses.please_select_a_product': 'Please select a product.',
  'financeWareHouses.transfer_group': 'Combined Transfer',
  'financeWareHouses.status_completed': 'Completed',
  'financeWareHouses.edit_warehouse_transfer': 'Edit Warehouse Transfer',
  'financeWareHouses.insufficient_stock': 'Insufficient stock',
  'financeWareHouses.detail_stockadjustment_title': 'Stock Adjustment Detail',
  'financeWareHouses.detail_stockadjustment': 'Stock Adjustment {number}',
  'financeWareHouses.difference': 'Difference',
  'financeWareHouses.average_price': 'Average Price',
  'financeWareHouses.account': 'Account',
  'financeWareHouses.account_per_item': 'Account per item',
  'financeWareHouses.follow_header_account': 'Follow header account ({code})',
  'financeWareHouses.follow_header_account_empty': 'Follow header account',
  'financeWareHouses.account_per_item_conflict': 'Use the same account as the other {product} rows',
  'financeWareHouses.pic': 'Person in Charge',
  'financeWareHouses.counted_by': 'Counted By',
  'financeWareHouses.actual_qty': 'Actual Qty',
  'financeWareHouses.actual_qty_2': 'Actual Qty',
  'financeWareHouses.import_stock_adjustment': 'Import Stock Adjustment',
  'financeWareHouses.download': 'Download',
  'financeWareHouses.please_select_adjustment_type': 'Please select adjustment type',
  'financeWareHouses.add_stock_adjustment': 'Add Stock Adjustment',
  'financeWareHouses.select_account': 'Select account',
  'financeWareHouses.recorded_qty': 'Recorded Qty',
  'financeWareHouses.please_input_the_actual_qty': 'Please input the actual qty',
  'financeWareHouses.please_input_the_difference_qty': 'Please input the difference qty',
  'financeWareHouses.please_input_the_average_price': 'Please input the average price',
  'financeWareHouses.error_cannot_update_stock_adjustment': 'Cannot update stock adjustment',
  'financeWareHouses.error_cannot_add_stock_adjustment': 'Cannot add stock adjustment',
  'financeWareHouses.edit_stock_adjustment': 'Edit Stock Adjustment',
  'financeWareHouses.transfer': 'Transfer',
  'financeWareHouses.cannot_less_than_0': 'Cannot less than 0.',
  'financeWareHouses.follow_these_steps_to_import_your_stockAdjustment':
    'Follow these steps to import your stock adjustment',
  'financeWareHouses.1_download_your_stockAdjustment_template_file':
    '1. Download your stock adjustment template file',
  'financeWareHouses.start_by_downloading_our_stockAdjustment_csv':
    'Start by downloading our stock adjustments Excel template file. This file has the correct column headings Kledo needs to import details of your stock adjustments.',
  'financeWareHouses.download_template_file': 'Download Template File',
  'financeWareHouses.download_template_data_example_file': 'Download template data example file',
  'financeWareHouses.import': 'Import Stock Adjustment',
  'financeWareHouses.2_copy_your_stockAdjustment_into_the_template':
    '2. Copy your stock adjustments into the template',
  'financeWareHouses.important': 'IMPORTANT',
  'financeWareHouses.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeWareHouses.upload': 'Upload',
  'financeWareHouses.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeWareHouses.a_maximum_of_500_stockAdjustment_can_be_imported_at_a_time':
    'A maximum of 1.000 stock adjustments can be imported at a time.',
  'financeWareHouses.import_actions_only_insert_new_stockAdjustment_cannot_update_or_delete':
    'Import actions only insert new stock adjustments, cannot update nor delete.',
  'financeWareHouses.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeWareHouses.stockAdjustment_successfully_imported':
    '{rowCount} stock adjustment imported successfully.',
  'financeWareHouses.go_to_stockAdjustment_list': 'Go to stock adjustment list',
  'financeWareHouses.account_id_help': 'Select stock adjustment account for journaling.',
  'financeWareHouses.count_stock_help':
    'If you want to do a stock take, select the type of stock calculation. With this type, the number of stock items will be locked so that all stock movements prior to this stock adjustment will be ignored.',
  'financeWareHouses.count_stock_in_out_help':
    'If you want to increase or decrease stock from a warehouse, select the In/Out Stock type.',
  'financeWareHouses.warehouse_transfer_successfully_imported':
    '{rowCount} warehouse transfer imported successfully.',
  'financeWareHouses.go_to_warehouse_page': 'Go to warehouse page',
  'financeWareHouses.follow_these_steps_to_import_your_warehouse_transfer':
    'Follow these steps to import your warehouse transfers',
  'financeWareHouses.1_download_your_warehouse_transfer_template_file':
    '1. Download your warehouse transfers template file',
  'financeWareHouses.start_by_downloading_our_warehouse_transfer_csv':
    'Start by downloading our warehouse transfer Excel template file. This file has the correct column headings Kledo needs to import details of your warehouse transfers.',
  'financeWareHouses.2_copy_your_warehouse_transfer_into_the_template':
    '2. Copy your warehouse transfers into the template',
  'financeWareHouses.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your warehouse transfer. Make sure the warehouse transfer details match the column headings provided in the template.',
  'financeWareHouses.a_maximum_of_500_warehouse_transfer_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data. Every row is counted, including warehouse transfer rows and item rows.',
  'financeWareHouses.change_access': 'Change Access Rights',
  'financeWareHouses.who_can_access_this_warehouse': 'Who can access this warehouse?',
  'financeWareHouses.all_user': 'All User',
  'financeWareHouses.access': 'Access Rights',
  'financeWareHouses.recorded_amount': 'Recorded Amount',
  'financeWareHouses.actual_amount': 'Actual Amount',
  'financeWareHouses.difference_2': 'Difference',
  'approvals.approval': 'Approval',
  'approvals.approve': 'Approve',
  'approvals.reject': 'Reject',
  'approvals.waiting_for_approval': 'Waiting for Approval',
  'approvals.waiting_for_my_approval': 'Waiting for My Approval',
  'approvals.rejected': 'Rejected',
  'approvals.rejected_because': 'Rejected because:',
  'approvals.wait': 'Wait',
  'approvals.are_you_sure_to_approve': 'Are you sure you approve to this transaction?',
  'approvals.are_you_sure_to_reject': 'Are you sure reject this transaction?',
  'approvals.enable_approvals': 'Enable Approvals',
  'approvals.approval_levels': 'How many levels of approval?',
  'approvals.approval_authority': 'Roles that have level {level} approval authority',
  'approvals.role_is_required': 'Please select a role',
  'approvals.approval_progress': 'Approval progress',
  'approvals.and_number_others': 'and {value} others',
  'approvals.cancel_approval': 'Cancel approval',
  'approvals.cancel_rejection': 'Cancel rejection',
  'approvals.are_you_sure_to_cancel_approval':
    'Are you sure to cancel the approval for this transaction?',
  'approvals.save_and_resubmit': 'Save and resubmit',
  'approvals.resubmit_confirm_title': 'Resubmit this transaction?',
  'approvals.resubmit_confirm_content':
    'The transaction will be resubmitted for approval and the approval starts over from the beginning. If nothing is changed, the transaction is not resubmitted and stays Rejected.',
  'approvals.rejected_at_level': 'Rejected at level {level} on {date}',
  'approvals.rejected_by_at_level': 'Rejected by {name} at level {level} on {date}',
  'approvals.submitted_by_name': 'Submitted by {name}',
  'approvals.resubmit_hint':
    'Fix this transaction and save it to resubmit for approval. Saving without changing anything does not resubmit it.',
  'approvals.cycle_history': 'Approval Cycle History',
  'approvals.cycle': 'Cycle {cycle}',
  'approvals.current_cycle': 'Current',
  'approvals.initial_submission': 'Initial submission',
  'approvals.cycle_trigger_1': 'Resubmitted after being rejected',
  'approvals.cycle_trigger_2': 'Approved transaction was edited',
  'approvals.cycle_trigger_3': 'Transaction awaiting approval was edited',
  'approvals.approval_config_changed': 'Approval settings changed',
  'approvals.previous_rejection': 'Previous rejection',
  'approvals.changed_fields': 'Changed fields',
  'approvals.approved_levels': 'Approved',
  'approvals.changed_field_contact': 'Contact',
  'approvals.changed_field_items': 'Items',
  'layoutInvoice.layout_invoice': 'Layout Invoice',
  'layoutInvoice.invoice': 'Invoice',
  'layoutInvoice.joined_sales_invoice': 'Joined Sales Invoice',
  'layoutInvoice.joined_purchase_invoice': 'Joined Purchase Invoice',
  'layoutInvoice.tax_invoice': 'Tax Invoice',
  'layoutInvoice.proforma': 'Proforma',
  'layoutInvoice.proforma_order': 'Proforma Order',
  'layoutInvoice.delivery': 'Delivery Slip',
  'layoutInvoice.order': 'Sales Order',
  'layoutInvoice.receipt': 'Receipt',
  'layoutInvoice.expense_slip': 'Expense Slip',
  'layoutInvoice.purchase_payment': 'Remittance Advice',
  'layoutInvoice.send_receive_money': 'Send/Receive Money',
  'layoutInvoice.remittance_advice': 'Remittance Advice',
  'layoutInvoice.cash_receipt': 'Cash Receipt',
  'layoutInvoice.account_code': 'Account Code',
  'layoutInvoice.account_name': 'Account Name',
  'layoutInvoice.error_cannot_load_data': 'Cannot load data.',
  'layoutInvoice.error_cannot_save_data': 'Cannot save data.',
  'layoutInvoice.error_cannot_reset_data': 'Cannot reset data.',
  'layoutInvoice.sale': 'Sale',
  'layoutInvoice.purchase': 'Purchase',
  'layoutInvoice.company_logo': 'Company Logo',
  'layoutInvoice.signature': 'Signature',
  'layoutInvoice.upload_logo': 'Upload logo',
  'layoutInvoice.change_logo_size': 'Change logo size',
  'layoutInvoice.upload_signature': 'Upload signature',
  'layoutInvoice.change_signature_size': 'Change signature size',
  'layoutInvoice.change_signature_spacing': 'Change signature spacing',
  'layoutInvoice.purchase_order': 'Purchase Order',
  'layoutInvoice.purchase_invoice': 'Purchase Invoice',
  'layoutInvoice.purchase_return': 'Purchase Return',
  'layoutInvoice.purchase_quote': 'Purchase Quote',
  'layoutInvoice.quote': 'Quote',
  'layoutInvoice.sell_invoice': 'Invoice',
  'layoutInvoice.show_discount': 'Show Discount',
  'layoutInvoice.show_discount_percent_and_amount': 'Show Discount Percent & Amount',
  'layoutInvoice.show_account': 'Show Account',
  'layoutInvoice.show_price': 'Show Price',
  'layoutInvoice.show_tax_total': 'Show Tax Total',
  'layoutInvoice.invoice_show_tax_amount': 'Show Item Tax Amount',
  'layoutInvoice.tax_amount_nominal': 'Tax Amount',
  'layoutInvoice.show_subtotal': 'Show Subtotal',
  'layoutInvoice.show_subtotal_plus_tax': 'Show Subtotal + Tax',
  'layoutInvoice.show_total': 'Show Total',
  'layoutInvoice.show_amount_column': 'Show Amount Column',
  'layoutInvoice.show_tax': 'Show Tax',
  'layoutInvoice.show_product': 'Show Product',
  'layoutInvoice.show_ref_code_product': 'Show Product SKU',
  'layoutInvoice.show_product_image': 'Show Product Image',
  'layoutInvoice.show_invoice': 'Show Invoice',
  'layoutInvoice.show_invoice_items': 'Show Invoice Items',
  'layoutInvoice.show_invoice_items_receipt': 'Show Item Transaction',
  'layoutInvoice.show_invoice_hpp': 'Show HPP',
  'layoutInvoice.show_invoice_hpp_subtotal': 'Show Subtotal',
  'layoutInvoice.show_qty': 'Show Quantity',
  'layoutInvoice.show_total_qty': 'Show Total Quantity',
  'layoutInvoice.show_unit': 'Show Unit',
  'layoutInvoice.show_description': 'Show Description',
  'layoutInvoice.show_tags': 'Show Tags',
  'layoutInvoice.show_term': 'Show Term',
  'layoutInvoice.show_payment': 'Show Payment',
  'layoutInvoice.show_payment_detail': 'Show Payment Detail',
  'layoutInvoice.show_sales_person': 'Show Sales Person',
  'layoutInvoice.show_paid_status': 'Show Paid Status',
  'layoutInvoice.show_warehouse': 'Show Warehouse',
  'layoutInvoice.show_amount_in_word': 'Show Amount in Word',
  'layoutInvoice.show_contact_name': 'Show Contact Name',
  'layoutInvoice.show_npwp': 'Show Company NPWP',
  'layoutInvoice.show_company_name': 'Show Company Name',
  'layoutInvoice.show_reconciliation_status': 'Show Reconciliation Status',
  'layoutInvoice.debit_memo_payment': 'Receive Debit Memo Payment',
  'layoutInvoice.portrait': 'Portrait',
  'layoutInvoice.landscape': 'Landscape',
  'layoutInvoice.show_company_information': 'Show Company Information',
  'layoutInvoice.show_email': 'Show Email',
  'layoutInvoice.show_phone': 'Show Phone',
  'layoutInvoice.show_address': 'Show Business Address',
  'layoutInvoice.show_contact': 'Show Contact',
  'layoutInvoice.show_memo': 'Show Memo',
  'layoutInvoice.show_issued_qty': 'Show Issued Qty',
  'layoutInvoice.show_outstanding_qty': 'Show Outstanding Qty',
  'layoutInvoice.show_signature_issuer': 'Show Issuer Signature Column',
  'layoutInvoice.show_signature_receiver': 'Show Receiver Signature Column',
  'layoutInvoice.signature_issuer_default_title': 'Issuer Team',
  'layoutInvoice.signature_receiver_default_title': 'Receiver Team',
  'layoutInvoice.show_material_request_ref': 'Show Material Request Number',
  'layoutInvoice.invoice_show_contact_npwp': 'Show Contact NPWP',
  'layoutInvoice.invoice_show_contact_phone': 'Show Contact Phone Number',
  'layoutInvoice.show_currency_symbol_table': 'Show Currency Symbol in Item Table',
  'layoutInvoice.show_attention': 'Show UP/ATTN',
  'layoutInvoice.show_detail_contact': 'Show Detail Contact',
  'layoutInvoice.show_manufacturing_product_materials_sales':
    'Show Manufacturing Product Materials / Package',
  'layoutInvoice.show_manufacturing_product_materials_purchase':
    'Show Manufacturing Product Materials',
  'layoutInvoice.show_manufacturing_product_materials_only':
    'Show Manufacturing Product Materials / Package Only',
  'layoutInvoice.show_manufacturing_product_materials_only_help_text':
    'Only displays the raw materials, without displaying the resulting product.',
  'layoutInvoice.show_the_calculated_value_of_the_remaining_bill':
    'Show The Calculated Value of the Remaining Bill',
  'layoutInvoice.show_total_after_discount': 'Show Total After Discount',
  'layoutInvoice.show_termin_summary_detail': 'Show Termin Summary Detail',
  'layoutInvoice.invoice_show_termin_payment_terms': 'Show Payment Terms',
  'layoutInvoice.invoice_show_termin_at_end': 'Show Term at the End',
  'layoutInvoice.invoice_show_termin_at_end_disabled':
    'Not applicable when Show Payment Terms is active',
  'layoutInvoice.show_coa': 'Show COA',
  'layoutInvoice.show_reference': 'Show Reference',
  'layoutInvoice.change_template': 'Change Template',
  'layoutInvoice.template': 'Template',
  'layoutInvoice.stamp': 'Stamp',
  'layoutInvoice.change_stamp': 'Change Stamp',
  'layoutInvoice.edit_header': 'Edit Header',
  'layoutInvoice.please_choose_template': 'Please choose template bellow :',
  'layoutInvoice.please_choose_stamp': 'Please choose stemp bellow :',
  'layoutInvoice.select_this_template': 'Select template',
  'layoutInvoice.select_this_stamp': 'Select stamp',
  'layoutInvoice.current_template': 'Current template',
  'layoutInvoice.current_stamp': 'Current stemp',
  'layoutInvoice.name': 'Name',
  'layoutInvoice.transfer_money': 'Transfer Money',
  'layoutInvoice.label_delivery': 'Label Delivery',
  'layoutInvoice.proof_of_goods_receipt': 'Proof of Goods Receipt',
  'layoutInvoice.payment_recap': 'Payment Recap',
  'layoutInvoice.production_orders': 'Production Orders',
  'layoutInvoice.show_due_date': 'Show Due Date',
  'layoutInvoice.show_invoice_time': 'Show Time',
  'layoutInvoice.show_invoice_dp_sequence': 'Show Down Payment Sequence Number on Invoice',
  'layoutInvoice.show_number': 'Show Number Item',
  'layoutInvoice.show_expedition': 'Show Expedition',
  'layoutInvoice.show_message': 'Show Message',
  'layoutInvoice.show_signature': 'Show Signature',
  'layoutInvoice.show_signature_detail': 'Show TTd Sender & Receiver',
  'layoutInvoice.show_signature_checked_by': 'Show Checked By Signature',
  'layoutInvoice.show_signature_received_by': 'Show Received By Signature',
  'layoutInvoice.show_signature_sender': 'Show Sender Signature',
  'layoutInvoice.show_signature_header': 'Show Company Signature',
  'layoutInvoice.font_size': 'Font Size',
  'layoutInvoice.ref_trans_label_case': 'Related Transaction Label Case',
  'layoutInvoice.ref_trans_label_case.uppercase': 'UPPERCASE ALL',
  'layoutInvoice.ref_trans_label_case.lowercase': 'lowercase all',
  'layoutInvoice.ref_trans_label_case.capitalize': 'Capitalize Each Word',
  'layoutInvoice.additional_message': 'Additional Message',
  'layoutInvoice.additional_message_desc':
    "Message on this additional message will be added automatically on the bottom of the transaction's message.",
  'layoutInvoice.default_message': 'Default Message',
  'layoutInvoice.default_message_desc':
    'Default message will be loaded automatically on the message input when adding a new transaction.',
  'layoutInvoice.account': 'Account',
  'layoutInvoice.show_due': 'Show Balance Due',
  'layoutInvoice.show_receivable_account': 'Show Receivable Account',
  'layoutInvoice.show_payable_account': 'Show Payable Account',
  'layoutInvoice.show_invoice_due': 'Show Remaining Receivable',
  'layoutInvoice.show_attachment': 'Show Attachment',
  'layoutInvoice.show_payments_received': 'Show Payments Received',
  'layoutInvoice.date_format': 'Date Format',
  'layoutInvoice.show_percentage_number_on_additional_number':
    'Show Additional Discount Percentage Number',
  'layoutInvoice.discount_price': 'Discount Price',
  'layoutInvoice.show_discount_price': 'Show Discount Price',
  'layoutInvoice.show_additional_discount_detail': 'Show Additional Discount Detail',
  'layoutInvoice.show_total_discount': 'Show Total Discount',
  'layoutInvoice.show_qty_actual': 'Show Qty Actual',
  'layoutInvoice.show_avg_price': 'Show Average Price',
  'layoutReport.layout_report': 'Report Layout',
  'layoutReport.manage_your_finance_print_pdf_layout_here':
    'Manage your finance print pdf layout here',
  'layoutReport.report_logo': 'Report Logo',
  'layoutReport.report_setting': 'Report Setting',
  'layoutReport.show_logo': 'Show Logo',
  'layoutReport.logo_position': 'Logo Position',
  'layoutReport.logo_position_left': 'Left',
  'layoutReport.logo_position_center': 'Center',
  'layoutReport.logo_position_right': 'Right',
  'layoutReport.show_comp_name': 'Show Company Name',
  'layoutReport.font_family': 'Font Family',
  'layoutReport.font_size': 'Font Size',
  'layoutReport.margin_size': 'Margin Size',
  'layoutReport.margin_top': 'Margin Top',
  'layoutReport.margin_right': 'Margin Right',
  'layoutReport.margin_bottom': 'Margin Bottom',
  'layoutReport.margin_left': 'Margin Left',
  'layoutReport.header_spacing': 'Report Header Spacing',
  'layoutReport.header_to_table_spacing': 'Header to Table Spacing (px)',
  'layoutReport.report_text': 'Report Text',
  'layoutReport.comp_name': 'Company Name',
  'layoutReport.report_title': 'Report Title',
  'layoutReport.report_date': 'Report Date',
  'layoutReport.click_here_to_reset_layout': 'Click here to reset report layout to the default',
  'layoutReport.show_comp_sign': 'Show Signature',
  'layoutReport.show_comp_sign_left': 'Show Signature Left',
  'layoutReport.show_comp_sign_center': 'Show Signature Center',
  'layoutReport.show_comp_sign_right': 'Show Signature Right',
  'layoutReport.signature': 'Signature',
  'financeTag.add_tag': 'Add Tag',
  'financeTag.financeTag': 'Tag',
  'financeTag.all_tags': 'All tags',
  'financeTag.only_archive': 'Only archive',
  'financeTag.select_tag_type': 'Select tag type',
  'financeTag.successfully_added': 'successfully added.',
  'financeTag.error_cannot_add': 'Cannot add tag.',
  'financeTag.error_cannot_update': 'Cannot update tag.',
  'financeTag.edit_tag': 'Edit Tag',
  'financeTag.please_input_the_tag_name': 'Please input the tag name.',
  'financeTag.name': 'Name',
  'financeTag.sale': 'Sale',
  'financeTag.purchase': 'Purchase',
  'financeTag.expense': 'Expense',
  'financeTag.fixed_asset': 'Fixed Asset',
  'financeTag.other': 'Other',
  'financeTag.date': 'Date',
  'financeTag.transaction': 'Transaction',
  'financeTag.desc': 'Description',
  'financeTag.total': 'Total',
  'financeTag.max_characters': 'Max {value} characters.',
  'financeTag.min_characters': 'Min {value} characters.',
  'financeTag.only_alphanumeric_allowed': 'Only alphanumeric allowed.',
  'financeTag.only_alphanumeric_and_dot_allowed':
    'Only letters, numbers, spaces, and the symbols . - / _ are allowed.',
  'financeTag.error_cannot_search': 'Cannot search tag.',
  'financeTag.select_tag': 'Select tag',
  'financeTag.reference': 'Reference',
  'financeTag.tag_per_item_with_title': 'Per-item {tag}',
  'financeTag.tag_per_item_help':
    'Enable to set a different {tag} on each item line. Reports filtered by {tag} will count each line under its item {tag}.',
  'financeTag.tag_per_item_help_non_journal':
    'Enable to set a different {tag} on each item line. Item {tag}s are carried over when this transaction is converted to a follow-up transaction.',
  'financeOrder.default_label_term': 'Term Order I',
  'financeOrder.message': 'Message',
  'financeOrder.add_order': 'Add Order',
  'financeOrder.financeOrder': 'Order',
  'financeOrder.open_order': 'Open order',
  'financeOrder.order_waiting_approval': 'Order waiting approval',
  'financeOrder.order_partial_shipped': 'Order partial shipped',
  'financeOrder.successfully_added': 'successfully added.',
  'financeOrder.error_cannot_add': 'Cannot add order.',
  'financeOrder.error_cannot_print_pdf': 'Cannot print pdf order.',
  'financeOrder.error_cannot_update': 'Cannot update order.',
  'financeOrder.error_cannot_move': 'Cannot move the order.',
  'financeOrder.error_cannot_change_status': 'Cannot change status the order.',
  'financeOrder.edit_order': 'Edit Invoice',
  'financeOrder.max_characters': 'Max {value} characters.',
  'financeOrder.min_characters': 'Min {value} characters.',
  'financeOrder.only_number_allowed': 'Only number allowed.',
  'financeOrder.description': 'Description',
  'financeOrder.tax': 'Tax',
  'financeOrder.select_tax': 'Select tax',
  'financeOrder.please_select_a_contact': 'Please select a contact',
  'financeOrder.select_contact': 'Select contact',
  'financeOrder.add_contact': 'Add contact',
  'financeOrder.all_contacts': 'All contact',
  'financeOrder.transaction_date': 'Transaction Date',
  'financeOrder.please_select_transaction_date': 'Please select transaction date',
  'financeOrder.due_date': 'Due Date',
  'financeOrder.please_select_due_date': 'Please select due date',
  'financeOrder.term': 'Term',
  'financeOrder.select_term': 'Select term',
  'financeOrder.add_term': 'Add term',
  'financeOrder.price_include_tax': 'Price include tax',
  'financeOrder.add_more': 'Add more',
  'financeOrder.number': 'Number',
  'financeOrder.import_quote_number': 'Quote Number',
  'financeOrder.please_input_the_number': 'Please input the number.',
  'financeOrder.memo': 'Memo',
  'financeOrder.date': 'Date',
  'financeOrder.status': 'Status',
  'financeOrder.balance_due': 'Balance Due',
  'financeOrder.total': 'Total',
  'financeOrder.please_select_a_term': 'Please select a term.',
  'financeOrder.search_by_memo': 'Search',
  'financeOrder.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financeOrder.detail_title': ' Invoice {number}',
  'financeOrder.customer': 'Customer',
  'financeOrder.reference': 'Reference',
  'financeOrder.product': 'Product',
  'financeOrder.qty': 'Qty',
  'financeOrder.not_sent_yet': 'Not Sent Yet',
  'financeOrder.price': 'Price',
  'financeOrder.add_product': 'Add Product',
  'financeOrder.select_product': 'Select product',
  'financeOrder.attachments': 'Attachments',
  'financeOrder.save_&_approve': 'Save & approve',
  'financeOrder.save_as_draft': 'Save as draft',
  'financeOrder.save_&_submit_for_approval': 'Save & submit for approval',
  'financeOrder.please_select_a_product': 'Please select a product.',
  'financeOrder.please_input_the_qty': 'Please input the qty.',
  'financeOrder.please_input_the_price': 'Please input the price.',
  'financeOrder.please_input_the_amount': 'Please input the amount.',
  'financeOrder.approve': 'Approve',
  'financeOrder.are_you_sure_to_approve': 'Are you sure to approve ?',
  'financeOrder.submit_for_approval': 'Submit for approval',
  'financeOrder.are_you_sure_to_submit_for_approval': 'Are you sure to submit for approval ?',
  'financeOrder.create_order': 'Create Order',
  'financeOrder.amount_paid': 'Amount Paid',
  'financeOrder.paid_from': 'Paid From',
  'financeOrder.add_payment': 'Receive Payment',
  'financeOrder.make_a_payment': 'Receive a payment',
  'financeOrder.select_paid_from': 'Select paid to',
  'financeOrder.please_select_a_paid_from': 'Please select receive payment to.',
  'financeOrder.error_cannot_add_payment': 'Cannot add payment.',
  'financeOrder.payment': 'Payment',
  'financeOrder.detail_order': 'Detail Order',
  'financeOrder.number_quotes': 'Quotes Number',
  'financeOrder.amount': 'Amount',
  'financeOrder.dp': 'DP',
  'financeOrder.create_delivery': 'Create Delivery',
  'financeOrder.follow_these_steps_to_import_your_order': 'Follow these steps to import your order',
  'financeOrder.1_download_your_order_template_file': '1. Download your order template file',
  'financeOrder.start_by_downloading_our_order_csv':
    'Start by downloading our orders Excel template file. This file has the correct column headings Kledo needs to import details of your orders.',
  'financeOrder.download_template_file': 'Download Template File',
  'financeOrder.download_template_data_example_file': 'Download template data example file',
  'financeOrder.import': 'Import Order',
  'financeOrder.2_copy_your_order_into_the_template': '2. Copy your orders into the template',
  'financeOrder.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your orders. Make sure the product details match the column headings provided in the template.',
  'financeOrder.important': 'IMPORTANT',
  'financeOrder.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financeOrder.upload': 'Upload',
  'financeOrder.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financeOrder.a_maximum_of_500_order_can_be_imported_at_a_time':
    'A single import supports up to 2.500 rows of Excel data. Every row is counted, including order rows and item rows.',
  'financeOrder.import_actions_only_insert_new_order_cannot_update_or_delete':
    'Import actions only insert new orders, cannot update nor delete.',
  'financeOrder.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financeOrder.order_successfully_imported': '{rowCount} order imported successfully.',
  'financeOrder.go_to_order_list': 'Go to order list',
  'financeOrder.print_order': 'Print Order',
  'financeOrder.order_will_be_sent_via': 'Order will be sent via',
  'financeOrder.copy_link': 'Copy Order Link',
  'financeOrder.send_email': 'Send Order Email',
  'financeOrder.send_sms': 'Send Order SMS',
  'financeOrder.send_wa': 'Send Order Whatsapp',
  'financeOrder.insufficient_stock_warning':
    'Cannot add to the order, because there are products that have insufficient stock.',
  'financeOrder.cannot_edit_insufficient_stock_warning':
    'Cannot edit to the order, because there are products that have insufficient stock.',
  'financeDelivery.message': 'Message',
  'financeDelivery.add_delivery': 'Add Delivery',
  'financeDelivery.financeDelivery': 'Delivery',
  'financeDelivery.open_delivery': 'Open delivery',
  'financeDelivery.successfully_added': 'successfully added.',
  'financeDelivery.error_cannot_add': 'Cannot add delivery.',
  'financeDelivery.error_cannot_print_pdf': 'Cannot print pdf delivery.',
  'financeDelivery.error_cannot_update': 'Cannot update delivery.',
  'financeDelivery.error_cannot_move': 'Cannot move the delivery.',
  'financeDelivery.error_cannot_change_status': 'Cannot change status the delivery.',
  'financeDelivery.edit_delivery': 'Edit Invoice',
  'financeDelivery.max_characters': 'Max {value} characters.',
  'financeDelivery.min_characters': 'Min {value} characters.',
  'financeDelivery.only_number_allowed': 'Only number allowed.',
  'financeDelivery.description': 'Description',
  'financeDelivery.tax': 'Tax',
  'financeDelivery.select_tax': 'Select tax',
  'financeDelivery.please_select_a_contact': 'Please select a contact',
  'financeDelivery.select_contact': 'Select contact',
  'financeDelivery.add_contact': 'Add contact',
  'financeDelivery.all_contacts': 'All contact',
  'financeDelivery.transaction_date': 'Transaction Date',
  'financeDelivery.please_select_transaction_date': 'Please select transaction date',
  'financeDelivery.due_date': 'Due Date',
  'financeDelivery.please_select_due_date': 'Please select due date',
  'financeDelivery.term': 'Term',
  'financeDelivery.select_term': 'Select term',
  'financeDelivery.add_term': 'Add term',
  'financeDelivery.price_include_tax': 'Price include tax',
  'financeDelivery.add_more': 'Add more',
  'financeDelivery.number': 'Number',
  'financeDelivery.please_input_the_number': 'Please input the number.',
  'financeDelivery.memo': 'Memo',
  'financeDelivery.date': 'Date',
  'financeDelivery.status': 'Status',
  'financeDelivery.balance_due': 'Balance Due',
  'financeDelivery.total': 'Total',
  'financeDelivery.please_select_a_term': 'Please select a term.',
  'financeDelivery.search_by_memo': 'Search',
  'financeDelivery.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financeDelivery.detail_title': ' Invoice {number}',
  'financeDelivery.customer': 'Customer',
  'financeDelivery.reference': 'Reference',
  'financeDelivery.product': 'Product',
  'financeDelivery.qty': 'Qty',
  'financeDelivery.price': 'Price',
  'financeDelivery.add_product': 'Add Product',
  'financeDelivery.select_product': 'Select product',
  'financeDelivery.attachments': 'Attachments',
  'financeDelivery.save_&_approve': 'Save & approve',
  'financeDelivery.save_as_draft': 'Save as draft',
  'financeDelivery.save_&_submit_for_approval': 'Save & submit for approval',
  'financeDelivery.please_select_a_product': 'Please select a product.',
  'financeDelivery.please_input_the_qty': 'Please input the qty.',
  'financeDelivery.please_input_the_price': 'Please input the price.',
  'financeDelivery.please_input_the_amount': 'Please input the amount.',
  'financeDelivery.approve': 'Approve',
  'financeDelivery.are_you_sure_to_approve': 'Are you sure to approve ?',
  'financeDelivery.submit_for_approval': 'Submit for approval',
  'financeDelivery.are_you_sure_to_submit_for_approval': 'Are you sure to submit for approval ?',
  'financeDelivery.amount_paid': 'Amount Paid',
  'financeDelivery.paid_from': 'Paid From',
  'financeDelivery.add_payment': 'Receive Payment',
  'financeDelivery.make_a_payment': 'Receive a payment',
  'financeDelivery.select_paid_from': 'Select paid to',
  'financeDelivery.please_select_a_paid_from': 'Please select receive payment to.',
  'financeDelivery.error_cannot_add_payment': 'Cannot add payment.',
  'financeDelivery.payment': 'Payment',
  'financeDelivery.detail_delivery': 'Detail Delivery',
  'financeDelivery.number_quotes': 'Quotes Number',
  'financeDelivery.amount': 'Amount',
  'financeDelivery.dp': 'DP',
  'financeDelivery.create_delivery': 'Create Delivery',
  'financeDelivery.shipping_delivery': 'Shipping Delivery',
  'financeDelivery.print_delivery': 'Print Delivery Order',
  'financeDelivery.print_delivery_label': 'Print Delivery Label',
  'financeDelivery.copy_link': 'Copy Delivery Link',
  'financeDelivery.send_email': 'Send Delivery Email',
  'financeDelivery.send_sms': 'Send Delivery SMS',
  'financeDelivery.send_wa': 'Send Delivery Whatsapp',
  'shipping.show_shipping_information': 'Show shipping information',
  'shipping.hide_shipping_information': 'Hide shipping information',
  'shipping.shipping_date': 'Shipping date',
  'shipping.shipping_expedition': 'Expediton',
  'shipping.shipping_tracking': 'Tracking number',
  'shipping.select_expedition': 'Select expedition',
  'shipping.add_expedition': 'Add expedition',
  'shipping.shipping_cost': 'Shipping cost',
  'shipping.please_select_shipping_date': 'Please select shipping date.',
  'shipping.shipping_information': 'Shipping information',
  'creditMemo.add_credit_memo': 'Add Credit Memo',
  'creditMemo.credit_memo': 'Credit Memo',
  'creditMemo.detail_credit_memo': 'Detail Credit Memo',
  'creditMemo.customer': 'Customer',
  'creditMemo.add_transactions': 'Add Transaction',
  'creditMemo.successfully_added': 'successfully added.',
  'creditMemo.error_cannot_add': 'Cannot add credit memo.',
  'creditMemo.error_cannot_update': 'Cannot update credit memo.',
  'creditMemo.edit_credit_memo': 'Edit Credit Memo',
  'creditMemo.max_characters': 'Max {value} characters.',
  'creditMemo.min_characters': 'Min {value} characters.',
  'creditMemo.only_number_allowed': 'Only number allowed.',
  'creditMemo.description': 'Description',
  'creditMemo.amount': 'Amount',
  'creditMemo.transaction_date': 'Transaction Date',
  'creditMemo.please_select_transaction_date': 'Please select transaction date',
  'creditMemo.number': 'Number',
  'creditMemo.please_input_the_number': 'Please input the number.',
  'creditMemo.memo': 'Memo',
  'creditMemo.message': 'Message',
  'creditMemo.date': 'Date',
  'creditMemo.total': 'Total',
  'creditMemo.search_by_memo': 'Search',
  'creditMemo.detail_title': 'Credit Memo {number}',
  'creditMemo.reference': 'Reference',
  'creditMemo.attachments': 'Attachments',
  'creditMemo.please_input_the_amount': 'Please input the amount.',
  'creditMemo.account': 'Account',
  'creditMemo.select_account': 'Select Account',
  'creditMemo.balancer_account': 'Payable Account',
  'creditMemo.balancer_account_placeholder': 'Follow contact settings',
  'creditMemo.balancer_account_tooltip': 'Leave empty to use the account from the contact mapping.',
  'creditMemo.balancer_account_locked':
    'Cannot be changed because this transaction is already paid or used for payment.',
  'creditMemo.credit_balance': 'Credit Balance',
  'creditMemo.make_a_payment': 'Make a payment',
  'creditMemo.return_number': 'Return Number',
  'return.add_return': 'Add Return',
  'return.return': 'Return',
  'return.detail_return': 'Detail Return',
  'return.customer': 'Customer',
  'return.vendor': 'Vendor',
  'return.add_transactions': 'Add Transaction',
  'return.successfully_added': 'successfully added.',
  'return.error_cannot_add': 'Cannot add credit memo.',
  'return.error_cannot_update': 'Cannot update credit memo.',
  'return.edit_return': 'Edit Return',
  'return.max_characters': 'Max {value} characters.',
  'return.min_characters': 'Min {value} characters.',
  'return.only_number_allowed': 'Only number allowed.',
  'return.description': 'Description',
  'return.amount': 'Amount',
  'return.transaction_date': 'Return Date',
  'return.please_select_transaction_date': 'Please select transaction date',
  'return.number': 'Number',
  'return.please_input_the_number': 'Please input the number.',
  'return.memo': 'Memo',
  'return.message': 'Message',
  'return.date': 'Date',
  'return.total': 'Total',
  'return.search_by_memo': 'Search',
  'return.detail_title': 'Return {number}',
  'return.reference': 'Reference',
  'return.attachments': 'Attachments',
  'return.please_input_the_amount': 'Please input the amount.',
  'return.invoice': 'Invoice',
  'return.faktur_balance': 'Faktur Balance',
  'return.qty_faktur': 'Qty Faktur',
  'return.available_return': 'Available Retur',
  'return.product': 'Product',
  'return.discount_percent': 'Discount',
  'return.tax': 'Tax',
  'return.qty_return': 'Qty Return',
  'return.price': 'Price',
  'return.please_input_the_qty': 'Please input the qty.',
  'return.price_include_tax': 'Price include tax',
  'return.cannot_greather_than_available': 'Cannot greather than available.',
  'return.amount_cannot_greather_than_available': 'Amount cannot exceed the available amount.',
  'return.balance_due': 'Balance Due',
  'return.total_return': 'Return Total',
  'financePurchaseQuotes.message': 'Message',
  'financePurchaseQuotes.add_quote': 'Add Quote',
  'financePurchaseQuotes.financePurchaseQuotes': 'Quote',
  'financePurchaseQuotes.financePurchaseQuotes2': 'Purchase Quote',
  'financePurchaseQuotes.successfully_added': 'successfully added.',
  'financePurchaseQuotes.error_cannot_add': 'Cannot add quote.',
  'financePurchaseQuotes.error_cannot_print_pdf': 'Cannot print pdf quote.',
  'financePurchaseQuotes.error_cannot_update': 'Cannot update quote.',
  'financePurchaseQuotes.error_cannot_move': 'Cannot move the quote.',
  'financePurchaseQuotes.error_cannot_change_status': 'Cannot change status the quote.',
  'financePurchaseQuotes.edit_quote': 'Edit Quote',
  'financePurchaseQuotes.max_characters': 'Max {value} characters.',
  'financePurchaseQuotes.min_characters': 'Min {value} characters.',
  'financePurchaseQuotes.only_number_allowed': 'Only number allowed.',
  'financePurchaseQuotes.description': 'Description',
  'financePurchaseQuotes.tax': 'Tax',
  'financePurchaseQuotes.select_tax': 'Select tax',
  'financePurchaseQuotes.amount': 'Amount',
  'financePurchaseQuotes.please_select_a_contact': 'Please select a contact',
  'financePurchaseQuotes.select_contact': 'Select contact',
  'financePurchaseQuotes.add_contact': 'Add contact',
  'financePurchaseQuotes.all_contacts': 'All contact',
  'financePurchaseQuotes.transaction_date': 'Transaction Date',
  'financePurchaseQuotes.please_select_transaction_date': 'Please select transaction date',
  'financePurchaseQuotes.due_date': 'Expiry',
  'financePurchaseQuotes.please_select_due_date': 'Please select expiry',
  'financePurchaseQuotes.term': 'Term',
  'financePurchaseQuotes.select_term': 'Select term',
  'financePurchaseQuotes.add_term': 'Add term',
  'financePurchaseQuotes.price_include_tax': 'Price include tax',
  'financePurchaseQuotes.add_more': 'Add more',
  'financePurchaseQuotes.number': 'Number',
  'financePurchaseQuotes.please_input_the_number': 'Please input the number.',
  'financePurchaseQuotes.memo': 'Memo',
  'financePurchaseQuotes.date': 'Date',
  'financePurchaseQuotes.status': 'Status',
  'financePurchaseQuotes.balance_due': 'Balance Due',
  'financePurchaseQuotes.please_select_a_term': 'Please select a term.',
  'financePurchaseQuotes.search_by_memo': 'Search',
  'financePurchaseQuotes.the_due_date_max_higger_than_transaction_date':
    'The expiry date must same or after transaction date',
  'financePurchaseQuotes.detail_title': 'Quote {number}',
  'financePurchaseQuotes.customer': 'Customer',
  'financePurchaseQuotes.reference': 'Reference',
  'financePurchaseQuotes.product': 'Product',
  'financePurchaseQuotes.qty': 'Qty',
  'financePurchaseQuotes.price': 'Price',
  'financePurchaseQuotes.add_product': 'Add Product',
  'financePurchaseQuotes.select_product': 'Select product',
  'financePurchaseQuotes.attachments': 'Attachments',
  'financePurchaseQuotes.save_as_draft': 'Save as draft',
  'financePurchaseQuotes.save_&_submit_for_approval': 'Save & submit for approval',
  'financePurchaseQuotes.please_select_a_product': 'Please select a product.',
  'financePurchaseQuotes.please_input_the_qty': 'Please input the qty.',
  'financePurchaseQuotes.please_input_the_price': 'Please input the price.',
  'financePurchaseQuotes.please_input_the_amount': 'Please input the amount.',
  'financePurchaseQuotes.mark_as_sent': 'Mark as sent',
  'financePurchaseQuotes.are_you_sure_to_mark_as_sent': 'Are you sure to mark as sent ?',
  'financePurchaseQuotes.mark_as_accepted': 'Mark as accepted',
  'financePurchaseQuotes.are_you_sure_to_mark_as_accepted': 'Are you sure to mark as accepted ?',
  'financePurchaseQuotes.mark_as_declined': 'Mark as declined',
  'financePurchaseQuotes.are_you_sure_to_mark_as_declined': 'Are you sure to mark as declined ?',
  'financePurchaseQuotes.create_invoice': 'Create Invoice',
  'financePurchaseQuotes.send': 'Send',
  'financePurchaseQuotes.detail_quote': 'Detail Quote',
  'financePurchaseQuotes.create_order': 'Create Order',
  'financePurchaseQuotes.follow_these_steps_to_import_your_quotes':
    'Follow these steps to import your quotes',
  'financePurchaseQuotes.1_download_your_quotes_template_file':
    '1. Download your quotes template file',
  'financePurchaseQuotes.start_by_downloading_our_quotes_csv':
    'Start by downloading our quotes Excel template file. This file has the correct column headings Kledo needs to import details of your quotes.',
  'financePurchaseQuotes.download_template_file': 'Download Template File',
  'financePurchaseQuotes.download_template_data_example_file':
    'Download template data example file',
  'financePurchaseQuotes.import': 'Import Quotes',
  'financePurchaseQuotes.2_copy_your_quotes_into_the_template':
    '2. Copy your quotes into the template',
  'financePurchaseQuotes.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your quotes. Make sure the product details match the column headings provided in the template.',
  'financePurchaseQuotes.important': 'IMPORTANT',
  'financePurchaseQuotes.3_upload_the_updated_template_file_here':
    '3. Upload the updated template file here',
  'financePurchaseQuotes.upload': 'Upload',
  'financePurchaseQuotes.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'financePurchaseQuotes.a_maximum_of_500_quotes_can_be_imported_at_a_time':
    'A single import supports up to 2.500 rows of Excel data. Every row is counted, including purchase quote rows and item rows.',
  'financePurchaseQuotes.contact_name_that_not_exist_will_be_inserted_as_a_new_contact':
    'Contact name that not exist will be inserted as a new contact.',
  'financePurchaseQuotes.import_actions_only_insert_new_quotes_cannot_update_or_delete':
    'Import actions only insert new quotes, cannot update nor delete.',
  'financePurchaseQuotes.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'financePurchaseQuotes.you_can_only_upload_csv_file': 'You can only upload csv or excel file.',
  'financePurchaseQuotes.upload_file': 'Upload File',
  'financePurchaseQuotes.check_the_imported_data': 'Check Data',
  'financePurchaseQuotes.please_check_the_imported_data': 'Please check the imported data',
  'financePurchaseQuotes.import_quotes_done': 'Import Success',
  'financePurchaseQuotes.error_upload_file': 'Upload failed.',
  'financePurchaseQuotes.file_not_found': 'File not found',
  'financePurchaseQuotes.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'financePurchaseQuotes.valid': 'Valid',
  'financePurchaseQuotes.invalid': 'Invalid',
  'financePurchaseQuotes.total': 'Total',
  'financePurchaseQuotes.import_now': 'Import Now',
  'financePurchaseQuotes.contact_name': 'Contact name',
  'financePurchaseQuotes.email': 'Email',
  'financePurchaseQuotes.address': 'Address',
  'financePurchaseQuotes.phone': 'Phone',
  'financePurchaseQuotes.quote_date': 'Quote Date',
  'financePurchaseQuotes.quote_number': 'Quote Number',
  'financePurchaseQuotes.product_name': 'Product name',
  'financePurchaseQuotes.code_sku': 'Kode/SKU',
  'financePurchaseQuotes.tax_inclusive': 'Tax Inclusive',
  'financePurchaseQuotes.paid': 'Paid',
  'financePurchaseQuotes.paid_account': 'Paid To Account',
  'financePurchaseQuotes.inventory_account': 'Inventory Account',
  'financePurchaseQuotes.quotes_successfully_imported': '{rowCount} quote imported successfully.',
  'financePurchaseQuotes.view_detail': 'View detail',
  'financePurchaseQuotes.import_another_file': 'Import another file',
  'financePurchaseQuotes.go_to_quote_list': 'Go to quote list',
  'financePurchaseQuotes.success': 'Success',
  'financePurchaseQuotes.failed': 'Failed',
  'financePurchaseQuotes.error_cannot_import': 'Import failed',
  'financePurchaseQuotes.error': 'Error',
  'financePurchaseQuotes.vendor': 'Vendor',
  'debitMemo.add_debit_memo': 'Add Debit Memo',
  'debitMemo.debit_memo': 'Debit Memo',
  'debitMemo.detail_debit_memo': 'Detail Debit Memo',
  'debitMemo.customer': 'Customer',
  'debitMemo.add_transactions': 'Add Transaction',
  'debitMemo.successfully_added': 'successfully added.',
  'debitMemo.error_cannot_add': 'Cannot add debit memo.',
  'debitMemo.error_cannot_update': 'Cannot update debit memo.',
  'debitMemo.edit_debit_memo': 'Edit Debit Memo',
  'debitMemo.max_characters': 'Max {value} characters.',
  'debitMemo.min_characters': 'Min {value} characters.',
  'debitMemo.only_number_allowed': 'Only number allowed.',
  'debitMemo.description': 'Description',
  'debitMemo.amount': 'Amount',
  'debitMemo.transaction_date': 'Transaction Date',
  'debitMemo.please_select_transaction_date': 'Please select transaction date',
  'debitMemo.number': 'Number',
  'debitMemo.please_input_the_number': 'Please input the number.',
  'debitMemo.memo': 'Memo',
  'debitMemo.message': 'Message',
  'debitMemo.date': 'Date',
  'debitMemo.total': 'Total',
  'debitMemo.search_by_memo': 'Search',
  'debitMemo.detail_title': 'Debit Memo {number}',
  'debitMemo.reference': 'Reference',
  'debitMemo.attachments': 'Attachments',
  'debitMemo.please_input_the_amount': 'Please input the amount.',
  'debitMemo.account': 'Account',
  'debitMemo.select_account': 'Select Account',
  'debitMemo.balancer_account': 'Receivable Account',
  'debitMemo.balancer_account_placeholder': 'Follow contact settings',
  'debitMemo.balancer_account_tooltip':
    'Leave empty to use the account from the contact account mapping.',
  'debitMemo.balancer_account_locked':
    'Cannot be changed because this transaction has been paid or used for payment.',
  'debitMemo.debit_balance': 'Debit Balance',
  'debitMemo.make_a_payment': 'Receive Payment',
  'debitMemo.return_number': 'Return Number',
  'financePurchaseDelivery.message': 'Message',
  'financePurchaseDelivery.add_delivery': 'Add Delivery',
  'financePurchaseDelivery.financePurchaseDelivery': 'Delivery',
  'financePurchaseDelivery.successfully_added': 'successfully added.',
  'financePurchaseDelivery.error_cannot_add': 'Cannot add delivery.',
  'financePurchaseDelivery.error_cannot_print_pdf': 'Cannot print pdf delivery.',
  'financePurchaseDelivery.error_cannot_update': 'Cannot update delivery.',
  'financePurchaseDelivery.error_cannot_move': 'Cannot move the delivery.',
  'financePurchaseDelivery.error_cannot_change_status': 'Cannot change status the delivery.',
  'financePurchaseDelivery.edit_delivery': 'Edit Invoice',
  'financePurchaseDelivery.max_characters': 'Max {value} characters.',
  'financePurchaseDelivery.min_characters': 'Min {value} characters.',
  'financePurchaseDelivery.only_number_allowed': 'Only number allowed.',
  'financePurchaseDelivery.description': 'Description',
  'financePurchaseDelivery.tax': 'Tax',
  'financePurchaseDelivery.select_tax': 'Select tax',
  'financePurchaseDelivery.please_select_a_contact': 'Please select a contact',
  'financePurchaseDelivery.select_contact': 'Select contact',
  'financePurchaseDelivery.add_contact': 'Add contact',
  'financePurchaseDelivery.all_contacts': 'All contact',
  'financePurchaseDelivery.transaction_date': 'Transaction Date',
  'financePurchaseDelivery.please_select_transaction_date': 'Please select transaction date',
  'financePurchaseDelivery.due_date': 'Due Date',
  'financePurchaseDelivery.please_select_due_date': 'Please select due date',
  'financePurchaseDelivery.term': 'Term',
  'financePurchaseDelivery.select_term': 'Select term',
  'financePurchaseDelivery.add_term': 'Add term',
  'financePurchaseDelivery.price_include_tax': 'Price include tax',
  'financePurchaseDelivery.add_more': 'Add more',
  'financePurchaseDelivery.number': 'Number',
  'financePurchaseDelivery.please_input_the_number': 'Please input the number.',
  'financePurchaseDelivery.memo': 'Memo',
  'financePurchaseDelivery.date': 'Date',
  'financePurchaseDelivery.status': 'Status',
  'financePurchaseDelivery.balance_due': 'Balance Due',
  'financePurchaseDelivery.total': 'Total',
  'financePurchaseDelivery.please_select_a_term': 'Please select a term.',
  'financePurchaseDelivery.search_by_memo': 'Search',
  'financePurchaseDelivery.the_due_date_max_higger_than_transaction_date':
    'The due date must same or after transaction date',
  'financePurchaseDelivery.detail_title': ' Invoice {number}',
  'financePurchaseDelivery.customer': 'Customer',
  'financePurchaseDelivery.vendor': 'Vendor',
  'financePurchaseDelivery.print_receipt_of_goods': 'Print Receipt of Goods',
  'financePurchaseDelivery.reference': 'Reference',
  'financePurchaseDelivery.product': 'Product',
  'financePurchaseDelivery.qty': 'Qty',
  'financePurchaseDelivery.price': 'Price',
  'financePurchaseDelivery.add_product': 'Add Product',
  'financePurchaseDelivery.select_product': 'Select product',
  'financePurchaseDelivery.attachments': 'Attachments',
  'financePurchaseDelivery.save_&_approve': 'Save & approve',
  'financePurchaseDelivery.save_as_draft': 'Save as draft',
  'financePurchaseDelivery.save_&_submit_for_approval': 'Save & submit for approval',
  'financePurchaseDelivery.please_select_a_product': 'Please select a product.',
  'financePurchaseDelivery.please_input_the_qty': 'Please input the qty.',
  'financePurchaseDelivery.please_input_the_price': 'Please input the price.',
  'financePurchaseDelivery.please_input_the_amount': 'Please input the amount.',
  'financePurchaseDelivery.approve': 'Approve',
  'financePurchaseDelivery.are_you_sure_to_approve': 'Are you sure to approve ?',
  'financePurchaseDelivery.submit_for_approval': 'Submit for approval',
  'financePurchaseDelivery.are_you_sure_to_submit_for_approval':
    'Are you sure to submit for approval ?',
  'financePurchaseDelivery.amount_paid': 'Amount Paid',
  'financePurchaseDelivery.paid_from': 'Paid From',
  'financePurchaseDelivery.add_payment': 'Receive Payment',
  'financePurchaseDelivery.make_a_payment': 'Receive a payment',
  'financePurchaseDelivery.select_paid_from': 'Select paid to',
  'financePurchaseDelivery.please_select_a_paid_from': 'Please select receive payment to.',
  'financePurchaseDelivery.error_cannot_add_payment': 'Cannot add payment.',
  'financePurchaseDelivery.payment': 'Payment',
  'financePurchaseDelivery.detail_delivery': 'Detail Delivery',
  'financePurchaseDelivery.number_quotes': 'Quotes Number',
  'financePurchaseDelivery.amount': 'Amount',
  'financePurchaseDelivery.dp': 'DP',
  'financePurchaseDelivery.create_delivery': 'Create Delivery',
  'financePurchaseDelivery.shipping_delivery': 'Shipping Delivery',
  'businessFlow.businessFlow': 'Settings Business Flow',
  'businessFlow.sales_discount': 'Sales discount',
  'businessFlow.sales_discount_desc': 'Does your company can give sales discount?',
  'businessFlow.delivery_desc': 'Does your company make a pass at delivery?',
  'businessFlow.order_desc': 'Does your company accept sales orders?',
  'businessFlow.quote_desc': 'Have your company send out sales offers?',
  'businessFlow.down_payment': 'Down payment',
  'businessFlow.down_payment_desc': 'Does your company can accept sales down payment?',
  'businessFlow.purchase_down_payment_desc': 'Does your company can paid purchase down payment?',
  'businessFlow.purchase_discount': 'Purchase discount',
  'businessFlow.purchase_discount_desc': 'Does your company can accept purchase discount?',
  'businessFlow.purchase_delivery': 'Purchase delivery',
  'businessFlow.purchase_delivery_desc': 'Does purchase delivery feature activated?',
  'businessFlow.purchase_order': 'Purchase order',
  'businessFlow.purchase_order_desc': 'Does your company place a purchase order?',
  'businessFlow.purchase_quote': 'Purchase quote',
  'businessFlow.purchase_quote_desc': 'Does your company accept purchase orders?',
  'businessFlow.purchase_request': 'Purchase request',
  'businessFlow.purchase_request_desc':
    'Does your company submit internal purchase requests before ordering?',
  'businessFlow.reconciliation': 'Reconciliation',
  'businessFlow.reconciliation_desc':
    'Do you reconcile transactions at Kledo with mutations in bank accounts?',
  'businessFlow.tracking_stock': 'Track inventory / stock by default',
  'businessFlow.tracking_stock_desc':
    'When adding products, by default set products to track stock',
  'businessFlow.error_cannot_update': 'Cannot change settings.',
  'businessFlow.decline_new_sales_if_stock_not_enough': 'Decline new invoice if stock not enough',
  'businessFlow.decline_new_order_if_stock_not_enough': 'Decline order if stock not enough',
  'businessFlow.decline_new_delivery_if_stock_not_enough':
    'Decline new delivery if stock not enough',
  'businessFlow.show_available_stock_when_making_a_sale': 'Show available stock when making a sale',
  'businessFlow.show_sales_description': 'Show description on sale',
  'businessFlow.show_sales_description_desc': 'Is the description column in sales showing?',
  'businessFlow.show_purchases_description': 'Show description on purchase',
  'businessFlow.show_purchases_description_desc': 'Is the description field in the purchase shown?',
  'businessFlow.whether_stock_is_in_the_warehouse':
    'Whether stock is in the warehouse needs to be displayed when making a new sale?',
  'businessFlow.show_available_stock_per_warehouse': 'Stock calculated by selected warehouse',
  'businessFlow.hide_products_that_are_out_of_stock': 'Hide products that are out of stock',
  'businessFlow.hide_products_that_are_out_of_stock_description':
    'Are out-of-stock products hidden when adding to a sales?',
  'businessFlow.show_profit_margin_when_making_transaction':
    'Show profit margin when making transaction',
  'businessFlow.show_details_of_average_price_and_profit_margin_when_making_a_new_transaction':
    'Show details of average price and profit margin when making a new transaction.',
  'businessFlow.whether_displayed_stock_needs_per_warehouse':
    'If active, then stock is calculated by selected warehouse instead of all stock',
  'businessFlow.decline_to_add_sales_if_the_total_stock_not_enough':
    'Decline to add invoice if the total stock in the warehouse is insufficient?',
  'businessFlow.decline_to_add_order_if_the_total_stock_not_enough':
    'Decline order if the total stock in the warehouse is insufficient?',
  'businessFlow.decline_to_add_delivery_if_the_total_stock_not_enough':
    'Decline to add delivery if the total stock in the warehouse is insufficient?',
  'businessFlow.discount_in_nominal': 'Discount input in numeric',
  'businessFlow.wether_discount_input_when_add_invoice_in_nominal_format_or_percent_format':
    'Wether discount input when add invoice in numeric format or percentage format',
  'businessFlow.product_price_dont_change': "Product price can't changed",
  'businessFlow.wether_product_price_can_be_changed_when_add_invoice':
    'Wether product price can be changed when add invoice',
  'businessFlow.sales_person': 'Sales person',
  'businessFlow.default_sale_include_tax': 'Default sale price include tax',
  'businessFlow.wether_create_sale_invoice_include_tax':
    'Wether when creating invoice default sale price include tax?',
  'businessFlow.default_purchase_include_tax': 'Default purchase price include tax',
  'businessFlow.wether_create_purchase_invoice_include_tax':
    'Wether when creating invoice default purchase price include tax?',
  'businessFlow.min_stock': 'Minimal stock',
  'businessFlow.when_product_below_min_stock_email_notification':
    'When product stock below minimal stock, email notification will be sent',
  'businessFlow.decline_product_conv_if_stock_not_enough':
    'Decline product conversion if stok is not enough',
  'businessFlow.wether_decline_add_product_conv_if_stock_not_enough':
    'Wether decline add product conversion if stock not enough',
  'businessFlow.lang_date_currency': 'Language, Date, & Currency',
  'businessFlow.module_desc.sales': 'Transaction flow, stock, and sales form',
  'businessFlow.module_desc.purchases': 'Transaction flow and purchase form',
  'businessFlow.module_desc.expenses': 'Expense form validation',
  'businessFlow.module_desc.products': 'Price, stock, and product data behavior',
  'businessFlow.module_desc.inventory': 'Warehouse transfers and stock adjustments',
  'businessFlow.module_desc.contacts': 'Contact data validation and completeness',
  'businessFlow.module_desc.reports': 'Report display preferences',
  'businessFlow.module_desc.cash_bank': 'Bank reconciliation and transaction validation',
  'businessFlow.module_desc.manual_journal': 'Manual journal validation',
  'businessFlow.module_desc.format_dropdown': 'Display format of dropdown options',
  'businessFlow.module_desc.lang_date_currency': 'Regional application preferences',
  'businessFlow.module_desc.system': 'System-level features',
  'businessFlow.module_desc.fixed_assets': 'Fixed asset behavior',
  'businessFlow.search_result_count': '{count} results for "{query}" in this module',
  'businessFlow.see_example': 'See example',
  'businessFlow.app_lang': 'Invoice language',
  'businessFlow.app_lang_desc': 'Default language for every staff in your company',
  'businessFlow.time_zone': 'Time zone',
  'businessFlow.time_zone_desc': 'Time zone location of your company',
  'businessFlow.date_format': 'Date format',
  'businessFlow.date_format_desc': 'Date display in Kledo app',
  'businessFlow.time_format': 'Time format',
  'businessFlow.time_format_desc': 'Hour and minute display in Kledo app',
  'businessFlow.number_after_comma': 'Number after comma',
  'businessFlow.number_after_comma_desc': 'How much number behind comma showed in Kledo app?',
  'businessFlow.currency_format': 'Currency format',
  'businessFlow.currency_format_desc': 'Currency display in Kledo app',
  'businessFlow.activate_multi_currency': 'Activate multi currency feature',
  'businessFlow.activate_multi_currency_desc': 'Does your company use more than one currency?',
  'businessFlow.base_currency': 'Base currency',
  'businessFlow.base_currency_desc': 'Currency used as main currency in your company',
  'businessFlow.show_coa': 'Show COA',
  'businessFlow.show_coa_desc': 'Show COA on profit loss report',
  'businessFlow.show_currency_symbol': 'Show currency symbol',
  'businessFlow.show_currency_symbol_desc':
    'Will the currency symbol be displayed on the interface?',
  'businessFlow.show_reference': 'Show reference',
  'businessFlow.show_reference_desc': 'Wether show reference input when creating invoice',
  'businessFlow.show_tag': 'Show tag',
  'businessFlow.show_tag_desc': 'Wether show tag input when creating invoice',
  'businessFlow.input_tag_is_required': 'Input tag is required',
  'businessFlow.input_tag_is_required_desc': 'Is the tag required when adding a sales transaction?',
  'businessFlow.show_delivery_info': 'Show delivery information',
  'businessFlow.show_delivery_info_desc':
    'Wether show delivery information input when creating invoice',
  'businessFlow.lock_price_from_quote': 'Lock price from quote',
  'businessFlow.lock_price_from_quote_desc':
    'Wether when create invoice from quote, the price cannot be changed?',
  'businessFlow.lock_price_from_purchase_quote': 'Lock price from purchase quote',
  'businessFlow.lock_price_from_purchase_quote_desc':
    'Wether when create purchase invoice from quote, the price cannot be changed?',
  'businessFlow.product_search_settings': 'Product Search Settings',
  'businessFlow.product_search_settings_desc':
    'Configure how Products are searched when creating a transaction',
  'businessFlow.product_search_mode': 'Search method',
  'businessFlow.product_search_mode_desc': 'Choose the Product search method in transactions',
  'businessFlow.product_search_mode_simple': 'Simple',
  'businessFlow.product_search_mode_advance': 'Advance (Full text)',
  'businessFlow.product_search_mode_advance_example':
    'Full text search, faster on large data. Search "dining table" → matches Products containing "dining" or "table"',
  'businessFlow.product_search_wildcard': 'Match pattern',
  'businessFlow.product_search_wildcard_desc': 'Keyword position matched on simple search',
  'businessFlow.product_search_wildcard_contains': 'Contains Keyword',
  'businessFlow.product_search_wildcard_contains_example':
    'Keyword anywhere. Search "table" → "table lamp", "dining table set"',
  'businessFlow.product_search_wildcard_front': 'Ends With Keyword',
  'businessFlow.product_search_wildcard_front_example':
    'Matches when the text ends with the keyword. Search "table" → "dining table"',
  'businessFlow.product_search_wildcard_back': 'Starts With Keyword',
  'businessFlow.product_search_wildcard_back_example':
    'Matches when the text starts with the keyword. Search "table" → "table lamp"',
  'businessFlow.product_search_field': 'Search by field',
  'businessFlow.product_search_field_desc': 'Product field used for searching',
  'businessFlow.product_search_field_both': 'Product Name and Code',
  'businessFlow.product_search_field_both_example': 'Search runs on both Product name and code',
  'businessFlow.product_search_field_name': 'Product Name',
  'businessFlow.product_search_field_name_example': 'Search runs on Product name only',
  'businessFlow.product_search_field_code': 'Product Code',
  'businessFlow.product_search_field_code_example': 'Search runs on Product code only',
  'businessFlow.use_fifo_method': 'Use FIFO method to calculate COGS',
  'businessFlow.use_fifo_method_desc':
    'Turn on to activate FIFO method to calculate COGS, or turn it off to use averaging method. You cannot change this setting after you have product with inventory tracking active. This settings only available on Elite Plan.',
  'businessFlow.auto_update_product_buy_price': 'Auto update product buy price',
  'businessFlow.auto_update_product_buy_price_desc':
    'When buying a product, the buy price is automatically updated to the product as the default buy price',
  'businessFlow.auto_update_product_sell_price': 'Auto update product selling price',
  'businessFlow.auto_update_product_sell_price_desc':
    'When selling a product, the selling price is automatically updated to the product as the default selling price',
  'businessFlow.reference_multiline': 'Multiline reference',
  'businessFlow.reference_multiline_desc': 'Can reference be multiline?',
  'businessFlow.show_due_date': 'Show due date',
  'businessFlow.is_the_due_date_shown_on_the_purchase_invoice_form':
    'Is the due date shown on the purchase form?',
  'businessFlow.is_the_due_date_shown_on_the_invoice_form':
    'Is the due date shown on the sales form?',
  'businessFlow.show_witholding': 'Show witholding',
  'businessFlow.show_witholding_desc': 'Wether show witholding when creating invoice?',
  'businessFlow.show_shipping_cost': 'Show shipping cost',
  'businessFlow.show_shipping_cost_desc': 'Whether to show shipping cost when creating invoice?',
  'businessFlow.show_transaction_fee': 'Show transaction fee',
  'businessFlow.show_transaction_fee_desc':
    'Whether to show transaction fee when creating invoice?',
  'businessFlow.show_sequence': 'Show sequence',
  'businessFlow.show_sequence_desc': 'Wether to show the order column of transaction items?',
  'businessFlow.auto_update_selling_price_from_orders_and_quotes':
    'Auto update selling price from orders & quotes',
  'businessFlow.auto_update_selling_price_from_orders_and_quotes_desc':
    'If it is active, the product price will be updated if there are orders and quotes. If it is not active then only update the price when it is invoice.',
  'businessFlow.product_last_price_after_discount': 'Last selling price after discount',
  'businessFlow.product_last_price_after_discount_desc':
    'If enabled, the last selling price history shows the price after discount',
  'businessFlow.product_last_buy_price_after_discount': 'Last purchase price after discount',
  'businessFlow.product_last_buy_price_after_discount_desc':
    'If enabled, the last purchase price history shows the price after discount',
  'businessFlow.auto_update_purchase_price_from_purchases_orders_and_purchases_quotes':
    'Auto update purchase price from purchase order & purchase quotes',
  'businessFlow.auto_update_purchase_price_from_purchases_orders_and_purchases_quotes_desc':
    'If it is active, the product price will be updated if there is a purchase orders or purchase quotes. If it is not active then only update the price when it is on the purchase invoice.',
  'businessFlow.default_trans_date_follow_parent':
    'Default transaction date is the same as the original transcation date',
  'businessFlow.default_trans_date_follow_parent_desc':
    "If yes, then when creating a bill from the order, the default transaction date is the same as the order date. Otherwise, the transaction date is today's date.",
  'businessFlow.default_message': 'Use the same message as the original transaction',
  'businessFlow.default_message_desc':
    'When creating a bill from an order, the contents of the message in the bill are automatically the same as the message in the order.',
  'businessFlow.invoice_lock_messages': 'Lock invoice message',
  'businessFlow.invoice_lock_messages_desc':
    'When enabled, the Message field on Sales Invoices cannot be changed and always uses the default message from the Invoice Layout.',
  'businessFlow.default_message_delivery': 'Use the same delivery message as the order transaction',
  'businessFlow.default_message_delivery_desc':
    'When making a delivery, the content of the message is the same as the order transaction.',
  'businessFlow.delivery_items_default_zero': 'Product quantity defaults from order to delivery',
  'businessFlow.delivery_items_default_zero_desc':
    'Product quantity will be set to 0 when making delivery from order',
  'businessFlow.invoice_show_tax_column': 'Show tax column on sales invoice',
  'businessFlow.invoice_show_tax_column_desc':
    'Is the tax column shown when creating a sales invoice?',
  'businessFlow.invoice_show_tax_column_disabled_tooltip':
    'Please turn off "Input tax is required" and "Default sale price include tax" first.',
  'businessFlow.purchase_show_tax_column': 'Show tax column on purchase invoice',
  'businessFlow.purchase_show_tax_column_desc':
    'Is the tax column shown when creating a purchase invoice?',
  'businessFlow.purchase_show_tax_column_disabled_tooltip':
    'Please turn off "Default purchase price include tax" first.',
  'businessFlow.input_tax_is_required': 'Input tax is required',
  'businessFlow.input_tax_is_required_desc': 'Is tax input required when creating an invoice?',
  'businessFlow.invoice_show_dpp_form': 'Show other-value tax base (DPP)',
  'businessFlow.invoice_show_dpp_form_desc':
    'Whether the other-value DPP (tax base) is shown when creating/editing an invoice and on the invoice detail.',
  'businessFlow.purchase_order_show_dpp_form': 'Show other-value tax base (DPP) on purchase orders',
  'businessFlow.purchase_order_show_dpp_form_desc':
    'Whether the other-value DPP (tax base) is shown when creating/editing a purchase order and on the purchase order detail.',
  'businessFlow.purchase_invoice_show_dpp_form':
    'Show other-value tax base (DPP) on purchase invoices',
  'businessFlow.purchase_invoice_show_dpp_form_desc':
    'Whether the other-value DPP (tax base) is shown when creating/editing a purchase invoice and on the purchase invoice detail.',
  'businessFlow.invoice_create_from_shipment_only':
    'Invoices can only be made from shipping transactions',
  'businessFlow.invoice_create_from_shipment_only_desc':
    'Are you required to make a shipping transaction in order to make an invoice?',
  'businessFlow.order_create_from_quotation_only':
    'Orders can only be made from quote transactions',
  'businessFlow.order_create_from_quotation_only_desc':
    'Are you required to make a quote transaction in order to make an order?',
  'businessFlow.invoice_profit_margin_not_minus':
    'Reject new bills and orders if the profit margin is minus',
  'businessFlow.invoice_profit_margin_not_minus_desc':
    'Reject bills and orders if the product is sold with a profit margin below 0',
  'businessFlow.sale_reject_price_below_min_sell':
    'Reject sales if price is below minimum sale price',
  'businessFlow.sale_reject_price_below_min_sell_desc':
    'Reject sales transactions when the product price is lower than the minimum sale price?',
  'businessFlow.quote_reject_forecast_margin_minus':
    'Reject new quotes if the profit margin is minus',
  'businessFlow.quote_reject_forecast_margin_minus_desc':
    'Reject sales quotes if a product is sold with a profit margin below 0',
  'businessFlow.purchase_invoice_create_from_shipment_only':
    'Purchase invoices can only be made from shipping purchase transactions',
  'businessFlow.purchase_invoice_create_from_shipment_only_desc':
    'Are you required to make a shipping purchase transaction in order to make an purchase invoice?',
  'businessFlow.purchase_order_create_from_quotation_only':
    'Purchase orders can only be made from quote purchase transactions',
  'businessFlow.purchase_order_create_from_quotation_only_desc':
    'Are you required to make a quote purchase transaction in order to make an purchase order?',
  'salesPerson.sales_person': 'Sales Person',
  'salesPerson.show_sales_person': 'Show Sales Person',
  'salesPerson.hide_sales_person': 'Hide Sales Person',
  'salesPerson.select_sales_person': 'Select sales person',
  'salesPerson.sales_name': 'Sales Name',
  'salesPerson.sales_amount': 'Sales Amount',
  'salesPerson.sales_value': 'Sales Value',
  'salesPerson.sales_total': 'Sales Total',
  'salesPerson.sales_qty': 'Total Quantity',
  'salesPerson.customer': 'Customer',
  'salesPerson.sales_incentive': 'Sales Incentive',
  'salesPerson.sales_commission': 'Sales Commission',
  'salesPerson.manage_sales_commission': 'Manage Sales Commission',
  'salesPerson.commission_rule': 'Commission Rule',
  'salesPerson.faq_question_commission_calculated':
    'How is the commission calculated on this report?',
  'salesPerson.faq_answer_commission_calculated':
    'Commission is calculated from the total bill after discount. The tax and postage components are not used to calculate commissions.',
  'salesPerson.faq_question_give_different_commission':
    'How to give a different commission for each sales?',
  'salesPerson.faq_answer_give_different_commission_menu_here': 'menu here',
  'salesPerson.faq_question_give_commission_progressively':
    'How to give commission progressively, the more sales the bigger the commission?',
  'salesPerson.faq_answer_give_commission_progressively':
    'You can set multilevel commission from settings, please {here}.',
  'massEmail.mass_email': 'Mass Send Email',
  'massEmail.cannot_mass_email': 'Cannot mass sent email',
  'massEmail.can_be_sent': 'Can be sent',
  'massEmail.cannot_be_sent': 'Cannot be sent',
  'massEmail.are_you_sure': 'Are you sure want to sent {count} {title}(s) email?',
  'massEmail.data_progress_sent': '{count} out of {total} email has been sent',
  'massEmail.data_has_been_sent': 'Total {count} email has been sent',
  'massDelete.mass_delete': 'Mass Delete',
  'massDelete.cannot_mass_delete': 'Cannot mass delete',
  'massDelete.can_be_deleted': 'Can be deleted',
  'massDelete.cannot_be_deleted': 'Cannot be deleted',
  'massDelete.archived': 'Archived',
  'massDelete.invalid_detail_data': 'Data',
  'massDelete.invalid_detail_reason': 'Reason',
  'massDelete.view_detail': 'View detail',
  'massDelete.are_you_sure': 'Are you sure want to delete {count} {title}(s)?',
  'massDelete.are_you_sure_archive': 'Are you sure want to delete/archive {count} {title}(s)?',
  'massDelete.deleted_data_is_irreversible': 'Deleted data is irreversible',
  'massDelete.data_progress_deleted': '{count} out of {total} data has been deleted',
  'massDelete.data_has_been_deleted': 'Total {count} data has been deleted',
  'massDelete.data_failed_count': '{count} data failed to process',
  'massDelete.still_running_in_background':
    'The process is still running in the background, please check again in a moment',
  'massDelete.transaction_before_lock_date_and_reconciled_cannot_be_deleted':
    '**Transaction before lock date and reconciled transaction cannot be deleted',
  'massDelete.transaction_before_lock_date_reconciled_and_related_cannot_be_deleted':
    '**Transaction before lock date, reconciled transaction, and transaction that has relation to another transaction cannot be deleted',
  'massVoid.mass_void': 'Void',
  'massVoid.cannot_mass_void': 'Unable to perform bulk void',
  'massVoid.can_be_voided': 'Can be voided',
  'massVoid.cannot_be_voided': 'Cannot be voided',
  'massVoid.are_you_sure': 'Are you sure you want to void {count} {title}?',
  'massVoid.preparing_void_process': 'Preparing void process...',
  'massVoid.data_progress_voided': '{count} of {total} items have been voided',
  'massVoid.data_has_been_voided': '{count} items have been successfully voided',
  'massPrint.cannot_mass_print': 'Cannot mass print',
  'massApproval.mass_approve': 'Mass Approve',
  'massApproval.mass_reject': 'Mass Reject',
  'massApproval.cannot_mass_approve': 'Cannot mass approve',
  'massApproval.cannot_mass_reject': 'Cannot mass reject',
  'massApproval.can_be_approved': 'Can be approved',
  'massApproval.can_be_rejected': 'Can be rejected',
  'massApproval.are_you_sure_will_approved':
    'Are you sure you will approve these {count} transactions?',
  'massApproval.are_you_sure_will_rejected':
    'Are you sure you will reject these {count} transactions?',
  'massApproval.approved_data_is_irreversible': 'Approved data is irreversible',
  'massApproval.rejected_data_is_irreversible': 'Rejected data is irreversible',
  'massApproval.data_progress_approved': '{count} out of {total} data has been appoved',
  'massApproval.data_progress_rejected': '{count} out of {total} data has been rejected',
  'massApproval.data_has_been_approved': 'Total {count} data has been approved',
  'massApproval.data_has_been_rejected': 'Total {count} data has been rejected',
  'financeOnboarding.welcome_eyebrow': 'Getting started · 3 steps',
  'financeOnboarding.welcome_title': 'Welcome to Kledo, {name} 👋',
  'financeOnboarding.welcome_lead':
    'Your account is ready. In about 3 minutes we will walk you through the core Kledo flow: create an invoice, send it to your customer via WhatsApp, and see the result instantly in the Profit & Loss report.',
  'financeOnboarding.step1_title': 'Create a sales invoice',
  'financeOnboarding.step1_desc':
    'Add your first contact and product, then complete the invoice. Sample data is available at each step.',
  'financeOnboarding.step2_title': 'Send the invoice via WhatsApp',
  'financeOnboarding.step2_desc': 'Your customer receives the invoice with a payment link.',
  'financeOnboarding.step3_title': 'View the Profit & Loss report',
  'financeOnboarding.step3_desc':
    'That transaction shows up in your financial reports in real time.',
  'financeOnboarding.start': 'Start Now',
  'financeOnboarding.welcome_note':
    'While the guide runs, other menus stay locked until all 3 steps are done.',
  'financeOnboarding.rail_title': 'Getting started',
  'financeOnboarding.rail_step1': 'Create invoice',
  'financeOnboarding.rail_step2': 'Send WhatsApp',
  'financeOnboarding.rail_step3': 'View Profit & Loss',
  'financeOnboarding.snooze': 'Maybe later',
  'financeOnboarding.guide_title': 'Getting Started',
  'financeOnboarding.guide_resume': 'Click to continue the guide',
  'financeOnboarding.guide_page_desc':
    'Follow these 3 short steps to learn the core Kledo flow, from creating an invoice to viewing your financial report.',
  'financeOnboarding.guide_page_card': 'Learn the core Kledo flow',
  'financeOnboarding.guide_page_eyebrow': 'Getting started · {done} of {total} done',
  'financeOnboarding.guide_page_title':
    'Hi {name}, {left, plural, one {# step} other {# steps}} to go',
  'financeOnboarding.guide_page_lead':
    'Your progress is saved automatically. Completed steps are marked, so pick up where you left off whenever you are ready.',
  'financeOnboarding.guide_page_done': 'Done',
  'financeOnboarding.guide_page_now': 'In progress',
  'financeOnboarding.guide_page_last': 'Last position: {title}',
  'financeOnboarding.guide_page_continue': 'Continue',
  'financeOnboarding.guide_page_locked': 'Unlocks after step {n}',
  'financeOnboarding.badge': 'Step {n} of 3',
  'financeOnboarding.sub_contact': 'Contact',
  'financeOnboarding.sub_product': 'Product',
  'financeOnboarding.sub_save': 'Save',
  'financeOnboarding.hint_click': 'Click the highlighted area to continue',
  'financeOnboarding.locked': 'Finish this step first, other menus are still locked.',
  'financeOnboarding.menu_invoices_title': 'Open the Invoices menu',
  'financeOnboarding.menu_invoices_desc':
    'Every sale to a customer is recorded as an Invoice. Click Sales › Invoices to begin.',
  'financeOnboarding.btn_add_title': 'Add your first invoice',
  'financeOnboarding.btn_add_desc':
    'Your invoice list is still empty. Click Add to create the first one.',
  'financeOnboarding.contact_field_title': 'Start with the customer',
  'financeOnboarding.contact_field_desc':
    'Every invoice goes to one contact. Your contact list is empty, so click the Customer field and choose Add to create one without leaving the form.',
  'financeOnboarding.contact_field_hint': 'Click the Customer field, then choose “+ Add”',
  'financeOnboarding.contact_modal_title': 'Who is your first customer?',
  'financeOnboarding.contact_modal_desc':
    'Enter the customer name, or use sample data to go faster.',
  'financeOnboarding.contact_modal_ready_title': 'Data filled in, ready to save',
  'financeOnboarding.contact_modal_ready_desc':
    'Complete other details if needed, then click Add. This contact is selected as the customer on your invoice right away.',
  'financeOnboarding.contact_modal_save_title': 'Save the contact',
  'financeOnboarding.contact_modal_save_desc':
    'Once the name is filled in, click Add. The contact is selected on the invoice form immediately.',
  'financeOnboarding.product_field_title': 'Contact selected. Now the product',
  'financeOnboarding.product_field_desc':
    'Next, define what you sell. Click the Product field and choose Add to create your first product or service.',
  'financeOnboarding.product_field_hint': 'Click the Product field, then choose “+ Add”',
  'financeOnboarding.product_modal_title': 'What do you sell?',
  'financeOnboarding.product_modal_desc':
    'Enter a name and selling price, or use sample data to go faster.',
  'financeOnboarding.product_modal_ready_title': 'Name and price filled in, ready to save',
  'financeOnboarding.product_modal_ready_desc':
    'Complete other details if needed, then click Add. The product and its price go straight into the invoice line.',
  'financeOnboarding.product_category_title': 'Pick a category first',
  'financeOnboarding.product_category_desc':
    'Category is required. Click the Category field and choose one before saving the product.',
  'financeOnboarding.product_category_hint': 'Click the Category field, then choose one',
  'financeOnboarding.product_modal_save_title': 'Save the product',
  'financeOnboarding.product_modal_save_desc':
    'Once the name and price are filled in, click Add. The product goes into the invoice line immediately.',
  'financeOnboarding.fill_sample': 'Fill with sample data',
  'financeOnboarding.sample_contact_name': 'Sample – PT Maju Jaya',
  'financeOnboarding.sample_contact_company': 'PT Maju Jaya',
  'financeOnboarding.sample_product_name': 'Sample – Consulting Service',
  'financeOnboarding.btn_save_title': 'Save the invoice',
  'financeOnboarding.btn_save_desc':
    'Everything is in place. Click Save and the invoice is recorded in your books and receivables right away.',
  'financeOnboarding.btn_send_title': 'Send to your customer',
  'financeOnboarding.btn_send_desc':
    'Invoice saved. Now send it to your customer via WhatsApp, complete with a payment link.',
  'financeOnboarding.wa_send_title': 'Send it now',
  'financeOnboarding.wa_send_desc':
    'Make sure WhatsApp is selected and the destination number is filled in, then click Send. You can use your own number to try it out.',
  'financeOnboarding.wa_done_title': 'Sent!',
  'financeOnboarding.wa_done_desc':
    'The message has reached your phone. Last step: see the effect in your financial reports.',
  'financeOnboarding.wa_done_next': 'Next: View Profit & Loss',
  'financeOnboarding.realtime_chip': 'REALTIME',
  'financeOnboarding.realtime_title': 'Your invoice is already in this report',
  'financeOnboarding.realtime_desc':
    'Every transaction you record instantly updates your financial reports, including Profit & Loss, Balance Sheet, and Cash Flow. No manual closing, no waiting for month end. Scroll through the details, then click Finish to end the guide.',
  'financeOnboarding.finish': 'Finish',
  'financeOnboarding.finish_title': 'Guide complete, {name}! 🎉',
  'financeOnboarding.finish_desc':
    'You just ran the core Kledo flow from start to report. All menus are now unlocked.',
  'financeOnboarding.finish_item1': 'First invoice saved',
  'financeOnboarding.finish_item2': 'Sent via WhatsApp',
  'financeOnboarding.finish_item3': 'Profit & Loss updated instantly',
  'financeOnboarding.finish_button': 'Start using Kledo',
  'financeOnboarding.finish_note':
    'The sample contact and product can be edited or deleted from the Contacts and Products menus at any time.',
  'onBoarding.greeting': 'Hallo {name},',
  'onBoarding.welcome_to_kledo': 'Welcome to Kledo!',
  'onBoarding.setup_kledo_account': "Let's go to setup Kledo account :)",
  'onBoarding.start_to_setup': 'Start to setup',
  'onBoarding.inventory_question':
    'Do you want to manage the stock and inventory of products sold ?',
  'onBoarding.quote_question': 'Do you need an offer letter to a customer ?',
  'onBoarding.order_question': 'Do you make a purchase order to a supplier ?',
  'onBoarding.delivery_question': 'Do you need a pass ?',
  'onBoarding.horee': 'Yeaah!',
  'onBoarding.checklist_greeting': "Let's start using Kledo",
  'onBoarding.setup_complete': 'Setup is complete, now you can start using Kledo.',
  'onBoarding.go_to_dashboard': 'Go to Dashboard',
  'onBoarding.cannot_access_onboarding': 'Cannot access on boarding',
  'onBoarding.next_step': 'Next',
  'onBoarding.prev_step': 'Prev',
  'onBoarding.step_question': 'Question - {step}',
  'onBoarding.company_location_question': 'Where is the {company} located?',
  'onBoarding.company_location_question_province': 'Please input province!',
  'onBoarding.company_location_question_city': 'Please input city!',
  'onBoarding.role_question': 'What role are you in the {company}?',
  'onBoarding.role_question_error':
    'Please select a role or enter a custom role before proceeding!',
  'onBoarding.employee_question': 'How many employees do you have in your company?',
  'recurring.add': 'Add Recurring {title}',
  'recurring.edit': 'Edit Recurring {title}',
  'recurring.add_invoice': 'Add recurring',
  'recurring.edit_invoice': 'Edit recurring',
  'recurring.add_order': 'Add recurring order',
  'recurring.edit_order': 'Edit recurring order',
  'recurring.add_purchaseinvoice': 'Add recurring purchase invoice',
  'recurring.edit_purchaseinvoice': 'Edit recurring purchase invoice',
  'recurring.add_purchaseorder': 'Add recurring purchase order',
  'recurring.edit_purchaseorder': 'Edit recurring purchase order',
  'recurring.add_expense': 'Add recurring expense',
  'recurring.edit_expense': 'Edit recurring expense',
  'recurring.add_manualjournal': 'Add recurring manual journal',
  'recurring.edit_manualjournal': 'Edit recurring manual journal',
  'recurring.add_cashbank': 'Add recurring {title}',
  'recurring.edit_cashbank': 'Edit recurring cash & bank',
  'recurring.recurring_transaction_periode': 'Repeat this transaction every',
  'recurring.start_date': 'Start date',
  'recurring.end_date': 'End date (Optional)',
  'recurring.end_date_column': 'End date',
  'recurring.next_date_transaction': 'Next of transaction date',
  'recurring.automatic_send_email_on_created_transaction':
    'Send automated email every time a transaction is made',
  'recurring.reminder_enabled': 'Send a reminder before the transaction is created',
  'recurring.reminder_days_before': 'How many days before to send the reminder',
  'recurring.reminder_days_suffix': 'day(s)',
  'recurring.please_input_reminder_days_before': 'Please input the reminder days',
  'recurring.reminder_days_min': 'Minimum 1 day',
  'recurring.reminder_days_max':
    'Maximum {max} days, cannot exceed the interval between transactions',
  'recurring.day': 'Day',
  'recurring.week': 'Week',
  'recurring.month': 'Month',
  'recurring.please_input_the_recurring': 'Please input the recurring',
  'recurring.please_select_start_date': 'Please select start date',
  'recurring.please_select_end_date': 'Please select end date',
  'recurring.title': 'Recurring {name}',
  'recurring.cannot_select_before_start_date': 'Cannot select before start date',
  'recurring.number': 'Number',
  'recurring.repeat_every': 'Repeat every',
  'recurring.next_date': 'Next Transaction',
  'recurring.total': 'Total',
  'recurring.error_load_data': 'Error on get list recurring',
  'recurring.error_cannot_recurring': 'Error cannot create recurring',
  'recurring.error_cannot_delete': 'Error cannot delete recurring',
  'recurring.error_load_detail': 'Error load detail transaction',
  'recurring.recurring': 'Recurring',
  'recurring.new_transaction': 'New Recurring Transaction',
  'recurring.cannot_select_before_current_date': 'Cannot select before current date',
  'recurring.repeat': 'Recurring',
  'tutorial.video_tutorial': 'Video Tutorial',
  'report.the_total_number_of_bills_issued_during_this_period':
    'The total number of bills issued during this period.',
  'report.average_value_of_invoices_issued_during_this_period':
    'Average value of invoices issued during this period.',
  'report.gross_profit_margin_is_the_ratio_of_gross_profit_to_total_revenue':
    'Gross profit margin is the ratio of gross profit to total revenue.',
  'report.gross_profit_margin_is_the_ratio_of_net_income_to_total_revenue':
    'Gross profit margin is the ratio of net income to total revenue.',
  'report.roi_is_the_ratio_of_net_income_to_net_assets_per_year':
    'ROI is the ratio of net income to net assets per year. Where net assets are total assets minus liabilities.<br/>ROI = (Net profit / Net asset) x 12 months x 100%',
  'report.the_average_number_of_days_it_takes_your_customer_to_pay_the_bill':
    'The average number of days it takes your customer to pay the bill.',
  'report.the_average_number_of_days_it_take_you_to_pay_a_bill_to_a_vendor':
    'The average number of days it takes you to pay a bill to a vendor.',
  'report.is_the_percentage_of_liabilities_divided_by_equity':
    'Is the percentage of liabilities divided by equity.',
  'report.is_the_percentage_of_current_assets_divided_by_labilities':
    'Is the percentage of current assets divided by liabilities.',
  'invoicePaymentCreditMemo.invoicePaymentCreditMemo': 'Invoice Payment Credit Memo',
  'purchaseInvoicePaymentDebitMemo.purchaseInvoicePaymentDebitMemo':
    'Purchase Invoice Payment Debit Memo',
  'unrealizedGain.unrealizedGain': 'Unrealized Gain',
  'financeProduct.profit_margin': 'Profit margin',
  'financeProduct.total_profit_margin': 'Total profit margin',
  'financeProduct.average_purchase_price': 'Average purchase price',
  'financeProduct.last_purchase_price': 'Last purchase price',
  'financeProduct.last_sell_price': 'Last sell price',
  'financeProduct.this_customer_selling_price': "This customer's selling price",
  'financeProduct.insufficient_payment': 'Insufficient payment',
  'settings.menu_cannot_be_found': 'Settings Menu Cannot Be Found',
  'report.avg': 'Avg',
  'reports.stock_adjustment': 'Stock Adjustment Report',
  'reports.cache.data_per': 'Data as of {date} · {age} ago',
  'reports.cache.data_per_live': 'Data as of {date} · Just refreshed',
  'reports.cache.just_updated': 'Just refreshed',
  'reports.cache.reload': 'Reload',
  'reports.cache.reload_tooltip': 'Fetch latest data from server',
  'reports.cache.live': 'Live',
  'reports.cache.cached': 'Cached',
  'reports.cache.age_seconds': '{value} second(s)',
  'reports.cache.age_minutes': '{value} minute(s)',
  'reports.cache.age_hours': '{value} hour(s)',
  'reports.cache.age_days': '{value} day(s)',
  'summary.cache.updated_ago': 'Updated {age} ago',
  'summary.cache.load_failed': 'Failed to load data. Try Reload from the ⋮ menu.',
  'bussinesFlow.default_tracking_stock': 'Default tracking stock',
  'bussinesFlow.desc_default_tracking_stock':
    'By default the track stock feature is active when creating a new product',
  'settings.reset': 'Reset',
  'financeContacts.taxable': 'Taxable',
  'financeContacts.not_taxable': 'Not Taxable',
  'tooltip.next': 'Next {title}',
  'tooltip.prev': 'Prev {title}',
  'financeBanks.bank_transaction': 'Bank Transaction',
  'picker.select_year': 'Select year',
  'picker.select_month': 'Select month',
  'picker.select_date': 'Select date',
  'chart.from_param_to_param': 'from {from} until {to}',
  'gajihub.hash_tag': '#better, easier and more practical.',
  'gajihub.head_title_1': 'Process',
  'gajihub.head_title_2': 'Payroll',
  'gajihub.head_title_3': 'Absence',
  'gajihub.head_title_4': 'and',
  'gajihub.head_title_5': 'Accountancy',
  'gajihub.head_title_6': 'Your Business is Now Integrated',
  'gajihub.head_desc_1': 'Now you can do it',
  'gajihub.head_desc_2': 'calculation',
  'gajihub.head_desc_3': 'salary recording',
  'gajihub.head_desc_4': 'allowance',
  'gajihub.head_desc_5': 'into',
  'gajihub.head_desc_6': 'tax',
  'gajihub.head_desc_7':
    "all employees are automatically in the company's books with the integration of GajiHub and Kledo.",
  'gajihub.integrate': 'Integrate Now',
  'appConnect.crm.processing_title': 'Connecting to CRM.ID...',
  'appConnect.crm.processing_subtitle':
    'App connection is being processed. Please wait a moment and do not close this page.',
  'appConnect.hr.processing_title': 'Connecting to GajiHub...',
  'appConnect.hr.processing_subtitle':
    'App connection is being processed. Please wait a moment and do not close this page.',
  'appConnect.success_title': 'Integration successful!',
  'appConnect.success_subtitle': 'Your account is connected. Redirecting...',
  'gajihub.footer_note':
    'Get HR management solutions and easy company accounting management that are perfectly integrated with each other.',
  'gajihub.feat_title_1': 'What will',
  'gajihub.feat_title_2': 'You Get',
  'gajihub.feat_title_3': 'From GajiHub and Kledo Integration?',
  'gajihub.feat_1_sub_title': 'Integration of payroll and accounting systems',
  'gajihub.feat_1_description':
    "The process of recording salaries and all allowances for all employees can be recorded in your company's bookkeeping system automatically in one integrated platform.",
  'gajihub.feat_2_sub_title': 'Automatic calculation of PPh 21',
  'gajihub.feat_2_description':
    'No need to worry about calculating income tax for all employees. With this integration, Kledo will automatically record employee PPh 21 according to the data stored in GajiHub.',
  'gajihub.feat_3_sub_title': 'Record attendance via smartphone',
  'gajihub.feat_3_description':
    'All your employees will also find it easy to make attendance attendance and apply for leave from their smartphone via the ESS GajiHub application.',
  'gajihub.feat_4_sub_title': 'Recording employee cash and reimbursements directly into the books',
  'gajihub.feat_4_description':
    'You can record all employee cash and reimbursement values in the GajiHub system. Then, this data will be automatically recorded in the Kledo accounting system.',
  'gajihub.feat_5_sub_title': 'Create and send real time employee pay slips',
  'gajihub.feat_5_description':
    "Create pay slips in seconds and send them directly to all your employees. This salary slip can also be accessed via the ESS GajiHub application on your employee's smartphone.",
  'gajihub.feat_6_sub_title': 'BPJS Employment contributions are recorded automatically',
  'gajihub.feat_6_description':
    'You can manage BPJS Employment and Health for all your employees on GajiHub. Later, contribution payments will be automatically recorded in the Kledo accounting system.',
  'payroll.goto_gajihub': 'Go to Gajihub',
  'payroll.integrate_with_gajihub': 'Integrate with Gajihub',
  'payroll.payroll': 'Payroll',
  'payroll.perform_employee_payroll_quickly_and_neatly':
    'Perform employee payroll quickly and neatly.',
  'payroll.employee_payroll_is_automatically_recorded_in_kledo_accounting_software':
    'Employee payroll is automatically recorded in Kledo accounting software.',
  'payroll.automatically_calculating_PPH_21_Tax': 'Automatically calculating PPH 21 Tax.',
  'payroll.automatic_employee_BPJS_calculation': 'Automatic employee BPJS calculation.',
  'payroll.employee_attendance_via_mobile_app': 'Employee attendance via mobile app.',
  'payroll.application_for_leave_and_permission': 'Application for leave and permission.',
  'payroll.employee_cash_account': 'Employee Cash Account.',
  'payroll.employee_reimbursement': 'Employee Reimbursement.',
  'payroll.and_many_more': 'And many more.',
  'payroll.click_the_button_below_to_start_the_integration':
    'Click the button below to start the integration.',
  'payroll.what_benefits_will_you_get_with_this_integration':
    'What benefits will you get with this integration ?',
  'payroll.this_feature_is_avilable_for_free': 'This feature is avilable for free.',
  'payroll.kledo_is_now_automatically_integrated_with_gajihub_payroll_software':
    'Kledo is now automatically integrated with GajiHub Payroll Software',
  'payroll.please_wait': 'Please wait a minutes!',
  'payroll.integrating_kledo_with_gajihub': 'Integrating Gajihub with Kledo...',
  'payroll.integrating_success_1': 'Yeaah!, The',
  'payroll.integrating_success_2': 'Kledo',
  'payroll.integrating_success_3':
    'account has been successfully connected to the Payroll Software',
  'payroll.integrating_success_4': 'GajiHub.',
  'companies.success_message_title': 'Your company was created successfully.',
  'companies.success_message_subtitle': 'Please click the button below to continue.',
  'companies.go_to_dashboard': 'Go to Dashboard',
  'message.sorry_you_are_not_authorized_to_access_this_page':
    'Sorry, You are not authorized to access this page.',
  'message.you_have_some_unsaved_transaction_entries':
    'You have {countTransaction} draft unsaved transaction entries, {clickHere} to view.',
  'message.click_here': 'click here',
  'message.click_here_2': 'Click here',
  'message.image_is_being_uploaded': 'Image is being uploaded...',
  'message.for_the_detail': 'for the detail.',
  'emailTemplate.invoice_due_reminder_email': '{transType} Due Reminder Email',
  'emailTemplate.send_email': 'Send email',
  'emailTemplate.days_before_due': 'days before due',
  'emailTemplate.days_after_due': 'days after due',
  'emailTemplate.send_a_due_reminder_email_to_the_group':
    'Send a due reminder email to the customer contact group as follows',
  'emailTemplate.send_reminder': 'Send Reminder',
  'report.stock_tracking_product': 'Stock Tracking Product',
  'report.non_stock_tracking_product': 'Non Stock Tracking Product',
  'report.package_product': 'Package Product',
  'return.product_not_found_in_this_transaction': 'Product not found in this transaction',
  'return.maximum_qty_that_can_be_returned': 'Maximum qty than can be returned {max}',
  'return.the_product_has_met_the_maximum_return_limit':
    'The product has met the maximum return limit',
  'financeWareHouses.the_product_is_already_on_the_list': 'The product is already on the list',
  'report.minimum_stock': 'Minimum Stock',
  'report.control_stock': 'Control Stock',
  'report.control_stock_tooltip': 'Difference between final stock and minimum stock',
  'businessFlow.reject_the_transaction_if_the_balance_is_insufficient':
    'Reject the transaction if the balance is insufficient',
  'businessFlow.reject_the_transaction_if_the_balance_is_insufficient_desc':
    'Refuse to add cash and bank transactions if the cash and bank balance is insufficient. Not valid for POS and Marketplace Connect transactions',
  'settings.finance_approval_setting': 'Set the transaction approval flow',
  'businessFlow.journal_desc_include_contact': 'Show contact in journal description',
  'businessFlow.journal_desc_include_contact_desc':
    'Will the contact name be displayed in the journal description?',
  'financeProduct.mass_unarchive_info': '**Only products with archive status can be unarchived.',
  'financeProduct.mass_unarchive': 'Mass Unarchive',
  'financeProduct.can_be_unarchive': 'Can be unarchived',
  'financeProduct.cannot_be_unarchive': 'Cannot be unarchived',
  'financeProduct.mass_unarchive_confirm_message':
    'Are you sure you want to unarchive {count} products ?',
  'financeProduct.preparing_unarchive_process': 'Preparing unarchive process',
  'massDelete.cannot_mass_unarchive': 'Unable to bulk unarchive',
  'massDelete.data_progress_unarchived': '{count} data from total {total} has been unarchived',
  'massDelete.data_has_been_unarchived': 'Total {count} data has been successfully unarchived',
  'financeContacts.salutation': 'Salutation',
  'financeContacts.choose_salutation': 'Choose salutation',
  'product.the_maximum_number_of_uploads_is_5_photos': 'Them maximum number is 5 photos',
  'reports.profitloss_hide_sub_account': 'Hide Sub Account',
  'reports.account_view': 'Account View',
  'reports.change_account_view_loading': 'Change the account display format...',
  'reports.change_account_view_success': 'The account display format has been successfully changed',
  'reports.format_account_profit_loss_1': 'Code - Account Name',
  'reports.format_account_profit_loss_2': '(Code) Account Name',
  'reports.format_account_profit_loss_3': 'Account Name - Code',
  'reports.format_account_profit_loss_4': 'Account Name (Code)',
  'reports.format_account_profit_loss_5': 'Account Name',
  'reports.separate_others_income_and_expenses': 'Separate Others Income & Expenses',
  'reports.only_account_name': 'Only Show Account Name',
  'financeWarehouse.qty_per_unit': 'Qty per Unit',
  'faqs.whats_your_question': "What's your Question?",
  'faqs.most_popular': 'Most Popular',
  'faqs.most_help': 'Most Help',
  'faqs.search_result': 'Search result {value}',
  'faqs.title_by_category': 'By {value} Category',
  'faqs.title_by_tag': 'By {value} Tag',
  'faqs.was_this_answer_helpful': 'Was this answer helpful?',
  'faqs.last_update': 'Last Update',
  'faqs.copy_raw_text': 'FAQ copied successfully',
  'faqs.help_center': 'Kledo Help Center',
  'faqs.hero_title': 'How can we help you?',
  'faqs.hero_subtitle':
    'Find answers from hundreds of questions about Kledo features, pricing, and usage.',
  'faqs.most_viewed': 'Most viewed',
  'faqs.highest_rated': 'Highest rated by users',
  'faqs.explore_category': 'Explore Categories',
  'faqs.explore_category_subtitle': 'Pick a topic to find answers faster.',
  'faqs.article_count': '{count} articles',
  'financeProduct.total_cost_summary': 'Total Cost',
  'financeWareHouses.production_warehouse': 'Production warehouse',
  'financeWareHouses.raw_material_warehouse_is_the_same_as_product_warehouse':
    'Raw material warehouse is the same as product warehouse',
  'conversionProduct.avg_price': 'Avg Price',
  'financeProduct.product_conversion_cost_per_unit_help_text':
    'Total product cost for each unit (raw material cost + production cost)',
  'layoutInvoice.show_the_print_delivery_on_the_invoice_with_title':
    'Show the print delivery on the {title}',
  'queue.data_is_waiting_to_be_processed': '{value} data is waiting to be processed...',
  'billing.using_the_invoicing_feature': 'Invoice feature usage',
  'billing.this_month': 'This month',
  'billing.last_month': 'Last month',
  'businessFlow.reject_warehouse_transfer_if_stock_is_less_with_title':
    'Reject {title} If Stock Is Less',
  'businessFlow.reject_warehouse_transfer_if_stock_is_less_desc_with_title':
    'If yes, then the {title} will be rejected if the stock is lacking',
  'financeProduct.products_with_stock_tracking_with_title': '{title} with stock tracking',
  'financeFixedAssets.run_automatic_deprecation': 'Run Automatic Depreciation',
  'financeFixedAssets.automatic_deprecation': 'Automatic Depreciation',
  'financeFixedAssets.automatic_depreciation_every_month': 'Automatic depreciation every month',
  'financeFixedAssets.automatic_depreciation_every_month_desc_with_title':
    'If this feature is active, {title} will be automatically depreciated on the 1st of each month.',
  'financeProduct.regular_product_with_title': 'Regular {title}',
  'financeProduct.package_product_with_title': 'Package {title}',
  'financeProduct.manufacturing_product_with_title': 'Manufacturing {title}',
  'button.void': 'Void',
  'button.unvoid': 'Unvoid',
  'financeBanks.spend_money_and_receive_money': 'Spend Money and Receive Money',
  'financeBanks.receive_transfers': 'Receive Transfer',
  'financeBanks.send_transfers': 'Send Transfer',
  'financeBanks.expense_payment': 'Expense Payment',
  'financeBanks.invoice_payment': 'Invoice Payment',
  'financeBanks.purchase_invoice_payment': 'Purchase Invoice Payment',
  'financeBanks.purchase_order_payment': 'Purchase Order Payment',
  'financeBanks.credit_memo_payment': 'Credit Memo Payment',
  'financeBanks.debit_memo_payment': 'Debit Memo Payment',
  'financeBanks.fixed_asset_payment': 'Fixed Asset Payment',
  'financeBanks.sales_shipping_costs': 'Sales Shipping Costs',
  'financeBanks.purchase_shipping_costs': 'Purchase Shipping Costs',
  'financeBanks.invoice_withholding': 'Invoice Withholding',
  'financeBanks.purchase_invoice_withholding': 'Purchase Invoice Withholding',
  'financeBanks.reversal': 'Reversal',
  'financeProduct.product_list_with_title': '{title} list',
  'financeProduct.product_detail_with_title': '{title} detail',
  'financeProduct.print_a_number': 'Print a number',
  'layoutBarcode.label_size': 'Label size',
  'layoutBarcode.number_of_columns': 'Number of Columns',
  'layoutBarcode.show_product_name': 'Show product name',
  'layoutBarcode.barcode_show_text': 'Show barcode numbers',
  'layoutBarcode.barcode_show_product_price': 'Show price',
  'layoutBarcode.click_here_to_reset_layout': 'Click here to reset barcode layout to the default',
  'settings.layout_barcode': 'Manage barcode layout',
  'financeContacts.date_of_birth': 'Date of Birth',
  'financeInvoices.witholding_total': 'Witholding Total',
  'financeInvoices.total_after_witholding': 'Total After Witholding',
  'financeContacts.total_from_value': 'Total from {value}',
  'pos.choose_product_favorites_with_title':
    'Select the {title} that will be displayed on the front page of the POS',
  'pos.page_note':
    'This page is for managing products that are favorites at POS. If you want to add a new product, please {clickHere}!',
  'pos.add_product_favorite_with_title': 'Add {title} Favorite',
  'pos.save_to_favorite': 'Save to Favorites',
  'pos.choose_product_to_become_favorite_with_title': 'Select a {title} to favorite',
  'pos.add_outlet': 'Add Outlet',
  'pos.edit_outlet': 'Edit Outlet',
  'pos.name_is_required': 'Name is required',
  'pos.name_at_least_3_characters': 'Name at least 3 characters',
  'pos.code_is_required': 'Code is required',
  'pos.code_at_least_3_characters': 'Code at least 3 characters',
  'pos.not_yet_connected_to_the_warehouse': 'Not yet connected to the warehouse',
  'pos.connect_now': 'Connect now!',
  'pos.connect_outlets_and_warehouses': 'Connect outlets and warehouses',
  'webPos.title': 'Welcome to Web POS',
  'webPos.description':
    'Manage your sales transactions quickly and easily right from your browser. Click the button below to open the cashier.',
  'webPos.open_cashier': 'Open Cashier',
  'customerDisplay.pageTitle': 'Customer Display',
  'customerDisplay.settingsTitle': 'Customer Display',
  'customerDisplay.settingsIntro':
    'Show the cart, order total, and promo media to customers on a TV, tablet, or second monitor. Just open the link below, no sign-in needed.',
  'customerDisplay.openDisplay': 'Open customer display',
  'customerDisplay.step3Label': '3. Promo media',
  'customerDisplay.mediaPanelTop': 'Top panel',
  'customerDisplay.mediaPanelTopHint': 'Large panel. Recommended size 1600 × 900 px (16:9).',
  'customerDisplay.mediaPanelBottom': 'Bottom panel',
  'customerDisplay.mediaPanelBottomHint': 'Small panel. Recommended size 1600 × 600 px (8:3).',
  'customerDisplay.mediaDrop': 'Click or drag images/videos here',
  'customerDisplay.mediaDropHint':
    'Up to {imageCount} JPG, PNG, WebP images of {imageMb} MB · {videoCount} MP4 videos of {videoMb} MB and {videoSeconds} seconds',
  'customerDisplay.mediaEmpty': 'No media yet. The display shows the outlet welcome.',
  'customerDisplay.mediaMaxImages': 'Up to {max} images per panel.',
  'customerDisplay.mediaMaxVideos': 'Up to {max} videos per panel.',
  'customerDisplay.mediaInvalidType': 'Unsupported format. Use JPG, PNG, WebP, or MP4.',
  'customerDisplay.mediaTooLarge': 'File is larger than {max} MB.',
  'customerDisplay.mediaVideoTooLong': 'Video is longer than {max} seconds.',
  'customerDisplay.mediaImage': 'Image',
  'customerDisplay.mediaVideo': 'Video',
  'customerDisplay.mediaSeconds': 'sec',
  'customerDisplay.mediaMoveUp': 'Move up',
  'customerDisplay.mediaMoveDown': 'Move down',
  'customerDisplay.mediaRemove': 'Remove',
  'customerDisplay.mediaScheduleStart': 'Start showing',
  'customerDisplay.mediaScheduleEnd': 'End',
  'customerDisplay.mediaActive': 'Showing',
  'customerDisplay.mediaInactive': 'Hidden',
  'customerDisplay.mediaPreview': 'Display preview',
  'customerDisplay.mediaUploadFailed':
    'Failed to upload {name}. Check your connection and try again.',
  'customerDisplay.mediaUploading': 'Uploading…',
  'customerDisplay.mediaRemoveConfirm': 'Remove this media from the customer display?',
  'customerDisplay.mediaNoAccess': 'You do not have access to manage customer display promo media.',
  'customerDisplay.mediaLoadFailed': 'Failed to load promo media.',
  'customerDisplay.previewSample1': 'Iced Coffee Latte',
  'customerDisplay.previewSample2': 'Butter Croissant',
  'customerDisplay.previewSample3': 'Mineral Water',
  'customerDisplay.statusPaired': 'Connected',
  'customerDisplay.statusChecking': 'Checking display…',
  'customerDisplay.statusOffline': 'Display inactive',
  'customerDisplay.statusOfflineHint':
    'The customer display is not responding. Make sure the customer display link is open on the display device, then click Check again.',
  'customerDisplay.recheckButton': 'Check again',
  'customerDisplay.disconnectButton': 'Disconnect',
  'customerDisplay.disconnectConfirm': 'Disconnect this display from the cashier?',
  'customerDisplay.pairingTitle': 'Connect this display to the cashier',
  'customerDisplay.cartEmpty': 'Ready to serve you',
  'customerDisplay.subtotal': 'Subtotal',
  'customerDisplay.fees': 'Additional fees',
  'customerDisplay.total': 'Total',
  'customerDisplay.thankYouTitle': 'Thank you!',
  'customerDisplay.thankYouSubtitle': 'See you again soon.',
  'customerDisplay.welcome': 'Welcome to',
  'customerDisplay.youSave': 'You save {amount}',
  'customerDisplay.greetingMorning': 'Good morning!',
  'customerDisplay.greetingAfternoon': 'Good afternoon!',
  'customerDisplay.greetingEvening': 'Good afternoon!',
  'customerDisplay.greetingNight': 'Good evening!',
  'customerDisplay.cartEmptyHint':
    'Your order will appear here once the cashier starts entering it.',
  'customerDisplay.yourOrder': 'Your order',
  'customerDisplay.itemsCount': '{count} items',
  'customerDisplay.paidTotal': 'Total paid',
  'customerDisplay.mediaTagline': 'Please check your order on the screen before paying.',
  'customerDisplay.pairingScan': 'Scan from the Kledo POS app',
  'customerDisplay.pairingOr': 'or',
  'customerDisplay.pairingSubtitle': 'Display code',
  'customerDisplay.pairingStep1': 'On the cashier, open Settings › Customer Display',
  'customerDisplay.pairingStep2': 'Click Connect',
  'customerDisplay.pairingStep3': 'Type the code above, then click Connect',
  'customerDisplay.linkLabel': '1. Open this link on a TV, tablet, or second monitor',
  'customerDisplay.showQr': 'Show QR',
  'customerDisplay.qrModalTitle': 'Scan to open the customer display',
  'customerDisplay.linkUnavailable':
    'The customer display link is not available for this outlet yet.',
  'customerDisplay.sendLabel': '2. Send orders from this cashier',
  'customerDisplay.sendHint':
    'Turn this on for only one cashier device per outlet. If more than one is on, the display shows the cart from the cashier that sent last.',
  'customerDisplay.linkInvalidTitle': 'This customer display link is no longer valid',
  'customerDisplay.linkInvalidHint':
    'Ask the cashier for the latest link in Settings › Customer Display, then open it on this device.',
  'kledoPos.hash_tag': '#better, easier and more practical.',
  'kledoPos.head_title_1':
    'Record, Monitor, and Analyze Every Sales Transaction More Easily with Kledo POS',
  'kledoPos.head_title_description':
    'Cashier application that is perfectly integrated with Kledo accounting software. The best solution for recording transactions from various outlets, shops and business branches on one platform.',
  'kledoPos.download': 'Download Kledo POS',
  'kledoPos.try_pos_web_version': 'Try POS Web Version',
  'kledoPos.footer_note':
    'Record every transaction and carry out business financial analysis more easily using the Kledo POS integration and Kledo accounting software now.',
  'kledoPos.feat_title_1': 'What will',
  'kledoPos.feat_title_2': 'You Get',
  'kledoPos.feat_title_3': 'If you use Kledo POS?',
  'kledoPos.feat_1_sub_title': 'Accepts various types of payments',
  'kledoPos.feat_1_description':
    'With Kledo POS, you can record payments from various payment methods ranging from cash, non-cash, e-wallet and EDC machines.',
  'kledoPos.feat_2_sub_title': 'Easy to use cashier application',
  'kledoPos.feat_2_description':
    'You can easily install Kledo POS on your Android smartphone or tablet and can be used online and offline.',
  'kledoPos.feat_3_sub_title': 'Promotion settings',
  'kledoPos.feat_3_description':
    'Create promos that pamper your customers and record every transaction using the promo without missing a single one.',
  'kledoPos.feat_4_sub_title': 'Free implementation',
  'kledoPos.feat_4_description':
    "Already purchased expensive POS software but still have to pay for training? Now you can use Kledo POS for free with no branch restrictions, and we promise free implementation and training until you're comfortable using it.",
  'kledoPos.feat_5_sub_title': 'Customer profile',
  'kledoPos.feat_5_description':
    'Customer data is an important thing that every business must have. By using Kledo POS, you can store everything more practically.',
  'kledoPos.feat_6_sub_title': 'Integration with accounting systems',
  'kledoPos.feat_6_description':
    'Perfectly integrated with the Kledo ecosystem, making it easier for you to manage financial data in one optimal platform.',
  'kledoPos.setting': 'POS Settings',
  'kledoPos.setting_custom_product': 'Custom Products',
  'kledoPos.setting_custom_product_desc':
    'You can make transactions at the POS for products that have not been recorded in the data, or are called custom products. For custom product transactions, the Kledo system will record it as a sale for the product according to this setting.',
  'kledoPos.setting_default_customer': 'Customer Default',
  'kledoPos.setting_default_customer_desc':
    'You can record sales at the POS without registering the customer. If the transaction is not recorded by the customer, the Kledo system will record it as a transaction belonging to the `customer default` in this setting.',
  'kledoPos.setting_product_placeholder': 'Select Product',
  'kledoPos.setting_customer_placeholder': 'Select Customer',
  'kledoPos.error_cannot_update': 'Failed to save settings',
  'kledoPos.setting_default_outlet_placeholder': 'Select Outlet',
  'kledoPos.setting_default_spend_account': 'Default Account Send Funds',
  'kledoPos.setting_default_spend_account_placeholder': 'Select Account',
  'kledoPos.setting_default_spend_account_desc':
    'When recording cash in and out at the POS, it will be recorded in accounting on this COA account.',
  'kledoPos.setting_default_receive_account': 'Default Account Receive Funds',
  'billing.pos_add_outlet_label': 'How many outlets will be added?',
  'billing.pos_current_quota': 'Current POS quota: {outlet} Outlet',
  'billing.pos_add_outlet': 'Add Outlet',
  'billing.pos_please_add_addon': 'Please add one POS addon',
  'financeBanks.import_bank_transfer': 'Import Bank Transfer',
  'financeBanks.follow_these_steps_to_import_your_bank_transfer':
    'Follow these steps to import your bank transfer',
  'financeBanks.1_download_your_bank_transfer_template_file':
    '1. Download your bank transfer template file',
  'financeBanks.start_by_downloading_our_bank_transfer_csv':
    'Start by downloading our bank transfers Excel template file. This file has the correct column headings Kledo needs to import details of your bank transfers.',
  'financeBanks.2_copy_your_bank_transfer_into_the_template':
    '2. Copy your bank transfers into the template',
  'financeBanks.bank_transfer_import_using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your bank transfers. Make sure the product details match the column headings provided in the template.',
  'financeBanks.a_maximum_of_500_bank_transfer_can_be_imported_at_a_time':
    'A maximum of 1.000 bank transfers can be imported at a time.',
  'financeBanks.bank_transfer_import_from_account': 'From Account (Account Code)',
  'financeBanks.bank_transfer_import_to_account': 'To Account (Account Code)',
  'financeBanks.bank_transfer_import_transfer_amount': 'Transfer Amount',
  'financeBanks.in': 'In',
  'financeBanks.out': 'Out',
  'financeAccounts.balance_per_category': 'Balance per Category',
  'financeAccounts.balance_per_account': 'Balance per Account',
  'reports.show_graph': 'Show Graph',
  'reports.hide_graph': 'Hide Graph',
  'reports.number_of_transactions_per_source': 'Number of transactions per source',
  'massRevertReconcile.mass_unreconciled': 'Cancel Mass Reconciliation',
  'massRevertReconcile.cannot_mass_unreconciled': 'Unable to cancel the reconciliation',
  'massRevertReconcile.can_be_unreconciled': 'Can cancel the reconciliation',
  'massRevertReconcile.are_you_sure_want_to_unreconciled':
    'Are you sure you want to cancel {count} reconciliation?',
  'massRevertReconcile.data_progress_unreconciled':
    '{count} record out of {total} has been unreconciled',
  'massRevertReconcile.data_has_been_unreconciled':
    'A total of {count} records have been successfully rolled back from reconciliation',
  'billing.downgrade_warning_title': 'Attention!!!',
  'billing.downgrade_warning_description_1':
    'An account that has been downgraded cannot be cancelled. An upgrade and payment is required to return to the previous plan.',
  'billing.downgrade_warning_description_2':
    'Accounts that have been downgraded, will follow the latest package prices and the latest feature limits.',
  'billing.downgrade_warning_description_3':
    'Older accounts on Kledo usually get lower prices and more complete features compared to new accounts on Kledo.',
  'billing.what_package_will_you_downgrade_to': 'What package will you downgrade to?',
  'billing.downgrade_now': 'Downgrade Now',
  'billing.button_confirm_title':
    'This action cannot be undone, and you will lose your benefits as the old account owner. Are you sure you want to downgrade your plan?',
  'billing.button_downgrade_now': 'Yes, Downgrade Now',
  'financeFixedAssets.asset_value': 'Asset Value',
  'financeFixedAssets.asset_depreciation': 'Asset Depreciation',
  'financeFixedAssets.asset_disposal': 'Gain/Loss on Asset Disposal',
  'financeFixedAssets.new_assets': 'New Assets',
  'financeFixedAssets.depreciation_chart': 'Depreciation',
  'financeFixedAssets.profit_and_loss_on_asset_disposal': 'Profit and Loss on Asset Disposal',
  'financeFixedAssets.highest_value_assets': '{count} Highest Value Assets',
  'financeFixedAssets.the_highest_acquisition_costs': 'The {count} Highest Acquisition Costs',
  'financeFixedAssets.profit': 'Profit',
  'financeFixedAssets.loss': 'Loss',
  'financeProduct.this_product_is_a_package_material_from_with_title':
    'This {title} is a package material from',
  'financeProduct.this_product_is_raw_material_from_with_title':
    'This {title} is raw material from',
  'settings.due_reminder': 'Send emails to customers who has bills due',
  'businessFlow.system': 'System',
  'businessFlow.enable_white_label': 'Enable white labels?',
  'businessFlow.enable_white_label_desc':
    'If the white label is active, the web app, WhatsApp content, and email content will be removed from the kledo text in the footer.',
  'financeOrder.amount_unbilled': 'Amount Unbilled',
  'settings.download_description':
    'You can download your Kledo database to save it offline on your computer. The downloaded data is in excel format (.xls), and it takes a few minutes to prepare the backup file.',
  'settings.download_button': 'Start Preparing Backup Files Now',
  'settings.please_wait_download_backup':
    'Please wait a moment, the download database file is being prepared.',
  'settings.preparing_data': 'Preparing {dataName} data',
  'settings.backup_auto_delete': '* Backup files will be deleted automatically in 1-4 days',
  'settings.download_backup_finish':
    'The database backup file is ready, click the button below to download:',
  'settings.finance_backup_database': 'Download your Kledo database',
  'settings.backup_date': 'Backup Date',
  'sales_overview.vs_same_date_with_another_date': 'vs same date {date}',
  'sales_overview.vs_another_date': 'vs {date}',
  'sales_overview.invoices_this_month_with_title': '{title} {date}',
  'sales_overview.of_the_total_unpaid_invoices_with_title': 'of the total unpaid {title}',
  'sales_overview.invoices_paid_vs_total_invoices_for_the_month_with_title':
    '{title} paid vs total {title} for {date}',
  'sales_overview.paid_ratio': 'Paid Ratio',
  'sales_overview.sales_flow_not_completed_with_title': '{title} Flow Not Completed',
  'sales_overview.quote_accepted_with_title': 'Accepted {title}',
  'sales_overview.order_not_finished_with_title': '{title} not finished',
  'sales_overview.delivery_has_not_been_invoiced_with_title': '{title} has not been invoiced',
  'sales_overview.invoices_due_with_title': '{title} due',
  'purchases_overview.purchase_payment_sent_with_title': '{title} payment sent',
  'purchases_overview.payment_purchases_pending_with_title': 'Waiting for {title} Payment',
  'financeProduct.qty_per_warehouse': 'Qty per Warehouse',
  'financeProduct.product_value_per_warehouse_with_title': '{title} Value per Warehouse',
  'billing.most_chosen': 'Most Chosen',
  'billing.see_more': 'See More',
  'billing.show_less': 'Show Less',
  'billing.product_manufacture': 'Product Manufacture',
  'billing.contract_length': 'Select Contract Length',
  'billing.please_choose_contract_length': 'Please Select Contract Length',
  'billing.saving': 'Saving',
  'billing.addon_user_description': 'Add users to get involved in helping manage your account.',
  'billing.addon_warehouse_description':
    'The more warehouses, the easier it is to categorize items or products.',
  'billing.addon_marketplace_description': 'Allows you to integrate your store with Marketplace',
  'billing.addon_invoice_description':
    'Adding the number of invoices in your account, 1 addons invoice = 5,000 invoices.',
  'billing.addon_product_description':
    'Adding the number of {products} in your account, 1 addons {product} = 5,000 {products}.',
  'billing.addon_bank_connect_description':
    'Integrate the business you have with the bank services you have.',
  'billing.invoices': 'Invoices',
  'billing.employee': 'Employee ',
  'billing.select_add_on_hris': 'Select the Payroll and HRIS Addon Package',
  'billing.hris_elite': 'Elite Package',
  'billing.hris_pro': 'Pro Package',
  'billing.active_package': 'Active Package',
  'billing.expired_date': 'Expired date',
  'billing.at_the_moment': 'At the Moment',
  'billing.after_extension': 'After Extension',
  'billing.extend_now': 'Extend Now',
  'billing.upgrade_plan_to': 'Plan Upgrades {planName}',
  'billing.contract': 'Contract',
  'billing.per_month': 'Per Month',
  'billing.calculation_details': 'Calculation Details',
  'billing.most_chosen_subs_with_x_discount':
    'With a {targetContract} subscription, you will get a discount of {discount}.',
  'billing.most_chosen_subs_with_x_discount_warning':
    'Are you sure you subscribe to {term} and not get {discount} discount?',
  'billing.i_want_discount': 'I want {discount} discount',
  'billing.i_dont_want_discount': "Yes, I don't want a discount",
  'financeBanks.bank_connect_less': 'Less',
  'financeBanks.error_cannot_export': 'Cannot export {bankName}',
  'report.total_due': 'Total Due',
  'settings.set_roles': 'Set Roles',
  'settings.set_users': 'Set Users',
  'report.aged_receivable_from_until_less_than_equal_months':
    '{firstMonth} until <= {secondMonth} months',
  'report.aged_receivable_greater_than_months': '> {month} months',
  'financeFixedAssets.last_automatic_depreciation': 'Last automatic depreciation on {dateTime}',
  'financeFixedAssets.see_automatic_depreciation_history': 'See auto depreciation history',
  'report.downloading_data': 'Downloading data...',
  'contacts.info_is_as_employee':
    'Some data cannot be changed because the contact is also an employee.',
  'report.balance_sheet_previous_month': 'previous month',
  'report.balance_sheet_previous_year': 'previous year',
  'report.balance_sheet_vs_1_month_ago': 'vs 1 month ago',
  'report.balance_sheet_structure': 'Balance Sheet Structure',
  'report.balance_sheet_trend': 'Balance Sheet Trend',
  'report.balance_sheet_component_trend': 'Balance Sheet Component Trend',
  'report.balance_sheet_component': 'Balance Sheet Component',
  'report.balance_sheet_equity': 'Equity',
  'report.balance_sheet_asset': 'Asset',
  'report.balance_sheet_liability': 'Liability',
  'report.balance_sheet_trend_net_position': 'Balance Sheet Trend Net Position',
  'report.quick_ratio_help_1':
    "The quick ratio functions as an indicator of a company's short-term liquidity, or its ability to meet its short-term obligations. In other words, it tests how much a company has in assets to pay off all its liabilities.",
  'report.quick_ratio_help_2':
    "When the value of the quick ratio is above 1, it means that the company or business's current assets are able to meet all its current obligations. This indicates a healthy financial condition of the business because it is able to pay off all liabilities if necessary.",
  'report.quick_ratio_help_3':
    'On the other hand, if the quick ratio value is less than 1, it means that the entity is unable to pay off its current liabilities using all the current assets it owns.',
  'report.quick_ratio_help_4':
    'Quick ratio formula: (Current Assets – Stock or Inventory) / Current Liabilities',
  'report.current_ratio_help_1':
    "The current ratio is used to evaluate a company's ability to pay short-term obligations, such as debt and wages. The current ratio is calculated by dividing current assets by current liabilities. The higher the result, the stronger the company's financial position.",
  'report.current_ratio_help_2':
    'However, keep in mind that a current ratio that is too high can also indicate that the company is not optimizing the use of its assets.',
  'report.current_ratio_help_3':
    'Current Ratio Formula = Total Current Assets / Total Current Liabilities',
  'report.debt_equity_ratio_help_1':
    'Debt to Equity Ratio is a financial ratio that compares the amount of debt with equity.',
  'report.debt_equity_ratio_help_2':
    'Equity and the amount of accounts payable and receivable used for company operations must be in a proportional amount. Debt to Equity Ratio is also often known as the leverage ratio or leverage ratio.',
  'report.debt_equity_ratio_help_3': 'Debt to Equity Ratio (DER) formula = Total Debt / Equity',
  'report.debt_equity_ratio_help_4':
    "A debt to equity ratio value above 2 or 200% indicates that the company's financial condition is very vulnerable to various types of risks.",
  'report.equity_ratio_help_1':
    "Equity Ratio shows the value of assets financed using owner's equity. The higher the proportion of funds from owners, the lower the risk is considered.",
  'report.equity_ratio_help_2':
    "This ratio is calculated by dividing a company's total equity by its total assets.",
  'report.equity_ratio_help_3': 'Equity Ratio Formula = Total Equity / Total Assets',
  'birthday.please_input_the_birthday_template_subject':
    'Please enter a title for the birthday template.',
  'birthday.send_an_email_to_a_customer_having_a_birthday':
    'Send an email to a customer having a birthday',
  'birthday.when_email_birthday_sent':
    "On birthdays, subscribers will automatically be sent a birthday wish email. Make sure you have filled in the customer's date of birth from each of your customer contact data!",
  'birthday.active': 'Active',
  'birthday.inactive': 'Inactive',
  'birthday.recipient_title': '{channel} recipients',
  'birthday.all_customers': 'All {customer}',
  'birthday.specific_groups': 'Specific groups',
  'birthday.select_group': 'Select groups',
  'birthday.select_min_one_group': 'Select at least 1 group',
  'birthday.send_whatsapp_to_customer': 'Send WhatsApp to customers having a birthday',
  'birthday.send_whatsapp_to_customer_desc':
    "Sent automatically on the birthday. Make sure the customer's date of birth and phone number are filled in.",
  'birthday.whatsapp_setting_saved': 'Birthday WhatsApp settings saved successfully',
  'birthday.whatsapp_not_sent_until_ok':
    'Birthday WhatsApp messages are not sent until this issue is resolved.',
  'birthday.status_template_params_incomplete': 'The template variables are incomplete.',
  'birthday.status_template_not_usable':
    'The selected WhatsApp template cannot be used. Select another template.',
  'birthday.status_app_disconnected':
    'The WhatsApp App is disconnected. Reconnect it or select another sender.',
  'birthday.status_number_inactive':
    'The sender WhatsApp number is no longer active. Select another number.',
  'birthday.status_crm_balance_empty':
    'The WhatsApp App balance is empty. Top up so greetings can be sent.',
  'birthday.sender': 'Sender',
  'birthday.sender_official_title': 'Kledo Official WhatsApp number',
  'birthday.sender_official_desc': 'Uses your Kledo WhatsApp add-on quota.',
  'birthday.sender_own_title': 'Your own number',
  'birthday.sender_own_desc':
    'Sends from your WhatsApp App number, using your WhatsApp App balance.',
  'birthday.official_quota_left': 'Official WhatsApp quota left: {count}',
  'birthday.official_quota_empty':
    'Official WhatsApp quota is used up. Greetings are not sent until you add quota.',
  'birthday.buy_whatsapp_addon': 'Add quota',
  'birthday.template_locked_info':
    'The template text is locked to meet Official WhatsApp standards. You can only change the variable parts (green).',
  'birthday.official_template_unavailable': 'The Official WhatsApp template is not available yet.',
  'birthday.wa_app_not_connected':
    'The WhatsApp App is not connected yet. Connect it first to send from your own number.',
  'birthday.connect_wa_app': 'Connect',
  'birthday.wa_app_no_active_number':
    'The WhatsApp App is connected, but there is no active number yet. Activate a number in the WhatsApp App.',
  'birthday.open_wa_app': 'Open WhatsApp App',
  'birthday.phone_number': 'WhatsApp number',
  'birthday.select_phone_number': 'Select a WhatsApp number',
  'birthday.template': 'Template',
  'birthday.select_template': 'Select a template',
  'birthday.whatsapp_preview': 'WhatsApp preview',
  'birthday.message_content': 'Message content',
  'birthday.variable_label': 'Variable {number}',
  'birthday.insert_tag': 'Insert Tag',
  'birthday.variable_required': 'Variable is required',
  'birthday.variable_max_length': 'Maximum {max} characters',
  'birthday.variable_invalid_whitespace':
    'Variable cannot contain new lines, tabs, or 4 consecutive spaces',
  'birthday.variable_unknown_tag': 'Unknown tag: {tags}',
  'birthday.own_number_not_ready':
    'The sender was not saved because no number and template are selected. Select them, or use Kledo Official WhatsApp.',
  'birthday.own_number_preview_name': 'Your WhatsApp number',
  'birthday.setting_load_failed': 'Failed to load birthday settings',
  'birthday.setting_load_failed_desc':
    'The form is hidden so your saved settings are not overwritten. Try loading again.',
  'birthday.wa_senders_load_failed': 'Failed to load the WhatsApp App numbers.',
  'birthday.email_template_not_saved':
    'The email template was not saved because it failed to load. Reload the page and try again.',
  'birthday.save_network_error':
    'Some settings failed to save because the server could not be reached. Try again.',
  'settings.customer_birthday': 'Send an email to customers who are celebrating their birthday',
  'financeInvoices.profit_margin_minus': 'Profit margin minus',
  'financeInvoices.select_name': 'Select {name}',
  'financeWareHouses.stock_adjustment_price': 'Stock Adjustment Price',
  'financeWareHouses.recorded_average_price': 'Recorded Average Price',
  'financeApproval.cannot_approve_transaction': 'Failed to approve this transaction.',
  'report.equity_movement_capital_balance': 'Capital Balance',
  'report.equity_movement_capital_increase': 'Capital Increase',
  'report.equity_movement_capital_reduction': 'Capital Reduction',
  'report.equity_movement_capital_component_trends': 'Capital Component Trends',
  'report.equity_movement_capital_component': 'Capital Component',
  'report.receivable_payable_debt_widget': 'Payable',
  'report.receivable_payable_receivable_widget': 'Receivable',
  'report.receivable_payable_net_debt_receivable_widget': 'Net Payable Receivable',
  'report.receivable_payable_debt_receivable_contact_widget': 'Contact',
  'report.receivable_payable_debt': 'Highest Debt',
  'report.receivable_payable_receivable': 'Highest Receivable',
  'report.receivable_payable_ratio_debt_receivable': 'Payable Receivable Ratio',
  'report.receivable_payable_trend_debt_receivable': 'Payable Receivable Trend',
  'report.receivable_payable_transaction': 'transactions',
  'report.receivable_payable_this_month': 'this month',
  'report.receivable_payable_this_year': 'this year',
  'report.receivable_payable_contact_debt_with_title': 'contacts with debt',
  'report.receivable_payable_contact_receivable_with_title': 'contacts with receivables',
  'report.executive_summary_equity_movement': 'Equity Movement',
  'financeProduct.change_column_display': 'Change column display...',
  'financeProduct.column_display_changed_successfully': 'Column display changed successfully',
  'reports.add_menu_to_favorites_menu': 'Add menu to favorites menu',
  'reports.remove_from_favorites_menu': 'Remove from favorites menu',
  'page404.title': 'Page not found',
  'page404.description': 'The page is deprecated, deleted, or does not exist at all',
  'page404.fallback': 'Go back to the home page',
  'page404.custom_detail_title': 'Detail page {title} not found',
  'page404.custom_import_title': '{title} import page not found',
  'page404.custom_detail_description': 'This {title} has been deleted or does not exist at all',
  'page404.custom_fallback': 'Go back to {title} page',
  'notFoundState.title': 'Data could not be found',
  'notFoundState.description':
    'The data you are looking for may have been deleted, moved, or the link is incorrect.',
  'notFoundState.code_label': 'Transaction code',
  'notFoundState.back': 'Go back',
  'notFoundState.home': 'Go to home',
  'report.cash_change': 'Cash Changes',
  'report.end_period': 'Closing Balance',
  'report.cash_out': 'Cash out',
  'report.cash_in': 'Cash In',
  'report.trend_cash_flow': 'Cash Flow Trends',
  'report.chart_cash_flow': 'Cash Balance',
  'report.funding_components': 'Funding Components',
  'report.investment_components': 'Investment Components',
  'report.operational_components': 'Operational Components',
  'report.vs_1_year_ago': 'vs 1 year ago',
  'report.bank_summary_balance_per_bank': 'Balance per Bank',
  'report.bank_summary_trend_balance_per_bank': 'Trend Balance per Bank',
  'report.bank_summary_trend_received_per_bank': 'Cash Inflow Trend per Bank',
  'report.bank_summary_balance_all_bank': 'All Balance Bank',
  'report.bank_summary_trend_spent_per_bank': 'Cash Out Trend per Bank',
  'report.bank_summary_trend_net_per_bank': 'Trend Net Movement per Bank',
  'financeContacts.contact_information': 'Contact Information',
  'financeInvoices.void_reason_label': 'Please enter the reason for voiding the transaction',
  'financeInvoices.void_reason_placeholder': 'Please enter your reason',
  'report.profit_loss_net_profit_margin': 'Net Profit Margin',
  'report.profit_loss_gross_profit_margin': 'Gross Profit Margin',
  'report.profit_loss_operating_expense_ratio': 'Operating Expense Ratio',
  'report.profit_loss_profit_loss_trend': 'Profit Loss Trend',
  'report.profit_loss_print_graph': 'Print Graph',
  'report.profit_loss_print_graph_selected': '{count} of {total} graphs selected',
  'report.profit_loss_print_graph_failed': 'Failed to load graph data. Please try again.',
  'report.profit_loss_flow': 'Profit Loss Flow',
  'report.profit_loss_income_details': 'Income Details',
  'report.profit_loss_expense_details': 'Expense Details',
  'report.profit_loss_component_trends': 'Profit and Loss Component Trends',
  'report.budget_profit_loss_component_trends': 'Budget Components Trend',
  'report.budget_profit_loss_income_details': 'Budget Income Details',
  'report.budget_profit_loss_expense_details': 'Budget Expense Details',
  'reports.sales_value_per_product_category_graph': 'Sales Value per Product Category',
  'reports.total_sales_per_product_category_graph': 'Number of Sales per Product Category',
  'reports.sales_delivery_summary_graph': 'Delivery Summary',
  'reports.sales_delivery_amount': 'Delivery Value',
  'reports.sales_delivery_total_amount_widget': 'Total Delivery Value',
  'reports.sales_delivery_total_qty_widget': 'Total Quantity Delivered',
  'reports.sales_delivery_total_transaction_widget': 'Total Delivery Transactions',
  'reports.sales_delivery_top_entities': 'Top {count} {title} — Delivery Value',
  'reports.sales_per_product_summary_graph': 'Sales per Product Summary',
  'reports.sales_per_product_amount': 'Sales Value',
  'reports.sales_per_product_top_entities': 'Top {count} {title} — Sales Value',
  'reports.purchases_per_product_summary_graph': 'Purchases per Product Summary',
  'reports.purchases_per_product_amount': 'Purchase Value',
  'reports.purchases_per_product_top_entities': 'Top {count} {title} — Purchase Value',
  'report.total_purchases': 'Total Purchases',
  'reports.sales_per_period_transaction_count_widget': 'Number of Invoices',
  'reports.purchase_order_per_product_summary_graph': 'Purchase Order per Product Summary',
  'reports.purchase_order_per_product_amount': 'Purchase Order Value',
  'reports.purchase_order_per_product_top_entities': 'Top {count} {title} — Purchase Order Value',
  'report.total_purchase_orders': 'Total Purchase Orders',
  'report.quantity_ordered': 'Quantity Ordered',
  'reports.product_purchases_per_vendor_summary_graph': 'Product Purchases per Vendor Summary',
  'reports.purchase_return_per_product_summary_graph': 'Purchase Return per Product Summary',
  'reports.purchase_return_per_product_amount': 'Purchase Return Value',
  'reports.purchase_return_per_product_top_entities': 'Top {count} {title} — Purchase Return Value',
  'report.total_purchase_returns': 'Total Purchase Returns',
  'reports.sales_detail_summary_graph': 'Sales Detail Summary',
  'reports.sales_detail_by_status_graph': 'Invoices by Payment Status',
  'reports.sales_detail_paid': 'Collected',
  'reports.sales_detail_outstanding': 'Outstanding',
  'report.number_of_invoices': 'Number of Invoices',
  'reports.sales_return_per_product_summary_graph': 'Sales Return per Product Summary',
  'reports.sales_return_per_product_amount': 'Sales Return Value',
  'reports.sales_return_per_product_top_entities': 'Top {count} {title} — Sales Return Value',
  'report.total_sales_returns': 'Total Sales Returns',
  'reports.graph_top_others': 'Others ({count})',
  'transactionFees.fees': 'Transaction Fees',
  'witholdings.title': 'Withholdings',
  'witholdings.outlets': 'Outlets',
  'witholdings.all_outlets': 'Available in all outlets',
  'witholdings.all_outlets_help':
    'When turned off, this withholding can only be used in the cashier of the selected outlets',
  'witholdings.please_select_outlet': 'Please select outlet',
  'witholdings.please_select_witholding': 'Please select withholding',
  'witholdings.select_witholding': 'Select withholding',
  'witholdings.exceed_total': 'Total withholding exceeds the invoice total',
  'witholdings.save_order_disabled':
    'Withholding is only for direct payment. Remove the withholding to save as an order',
  'transactionFees.nominal': 'Nominal',
  'transactionFees.please_input_the_nominal': 'Please input the nominal',
  'transactionFees.please_select_transaction_fee': 'Please select transaction fee',
  'transactionFees.select_transaction_fee': 'Select transaction fee',
  'transactionFees.total_transaction_fees': 'Total Transaction Fees',
  'transactionFees.include_tax': 'Include Tax',
  'transactionFees.include_tax_help':
    'Enable to calculate percent from subtotal + tax. Disable to calculate from subtotal only.',
  'settings.fees': 'Set sales and purchase transaction fees',
  'settings.witholdings': 'Set withholding masters for transactions and POS',
  'reports.total_of_transactions_per_customer': 'Total of Transactions per Customer',
  'reports.total_of_transactions_per_vendor': 'Total of Transactions per Vendor',
  'reports.expense_claim_per_term': 'Claim Cost Per Tempo',
  'reports.term_expense_claim': 'Cost Claim Time',
  'reports.total_due_expense_claim': 'Total Expense Claim Due',
  serial_or_production_number: 'Serial / Production Numbers',
  'financeProduct.unique_number': 'Unique Number',
  'financeProduct.production_number': 'Production Number',
  'financeProduct.use_expired_date': 'Use expired date',
  'financeProduct.series_type': 'Type',
  'financeBanks.bank_statements_empty_title': "You don't have bank transaction data yet",
  'financeBanks.bank_statements_empty_description':
    'Bank transaction data can be imported automatically from your bank account or imported <br/> manually by uploading an Excel file.',
  'financeBanks.bank_statements_automatic_import': 'Automatic Import',
  'financeBanks.bank_statements_manual_import': 'Manual Import',
  'financeInvoices.enter_the_number_of_shipping_items': 'Enter qty of shipping items',
  'billing.pos_renew_outlet': 'Renew Outlet',
  'billing.pos_length_of_contract': 'Length of Contract',
  'billing.add_pos_addon': 'Add POS Addon',
  'billing.renew_pos': 'Renew POS',
  'hideFeature.add_pos_addon_or_upgrade':
    'Your POS addon has expired, please order<br/>an extension to be able to access POS again',
  'report.journal_transaction_value': 'Transaction Value',
  'report.journal_transaction_amount': 'Transaction Amount',
  'report.journal_journal_row': 'Journal Row',
  'report.journal_value_per_transaction_type': 'Value Per Transaction Type',
  'report.journal_total_transaction_per_type': 'Total Transaction Per Type',
  'report.journal_total_transaction_value': 'Total Transaction Value',
  'report.journal_total_transaction_amount': 'Total Transaction Amount',
  'report.journal_total_journal_row': 'Total Journal Row',
  'bankConnect.hash_tag': '#bankconnect',
  'bankConnect.head_title_1': 'Automatically Download',
  'bankConnect.head_title_2': 'Bank Account Mutations',
  'bankConnect.head_title_3': 'to Kledo',
  'bankConnect.head_title_description':
    'Now every transaction in your bank account can be automatically entered into Kledo and reconciled. No more differences between financial statements and real transactions at the bank.',
  'bankConnect.sales_contact': 'Contact Sales',
  'bankConnect.add_bank_connect': 'Add Bank Connect',
  'bankConnect.set_bank_connect': 'Set Bank Connect',
  'bankConnect.feat_title_1': 'What will',
  'bankConnect.feat_title_2': 'You get',
  'bankConnect.feat_title_3': 'With Bank Connect',
  'bankConnect.feat_1_sub_title': 'Automatic Download Mutation',
  'bankConnect.feat_1_description':
    'Every day, bank mutation transaction data will be automatically downloaded to the Kledo application. No more hassle of exporting transactions from ibanking and importing them to Kledo.',
  'bankConnect.feat_2_sub_title': 'Free, No Cost',
  'bankConnect.feat_2_description':
    'Kledo does not charge a penny to use the Bank Connect feature. But banks will charge a fee for API connections, fees vary for each bank.',
  'bankConnect.feat_3_sub_title': 'Direct Connection via API Bank',
  'bankConnect.feat_3_description':
    'Without using a 3rd party, Kledo will directly connect with your bank via API.',
  'bankConnect.feat_4_sub_title': 'Safe and Secure',
  'bankConnect.feat_4_description':
    'The cooperation between Kledo and the Bank is only limited to taking account mutations, so it is not possible to make money transactions out of your account.',
  'bankConnect.feat_5_sub_title': 'Unlimited',
  'bankConnect.feat_5_description':
    "No limit on the number of transactions per day, and no limit on the number of accounts you connect. It's all free!",
  'bankConnect.footer_note': "Let's simplify your bank reconciliation process right now!",
  'report.number_of_shipments_per_expedition': 'Number of Shipments per Expedition',
  'report.sales_value_per_expedition': 'Sales Value per Expedition',
  'reports.product_sales_per_customer': 'Product Sales per Customer',
  'reports.product_sales_per_customer_group': 'Product Sales per Customer Group',
  'reports.product_purchases_per_vendor': 'Product Purchases per Vendor',
  'reports.product_purchases_per_vendor_group': 'Product Purchases per Vendor Group',
  'reports.sales_contribution_per_vendor': 'Sales Contribution per Vendor',
  'reports.cash_movement': 'Cash Movement',
  'reports.account_component': 'Account Component',
  'reports.excluded_accounts': 'Excluded Accounts',
  'reports.select_excluded_accounts': 'Select the account you want to exclude',
  'kledoPos.setting_default_account_receive_payment': 'Default Account Receive Payment',
  'kledoPos.setting_default_account_receive_payment_desc':
    'When you make a transaction payment at the POS, it will be recorded in accounting on this COA account.',
  'billing.show_coupon': 'Show Coupon',
  'billing.hide_coupon': 'Hide Coupon',
  'billing.input_coupon': 'Input Coupon',
  'reports.purchase_per_period_value': 'Purchase Value',
  'reports.purchase_per_period_amount': 'Purchase Amount',
  'layoutInvoice.invoice_show_witholding': 'Show Withholding',
  'layoutInvoice.invoice_show_witholding_detail': 'Show Withholding Detail',
  'financeContacts.new_contact': 'New Contact',
  'financeContacts.total_contact': 'Contact Total',
  'financeContacts.contact_per_group': 'Contact Per Group',
  'financeContacts.contact_per_province': 'Contact Per Province',
  'reportsImport.date_and_time': 'Date & Time',
  'reportsImport.total': 'Total Import',
  'reportsImport.valid': 'Success',
  'reportsImport.invalid': 'Failed',
  'pos.pos_role': 'POS Role',
  'approval.financeBanks': 'Cash & Bank',
  'financeWareHouses.change_access_per_contact': 'Change Access Per Contact',
  'financeWareHouses.per_contact_warehouse_access': 'Per Contact Warehouse Access',
  'financeWareHouses.per_contact_warehouse_access_desc':
    'Warehouse can be dedicated to only selected groups of contacts. <br /> For example, Surabaya Warehouse can only be used for customers in the Surabaya group. Meanwhile, the National Warehouse can be used by all customers',
  'financeWareHouses.warehouse_per_contact_type': 'The warehouse can be used by any contact group?',
  'financeWareHouses.all_contact_groups': 'All Contact Groups',
  'financeWareHouses.select_contact_group': 'Select Contact Group',
  'reports.using_new_table_view': 'You are using a new table view',
  'reports.using_legacy_table_view': 'You are using a legacy table view',
  'reports.switch_to_new_table_view': 'Switch to the new table view',
  'reports.switch_to_old_table_view': 'Switch to the old table view',
  'settings.finance_payment_connect': 'Accept payments from ewallet, credit card, VA',
  'paymentConnect.connection_test': 'Connection Test',
  'paymentConnect.activate_payment_via_provider_name': 'Activate payment via {providerName}',
  'paymentConnect.section_kledo': 'Kledo Payment Connect settings',
  'paymentConnect.section_accounting': 'Chart of accounts',
  'paymentConnect.section_integration': 'Credentials & callback',
  'paymentConnect.coa_cash_bank_accounts': 'COA Cash & Bank Accounts',
  'paymentConnect.coa_cash_bank_accounts_help_text':
    'Payments from the payment gateway will be recorded in this bank account',
  'paymentConnect.coa_expense_account': 'COA Expense Account',
  'paymentConnect.coa_expense_account_help_text':
    'Transaction fees for payments will be recorded on this COA account',
  'paymentConnect.tax_coa_account': 'Tax COA Account',
  'paymentConnect.tax_coa_account_help_text':
    'Imposition of transaction tax on payments will be recorded in this COA account',
  'paymentConnect.midtrans_api_key_help_text':
    'Copy the API Key from your Midtrans account, via the menu Settings >> Access Keys >> Server Key',
  'paymentConnect.xendit_api_key_help_text':
    'Copy the API Key from your Xendit account, via the menu Settings >> Developer >> API keys >> Create new secret key >> Secret API Key',
  'paymentConnect.doku_api_key_help_text':
    'Copy the API Key from your DOKU account, via the menu Integration >> API Keys >> Secret Key',
  'paymentConnect.required_title': 'Payment Connect Settings Required',
  'paymentConnect.required_message':
    'Please set up Payment Connect first in the settings page before using QRIS or Payment Gateway features. After setting it up, make sure to set Payment Connect as default first.',
  'paymentConnect.required_message_1':
    'Please set up Payment Connect in your configuration panel before attempting to use QRIS or Payment Gateway features.',
  'paymentConnect.required_message_2':
    'Once configured, ensure you set Payment Connect as your default provider to activate all payment channels.',
  'paymentConnect.bank_verification_title': 'Bank account not verified yet',
  'paymentConnect.bank_verification_message':
    'Your bank account for Kledo Payment Connect is still being verified. Please wait until verification is complete before using Payment Gateway at the cashier. If it has been pending for a while, check the status in Payment Connect settings.',
  'paymentConnect.qris_not_activated':
    'QRIS payment is not activated in your provider. Please activate it first through Payment Connect settings.',
  'paymentConnect.required_link_text': 'here',
  'paymentConnect.required_link_text_full': 'Open settings in a new tab',
  'paymentConnect.required_link_description': 'to open the settings page in a new tab.',
  'paymentConnect.required_link_prefix': 'Click',
  'paymentConnect.token_callback_help_text':
    'Click the copy URL button below, then enter it into {providerName} account',
  'invoices.payment_link': '{providerName} Payment Link',
  'invoices.link_payment_button': 'Payment Link',
  'invoices.link_payment_title': 'Payment Link',
  'invoices.select_payment_gateway': 'Select Payment Gateway',
  'invoices.share_link_description':
    'Share this link with your customer to receive payments instantly via Kledo.',
  'invoices.link_ready_for': 'Payment link for {providerName} is ready to share with customer',
  'invoices.payment_connect_not_activated':
    'You have not activated the {title} feature. With {title}, your customers can make payments via various payment channels, such as GoPay, Credit Card, Virtual Account, Alfamart, Kredivo and many more.',
  'invoices.activate': 'Activate',
  'paymentConnect.please_input_api_key': 'Please enter the API Key',
  'paymentConnect.please_input_tax_coa_account': 'Please select the Tax COA Account',
  'paymentConnect.please_input_coa_expense_account': 'Please select the COA Expense Account',
  'paymentConnect.please_input_coa_cash_bank_accounts':
    'Please select the COA Cash & Bank Accounts',
  'layoutInvoice.show_reference_as_message_with_title': 'Show {reference} As Message',
  'tags.choose_a_color': 'Choose a color',
  'report.profitloss_delta_tooltip':
    'The difference between the revenue of the previous period and the revenue of this period.',
  'report.profitloss_delta_percentage_tooltip':
    'Growth or decline in revenue from the previous period.',
  'report.profitloss_percent_of_parent_tooltip': 'Percentage of COGS',
  'reports.production_number_expires_soon': 'Production Number Expires Soon',
  'reports.expired_date': 'Expired Date',
  'reports.remaining_days_expiry': 'Remaining Days (Expiry)',
  'reports.serial_no': 'Serial No',
  'reports.remaining_life_per_production_number': 'Remaining Life Per Production Number',
  'report.serial_number': 'Serial Number',
  'report.all_serial_products': 'All Serial Products',
  'report.unique': 'Unique',
  'report.production_code': 'Production Code',
  'report.serial_type': 'Serial Type',
  'report.select_serial_type': 'Select Serial Type',
  'kledoPos.setting_sales_tags': 'Sales Tags',
  'kledoPos.setting_sales_tags_description':
    'Sales made through POS will automatically use the following tags.',
  'sso.please_input_your_code': 'Please input your code',
  'sso.verified': 'Verified',
  'sso.pending_verification': 'Pending Verification',
  'sso.domain_verification': 'Domain Verification',
  'sso.domain_verification_successful': 'Domain Verification Successful',
  'sso.add_domain': 'Add Domain',
  'sso.add_domain_desc':
    "Please enter your email address containing your company's domain name. For example myname@companyname.com",
  'sso.domain_successfully_verified': 'Congratulation! Domain {domainName} successfully verified.',
  'sso.verify_domain_desc':
    'A verification code has been sent to your email address. Please enter the verification code in the form below',
  'sso.verification': 'Verification',
  'sso.resend_code': 'Resend code',
  'sso.sso_configuration_service_provider_desc':
    'Please enter the SP Entity ID and SP ACS URL data below into your identity provider administration page',
  'sso.sso_configuration_identity_provider_desc':
    'Retrieve the IDP Entity ID and SAML Login URL data from your identity provider, then enter it in the form below',
  'sso.sso_please_enter_idp_entity_id': 'Please enter the IDP Entity ID',
  'sso.sso_please_enter_saml_login_url': 'Please enter the SAML Login URL',
  'sso.sso_configuration': 'SSO Configuration',
  'settings.sso_setting': 'Login to Kledo with just one account',
  'sso.continue_with_sso': 'Continue with SSO',
  'sso.login_with_sso': 'Sign in with SSO',
  'sso.login_sso_desc':
    'Your account has Single Sign-On enabled. Proceed with SSO <br /> to access your Kledo account',
  'sso.return_to_login': 'Return to login',
  'businessFlow.enable_login_with_sso': 'Enable login with SSO?',
  'businessFlow.enable_login_with_sso_desc': 'Do you use SSO to login?',
  'contacts.group_with_title': '{title} Group',
  'contacts.who_can_access_this_contact_group': 'Who can access this group?',
  'settings.approval_setting': 'Approval Setting',
  'financeExpenseTerms.select_terms': 'Select Term',
  'approval.transfer_money': 'Transfer Money',
  'dashboard.the_maximum_number_that_can_be_displayed_on_the_dashboard':
    'The maximum number that can be displayed on the dashboard is 30',
  'sso.faq_question_what_is_sso': 'What is Single Sign On (SSO)?',
  'sso.faq_answer_what_is_sso':
    'SSO allows users to login to multiple applications and websites using one identity provider. So that users do not need to memorize many users and passwords for each application or website.',
  'sso.faq_question_how_does_sso_work': 'How does SSO work?',
  'sso.faq_answer_1_how_does_sso_work': 'User attempts to login to Kledo using SSO',
  'sso.faq_answer_2_how_does_sso_work': 'Kledo sends user data to Identity Provider',
  'sso.faq_answer_3_how_does_sso_work': 'Identity Provider checks user credentials',
  'sso.faq_answer_4_how_does_sso_work':
    'Identity Provider sends a response to Kledo, informing that the user is allowed to login',
  'sso.faq_answer_5_how_does_sso_work':
    'Kledo receives the info from the Identity Provider, and logs the user into Kledo',
  'sso.faq_question_how_to_setup_sso_in_kledo': 'How to setup SSO in Kledo?',
  'sso.faq_answer_how_to_setup_sso_in_kledo':
    'Click {here} for a tutorial on how to setup SSO in Kledo.',
  'sso.here': 'here',
  'report.average_unit_price': 'Average Unit Price',
  'report.average_product_value': 'Average Product Value',
  'report.total_product_value': 'Total Product Value',
  'billing.payment_balance': 'Payment Balance',
  'roles.time_access_limit': 'Enable time access limit',
  'roles.access_limit': 'Access time limit',
  'roles.restricted_access_type_monday_friday': 'Monday - Friday Working hours',
  'roles.restricted_access_type_monday_saturday': 'Monday - Saturday Working hours',
  'roles.restricted_access_type_custom': 'Custom',
  'roles.active_days_monday': 'Monday',
  'roles.active_days_tuesday': 'Tuesday',
  'roles.active_days_wednesday': 'Wednesday',
  'roles.active_days_thursday': 'Thursday',
  'roles.active_days_friday': 'Friday',
  'roles.active_days_saturday': 'Saturday',
  'roles.active_days_sunday': 'Sunday',
  'businessFlow.enable_contact_group_is_required': 'Group is required',
  'businessFlow.enable_contact_group_is_required_desc':
    'Does there need to be a group when adding and modifying contacts?',
  'report.unit_price_help':
    'The Unit Price displayed is the last purchase price (not the average price)',
  'report.product_value_help':
    'The Product Value displayed is the last unit price multiplied by the quantity (not the average product value)',
  'scheduler_lock_date.monday': 'Monday',
  'scheduler_lock_date.tuesday': 'Tuesday',
  'scheduler_lock_date.wednesday': 'Wednesday',
  'scheduler_lock_date.thursday': 'Thursday',
  'scheduler_lock_date.friday': 'Friday',
  'scheduler_lock_date.saturday': 'Saturday',
  'scheduler_lock_date.sunday': 'Sunday',
  'scheduler_lock_date.days': 'Days',
  'scheduler_lock_date.weeks': 'Weeks',
  'scheduler_lock_date.months': 'Months',
  'scheduler_lock_date.create_successfully': 'Option successfully updated.',
  'scheduler_lock_date.create_failed': 'Cannot update option.',
  'scheduler_lock_date.subtitle_1': 'Now you can automatically change the lock date.',
  'scheduler_lock_date.subtitle_2':
    'Specify the automatic change rules in the form below, and the lock date will be automatically updated according to your settings.',
  'scheduler_lock_date.is_automatically_changed':
    'Is the lock date automatically changed periodically?',
  'scheduler_lock_date.label1': 'How frequently is the lock date changed?',
  'scheduler_lock_date.label2': 'On which date is the lock date changed?',
  'scheduler_lock_date.label3': 'On which day is the lock date changed?',
  'scheduler_lock_date.label4': 'Change the lock date to which date?',
  'scheduler_lock_date.daily': 'Daily',
  'scheduler_lock_date.weekly': 'Weekly',
  'scheduler_lock_date.monthly': 'Monthly',
  'scheduler_lock_date.example': 'Example:',
  'scheduler_lock_date.example_sub':
    'If the automatic lock date is changed on March 1, and the lock date is moved 2 months earlier, then the lock date will be changed to January 1.',
  'scheduler_lock_date.earlier': 'Earlier',
  'scheduler_lock_date.update_successfully': 'Schedule Lock Date successfully activated.',
  'scheduler_lock_date.update_failed': 'Cannot activate Schedule Lock Date.',
  'scheduler_lock_date.update_successfully_inactive':
    'Schedule Lock Date successfully deactivated.',
  'scheduler_lock_date.update_failed_inactive': 'Cannot dactivate Schedule Lock Date.',
  'financeFixedAssets.effective_life_title': 'Effective Life',
  'financeFixedAssets.upgrade_cost': 'Upgrade Cost',
  'financeFixedAssets.purchase_price_after_upgrade': 'Purchase Price After Upgrade',
  'paymentConnect.faq_question_payment_gateway': 'What is Payment Gateway?',
  'paymentConnect.faq_answer_payment_gateway':
    'By using a payment gateway, your customers can pay the bills you issue through various payment channels, such as credit cards, gopay, virtual accounts and so on. QR codes will be embedded on your bills, so customers can pay easily by scanning QR codes.',
  'paymentConnect.faq_question_when_customer_pays_through_payment_gateway':
    'What happens when my customer pays through the Payment Gateway?',
  'paymentConnect.faq_answer_when_customer_pays_through_payment_gateway':
    'When a payment is made, your bill will be automatically updated with the payment status. So you no longer need to bother recording every incoming payment.',
  'paymentConnect.faq_question_payment_gateway_supported_by_kledo':
    'What Payment Gateway is supported by Kledo?',
  'paymentConnect.faq_answer_payment_gateway_supported_by_kledo':
    'You can use Midtrans, Xendit or Doku.',
  'paymentConnect.faq_question_charge_a_fee': 'Does Kledo charge a fee for using Payment Gateway?',
  'paymentConnect.faq_answer_charge_a_fee':
    'No. However, the payment gateway provider will charge a fee per transaction. For more detailed information, you can ask directly to Midtrans, Xendit or Doku.',
  'paymentConnect.faq_question_how_to_setup': 'How to setup?',
  'paymentConnect.faq_answer_how_to_setup': 'Click on the following links:',
  'report.see_report': 'View Report',
  'paymentConnect.click_here_to_go_to_tutorial':
    '{clickHere} for details on how to set up payment connect {providerName}',
  'kledoPos.service_charge': 'Service Charge On Invoice Fees',
  'kledoPos.service_charge_desc':
    'For sales that include a service charge, the fee is recorded in this invoice fee master.',
  'paymentConnect.success_copy_url_callback': 'The callback url was copied successfully',
  'paymentConnect.activate_payment_methods': 'Activate Payment Methods',
  'paymentConnect.payment_methods_required': 'Please select at least 1 payment method',
  'paymentConnect.payment_methods_intro':
    'Select the payment methods you want to enable for receiving payments from your customers.',
  'paymentConnect.section.virtual_account.title': 'Bank Transfer',
  'paymentConnect.section.virtual_account.subtitle': 'BCA, Mandiri, BNI, BRI',
  'paymentConnect.section.e_wallet.title': 'E-Wallet',
  'paymentConnect.section.e_wallet.subtitle': 'GoPay, OVO, ShopeePay',
  'paymentConnect.section.over_the_counter.title': 'Over the Counter',
  'paymentConnect.section.over_the_counter.subtitle': 'Indomaret, Alfamart',
  'paymentConnect.section.qris.title': 'QRIS',
  'paymentConnect.section.qris.subtitle': 'Pay via QR code',
  'paymentConnect.section.card.title': 'Card',
  'paymentConnect.section.card.subtitle': 'Debit/Credit card payment',
  'paymentConnect.section.paylater.title': 'PayLater',
  'paymentConnect.section.paylater.subtitle': 'Akulaku, Kredivo',
  'paymentConnect.section.others.title': 'Others',
  'paymentConnect.section.others.subtitle': 'Other payment methods',
  'paymentConnect.kledo_empty_active_methods':
    'There are no active payment methods in Kledo Payment Connect settings yet.',
  'paymentConnect.processing_payment': 'Processing Payment',
  'paymentConnect.failed_create_payment': 'Failed to create payment',
  'paymentConnect.payment_code_not_available': 'Payment code is not available yet',
  'paymentConnect.failed_copy_payment_code': 'Failed to copy payment code',
  'paymentConnect.virtual_account_copied': 'Virtual Account number copied',
  'paymentConnect.billing_code_copied': 'Billing code copied',
  'paymentConnect.virtual_account_number_label': 'Virtual Account Number',
  'paymentConnect.amount_to_pay': 'Amount to pay',
  'paymentConnect.company_code_biller_code': 'Company Code (Biller Code)',
  'paymentConnect.billing_code_bill_key': 'Billing Code (Bill Key)',
  'paymentConnect.qr_code_payment_alt': 'Payment QR Code',
  'paymentConnect.pay_with_method': 'Pay with {methodName}',
  'paymentConnect.e_wallet': 'E-Wallet',
  'paymentConnect.payment_code_label': 'Payment Code',
  'paymentConnect.payment_code_copied': 'Payment code copied',
  'paymentConnect.cstore_show_at_cashier_hint': 'Show this code at the cashier',
  'paymentConnect.continue_payment': 'Continue Payment',
  'paymentConnect.card_number_label': 'Card number',
  'paymentConnect.card_number_required': 'Card number is required',
  'paymentConnect.card_number_invalid': 'Invalid card number (12–19 digits)',
  'paymentConnect.card_expiry_label': 'Expiry date',
  'paymentConnect.card_expiry_invalid': 'Enter expiry as MM/YY',
  'paymentConnect.card_exp_month_invalid': 'Invalid month (01–12)',
  'paymentConnect.card_expired': 'Card has expired',
  'paymentConnect.card_cvv_label': 'CVV',
  'paymentConnect.card_cvv_required': 'CVV is required',
  'paymentConnect.card_cvv_invalid': 'CVV must be 3 or 4 digits',
  'paymentConnect.pay_now': 'Pay now',
  'paymentConnect.midtrans_client_key_missing':
    'Midtrans client key is not configured. Set VITE_MIDTRANS_CLIENT_KEY in the environment.',
  'paymentConnect.card_token_failed':
    'Could not get card token. Check the card details or try again.',
  'paymentConnect.card_token_timeout':
    'Timed out waiting for Midtrans. Check your connection, or that the client key matches the environment (sandbox vs production).',
  'paymentConnect.kartu_kredit': 'Credit Card',
  'paymentConnect.va_bca': 'Virtual Account BCA',
  'paymentConnect.va_bni': 'Virtual Account BNI',
  'paymentConnect.va_mandiri': 'Virtual Account Mandiri',
  'paymentConnect.va_bri': 'Virtual Account BRI',
  'paymentConnect.retail': 'Retail (Alfamart/Indomaret)',
  'paymentConnect.disbursement.title': 'Disbursement',
  'paymentConnect.disbursement.click_to_setup': 'Click here',
  'paymentConnect.disbursement.click_to_setup_suffix': 'to set up your disbursement account.',
  'paymentConnect.disbursement.funds_will_be_forwarded': 'Funds will be forwarded to account:',
  'paymentConnect.disbursement.change': 'Change',
  'paymentConnect.disbursement.rejected_message': 'Your application has been rejected,',
  'paymentConnect.disbursement.rejected_because': 'Your application was rejected because:',
  'paymentConnect.disbursement.reapply_suffix': 'to re-apply!',
  'paymentConnect.disbursement.pending_message': 'Waiting for admin verification.',
  'paymentConnect.disbursement.pending_info':
    'Verification process takes at least 1 business day during working hours.',
  'paymentConnect.disbursement.form_title': 'Disbursement Account',
  'paymentConnect.disbursement.form_description':
    'Enter the destination account for your fund withdrawal. Ensure the account holder name matches your personal data or company data.',
  'paymentConnect.disbursement.account_info': 'Account Information',
  'paymentConnect.disbursement.documents': 'Documents',
  'paymentConnect.disbursement.bank': 'Bank',
  'paymentConnect.disbursement.account_number': 'Account Number',
  'paymentConnect.disbursement.account_holder_name': 'Account Holder Name',
  'paymentConnect.disbursement.whatsapp_number': "Responsible Person's WhatsApp Number",
  'paymentConnect.disbursement.whatsapp_help':
    'Ensure WhatsApp can be contacted by our team for verification. And the WhatsApp number is the same as your account phone number.',
  'paymentConnect.disbursement.ktp_upload':
    'KTP Photo or Company Deed According to Account Holder Name',
  'paymentConnect.disbursement.selfie_upload': 'Selfie photo with company location background',
  'paymentConnect.disbursement.selfie_help':
    'Ensure the company logo and company location situation are clearly visible.',
  'paymentConnect.disbursement.submit_verification': 'Submit Verification',
  'paymentConnect.disbursement.success_message_1': 'Thank you! We have received your data.',
  'paymentConnect.disbursement.success_message_2':
    'You will receive verification submission information within 1 business day via WhatsApp.',
  'paymentConnect.disbursement.please_select_bank': 'Please select a bank',
  'paymentConnect.disbursement.please_fill': 'Please complete this field',
  'paymentConnect.disbursement.please_upload_photo': 'Please upload photo',
  'paymentConnect.disbursement.digits_only': 'Only digits (0–9) are allowed',
  'paymentConnect.disbursement.placeholder_account_number': 'Enter disbursement account number',
  'paymentConnect.disbursement.placeholder_account_holder_name': 'Enter account holder name',
  'paymentConnect.disbursement.placeholder_phone_number':
    'Enter responsible person WhatsApp number',
  'paymentConnect.disbursement_schedule.label': 'Funds forwarded every',
  'paymentConnect.disbursement_schedule.daily': 'Working Day',
  'paymentConnect.disbursement_schedule.weekly': '1 Week on the first working day of each week',
  'paymentConnect.disbursement_schedule.monthly': '1 Month on the first working day of each month',
  'paymentConnect.disbursement_schedule.placeholder': 'Select schedule',
  'paymentConnect.disbursement_schedule.please_select': 'Please select fund forwarding schedule',
  'paymentConnect.fee_charge_to.label': 'Fee charged to',
  'paymentConnect.fee_charge_to.customer': 'Customer',
  'paymentConnect.fee_charge_to.seller': 'Seller',
  'paymentConnect.fee_charge_to.please_select': 'Please select who will be charged the fee',
  'paymentConnect.fee_charge_to.help':
    'The payment gateway fee will be charged to the selected party in each transaction.',
  'paymentConnect.report.invoice_count': 'Invoice Count',
  'paymentConnect.report.account': 'Account',
  'financeContacts.search_on_google_map': 'Search on Google Map',
  please_fill_the_serial_numbers: 'Please fill the No. Seri/Production',
  'report.start_date': 'Start Date',
  'report.end_date': 'End Date',
  'report.show': 'Show',
  'report.serial_number_mutation': 'Serial Number Mutation',
  'reports.stock_serial_number_per_warehouse': 'Stock Serial Number Per Warehouse',
  'reports.inventory_product_serial_stock_detail_title':
    'Stock Details Serial Number Per Warehouse',
  'users.check_user_quota_availability': 'Check {title} quota availability',
  'businessFlow.duplicate_contact_email': 'Duplicate contact email',
  'businessFlow.duplicate_contact_email_desc': 'If active, the contact email can be duplicated.',
  'businessFlow.duplicate_contact_name': 'Duplicate contact name',
  'businessFlow.duplicate_contact_name_desc': 'If active, the contact name can be duplicated.',
  fill_the_name: 'Fill the {name}',
  the_serial_number_must_be_the_same_as_the_item_quantity:
    'The serial number must be the same as the item quantity.',
  must_not_exceed_the_available_qty: 'Must not exceed the available qty',
  'audit.ip_address': 'IP Address',
  'audit.enter_ip_address': 'Enter IP address',
  please_fill_serial_or_production_number: 'Please fill Serial / Production number',
  serial_or_production_number_is_empty: 'Serial / Production number is empty',
  setting_serial_or_production_number_sequencial:
    'Setting Serial / Production number as Sequencial',
  fill_serial_number_prefix: 'Fill serial number prefix',
  prefix: 'Prefix',
  create_serial_or_production_number_sequential_for: 'Create ordered number as for',
  qty: 'Qty',
  expired: 'Expired',
  preview: 'Preview',
  serial_or_production_number_not_found: 'Serial / Production number not found',
  serial_or_production_number_already_in_use: 'Serial / Production number already in use',
  scan_barcode_or_sku_or_type_then_press_enter: 'Scan Barcode/SKU then type and press [Enter]',
  delete: 'Delete',
  amount: 'Amount',
  add_amount_more: 'Add {amount} more',
  advantages_amount: 'advantages {amount}',
  please_select_serial_or_production_number: 'Select {value} Serial / Production number',
  select_serial_or_production_number: 'Select Serial / Production number',
  search: 'Search',
  stock: 'Stock',
  less_than_amount: 'less than {amount}',
  setting_serial_or_production_number: 'Setting Serial / Production number',
  select: 'Select',
  'topBar.show_dark_mode': 'Show dark mode',
  'topBar.show_light_mode': 'Show light mode',
  'financeInvoices.reject_reason_label': 'Please enter your reason for rejecting the transaction',
  please_select_expired_date: 'Please select expired date',
  no_items_have_been_added_yet: 'No items have been added yet',
  'massDownload.data_progress_processed': '{count} out of {total} data has been processed',
  'billing.enter_coupon_code': 'Enter coupon code',
  'approval.receive_invoice_payment': 'Receive Invoice Payment',
  'approval.receive_sales_order_payment': 'Receive Sales Order Payment',
  'approval.purchase_payment': 'Purchase Payment',
  'approval.purchase_order_payment': 'Purchase Order Payment',
  'financeInvoices.detail_something': '{something} Detail',
  'financeInvoices.logistic': 'Logistic',
  'financeInvoices.location': 'Location',
  select_transaction_status: 'Select transaction status',
  'placeholder.attachment': 'Select Attachment',
  'option.with_attachment': 'With Attachment',
  'option.without_attachment': 'Without Attachment',
  'placeholder.attachment_photo': 'Select Photo',
  'option.with_attachment_photo': 'With Photo',
  'option.without_attachment_photo': 'Without Photo',
  'title.attachment_photo': 'Photo',
  'layoutInvoice.show_transaction_fee': 'Show Transaction Fee',
  'layoutInvoice.show_transaction_fee_details': 'Show Transaction Fee Details',
  'massPrint.data_progress_processed': '{count} out of {total} data has been processed',
  'massPrint.mass_print': 'Mass Print',
  'pos.table_list': 'Table List',
  'pos.add_table': 'Add Table',
  'pos.example_table_index': 'Example: Table {index}',
  'pos.floor_name': 'Floor Name',
  'pos.add_floor': 'Add Floor',
  'pos.edit_floor': 'Edit {floorName}',
  'pos.floor_list': 'Floor List',
  'pos.floor': 'Floor',
  'pos.maximum_guests': 'Maximum Guests',
  'pos.total_table': 'Total Table',
  'pos.minimum_guests': 'Minimum Number of Guests 1',
  'pos.outlet_name': 'Outlet Name',
  'pos.shift_id': 'Shift ID',
  'pos.are_you_sure_to_delete_room': 'Are you sure to delete {roomName} this?',
  select_status: 'Select status',
  revert_count_reconciliation: 'Revert {count} Reconciliation',
  reload_window: 'Reload window',
  welcome_to_company: 'Welcome to {value}',
  thankyou_you_have_successfully_joined_to_company:
    'Thank you, You have successfully joined to {value}',
  please_click_next_to_start_the_application: 'Please click next, to start the application',
  'uploadImage.image_with_title': '{title} Image',
  'uploadImage.show_image_with_title': 'Show {title} Image',
  'uploadImage.hide_image_with_title': 'Hide {title} Image',
  'reports.serial_number_history': 'Serial Number History',
  'reports.no_stock_details_transaction': 'No. Stock Details Transaction',
  'reports.products_with_expiration_dates': 'Products with expiration dates',
  'financeInvoices.this_customer': 'This {customer}',
  'financeInvoices.all_customer': 'All {customer}',
  'financeInvoices.customer_name': '{customer} Name',
  'financeInvoices.sales_price_history': 'Sales Price History',
  'financeInvoices.sales_price_history_of_all_customers': 'Sales Price History of All {customer}',
  'financeInvoices.something_has_been_applied': '{something} has been applied',
  'financeBanks.total_of_selected_rows_reconcile': 'total reconciliation amount : {count}',
  'financePurchaseInvoices.transaction_date_must_be_gt_date':
    'Transaction date must be later than {date}',
  'financeInvoices.failed_to_get_sales_price_history': 'Failed to get last sale price history',
  'report.create_data': 'Create Data',
  'report.change_data': 'Change Data',
  'report.delete_data': 'Delete Data',
  'report.data_change': 'Data Change',
  'report.data_change_activity': 'Data Change Activity',
  'report.last_month_login_day': 'Last Month Login Day',
  'report.number_of_team_members_login': 'Number of Team Members Login',
  'report.new': 'New',
  'report.change': 'Change',
  'report.actions_taken_by_the_team': 'Actions taken by the team',
  'report.action_name': 'Action Name',
  'report.total_action': 'Total Action',
  'report.times': 'times',
  'report.team_activities': 'Team Activities',
  'report.activity_per_transaction': 'Activity per Transaction',
  'report.activity_per_transaction_desc':
    "Summary of each team member's transaction input activity for the selected period",
  'report.menu': 'Menu',
  'report.member_name': 'Member Name',
  'report.login_count': 'Login Count',
  'report.activity_count': 'Total Activity',
  'report.create_count': 'Created',
  'report.update_count': 'Updated',
  'report.delete_count': 'Deleted',
  'report.activity_percentage': 'Percentage',
  'report.all_menu': 'All Menus',
  'report.menu_sales': 'Sales',
  'report.menu_purchase': 'Purchase',
  'report.menu_expense': 'Expense',
  'financePurchaseInvoices.recurring_purchase_invoice': 'Recurring Purchase Invoice',
  'financePurchaseInvoices.1_download_your_purchase_invoices_recurring_template_file':
    '1. Download the recurring purchase invoice template file',
  'financePurchaseInvoices.start_by_downloading_our_purchase_invoices_recurring_csv':
    'Start by downloading the recurring purchase invoice Excel template file. This file has the header fields that Kledo needs to import the details of your recurring purchase invoices.',
  'financePurchaseInvoices.2_copy_your_invoices_purchase_recurring_into_the_template':
    '2. Copy recurring purchase invoice details into template',
  'financePurchaseInvoices.purchase_invoice_recurring_using_excel_or_another_spreadsheet_editor':
    'Using Excel or other spreadsheet software, enter recurring purchase invoice details into a template file from Kledo. Make sure the recurring purchase invoice details match the header fields in the template.',
  'financeWarehouse.upload_photo': 'Upload Images of Your Warehouse',
  'financeWarehouse.upload_photo_maxsize': '(Max Attachment Size 10 MB)',
  'billing.term_and_conditions':
    'By clicking the button above, you agree to our {termOfUse} and confirm that you have read our {privacyPolicy}.',
  'billing.terms_of_use': 'Terms of Use',
  'billing.privacy_policy': 'Privacy Policy',
  'report.mass_export': 'Mass Export',
  'massExport.data_has_been_exported': 'Total {count} data has been exported',
  'massExport.its_ok_to_close_this_process':
    'Export is in progress, you can leave this page. After the export process is complete, we will send a notification via email. You can also monitor the export status on the export report page {here}.',
  'massExport.cannot_mass_export': 'Cannot mass export',
  'massExport.part': 'Part',
  'massExport.data_progress_exported': '{count} out of {total} data has been exported',
  'massExport.retrieving_the_necessary_data': 'Retrieving the necessary data',
  'financeProduct.all_row': 'All Row',
  'financeBanks.manual_get_data': 'Manual Data Retrieval',
  'button.get_data': 'Retrieve data',
  'financeBanks.schedule_get_data': 'Mutation Retrieval Schedule',
  'users.login_with_facebook': 'Sign in with Facebook',
  'warehouses.avg_cogs': 'Avg COGS',
  'pos.table_name_is_already_in_use': 'The {tableName} is already in use.',
  each_stock_items_has_a_unique_serial_number_for_example_cellphones_have_a_unique_imei_number_for_each_item:
    'Each stock item has a unique serial number. For example, cellphones have a unique IMEI number for each item.',
  the_same_serial_number_can_be_owned_by_more_than_1_product_stock_for_example_products_produced_by_factory_in_the_same_batch_are_given_the_same_production_number:
    'The same serial number can be owned by more than 1 product stock. For example, products produced by a factory in the same batch are given the same production number.',
  production_code_that_has_an_expiration_date_for_example_for_medical_products_or_food_products:
    'Production code that has an expiration date. For example, for medicinal products or food products.',
  this_product_has_a_serial_number_or_production_number:
    'This product has a serial number / production number',
  enter_value_serial_numbers: 'Enter {value} serial numbers',
  issue_value_serial_numbers: 'Issue {value} serial numbers',
  value_serial_numbers: '{value} serial numbers',
  list_serial_numbers: 'List serial numbers',
  scan_barcode_or_type: 'Scan Barcode',
  automatic_sequence: 'Automatic',
  take_from_existing_data: 'Select Serial',
  please_add: 'Add',
  excees_value_serial_numbers: 'Excees {value} serial number',
  a_total_of_value_serial_numbers_match: 'A Total of {value} serial numbers matchs',
  there_are_still_value_serial_numbers_missing: 'There are still {value} serial numbers missing',
  value_serial_numbers_are_selected: '{value} nomor seri dipilih',
  must_be_an_integer: 'Must bug an integer',
  serial_numbers: 'Serial Numbers',
  custom_fields: 'Custom Fields',
  please_fill_serial_or_production_number_template: 'Please fill serial number prefix',
  no_results_displayed: 'No results displayed',
  please_fill_number_of_sequences: 'Please fill number of sequences',
  export_bank_successfully: 'Successfully exported {value}',
  'report.diff_qty_help': 'Difference in quantity of raw materials and finished goods',
  'roles.start_time_must_be_before_end_time': 'Start time must be before end time',
  'roles.end_time_must_be_after_start_time': 'End time must be after start time',
  'roles.custom_options_require_minimum_1_active_day':
    'Custom options require a minimum of 1 active day',
  'financeWareHouses.approval_status': 'Approval Status',
  'report.production_amount_help': 'Production value = COGS x quantity',
  'report.production_value': 'Production Value',
  'report.production_raw_material_chart_title': 'Most Used Raw Materials',
  'report.production_raw_material_chart_showing': 'Showing {count} of {total} raw materials',
  'report.production_raw_material_chart_frequency': 'Frequency: {count}x',
  'report.production_raw_material_chart_usage': 'Usage: {qty}',
  'report.production_raw_material_chart_empty': 'No raw materials were used in this period.',
  'report.production_audit.qty_result': 'Result Qty',
  'report.production_audit.qty_formula': 'Formula Qty',
  'report.production_audit.qty_actual': 'Actual Qty',
  'report.production_audit.status.sesuai': 'Match',
  'report.production_audit.status.kurang': 'Under',
  'report.production_audit.status.lebih': 'Over',
  'billing.addon_stamp_description': 'Affix E-Stamp to your transaction',
  'billing.stamp': 'Stamp',
  'financeInvoices.stamp': 'E-Stamp',
  'stamp.billing_title': 'E-Stamp Billing',
  'stamp.balance': 'E-Stamp Balance',
  'stamp.yes': 'Yes',
  'stamp.no': 'No',
  'stamp.affix_description':
    'Easily affix an E-Stamp to your {value} document with just one click! The legality of the E-Stamp is guaranteed by Law No.10 of 2020.',
  'stamp.zero_quota_description':
    'No more hassle of manually attaching stamps to documents. With E-Stamp, legality is guaranteed by law!',
  'stamp.add_stamp_quota_description':
    'Please add your E-Stamp balance first, so you can start affixing E-Stamps to your bills',
  'stamp.total_billing': 'Total Billing',
  'stamp.user': 'Affixer',
  'stamp.document': 'Document',
  'stamp.affix_stamp': 'Affix E-Stamp',
  'stamp.stamped': 'Stamped',
  'stamp.affix': 'Affix',
  'stamp.add_stamp_balance': 'Add E-Stamp Balance',
  'stamp.sheets': 'Sheets',
  'stamp.your_stamp_quota': 'Your E-Stamp Quota',
  'stamp.bill_preview': '{value} Preview',
  'stamp.balance_left': 'Balance Left',
  'stamp.amount': 'Amount',
  'stamp.description': 'Description',
  'stamp.date': 'Date',
  'stamp.confirm_message':
    'Are you affixing an E-Stamp to the document {value}? Affixing the E-Stamp will reduce your balance and cannot be undone.',
  'stamp.cancel': 'Cancel',
  'stamp.usage': 'Usage',
  'stamp.add_balance': 'Add Balance',
  'stamp.loading_document': 'Loading document...',
  'stamp.drag_help_text': 'Drag to change stamp position',
  'stamp.drag_text':
    "Please ensure the e-Stamp does not cover the signature. Place it next to the signature to ensure the document's validity.",
  'stamp.page': 'Page {page} of {total}',
  'stamp.print_confirm_title': 'Print document',
  'stamp.print_confirm_message':
    'E-Stamp has been affixed to document {value}. Print the document now?',
  'stamp.select_user': 'Select User',
  'stamp.progress_starting': 'Preparing stamping...',
  'stamp.progress_milestone_queued': 'Queued',
  'stamp.progress_milestone_document': 'Preparing document',
  'stamp.progress_milestone_serial': 'Issuing stamp',
  'stamp.progress_milestone_signed': 'Affixing stamp',
  'stamp.progress_milestone_uploaded': 'Uploading document',
  'stamp.progress_milestone_complete': 'Complete',
  'stamp.progress_waiting_peruri': 'Waiting for Peruri...',
  'stamp.progress_waiting_peruri_note': 'Waiting for Peruri to issue the stamp, please wait…',
  'stamp.progress_failed_title': 'Stamping failed.',
  'stamp.retry': 'Retry',
  'stamp.result_opened_new_tab': 'The stamped PDF opened in a new tab.',
  'stamp.result_title': 'Stamping successful',
  'stamp.result_success_title': 'Stamp affixed successfully',
  'stamp.open_result_pdf': 'Open PDF',
  'reporting.warehouse_transfer_report.total_price': 'Selling Price',
  'reporting.warehouse_transfer_report.total_price.tooltip':
    'Product selling price multiplied by quantity.',
  please_select_serial_or_production_number_type: 'Please select Serial / Production Number',
  no_value_number_has_selected_yet: 'No {value} has selected yet',
  'audit.reload': 'Reload',
  'layoutInvoice.document_receipt': 'Document Receipt',
  'layoutInvoice.document_receipt_show_logo': 'Show logo',
  'layoutInvoice.document_receipt_show_company_information': 'Show company information',
  'layoutInvoice.document_receipt_show_detail_table': 'Show Detail Table',
  'layoutInvoice.document_receipt_show_detail_no': 'Show No',
  'layoutInvoice.document_receipt_show_detail_invoice_date': 'Show Invoice Date',
  'layoutInvoice.document_receipt_show_detail_invoice_number': 'Show Invoice Number',
  'layoutInvoice.document_receipt_show_detail_sale_price': 'Show Sale Price',
  'layoutInvoice.document_receipt_show_detail_ppn': 'Show PPN',
  'layoutInvoice.document_receipt_show_detail_amount': 'Show Amount',
  'layoutInvoice.document_receipt_detail_no': 'No',
  'layoutInvoice.document_receipt_detail_invoice_date': 'Invoice Date',
  'layoutInvoice.document_receipt_detail_invoice_number': 'Invoice Number',
  'layoutInvoice.document_receipt_detail_sale_price': 'Sale Price',
  'layoutInvoice.document_receipt_detail_ppn': 'PPN',
  'layoutInvoice.document_receipt_detail_amount': 'Amount',
  'layoutInvoice.print_document_receipt': 'Print Document Receipt',
  'layoutInvoice.hide_checklist': 'Hide Checklist',
  'financeInvoices.received': 'Received',
  'financeInvoices.order_number': 'Order Number',
  'financeInvoices.tax_number': 'Tax Number',
  'kledoPos.setting_default_open_shift_account_id': 'Default Account Open Cashier',
  'kledoPos.setting_default_open_shift_account_id_desc':
    'When you open cashier at the POS, it will be recorded in accounting on this COA account.',
  'kledoPos.setting_default_close_shift_account_id': 'Default Account Close Cashier',
  'kledoPos.setting_default_close_shift_account_id_desc':
    'When you close cashier at the POS, it will be recorded in accounting on this COA account.',
  'invoice_layout.invoice_lang_account_code_and_name': 'Account Code & Name',
  'layoutInvoice.show_coa_in_description': 'Show COA in Description',
  'businessFlow.show_available_stock_when_making_a_purchase':
    'Show available stock when making a purchase',
  'businessFlow.show_available_stock_when_making_a_purchase_desc':
    'Whether stock is in the warehouse needs to be displayed when making a new purchase?',
  'businessFlow.fixed_asset_depreciation_on': 'Default No Depreciation Off',
  'businessFlow.fixed_asset_depreciation_on_desc': 'Is the default without depreciation disabled?',
  'report.comparison_date': 'Comparison Date',
  'businessFlow.warehouse_transfer_items_description':
    'Show product description in {warehouseTransfer}',
  'businessFlow.warehouse_transfer_items_description_desc':
    'Is the product description displayed in the {warehouseTransfer}?',
  'businessFlow.split_in_out_reporting_warehouse_transfer':
    'Split print incoming & outgoing warehouse transfer reports',
  'businessFlow.split_in_out_reporting_warehouse_transfer_desc':
    'Should print warehouse transfer reports be split into incoming and outgoing transactions?',
  'businessFlow.material_module_enabled': 'Enable Material Request & Issue module',
  'businessFlow.material_module_enabled_desc':
    'If yes, the Material Request and Material Issue menus are enabled and can be used',
  'businessFlow.material_request_create_as_draft': 'Save Material Request as draft',
  'businessFlow.material_request_create_as_draft_desc':
    'If yes, new Material Requests are created as a draft and must be submitted before processing',
  'menu.warehouses': 'Warehouse',
  'menu.material_requests': 'Material Request',
  'menu.purchase_requests': 'Purchase Request',
  'menu.material_issues': 'Material Issue',
  'menu.other_apps': 'Other Apps',
  'menu.sidebar_apps_saved': 'Sidebar app menu settings saved successfully.',
  'menu.sidebar_apps_move_group': 'Move to Other Apps',
  'menu.sidebar_apps_show_main': 'Show in main menu',
  'menu.search_placeholder': 'Search menu',
  'financeInvoices.sales_person_required': '{sales_person} is required',
  'businessFlow.required_sales_person': '{sales_person} is required',
  'businessFlow.required_sales_person_desc':
    'Is it mandatory to fill in the {sales_person} when adding a sales transaction?',
  'businessFlow.show_conversion_variance':
    'Show the difference between raw materials and finished products in product conversion',
  'businessFlow.show_conversion_variance_desc':
    'On the product conversion page, is the difference in the quantity of raw materials and finished products displayed?',
  'businessFlow.product_conversion_show_qty_multiplier':
    'Show Multiplier column on Product Conversion',
  'businessFlow.product_conversion_show_qty_multiplier_desc':
    'Show the multiplier column on product conversion?',
  'financeWareHouses.product_description': 'Product Description',
  'report.noPO': 'No PO',
  'report.total_qty': 'Total Qty',
  'report.total_price_after_discount': 'Total Price After Discount',
  item_description: 'Item Description',
  'financeTag.alphanumeric_and_this_regex_allowed':
    'only alphanumeric dan _ @ . / # & + - allowed.',
  'businessFlow.invoice_locked_discount': 'Lock Product Discount',
  'businessFlow.invoice_locked_discount_desc': 'Will product discounts in the sale be locked?',
  'layoutInvoice.alternative_invoice': 'Alternative Sales Invoice',
  'layoutInvoice.use_invoice_alternative_layout': 'Enable alternative layout',
  'layoutInvoice.updating_option_loading': 'Updating option...',
  'financeInvoices.print_invoice_alternative': 'Alternative Invoice',
  please_adjust_user_permissions_based_on_their_role:
    'Please adjust user permissions base on their role',
  pos_user_permissions: 'POS User Permissions',
  manage_pos_user_permissions: 'Manage POS User Permissions',
  'report.reference_number': '{reference} Number',
  'approval.approval_status': 'Approval Status',
  'layoutInvoice.paper_size': 'Paper Size',
  'businessFlow.invoice_user_maximum_receivables': 'Limit maximum receivables per {salesPerson}',
  'businessFlow.invoice_user_maximum_receivables_desc':
    'Reject sales if the receivables from the {salesPerson} exceed the limit.',
  'businessFlow.default_value_maximum_receivable': 'Default Limit for all {salesPerson}',
  'businessFlow.limit_per_sales_person': 'Limit per {salesPerson}',
  'financeProduct.total_product_value': 'Total {product} Value',
  'financeProduct.inventory_journal': 'Inventory Journal',
  'financeProduct.total_inventory_journal': 'Total Inventory Journal',
  'financeProduct.non_stock_journal': 'Non Stock Journal',
  'financeProduct.active_product_value': '{product} Active Value',
  'financeProduct.archive_product_value': '{product} Archive Value',
  'financeProduct.inventory_journal_from_non_stock_transactions':
    'Inventory Journal from Non Stock Transactions',
  'financeProduct.total_inventory_journal_from_non_stock_transactions':
    'Total Inventory Journal from Non Stock Transactions',
  'financeProduct.stock_adjustment_with_inventory_account':
    '{stockAdjustment} with Inventory Account',
  'financeProduct.total_product_value_details': 'Total {product} Value Details',
  'priceRule.follow_these_steps_to_import_your_price_rule':
    'Follow these steps to import your price rule',
  'priceRule.1_download_your_price_rule_template_file': '1. Download your price rule template file',
  'priceRule.start_by_downloading_our_price_rule_csv':
    'Start by downloading our price rule Excel template file. This file has the correct column headings Kledo needs to import details of your price rules.',
  'priceRule.2_copy_your_price_rule_into_the_template':
    '2. Copy your price rules into the template',
  'priceRule.a_maximum_of_1000_price_rule_can_be_imported_at_a_time':
    'A maximum of 1.000 price rules can be imported at a time.',
  'import.upload_file': 'Upload File',
  'import.check_the_imported_data': 'Check Data',
  'import.import_done': 'Import Success',
  'import.import_in_progress': 'Import in progress',
  'import.please_check_the_imported_data': 'Please check the imported data',
  'import.if_you_are_happy_to_continue_with_the_import_please_click_the_import_now_button':
    'If you are happy to continue with the import please click the "Import Now" button.',
  'import.valid': 'Valid',
  'import.invalid': 'Invalid',
  'import.total': 'Total',
  'import.import_now': 'Import Now',
  'import.view_detail': 'View detail',
  'import.success': 'Success',
  'import.failed': 'Failed',
  'import.import_another_file': 'Import another file',
  'import.import_is_still_in_progress': 'Import is still in progress',
  'import.its_ok_to_close_this_page':
    "It's OK to close this page or import another file. When import done, you will be notified via email.",
  'import.row_imported': '{imported} of {total} rows imported',
  'import.download_template_file': 'Download Template File',
  'import.important': 'IMPORTANT',
  'import.3_upload_the_updated_template_file_here': '3. Upload the updated template file here',
  'import.save_your_updated_template_as_.csv_or_.txt_and_you_are_ready_to_go':
    'Save your updated template and you are ready to go',
  'import.import_actions_only_insert_new_data_cannot_update_or_delete':
    'Import actions only insert new data, cannot update nor delete.',
  'import.dont_change_the_column_heading_in_the_template_file':
    'Do not change the column headings in the template file. These need to be unchanged for the important to work in the next step.',
  'priceRule.price_rule_using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your price rule. Make sure the price rule details match the column headings provided in the template.',
  'priceRule.import_price_rule': 'Import Price Rule',
  'priceRule.percent': 'Percent',
  'priceRule.purchase_type_minimum_type': 'Purchase Type Minimum Type',
  'priceRule.discount_type': 'Discount Type',
  'priceRule.does_it_last_forever': 'Does it Last Forever?',
  'priceRule.customer_type': '{customer} Type',
  'priceRule.go_to_price_rule_list': 'Go to price rule list',
  'priceRule.price_rule_successfully_imported': '{rowCount} price rule imported successfully',
  'layoutInvoice.invoice_show_empty_qty': 'Show Product with Qty 0',
  'businessFlow.input_reference_is_required': '{reference} is required',
  'businessFlow.sales_input_reference_is_required_desc':
    'Is it mandatory to fill in the {reference} when adding a {sales} transaction?',
  'businessFlow.expense_pay_later_required': 'Enable Pay Later by Default',
  'businessFlow.expense_pay_later_required_desc':
    'Should Pay Later be enabled by default for expenses?',
  'businessFlow.purchase_input_reference_is_required_desc':
    'Is it mandatory to fill in the {reference} when adding a {purchases} transaction?',
  'businessFlow.expense_input_reference_is_required_desc':
    'Is it mandatory to fill in the {reference} when adding a {expenses}?',
  'financePurchaseInvoices.purchase_price_history': 'Purchase Price History',
  'financePurchaseInvoices.purchase_price_history_of_all_vendors':
    'Purchase Price History of All {vendors}',
  'financePurchaseInvoices.this_vendor_purchase_price': 'This {vendor} purchase price',
  'financePurchaseInvoices.last_purchase_price': 'Last purchase price',
  'financePurchaseInvoices.this_vendor': 'This {vendor}',
  'financePurchaseInvoices.all_vendors': 'All {vendors}',
  'financePurchaseInvoices.failed_to_get_buy_price_history':
    'Failed to get last purchase price history',
  'financeContacts.default_term': 'Default term',
  data_exported_successfully: 'Data exported successfully',
  'import.download_template_data_example_file': 'Download example file',
  'financeTag.follow_these_steps_to_import_your_tags': 'Follow these steps to import your {tags}',
  'financeTag.1_download_your_tag_template_file': '1. Download your {tag} template file',
  'financeTag.start_by_downloading_our_tags_csv':
    'Start by downloading our contacts Excel template file. This file has the correct column headings Kledo needs to import details of your {tags}.',
  'financeTag.2_copy_your_tags_into_the_template': '2. Copy your {tags} into the template',
  'financeTag.using_excel_or_another_spreadsheet_editor':
    'Using Excel or another spreadsheet editor, fill the Kledo template with the details of your {tag}. Make sure the {tag} details match the column headings provided in the template.',
  'financeTag.import_benefit_with_update':
    'You can also use the imported file to update all your {tags}, saving time and effort over updating {tags} one by one through the browser.',
  'financeTag.a_maximum_of_1000_tags_can_be_imported_at_a_time':
    'A maximum of 1.000 {tags} can be imported at a time.',
  'financeTag.go_to_tag_list': 'Go to {tag} list',
  'financeTag.tags_successfully_imported': '{rowCount} {tags} imported successfully.',
  'financeTag.color': 'Color',
  'layoutInvoice.show_tax_percentage': 'Show Tax Percentage',
  'businessFlow.invoice_multi_currency_manual_input_required': 'Multi Currency manual is required',
  'businessFlow.invoice_multi_currency_manual_input_required_desc':
    'Is Multi Currency manual required when adding a sales transaction?',
  please_input_manual_multi_currency: 'Please input manual multi currency',
  'businessFlow.invoice_allow_negative_stock_movement':
    'Allow additional transactions that always reduce stock',
  'businessFlow.invoice_allow_negative_stock_movement_desc':
    'Is it permissible for the last few transactions to always reduce the stock of {product}?\nIt is not recommended to allow this, because it will cause the product stock to be negative.',
  'financePurchaseInvoices.follow_these_steps_to_import_your_purchase_return':
    'Follow these steps to import your purchase return',
  'financePurchaseInvoices.1_download_your_purchase_return_template_file':
    '1. Download the purchase return template file',
  'financePurchaseInvoices.start_by_downloading_our_purchase_return_csv':
    'Start by downloading the purchase return Excel template file. This file has the header fields that Kledo needs to import the details of your purchase return.',
  'financePurchaseInvoices.2_copy_your_purchase_return_into_the_template':
    '2. Copy purchase return details into template',
  'financePurchaseInvoices.purchase_return_using_excel_or_another_spreadsheet_editor':
    'Using Excel or other spreadsheet software, enter purchase return details into a template file from Kledo. Make sure the purchase return details match the header fields in the template.',
  'financePurchaseInvoices.a_maximum_of_1000_purchase_returns_can_be_imported_at_a_time':
    'A single import supports up to 3.000 rows of Excel data. Every row is counted, including purchase invoice rows and item rows.',
  'layoutInvoice.invoice_use_termin_as_amount_in_word':
    'Show the Value in Words of the Term Bill Value',
  'layoutInvoice.only_valid_for_printed_terms': 'Only valid for printed terms',
  'report.export_summary': 'Export Summary',
  'report.export_per_sales_person': 'Export Per {salesPerson}',
  'report.please_select_a_sales_person': 'Please select a {salesPerson}',
  'kledoPos.settings_title': 'Settings',
  'kledoPos.settings_driver_online': 'Driver Online',
  'kledoPos.add_online_driver': 'Add Online Driver',
  'kledoPos.edit_online_driver': 'Edit Online Driver',
  'kledoPos.discounted_product_with_title': 'Discounted {product}',
  'kledoPos.markup_product_with_title': 'Marked-up {product}',
  'kledoPos.outlet_required': 'Outlet is required',
  'kledoPos.ojol_placeholder': 'Name of Online Driver',
  'kledoPos.outlet': 'Outlet',
  'kledoPos.outlet_placeholder': 'Select Outlet',
  'kledoPos.price': 'Price',
  'kledoPos.markup': 'Markup',
  'kledoPos.discount': 'Discount',
  'kledoPos.name': 'Name',
  'kledoPos.price_type': 'Price Type',
  'kledoPos.nominal': 'Nominal',
  'kledoPos.outlets': 'Outlets',
  'kledoPos.products': 'Products',
  'kledoPos.setting_pos': 'Setting POS',
  'kledoPos.setting_pos_desc': 'Set up a POS system to support your business.',
  'kledoPos.setting_ojol': 'Online Driver',
  'kledoPos.setting_ojol_desc': 'Customize online driver services to suit your business needs.',
  'kledoPos.label_applies': 'Applies to the Following POS {subject}',
  'kledoPos.markup_': 'markup',
  'kledoPos.discount_': 'discount',
  'kledoPos.free_reward_item': 'Free — {name}',
  'kledoPos.ojek_online': 'Driver Online',
  'priceRule.per_desc': '{subject} that will get {priceType}',
  'kledoPos.discounted': 'Discounted',
  'kledoPos.outlet_product_label': 'Products displayed at this outlet',
  'kledoPos.outlet_product_category': 'Product Category',
  'kledoPos.outlet_per_product': 'Per Product',
  'kledoPos.outlet_info_title': 'Outlet Information',
  'kledoPos.outlet_users_desc': 'Users who can sign in to POS at this outlet.',
  'kledoPos.outlet_product_desc': 'Choose which {product} are shown in POS at this outlet.',
  'kledoPos.outlet_price_title': 'Outlet Pricing',
  'kledoPos.outlet_price_desc':
    'This markup or discount changes the {product} selling price in POS directly, it is not shown as a promo.',
  'kledoPos.outlet_price_remove_warning':
    '{count} custom category/{product} prices will be removed when you save with this option.',
  'kledoPos.outlet_price_other_product_rows':
    '{count} per {product} prices are also saved and take priority over category prices.',
  'kledoPos.outlet_price_other_category_rows':
    '{count} per category prices are also saved and apply to {product} without their own price.',
  'kledoPos.outlet_price_archived': 'Archived',
  'kledoPos.outlet_price_serial_not_allowed':
    '{product} with serial numbers cannot have a custom outlet price.',
  'kledoPos.outlet_price_min_one': 'Add at least 1 custom price.',
  'kledoPos.outlet_price_empty_category':
    'No categories yet. Choose a category to give it a markup or discount.',
  'kledoPos.outlet_price_empty_product':
    'No {product} yet. Choose a {product} to give it a markup or discount.',
  'kledoPos.outlet_shown_empty_category':
    'No category yet. Choose the categories shown on this outlet POS.',
  'kledoPos.outlet_shown_empty_product':
    'No {product} yet. Choose the {product} shown on this outlet POS.',
  'kledoPos.outlet_photo_title': 'Outlet Photo',
  'kledoPos.outlet_photo_upload': 'Upload photo',
  'kledoPos.outlet_photo_change': 'Change photo',
  'kledoPos.outlet_photo_hint':
    'Click or drag a file into the box. JPG/PNG, max {size} MB, max {width} × {height} px.',
  'kledoPos.outlet_users_count': '{count} people',
  'kledoPos.outlet_users_empty': 'No users yet.',
  'kledoPos.outlet_price_add_category': 'Choose a category to add',
  'kledoPos.outlet_price_add_product': 'Search {product} to add',
  'kledoPos.outlet_price_on_pos': 'Price in POS',
  'kledoPos.outlet_price_category_overridden': '{count} {product} have their own price',
  'kledoPos.outlet_price_overrides_category': 'overrides category {name}',
  'kledoPos.outlet_save_hint': 'Price changes apply in POS right after saving.',
  'kledoPos.outlet_floor_title': 'Floors & Tables',
  'kledoPos.outlet_floor_desc': 'Manage the floors and tables available at this outlet.',
  'kledoPos.all_outlet': 'All Outlet',
  'kledoPos.all_ojol': 'All Online Driver',
  'kledoPos.all_product': 'All Products',
  'financeFixedAssets.view_total': 'View Total',
  consult_now: 'Consult Now',
  direct_consultation_with_kledo_amazing_team:
    "Direct Consultation with Kledo's Amazing Team. Join the Live Now!",
  'businessFlow.invoice_order_validation_receivable':
    'Reject add order and delivery if contact receivables exceed the limit',
  'businessFlow.invoice_order_validation_receivable_desc':
    'Will ordering and shipping use the maximum contact receivables limit?',
  decline_new_sales_if_there_are_still_past_due_bill_that_have_not_been_paid:
    'Decline new sales if there are still past due bill that have not been paid',
  decline_new_sales_if_there_are_still_unpaid_past_due_bills_in_the_selected_contact:
    'Decline new sales if there are still unpaid past due bill in the selected contact?',
  customer_still_has_past_due_bills_unpaid:
    '{customer} still has past due bills unpaid, {link} for details!',
  'layoutInvoice.order_alternative': 'Order Alternative',
  'report.subtotal_value': 'Subtotal Value',
  'report.total_value': 'Total Value',
  'report.total_avg_base_price_product': 'COGS {product} Total',
  'page404.data_you_accessed_has_been_deleted_or_does_not_exist_at_all':
    'The data you accessed has been deleted or does not exist at all.',
  'financeWarehouses.qty_serial_or_production_number': 'Qty Serial / Production Numbers',
  with_serial: 'With Serial Number',
  without_serial: 'Without Serial Number',
  with_modifier: 'Has Extra',
  without_modifier: 'No Extra',
  with_serial_unique: 'Have a Unique Serial Number',
  with_serial_production: 'Has Production Serial Number',
  with_expiry_date: 'With Expiry Date',
  manage_expiry_date: 'Mana Exiry Date',
  'report.show_paid_transactions': 'Show Paid Transactions',
  'report.total_before_discount': 'Total Before Discount',
  'report.total_after_tax': 'Total After Tax',
  'report.avg_after_tax': 'Avg After Tax',
  'report.other_units': 'Other Units',
  'financeInvoices.number_2': 'No.',
  please_input_the_group_name: 'Please input the group name',
  please_input_the_value: 'Please input the {value}',
  please_select_at_least_1_group: 'Please select at least 1 group',
  please_select_at_least_1_contact: 'Please select at least 1 contact',
  please_select_at_least_1_category: 'Please select at least 1 category',
  please_select_at_least_1_product: 'Please select at least 1 product',
  'report.total_payment_and_witholding': 'Total Payment & Witholding',
  'report.per_week': 'Per Week',
  select_custom_column: 'Select custome field',
  'notification.live_webinar_event_notification': 'Live webinar event notification',
  'notification.error_cannot_update': 'Cannot change notification.',
  'financeInvoices.join_invoice': 'Join Invoice',
  'financeInvoices.join_purchase_invoice': 'Join Purchase Invoice',
  'financeInvoices.edit_join_invoice': 'Edit Joined Invoice',
  'financeInvoices.edit_join_purchase_invoice': 'Edit Joined Purchase Invoice',
  'financeInvoices.sales_invoice': 'Sales Invoice',
  'financeInvoices.amount_billed': 'Amount Billed',
  'financeInvoices.remaining_billed': 'Remaining Billed',
  'financeInvoices.remaining_billed_total': 'Total Remaining Billed',
  'financeInvoices.date_cannot_be_earlier_than_item_date':
    'Transaction date cannot be earlier than invoice date.',
  'financeInvoices.proforma': 'Proforma',
  'financeInvoices.create_proforma_invoice': 'Create Proforma Invoice',
  'financeInvoices.edit_proforma_invoice': 'Edit Proforma Invoice',
  'financeInvoices.print_proforma': 'Print Proforma',
  'financeInvoices.proforma_invoice': 'Proforma Invoice',
  'financeInvoices.combined_invoice': 'Join Invoice',
  'financeInvoices.print_join_invoice': 'Print Join Invoice',
  'financeInvoices.master_invoice': 'Master Invoice',
  'financeInvoices.merged_invoice_title': 'This invoice has been merged',
  'financeInvoices.merged_invoice_description':
    'The invoice has been merged with another invoice on {date}',
  'financeInvoices.view_invoice': 'View invoice',
  'financeInvoices.related_invoice_tag': 'Merged invoice',
  'financeOrder.there_is_still_0_data': 'The total data you entered is still 0',
  'financeOrder.are_you_sure_you_want_to_continue': 'Are you sure you want to continue?',
  'layoutInvoice.invoice_show_sale_price': 'Show Selling Price',
  'financeInvoices.export_coretax': 'Export Coretax',
  'layoutInvoice.invoice_show_remaining_credit_memo':
    'Show Remaining Credit Memo & Total Credit Memo',
  'report.less_than_1_month': 'Less Than 1 Month',
  'report.less_than_1_week': 'Less Than 1 Week',
  'report.until_less_than_equal_months': '{firstMonth} Until ≤ {secondMonth} Months',
  'report.until_less_than_equal_weeks': '{firstWeek} Until ≤ {secondWeek} Weeks',
  'report.more_than_months': 'More Than {month} Months',
  'report.more_than_weeks': 'More Than {week} Weeks',
  'report.more_than_now_date': 'More Than {now}',
  'layoutInvoice.invoice_show_dpp': 'Show Tax Base',
  'dueReminder.send_reminder_to_customers_who_have_invoices_due':
    'Send reminder to customers who have {transType} due',
  'dueReminder.send_reminder': 'Send reminder',
  'dueReminder.section_schedule': 'Delivery Schedule',
  'dueReminder.section_schedule_hint': 'Set when reminders are sent relative to the due date.',
  'dueReminder.section_channel': 'Delivery Channel',
  'dueReminder.section_channel_hint': 'Choose where and through which channels reminders are sent.',
  'dueReminder.section_group': 'Recipient Contact Groups',
  'dueReminder.section_group_hint':
    'Choose additional contact groups that also receive the reminder email.',
  'dueReminder.module_desc':
    'Automatically send email or WhatsApp to {customer} when {transType} are approaching or past the due date, so payments are never missed.',
  'dueReminder.send_before_due': 'Send before due date',
  'dueReminder.send_before_due_desc': 'Remind {customer} ahead of the due date.',
  'dueReminder.send_after_due': 'Send after due date',
  'dueReminder.send_after_due_desc': 'Follow up on {transType} that are past due.',
  'dueReminder.count_days': '{count} days',
  'dueReminder.before': 'before',
  'dueReminder.after': 'after',
  'dueReminder.send_consecutive': 'Send on consecutive days',
  'dueReminder.send_consecutive_desc_on': 'Reminders are sent every day until the due date.',
  'dueReminder.send_consecutive_desc_off':
    'Reminders are sent only on the boundary day and the due date.',
  'dueReminder.email_to_customer': 'Email to {customer}',
  'dueReminder.email_to_customer_desc': 'Send reminders directly to the {customer} email address.',
  'dueReminder.email_to_admin': 'Email to admin',
  'dueReminder.email_to_admin_desc': 'Copy reminders to the admin email as an internal archive.',
  'dueReminder.whatsapp_to_customer': 'WhatsApp to {customer}',
  'dueReminder.whatsapp_to_customer_desc':
    'Send reminders via WhatsApp. Uses your WhatsApp message quota.',
  'dueReminder.whatsapp_balance_left': '{count} messages left',
  'dueReminder.active': 'Active',
  'dueReminder.inactive': 'Inactive',
  'dueReminder.group_name': 'Group Name',
  'dueReminder.receive': 'Receive',
  'dueReminder.setting_menu': 'Set Due Reminder',
  'billing.whatsapp_balance': 'Whatsapp Balance',
  'billing.whatsapp_title': 'Whatsapp Billing',
  'billing.balance_history': 'Balance History',
  'billing.whatsapp_status': 'Status',
  'billing.whatsapp_filter_status': 'Filter status',
  'billing.whatsapp_status_processing': 'Processing',
  'billing.whatsapp_status_sent': 'Sent',
  'billing.whatsapp_status_delivered': 'Delivered',
  'billing.whatsapp_status_read': 'Read',
  'billing.whatsapp_status_replied': 'Replied',
  'billing.whatsapp_status_failed': 'Failed',
  'billing.whatsapp_contact': 'Contact: {name}',
  'billing.whatsapp_addon': 'Whatsapp Addon',
  'dueReminder.top_up_whatsapp_balance': 'Top Up Whatsapp Balance',
  'dueReminder.out_of_whatsapp_balance_desc':
    'To be able to send reminders via WhatsApp, please top up your WhatsApp balance first.',
  'massWhatsapp.mass_whatsapp': 'Mass Send Whatsapp',
  'massWhatsapp.cannot_be_sent': 'Whatsapp mass data cannot be sent',
  'massWhatsapp.are_you_sure': 'Are you sure want to sent {count} {title}(s) Whatsapp?',
  'massWhatsapp.data_has_been_sent': 'Total {count} Whatsapp has been sent',
  'massWhatsapp.out_of_whatsapp_balance_desc':
    'Please top up your WhatsApp balance first to be able to send WhatsApp messages in bulk.',
  'whatsappModal.out_of_whatsapp_balance_desc':
    'To be able to send reminders via WhatsApp, please top up your WhatsApp balance first. Or you can also send using Personal WhatsApp for free delivery.',
  'report.cashier': 'Cashier',
  'report.cashier_open_close_time': 'Cashier Open / Close Time',
  'report.initial_capital_with_currency': 'Initial Capital (Rp)',
  'report.initial_capital': 'Initial Capital',
  'report.actual_cash_total': 'Actual Cash Total (Rp)',
  'report.total_non_cash_income': 'Total Non-Cash Income (Rp)',
  'report.cash': 'Cash',
  'report.cash_refund': 'Cash Refund',
  'report.cash_payment': 'Cash Payment',
  'report.total_revenue': 'Total Revenue',
  'report.cashless': 'Cashless',
  'report.edc_payment': 'EDC Payment',
  'report.transfer_payment': 'Transfer Payment',
  'report.deposit_payment': 'Deposit Payment',
  'report.total_non_cash_revenue': 'Total Non-Cash Revenue',
  'report.pos_unpaid': 'Unpaid',
  'report.products_sold': 'Products Sold',
  'report.total_sold': 'Total Sold',
  'report.overall_total': 'Overall Total',
  'report.total_entered': 'Total Entered',
  'report.total_expected': 'Total Expected',
  'report.open_time': 'Open Time',
  'report.close_time': 'Close Time',
  'report.payment_type': 'Payment Type',
  'report.deposit_transaction_amount': 'Deposit Transaction Amount',
  'report.deposit_sales': 'Deposit Sales',
  'report.total_transactions_paid': 'Total Transactions Paid',
  'report.total_transactions_paid_help_text':
    'Only show the total transaction of all transactions that have been paid.',
  'report.total_sales_paid': 'Total Sales Paid',
  'report.total_sales_paid_help_text':
    'Only displays total sales from all transactions that have been paid.',
  'report.total_payment_types': 'Total Payment Types',
  'report.total_deposit_transactions': 'Total Deposit Transactions',
  'report.total_deposit_transactions_help_text':
    'Only displays the total deposit transactions that have been paid',
  'report.total_sales_deposit': 'Total Sales Deposit',
  'report.total_sales_deposit_help_text':
    'Only displays the total sales of deposits that have been paid',
  'report.pos_closing_balance': 'Closing Balance (Rp)',
  'report.payment_method': 'Payment Method',
  'report.cash_movement_physical': 'Cash Movement (Physical)',
  'report.cash_reconciliation': 'Cash Reconciliation',
  'report.total_omzet': 'Total Sales',
  'report.sales_transaction_completed': 'Completed Transactions',
  'report.pos_unpaid_currency': 'Unpaid (Rp.)',
  'report.non_cash_payment': 'Non-Cash Payment',
  'report.total_non_cash': 'Total Non-Cash',
  'report.received_cash': 'Received Cash',
  'report.cash_in_drawer': 'Cash in Drawer (Expected Cash)',
  'report.actual_cash_counted': 'Actual Cash Counted',
  'report.expected_cash': 'Expected Cash',
  'report.cash_difference': 'Cash Difference',
  'report.status_more': 'MORE',
  'report.status_less': 'LESS',
  'report.status_matched': 'MATCHED',
  'report.cash_movement_formula':
    'Formula: Opening Balance + Cash In + Received Cash − Cash Out − Cash Refund',
  'report.cash_reconciliation_formula': 'Formula: Difference = Actual Cash Counted − Expected Cash',
  'report.not_available': 'Not available',
  'report.unfinished_transactions': 'Unfinished Transactions',
  'report.unpaid_invoice_count': 'Unpaid Invoices',
  'report.unpaid_invoice_amount': 'Remaining Unpaid Amount',
  'report.unpaid_invoices': 'Unpaid Invoices',
  'report.open_orders': 'Open Orders',
  'report.voided_transactions': 'Voided Transactions',
  'report.voided_transactions_help':
    'Invoices paid during this shift and then voided. Their amounts are not counted in revenue, total payment, or cash.',
  'report.transaction_has_been_voided': 'Transaction has been voided',
  'report.no_voided_transactions': 'No voided transactions.',
  'report.cash_reconciliation_legend': '(−) = Less     (+) = More',
  'report.vendor_name': '{vendor} Name',
  'errors.1_transaction_draft':
    'To use draft transaction feature, consider deleting your draft transaction and try again.',
  'errors.2_transaction_draft':
    'If the problem persists, consider clearing your browser cache and cookies.',
  'errors.3_transaction_draft':
    "Or ignore this message if you don't want to use the draft transaction feature.",
  'report.order_date': 'Order Date',
  'report.transaction_time': 'Transaction Time',
  'report.pos_order_date': 'POS Order Date',
  'report.hour_from': 'From Hour',
  'report.hour_to': 'To Hour',
  'report.hour_to_must_be_after_hour_from': 'To hour must be after from hour',
  'report.payment_date': 'Payment Date',
  'report.order_type': 'Order Type',
  'report.total_sales': 'Total Sales',
  'report.pos_net_sales': 'Net Sales',
  'report.pos_net_sales_help': 'Total Sales - Total Returns',
  'report.total_payment': 'Total Payment',
  'report.total_receivables': 'Total Receivables',
  'report.not_yet_paid_off': 'Not Yet Paid Off',
  'report.paid_off': 'Paid Off',
  'report.minimum_sales': 'Minimum Sales',
  'report.maximum_sales': 'Maximum Sales',
  'report.minimum_gross_sales': 'Minimum Gross Sales',
  'report.maximum_gross_sales': 'Maximum Gross Sales',
  'report.price_type': 'Price Type',
  'report.pos_total_price': 'Total Price',
  'report.order_details': 'Order Details',
  'report.order_notes': 'Order Notes',
  'report.receipt_print': 'Print Receipt',
  'report.invoice_print': 'Print Invoice',
  'report.ordered_details': 'Ordered Details',
  'report.product_subtotal': '{product} Subtotal',
  'report.service_fee': 'Service Fee',
  'report.rounding': 'Rounding',
  'report.administration_costs': 'Administration Costs',
  'report.payment_details': 'Payment Details',
  'report.return': 'Return',
  'report.served_by': 'Served By',
  'report.table_name': 'Table Name',
  'report.pos_order_number': 'Order Number',
  'report.points_earned': 'Points Earned',
  'report.transaction_reference': 'Transaction {reference}',
  'pos.total_sales_orders': 'Total Sales Orders',
  'pos.total_unprocessed': 'Total Unprocessed',
  'pos.total_completed': 'Total Completed',
  'pos.customer_name': '{customer} Name',
  'pos.partially_sent': 'Partially Sent',
  'pos.unprocessed': 'Unprocessed',
  'posSalesOrders.full_address': 'Full Address',
  'posSalesOrders.shipping_address_same_with_billing_address':
    'My Billing Address is the same as my shipping address',
  'posSalesOrders.example': 'Example',
  'posSalesOrders.please_select_outlet': 'Please select outlet',
  'financeInvoices.payment_account': 'Cash & Bank Payment',
  'financeInvoices.no_payment_account': 'No payment yet',
  'financeInvoices.contact_bank_account': '{something} Bank Account',
  'financeInvoices.contact_bank_account_number': '{something} Bank Account Number',
  'financeInvoices.contact_bank_account_number_placeholder': 'Account Number',
  'businessFlow.invoice_delivery_expedition_required': 'Expedition is required',
  'businessFlow.invoice_delivery_expedition_required_desc':
    'Is it mandatory to fill in the expedition when adding a sales transaction?',
  'report.consolidation_balance_sheet_modal_detail': '{accountName} Detail',
  'report.coa_account': 'COA Account',
  'layoutInvoice.invoice_show_ref_order': 'Show Order Number',
  'layoutInvoice.invoice_show_ref_quote': 'Show Quote Number',
  'layoutInvoice.invoice_show_barcode': 'Show Barcode',
  'layoutInvoice.invoice_show_payment_connect_barcode': 'Show Payment Connect QR Code',
  'layoutInvoice.change_payment_connect_barcode_size': 'Change QR code size',
  change_password: 'Change Password',
  update_your_current_password: 'Update your current password.',
  upload_new_image: 'Upload New Image',
  update_your_profile_data: 'Update your profile data.',
  enable_two_factor_authentication: 'Enable two-factor authentication',
  two_factor_authentication: 'Two-Factor Authentication',
  enable_two_factor_authentication_desc:
    'Strengthen your account security by enabling two-step verification (2FA).',
  setup_authenticator_app: 'Setup Authenticator App',
  download_and_install_aplication_like_google_authenticator:
    'Download and install applications like {googleAuthenticator}, {authy}, {microsoftAuthenticator}, or other applications on your phone. This application will generate a one-time password that will be used as two-factor authentication to verify your identity when you log in.',
  scan_qr_code: 'Scan QR Code',
  scan_qr_code_below_with_your_authenticator_app:
    'Scan the QR code below with your Authenticator app.',
  or_you_can_manually_add_the_code_below: 'Or you can manually add the code below',
  your_password: 'Your Password',
  enter_your_password_to_register_two_factor_authentication:
    'Enter your current password to register two-factor authentication',
  enter_the_code_generated_by_your_authenticator_app:
    'Enter the code generated by your Authenticator app',
  verification_code: 'Verification Code',
  enter_the_verification_code_that_was_generated_in_the_two_factor_authentication_application:
    'Enter the verification code that was generated in the two-factor authentication application.',
  process_two_factor_authentication: 'Process Two-Factor Authentication',
  please_input_your_password: 'Please input your password',
  please_input_the_verification_code: 'Please input the verification code',
  code_has_been_copied: 'Code has been copied',
  download_recovery_code: 'Download Recovery Codes',
  use_recovery_code_as_two_factor_authentication_methode:
    'Use recovery codes as two-factor authentication method, if your phone or two-factor authentication application is not accessible. Each recovery code can only be used once for login.',
  please_download_print_or_copy_the_code_below:
    'Please download, print or copy the code below first.',
  download_code: 'Download Code',
  print_code: 'Print Code',
  copy_code: 'Copy Code',
  your_current_password: 'Your Current Password',
  disable_two_factor_authentication: 'Disable Two-Factor Authentication',
  yes_disabled: 'Yes, Disable',
  are_you_sure_to_disabled_two_factor_authentication:
    'Are you sure to disabled Two-Factor Authentication? Your account will lose extra security layer.',
  please_input_your_password_to_continue: 'Please input your password to continue.',
  enter_verification_code_from_authentication_app:
    'Enter the verification code from the two-factor authentication application. ',
  if_you_cannot_access_the_application: 'If you cannot access the application, {recoveryModeLink}.',
  use_recovery_code: 'use recovery code',
  verify_code: 'Verify Code',
  continue_with_otp: 'Continue with OTP',
  enter_your_email_so_we_can_send_you_the_otp_code_for_the_login_process:
    'Enter your email so we can send you the OTP code for the login process.',
  send_otp_code: 'Send OTP Code',
  otp_has_been_sent_to_your_email:
    'The OTP code has been sent to your email {email}. Check your email and enter the code to complete the login process.',
  not_received_otp_code: 'Not received OTP code?',
  resend_code: 'Resend Code',
  enter_kledo: 'Enter Kledo',
  recovery_code: 'Recovery Code',
  enter_the_recovery_code: 'Enter the recovery code',
  please_input_the_recovery_code: 'Please input the recovery code',
  use_verification_code: 'Use verification code',
  otp_has_been_resent_to_your_via_registered_channel:
    'The OTP code has been resent to your registered {channel}.',
  product_and_serial_number: 'Product and Serial Number',
  'financeClosing.product_stock_validation': 'Product Stock Validation',
  'financeClosing.please_wait_product_stock_validation':
    'Please wait, product stock validation is being carried out',
  'financeClosing.product_stock_validation_desc':
    'The following {product} have negative stock, please make stock adjustments first:',
  'financeExpenseTerms.active_in': 'Active In',
  'financeExpenses.reference_is_required': '{reference} is required',
  'financeExpenseTerms.please_enable_one_of_the_options': 'Please enable one of the options',
  'financeExpenseTerms.enable_in_sales': 'Enable in Sales',
  'financeExpenseTerms.enable_in_purchase': 'Enable in Purchase',
  'financeExpenseTerms.enable_in_expense': 'Enable in Expense',
  'financeExpenseTerms.enable_in_contact': 'Enable in Contact',
  'layoutInvoice.add_default_message': 'Add Default Message',
  'layoutInvoice.delete_default_message_confirmation': 'Delete Default Message',
  'layoutInvoice.delete_default_message_confirmation_desc':
    'Are you sure to delete this default message?',
  'layoutInvoice.set_as_default': 'Set as Default',
  'layoutInvoice.rename_default_message': 'Rename',
  'layoutInvoice.rename_default_message_title': 'Rename Default Message',
  'layoutInvoice.default_message_name': 'Default message name',
  'layoutInvoice.select_default_message': 'Select Default Message',
  'billing.edit_tax_number': 'Edit Tax Number',
  'billing.yes_correct': 'Yes, Correct',
  'billing.tax_number': 'Tax Number',
  'billing.tax_number_min_length': 'Tax number must be at least 15 characters',
  'billing.tax_number_max_length': 'Tax number maximum 16 characters',
  'billing.company_name_is_required': 'Company Name is required',
  'billing.company_name_min_length': 'Company Name must be at least 10 characters',
  'billing.tax_number_is_required': 'Tax Number is required',
  'billing.tax_number_is_number': 'Tax Number must be a number',
  'billing.address_is_required': 'Address is required',
  'billing.address_min_length': 'Address must be at least 20 characters',
  'billing.tax_invoice_is_correct': 'Is the data above correct?',
  'billing.tax_number_successfully_saved': 'Tax Number successfully saved',
  'billing.tax_number_successfully_saved_desc_1':
    'Please wait a maximum of 2 working days for the verification process from the Kledo Great Team.',
  'billing.tax_number_successfully_saved_desc_2':
    'Tax invoice can be downloaded on this page within 15 days after payment.',
  'billing.tax_invoice_approve_desc_1':
    'Tax invoices can be downloaded on this page a maximum of 15 days after payment.',
  'billing.tax_invoice_approve_desc_2':
    'Here is your company tax number data, make sure the data is correct and accurate. The generated Tax Invoice cannot be changed back',
  'billing.tax_invoice_waiting_approval_desc_1':
    'Your tax number data is still waiting for the verification process by the Kledo Great Team.',
  'billing.tax_invoice_waiting_approval_desc_2':
    'Please wait max. 2 working days for this verification process.',
  'billing.tax_invoice_waiting_approval_desc_3': 'Thank you.',
  'billing.tax_invoice_rejected_desc_1': 'Your tax number data is invalid:',
  'billing.tax_invoice_rejected_desc_2':
    'Please update your data to be able to download your tax invoice.',
  'billing.taxt_invoice_step_1_desc':
    'To be able to download tax invoices, please enter your company tax number data. Make sure the data entered is correct and accurate.',
  'billing.taxt_invoice_step_2_desc':
    'Please make sure that the tax number data you entered is correct.',
  'billing.taxt_invoice_step_1_and_2_desc':
    'Invoices that have been generated cannot be changed again.',
  'billing.tax_invoice_hooray': 'Hooray!!',
  'financeContacts.hide': 'Hide',
  'report.period_type': 'Period Type',
  'financeFixedAssets.please_enter_year_or_month': 'Please enter year or month',
  'financeFixedAssets.asset_upgrade': 'Asset Upgrade',
  'financeFixedAssets.upgrade_date': 'Upgrade Date',
  'financeFixedAssets.add_fixed_asset_upgrade': 'Add Fixed Asset Upgrade',
  'financeFixedAssets.edit_fixed_asset_upgrade': 'Edit Fixed Asset Upgrade',
  'financeFixedAssets.fixed_asset_upgrade': 'Asset Upgrade',
  message_required: 'Message is required',
  'report.re_export': 'Re-Export',
  'report.download_or_download': 'Download',
  'financeLockDate.input_lock_date_help_1':
    'The lock date cannot be set to a date before the last closing.',
  'financeLockDate.input_lock_date_help_2':
    'All depreciable fixed assets must have been depreciated in advance on the specified lock-in date.',
  'financeLockDate.delete_lock_date_desc': 'The lock date cannot be removed if there is a closing.',
  'massReconcile.mass_reconcile': 'Mass Reconcile',
  'massReconcile.cannot_mass_reconcile': 'Unable to reconcile mass',
  'businessFlow.unique_product_name': 'Unique {product} name',
  'businessFlow.unique_product_name_desc': 'Does the {product} name have to be unique?',
  'financeProduct.name_is_used': '{product} name has been used',
  'financeProduct.fail_check_unique_product_name': '{product} unique name check failed',
  'users.roles_help_text':
    'Your account has reached the user limit. You can only add users for POS.',
  'report.total_payment_debt': 'Total Payment + Debt',
  'report.total_payment_receivables': 'Total Payments + Receivables',
  'businessFlow.sale_price_disabled': "{product} price can't changed",
  'businessFlow.sale_price_disabled_desc':
    'If active, the {product} price when adding invoice, order and quote cannot be changed.',
  'report.actual_budget': 'Actual Budget',
  'report.profit_and_loss_budget': 'Profit and Loss Budget',
  'report.actual_loss': 'Actual Loss',
  'report.realized_loss': 'Realized Loss',
  'report.actual_profit': 'Actual Profit',
  'report.realized_profit': 'Realized Profit',
  duplicate_to_transaction: 'Duplicate to Transaction',
  'report.current_rate': 'Current Rate',
  'report.balance_in_rupiah': 'Balance in Rupiah',
  'report.revaluation_of_accounts_in_foreign_currency':
    'Revaluation of Accounts in Foreign Currency',
  'report.total_revaluation': 'Total Revaluation',
  'report.total_cash_and_cash_equivalents': 'Total Cash and cash equivalents',
  'report.cash_and_cash_equivalents_as_of_date': 'Cash and cash equivalents as of {date}',
  'layoutInvoice.invoice_show_qty_not_send': 'Show Remaining {product} Not Yet Send',
  'financeWarehouses.include_all_tracked': 'Only {products} found in this warehouse',
  'report.cost': 'Cost',
  'financeFixedAssets.total_cost_limit': 'Total Cost Limit',
  'financeWareHouses.data_progress_processed': '{count} data from total {total} has been processed',
  please_select_invoice: 'Please select invoice',
  please_select_purchase_invoice: 'Please select purchase invoice',
  purchase_invoice: 'Purchase Invoice',
  minimal_2_invoice: 'Minimal two invoice',
  same_currency_required: 'All invoices must have the same currency',
  edit_join_invoice: 'Edit Join Invoice',
  paid_invoice_cannot_be_edited: 'Paid invoice cannot be edited',
  'layoutInvoice.invoice_show_cost_production': 'Show Production Costs',
  'layoutInvoice.invoice_show_cost_per_unit': 'Show Cost per Unit',
  mass_duplicate_to: 'Duplicate to {title}',
  mass_duplicate_selected_transactions: '{count} transactions selected',
  mass_duplicate_items_copied: 'Will be copied',
  mass_duplicate_items_skipped: 'Skipped',
  mass_duplicate_items_skipped_hint: 'Product is not marked as purchasable',
  mass_duplicate_trans_without_purchase: 'Transactions without purchasable products',
  mass_duplicate_skipped_products: 'Skipped products',
  mass_duplicate_rule_header:
    'Date, due date, tags and other details follow the first transaction. Shipping date is set to today.',
  mass_duplicate_rule_items:
    'Items from all transactions are combined, only products marked as purchasable.',
  show_less: 'Show less',
  ok_continue: 'OK, Continue',
  'import.import_note':
    'The import process is ongoing and may take some time. During the import process, General Ledger, Bank Balance and Stock data will change and there may be temporary data discrepancies. Please wait until the import process is complete to check the data again.',
  order_type: 'Order Type',
  'financeProduct.update_duplicate_sku': 'Update Duplicate SKU',
  'financeFixedAssets.total_asset_upgrade': 'Total Asset Upgrade',
  'financeFixedAssets.acquisition_cost': 'Acquisition Cost',
  'financeInvoices.payment_amount': 'Payment Amount',
  'financeInvoices.payment_reference': 'Payment {reference}',
  'financeOrders.down_payment_amount': 'Down Payment Amount',
  'financeOrders.down_payment_amount_percent': 'Down Payment Amount (%)',
  'financeOrders.down_payment_account_code': 'Down Payment Account Code',
  'financeInvoices.shipping_receipt_number': 'Shipping Receipt Number',
  'financeInvoices.product_description': '{product} Description',
  'financeInvoices.product_unit': '{product} Unit',
  'financeInvoices.product_discount': '{product} Discount',
  'financeInvoices.payment_account_code': 'Payment Account Code',
  create_join_invoice: 'Create Join Invoice',
  'layoutInvoice.invoice_show_detail_return': 'Show Return Details',
  automatic_depreciation_history: 'Automatic Depreciation History',
  'layoutInvoice.invoice_show_product_serial_number': 'Show {product} Serial Number',
  'billing.hris_champion': 'Champion Package',
  'financeContacts.input_that_appears_when_adding_a_contact':
    'Input that appears when adding a contact',
  'businessFlow.npwp_contact_required': 'Tax number is required',
  'businessFlow.npwp_contact_required_desc':
    'Does there need to be a tax number when adding and modifying contacts?',
  'financeContacts.please_input_a_npwp': 'Please input a tax number.',
  'businessFlow.phone_contact_required': 'Phone is required',
  'businessFlow.phone_contact_required_desc':
    'Does there need to be a phone number when adding and modifying contacts?',
  'businessFlow.address_contact_required': 'Address is required',
  'businessFlow.address_contact_required_desc':
    'Does there need to be a billing address when adding and modifying contacts?',
  'businessFlow.photo_contact_required': 'Photo is required',
  'businessFlow.photo_contact_required_desc':
    "Does there need to be a photo when adding contacts? The contact's last photo also cannot be deleted.",
  'businessFlow.contact_required_disabled_tooltip':
    'To enable this, make sure the "{field}" input is enabled in the "Input that appears when adding a contact" setting.',
  'financeContacts.phone_is_required': 'Contact phone is required.',
  'financeContacts.address_is_required': 'Contact address is required.',
  'financeContacts.photo_is_required': 'Contact photo is required.',
  'businessFlow.restore_settings_to_default': 'Restore settings to default',
  preparing_export_process: 'Preparing export process',
  'report.company_bank': 'Company Bank',
  'report.customer_bank': '{customer} Bank',
  'report.account_holder': 'Account Holder',
  maks_n_caracters: 'Maximum {n} characters',
  company_name_can_not_be_all_capital: 'Name cannot be all capital',
  company_name_can_not_contain_offensive_words: 'Name cannot contain offensive words',
  'businessFlow.invoice_allow_duplicate_product': 'Allow duplicate product in sales item',
  'businessFlow.invoice_allow_duplicate_product_desc':
    'Allow the same product to be added more than once in a sales transaction.',
  'businessFlow.purchase_invoice_allow_duplicate_product':
    'Allow duplicate product in purchase item',
  'businessFlow.purchase_invoice_allow_duplicate_product_desc':
    'Allow the same product to be added more than once in a purchase transaction.',
  product_already_exists: 'This product already exists in the item list!',
  preparing_approval_process: 'Preparing approval process',
  preparing_rejection_process: 'Preparing rejection process',
  preparing_reconciliation_process: 'Preparing reconciliation process',
  preparing_payment_process: 'Preparing payment process',
  preparing_import_process: 'Preparing import process',
  preparing_create_trans_process: 'Preparing create trans process',
  preparing_delete_process: 'Preparing delete process',
  preparing_mass_print_process: 'Preparing mass print process',
  preparing_mass_edit_process: 'Preparing mass edit process',
  'report.balance_receivable_termin_detail': 'Detail {title}',
  'report.invoice_age': 'Invoice Age',
  'report.invoice_age_to_due_date': 'Invoice Age to Due Date',
  'layoutInvoice.invoice_show_stock_count_recorded_qty': 'Show Recorded Qty',
  'layoutInvoice.invoice_show_stock_count_diff_qty': 'Showing Difference',
  'layoutInvoice.show_pic': 'Show Person in Charge',
  'layoutInvoice.show_counted_by': 'Show Counted By',
  please_select_data_to_format: 'Please select data to format',
  'financeWareHouses.mass_delete_transaction_before_lock_date_and_related_cannot_be_deleted':
    '**Transaction before lock date and transaction that has relation to another transaction cannot be deleted',
  cashier: 'Cashier',
  all: 'All',
  order_details: 'Order Details',
  remove_all: 'Remove All',
  order_details_empty: 'No order yet',
  save_to_order: 'Save to Order',
  quantity_cannot_be_negative: 'Qty cannot be negative',
  remove_all_items: 'Remove All Items',
  are_you_sure_to_remove_all_items: 'Are you sure to remove all items?',
  'slackConnect.hash_tag': '#SlackIntegration',
  'slackConnect.head_title_1': 'Receive',
  'slackConnect.head_title_2': 'Notifications of Every Transaction',
  'slackConnect.head_title_3': 'Directly in Your Slack',
  'slackConnect.head_desc_1':
    'By integrating Kledo and Slack, every financial transaction will be sent directly to the Slack channel of your choice, ensuring your team always gets the latest information without having to open another application.',
  'slackConnect.footer_note':
    'Get full transparency in every financial transaction in a practical and free way with the Kledo and Slack integration now.',
  'slackConnect.feat_title_1': 'What Will',
  'slackConnect.feat_title_2': 'You Get',
  'slackConnect.feat_title_3': 'from Kledo and Slack Integration?',
  'slackConnect.feat_1_sub_title': 'Real-Time Transaction Notifications in Slack',
  'slackConnect.feat_1_description':
    'Every transaction detail that occurs in Kledo POS, invoices, payments, and receipts are automatically sent directly to the Slack channel. Financial management is more organized and easily accessible.',
  'slackConnect.feat_2_sub_title': 'Better Financial Transparency',
  'slackConnect.feat_2_description':
    'Kledo and Slack integration provides full visibility into all financial transactions. Every update is sent directly to Slack, making it easy for teams to monitor every detail without any hassle.',
  'slackConnect.feat_3_sub_title': 'More Efficient Team Collaboration',
  'slackConnect.feat_3_description':
    'Discuss financial reports, ask questions, or validate transactions directly from Slack. This integration allows for faster and more organized communication between team members.',
  'slackConnect.feat_4_sub_title': 'Accessible Anywhere',
  'slackConnect.feat_4_description':
    'You to get access to every transaction information as detailed as possible, anytime and anywhere. Ensure your business continues to run smoothly even though the team works from different locations.',
  'slackConnect.feat_5_sub_title': 'Data Security Guaranteed',
  'slackConnect.feat_5_description':
    'With integration, your transaction and financial data is stored securely and can only be accessed by authorized team members. We have industry-standard security to protect all your critical data.',
  'slackConnect.feat_6_sub_title': 'Free for All Users',
  'slackConnect.feat_6_description':
    'Kledo and Slack integration is free to use. You can start optimizing financial management and better transaction monitoring at no additional cost.',
  'slackConnect.integrate_slack': 'Integrate Slack',
  'slackConnect.integration_success': 'Hooray, successfully integrating Slack and Kledo',
  'slackConnect.back_to_slack_connect_settings': 'To Slack Connect Settings',
  'slackConnect.choose_slack_channel_to_integrate_with_kledo':
    'Please select the Slack channel that will be integrated with Kledo:',
  'slackConnect.select_slack_channel': 'Select a Slack channel',
  'slackConnect.click_to_integrate_with_slack':
    'Click the button below to integrate Slack with Kledo',
  'slackConnect.help_text_integration':
    'You will be redirected to the Slack website, and please fill out the form on the Slack website. Once completed, you will be redirected back to this page.',
  'slackConnect.follow_the_tutorial':
    'Please follow the video tutorial below for more information:',
  'slackConnect.how_to_integrate_kledo_api': 'How to Integrate Kledo API',
  'slackConnect.default_send_slack_notification_to_channel':
    'Default send Slack notification to channel',
  'slackConnect.send_notification_every_new_invoice_at_pos':
    'Send notification every time there is a new invoice at POS',
  'slackConnect.new_invoice': 'New Invoice',
  'slackConnect.daily_report': 'Daily Report',
  'slackConnect.pos_daily_sales_report': 'POS daily sales report',
  'slackConnect.successfully_updated_default_channel': 'Successfully updated default channel',
  'slackConnect.notification_options_updated_successfully':
    'Notification options updated successfully',
  'slackConnect.successfully_updated_slack_notification':
    'Successfully updated Slack notifications',
  'slackConnect.failed_to_updated_slack_notification': 'Failed to update Slack notifications',
  'slackConnect.add_channel': 'Add Channel',
  'slackConnect.channel_name': 'Channel Name',
  'slackConnect.channel_name_is_required': 'Channel name is required',
  'slackConnect.max_length_channel_name': 'Channel names can’t be longer than 80 characters.',
  'slackConnect.use_valid_characters':
    'Channel name can’t contain spaces or punctuation. Use dashes to separate words.',
  'slackConnect.channel_name_already_taken':
    'The name is already taken by a channel, username, or user group in your Slack workspace.',
  'layoutInvoice.invoice_show_ref_number': 'Show Number',
  'financeProduct.zero_price':
    'This stock movement has no price because this stock movement is the result of the movement of package product stock, one of the items of which is this product.',
  'export.error_cannot_export_data': 'Data cannot be exported',
  'export.mode.label': 'Export mode',
  'export.mode.expanded': 'Per product',
  'export.mode.expanded_desc': '(1 row per product)',
  'export.mode.compact': 'Per transaction',
  'export.mode.compact_desc': '(1 row per transaction, totals can be summed directly in Excel)',
  'export.mode.compact_warning':
    'The exported file from this mode cannot be reused as an import template.',
  'businessFlow.country_is_required': 'Country is required',
  'businessFlow.province_is_required': 'Province is required',
  'businessFlow.city_is_required': 'City is required',
  'businessFlow.district_is_required': 'District is required',
  'settings.slack_connect': 'Get transaction notifications in your Office Slack',
  'discordConnect.main_webhook': 'Main Webhook',
  'discordConnect.main_webhook_url': 'Main Webhook URL',
  'discordConnect.main_webhook_desc': 'Default webhook URL for all Discord notifications',
  'discordConnect.copy_webhook_info':
    'Please copy your Discord webhook link and add it in Kledo to perform integration',
  'discordConnect.tutorial_title': 'Discord Connect Tutorial',
  'discordConnect.click_here': 'Click here',
  'discordConnect.tutorial_description':
    'for details on how to set up Discord integration in Kledo',
  'discordConnect.link_webhook': 'Link Webhook',
  'discordConnect.unlink_webhook': 'Unlink Webhook',
  'discordConnect.show_webhook': 'Show Webhook',
  'discordConnect.hide_webhook': 'Hide Webhook',
  'discordConnect.webhook_url': 'Webhook URL',
  'discordConnect.enter_webhook_url': 'Enter webhook URL',
  'discordConnect.pos_order_notification': 'POS Order Notification',
  'discordConnect.pos_daily_report_notification': 'POS Daily POS Report Notification',
  'discordConnect.pos_invoice_notification': 'POS Invoice Notification',
  'discordConnect.notification_options': 'Notification Options',
  'discordConnect.webhook_url_saved': 'Webhook URL saved successfully',
  'discordConnect.notification_options_updated_successfully':
    'Notification options updated successfully',
  'discordConnect.disconnected_successfully': 'Discord integration disconnected successfully',
  'discordConnect.disconnect': 'Disconnect Discord',
  'discordConnect.confirm_disconnect': 'Are you sure you want to disconnect Discord integration?',
  'discordConnect.webhook_url_required': 'Webhook URL is required',
  'discordConnect.webhook_url_invalid':
    'Please enter a valid Discord webhook URL (must start with https://discord.com/api/webhooks)',
  'reportsImport.detail_trans': '{trans} Import Detail',
  'report.also_show_the_paid_ones': 'Also show the paid ones',
  set_to_default: 'Set to Default',
  remove_from_default: 'Remove from Default',
  default_unit_conversion_tooltip:
    'When a unit is set as default, the unit will automatically be selected in the sales and purchase transactions. If no unit is set as default, the base unit of the product will be selected.',
  weight: 'Weight',
  product_image: '{title} Image',
  'slackConnect.order_notification': 'Order Notification',
  'slackConnect.configure_notifications_for_order_events_at_pos':
    'Configure notifications for order events at POS',
  'slackConnect.add_order': 'Add Order',
  'slackConnect.add_order_desc': 'Send notification every time there is a new order at POS',
  'slackConnect.update_order': 'Update Order',
  'slackConnect.update_order_desc': 'Send notification every time an order is updated at POS',
  'slackConnect.delete_order': 'Delete Order',
  'slackConnect.delete_order_desc': 'Send notification every time an order is deleted at POS',
  'approvals.minimum_limit': 'Minimum Limit',
  'layoutReport.show_currency_symbol': 'Show Currency Symbol',
  'financeBanks.import_maybank_1': '1. Login to MayBank',
  'financeBanks.import_maybank_2': '2. Click Portfolio',
  'financeBanks.import_maybank_3': '3. Click Account Statement then Account Report',
  'financeBanks.import_maybank_4': '4. Click Account Number',
  'financeBanks.import_maybank_5': '5. Click "Search" then select Account Number',
  'financeBanks.import_maybank_6': '6. Fill in the Date then click "Search"',
  'financeBanks.import_maybank_7': '7. Select CSV then click Download',
  'financeBanks.import_maybank_8':
    '8. Go back to the Homepage then click the checkbox then “Download Select”',
  'financeBanks.import_ocbc_1': '1. Log in at https://business.ocbc.id/',
  'financeBanks.import_ocbc_2': '2. Click Account Management - Account Summary',
  'financeBanks.import_ocbc_3': '3. Scroll down',
  'financeBanks.import_ocbc_4': '4. Select the IDR currency account',
  'financeBanks.import_ocbc_5': '5. Choose the date filter, then click Export',
  'financeBanks.import_ocbc_6': '6. Fill in the file name and select CSV format, then click Export',
  'financeBanks.import_ocbc_7': '7. Click "Click Here"',
  'financeBanks.import_ocbc_8': '8. Tick the checklist, then click Download',
  'financeBanks.import_bni_1': '1. Login to BNI Direct Cash',
  'financeBanks.import_bni_2':
    '2. Select “Account Information” and then select “Account Transactions”',
  'financeBanks.import_bni_3': '3. Select the mutation period and Account Number.',
  'financeBanks.import_bni_4': '4. Select File Format CSV',
  'financeBanks.import_bni_5': '5. Click Download',
  'financeBanks.import_bni_6': '6. Click Request Date and click Search',
  'financeBanks.import_bni_7':
    '7. Click the check mark on the file to be downloaded then click Download',
  'financeBanks.import_bri_1': '1. Login to QLOLA by BRI',
  'financeBanks.import_bri_2': '2. Select “Account Info” then select “Transaction Info”',
  'financeBanks.import_bri_3': '3. Select Account Number and Transaction Period',
  'financeBanks.import_bri_4': '4. Click Download',
  'financeBanks.import_bri_5': '5. Select CSV format then click Next',
  'financeBanks.import_bri_6': '6. Select Download',
  'financeBanks.import_cimb_1': '1. Login to CIMB NIAGA',
  'financeBanks.import_cimb_2':
    '2. Click “Transaction Inquiry” then enter the date then click Account No.',
  'financeBanks.import_cimb_3': '3. Select “File Format” CSV then click “Download”',
  'financeBanks.import_cimb_4': '4. Click “Report Name” to download the file',
  'financeBanks.import_permata_1': '1. Login to Permata eBusiness',
  'financeBanks.import_permata_2': '2. Select Account Information then click “Transaction Inquiry”',
  'financeBanks.import_permata_3': '3. Select Transaction Period and Account Number',
  'financeBanks.import_permata_4': '4. In Custom File Format, select “Excel”',
  'financeBanks.import_permata_5': '5. Then click Download',
  'financeBanks.import_btn_1': '1. Login to Bale Bisnis by BTN',
  'financeBanks.import_btn_2':
    '2. Click “Account Statement” select the account then fill in the Date then click “Apply”',
  'financeBanks.import_btn_3': '3. Click “Download” then select the “XLSX” File Format.',
  'financeBanks.upload_downloaded_csv_on_form_below':
    'Upload the CSV file you just downloaded in the form below.',
  weight_subtotal: 'Sub total weight',
  all_items_weight_total: 'Total {product} weight',
  product_show_weight: 'Show {product} weight',
  product_show_weight_desc:
    'Do you want to show the {product} weight information in sales and purchase transactions?',
  'report.price_before_tax': 'Price Before Tax',
  'report.price_after_tax': 'Price After Tax',
  'financeBanks.schedule_is_required': 'Schedule is required',
  'financeBanks.schedule_must_be_unique': 'Schedule must be unique',
  'financeBanks.set_a_schedule': 'Set a Schedule',
  'financeBanks.add_schedule': 'Add Schedule',
  'financeBanks.schedule': 'Schedule',
  not_receive_verification_code_from_email: 'Didn’t receive the verification code?',
  please_check_your_email_folder_spam: 'Please check your Spam or Junk folder.',
  application_detect_sigin_from_other_different_browser:
    'Application detect sign-in from different browser.',
  two_factor_verification_code_has_been_sent_to_your_email:
    'A verification code has been sent to your email address {email}. This verification is required to ensure the security of your account.',
  verification_with_otp: 'OTP Verification',
  need_help: 'Need help? {callCenterLink}.',
  'financeInvoices.receipt_number': 'Receipt Number',
  'layoutInvoice.fixed_asset_label': 'Fixed Asset Label',
  'financeFixedAssets.fixed_asset_details': 'Fixed Asset Details',
  'financeFixedAssets.fixed_assets_label': 'Fixed Asset Label',
  'financeTags.error_cannot_add': 'Cannot add {tag}',
  'layoutInvoice.invoice_label_template': 'Enable simple layout',
  change_email_verification: 'Change Email Verification',
  you_try_to_change_your_login_email_to: 'You are attempting to change your login email to:',
  for_security_reasons_we_have_sent_an_otp_to_the_old_email:
    'For security reasons, we have sent an OTP to the old and new email.',
  please_fill_the_otp_code_below_to_complete_the_process:
    'Please fill the OTP code below to complete the process.',
  verification_and_save: 'Verification and Save',
  'layoutInvoice.invoice_show_product_percent_qty_from_order':
    'Show {product} Percentage Quantity of Order',
  show_selected_rows: 'Show {selected_rows}',
  hide_selected_rows: 'Hide {selected_rows}',
  'webhook.webhook_object_help_text':
    'Here are all the objects you can receive notifications for via webhook.',
  'webhook.example_script': 'Example Script',
  'webhook.download_example_script':
    'Download examples of using webhooks in the following programming languages:',
  'webhook.successfully_copied_code': 'Successfully copied {name} code',
  'webhook.successfully_downloaded_code': 'Successfully downloaded {name} code',
  'webhook.successfully_saved_callback_url': 'Successfully saved callback URL',
  'webhook.successfully_updated_callback_url': 'Successfully updated callback URL',
  'webhook.failed_to_save_callback_url': 'Failed to save callback URL',
  'webhook.successfully_verified_webhook': 'Successfully verified webhook',
  'webhook.failed_to_verify_webhook': 'Failed to verify webhook',
  'webhook.successfully_activated_webhook': 'Successfully activated webhook',
  'webhook.successfully_disabled_webhook': 'Successfully disabled webhook',
  'webhook.failed_activated_webhook': 'Failed activated webhook',
  'webhook.failed_disabled_webhook': 'Failed disabled webhook',
  'webhook.successfully_copied_signature_secret': 'Successfully copied signature secret',
  'webhook.webhook_desc':
    'Receive real-time data change notifications without having to call an API.',
  'webhook.click_here_for_the_full_tutorial': 'Click here for the full tutorial.',
  'webhook.webhook_configuration': 'Webhook Configuration',
  'webhook.webhook_configuration_desc':
    'To get notified when data changes, you need to set up a webhook endpoint for your application.',
  'webhook.enable_webhook': 'Enable webhook',
  'webhook.callback_url_help_text': 'This is the URL that Kledo will call when data changes.',
  'webhook.callback_url_is_required': 'Callback URL is required',
  'webhook.url_must_use_https': 'URL must use https',
  'webhook.invalid_url': 'Invalid URL',
  'webhook.signature_secret_help_text': 'This secret signature will only be displayed once.',
  'webhook.re_request_signature_secret': 'Re-request signature secret',
  'webhook.url_cannot_same_with_verify_url': 'The webhook URL cannot be the same as the verify URL',
  'webhook.webhook_url_must_use_https': 'Webhook URL must use https',
  'webhook.url_must_have_valid_structure':
    'Webhook URL must have valid structure: https://domain.com/endpoint',
  'webhook.url_must_have_endpoint_after_domain': 'Webhook URL must have endpoint after domain',
  'webhook.url_must_start_with_base_url': 'Webhook URL must start with {baseUrl}',
  'webhook.url_must_have_endpoint_after_base_url': 'Webhook URL must have endpoint after {baseUrl}',
  'webhook.url_must_have_single_endpoint_after_base_url':
    'Webhook URL must have a single endpoint after base URL (no additional path segments allowed)',
  'webhook.successfully_updated_object_endpoint': 'Successfully updated object endpoint',
  'webhook.url_is_required': 'URL is required',
  'webhook.successfully_subscribed': 'Successfully subscribed',
  'webhook.failed_to_subscribe': 'Failed to subscribe',
  'webhook.test_connection_successful': 'Webhook connection test successful',
  'webhook.test_connection_failed': 'Webhook connection test failed',
  'report.subtotal_payable_receivable': 'Subtotal Invoice Amount',
  'report.transactions_subtotal': 'Subtotal Amount Due',
  'report.total_payable_receivable': 'Total Invoice Amount',
  'report.total_transactions': 'Total Amount Due',
  main_transaction: 'Main Transaction',
  'financeContacts.account_report_filter': 'Account Report Filter',
  'financeContacts.view_account_statement': 'View Account Statement',
  'settings.webhook': 'Get real-time data notifications',
  'financeInvoices.created_at': 'Created At',
  resend_code_by: 'You can also resend the code to your registered contact',
  'report.average_per_transaction': 'Average per Transaction',
  otp_has_been_resent_to_your_email: 'The OTP code has been resent to your email {email}.',
  'report.actual_status': 'Actual Status',
  'report.amount_paid': 'Paid Amount',
  'report.discount_amount': 'Discount Amount',
  'financeInvoices.is_required': 'is required',
  'customColumn.required_field': 'Required Field',
  please_fill_in_the_custom_column: 'Please fill in the custom column',
  'layoutReport.invoice_show_ref_trans_date_delivery': 'Show Delivery Date',
  'layoutReport.invoice_show_ref_trans_date_order': 'Show Order Date',
  'layoutReport.invoice_show_grand_total': 'Show Grand Total',
  'report.view_profitability': 'View Profitability',
  'layoutInvoice.invoice_use_payment_received_as_amount_in_word':
    'Show the Value from Payments Received',
  loading_tour: 'Loading tour',
  'tour.sales.step1': 'You able to see statistic and sales overview at this overview menu.',
  'tour.sales.step2':
    '<div class="text-left">Sales flow start form : <ul class="mt-3 list-group"><li class="list-group-item">1. Quotes</li><li class="list-group-item">2. Order</li><li class="list-group-item">3. Deliveries</li><li class="list-group-item">4. Invoice</li></ul></div>',
  'tour.sales.step3':
    'You able to make direct invoice or you able to make invoice from Quotes/Orders/Deliveries.',
  'tour.sales.step4':
    'Stock and manual journal written automatically on Deliveries transaction and invoice. Stock will automatically reduce when deliveries and invoice recorded.',
  'tour.sales.step5': 'for further Sales purchase tutorial, please visit video tutorial.',
  'tour.quotes.step1':
    'Quotation Feature will be used when you give quotation to customer for the product you sell.<br>Successfully quotation will not affect to manual journal and product stock.',
  'tour.quotes.step2': 'Click add quotes to make a new quotation.',
  'tour.quotes.step3':
    'On Import button you able to import all data from excel or export data to excel.',
  'tour.quotes.step4':
    'Click this filter button to filtering quotation based on date, customer or tags.',
  'tour.quotes.step5': 'Employ this search engine to searching quotation.',
  'tour.quotes.step6':
    'Quotation collected by quotation status. You able to change quotation status on detail quotation then edit quotation.',
  'tour.quotes.step7': 'Quotation with Closed status is quotes have been ordered, or invoiced.',
  'tour.quotes.step8':
    'To learn quotes status, click this link for tutorial article, <a href="https://kledo.com/status-transaksi-penawaran-penjualan-quote/" class="text-primary" target="_blank" rel="noopener noreferrer">klik disini untuk artikel tutorialnya.</a>',
  'tour.purchases.step1': 'You able to see purchases overview at this overview menu.',
  'tour.purchases.step2':
    '<div class="text-left">Purchase flow start form : <ul class="mt-3 list-group"><li class="list-group-item">1. Purchase Quotes</li><li class="list-group-item">2. Purchase Order </li><li class="list-group-item">3. Deliveries</li><li class="list-group-item">4. Purchase Invoice</li></ul></div>',
  'tour.purchases.step3':
    'You able to make direct invoice or you able to make purchase invoice from Quotes/Orders/Deliveries.',
  'tour.purchases.step4':
    'Stock and manual journal written automatically on Deliveries transaction and invoice. Stock will automatically increase when deliveries and invoice record.',
  'tour.purchases.step5': 'for further Sales purchase tutorial, please visit video tutorial.',
  'tour.expenses.step1':
    'Expenses Feature used when you record company operational expense. <br> Expenses recorded will automatically recorded in manual journal.',
  'tour.expenses.step2': 'Click add expenses to add a new expense.',
  'tour.expenses.step3':
    'on Import button you able to import multiple data from excel or you also able to export data to excel.',
  'tour.expenses.step4':
    'Click this filter button to filtering expense based on date, contact or tags.',
  'tour.expenses.step5': 'Use search enginee to search expenses.',
  'tour.expenses.step6': 'Expenses collected of payments that have been made, form unpaid to paid',
  'tour.expenses.step7': 'Click Others to see other statuses.',
  'tour.expenses.step8':
    'You able to make reccuring expense automatically here. For example making cost of renting a building per month.',
  'tour.accounts.step1': 'On Accounts Feature shows Accounts / COA ( Chart of Account) list.',
  'tour.accounts.step2': 'You able to add new Account/ COA here.',
  'tour.accounts.step3': 'Used Manual Journal to input journal transaction by manual way.',
  'tour.accounts.step4':
    'Click import button to import multiple data at once from excel or export data to excel.',
  'tour.accounts.step5': 'Click here to see other menus.',
  'tour.accounts.step6': 'Click here, add account to set up account/ coa conversion balance.',
  'tour.accounts.step7': 'You able to cutt off on closing button.',
  'tour.accounts.step8':
    "You able to delete Account/ COA over here. Default system account and accounts that have transactions can't be deleted.",
  'tour.accounts.step9': 'At balance button will shown balances from each Account/ COA.',
  'tour.accounts.step10':
    'When all filling is complete, click this button to save. Please visit https://www.youtube.com/watch?v=gupl4YuibB4&list=PLoKPSI6LG_CJKxSKvAWjeeGjExQwbw2-3&index=2 for further Accounts Feature tutorial.',
  'tour.add_contact.step1': 'This add contact form used to add new contact.',
  'tour.add_contact.step2': 'Select contact type.',
  'tour.add_contact.step3': 'Add Full name contact.',
  'tour.add_contact.step4': 'Add another detail contact data here.',
  'tour.add_contact.step5':
    'Click accounting mapping to mapping Account coa Payable Account - Receivable Account from contact.',
  'tour.add_contact.step6':
    "When all filling is complete.<br/>click this button to save, Please visit video tutorial dan <a href='https://kledo.com/cara-membuat-kontak/' class='text-primary' target='_blank'>This Article</a>.",
  'tour.add_delivery.step1':
    'Sales Deliveries Feature will be used when you sending ordered product to customer.<br/>Succesfully Sales Deliveries will automatically affect to manual journal and product stock will reduce.',
  'tour.add_delivery.step2':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_delivery.step3':
    'To make transaction category you can use Tag. you also able to make statement based on this Tag.',
  'tour.add_delivery.step4':
    'To make transaction category you can use Tag. you also able to make statement based on this Tag.',
  'tour.add_delivery.step5': 'You able to add expedition delivery and receipt number here.',
  'tour.add_delivery.step6': 'Set amount of product which will delivered',
  'tour.add_delivery.step7':
    'You can write a note to be shown when delivery order printed. you also able to attach delivery file over here.',
  'tour.add_delivery.step8': 'Add shipping cost right here.',
  'tour.add_delivery.step9':
    'When all filling is complete, click this button to save.<br/> for further purchase order feature video tutorial.',
  'tour.add_expense.step1':
    'Expenses feature used when you recorded company operational expenses.<br/>Expense will be automatically recorded in the general journal.',
  'tour.add_expense.step2': 'Select account which will you used to pay expenses.',
  'tour.add_expense.step3': 'Select name of receiving payment.',
  'tour.add_expense.step4':
    'Tags can be used to make transaction category. You also able to make report based on this tags.',
  'tour.add_expense.step5': 'Select expenses account dan set the amount of expenses.',
  'tour.add_expense.step6':
    "When all filling is complete, click this button to save. for further expenses feature tutorial or article tutorial on <a href='https://kledo.com/cara-posting-biaya-expense/' class='text-primary' target='_blanl'>artikel tutorial</a>.",
  'tour.add_fixed_asset.step1': 'Add detail from fixed assets which will recorded.',
  'tour.add_fixed_asset.step2': 'Input purchase price, tax not included.',
  'tour.add_fixed_asset.step3': 'Select account to relocate fixed assets balance.',
  'tour.add_fixed_asset.step4':
    'Select account to credited fixed assets purchasing, example : Cash,Loan, Equitas.',
  'tour.add_fixed_asset.step5':
    'Click here, depreciation button, if there is depreciation on your fixed assets.',
  'tour.add_fixed_asset.step6':
    'Select Accumulated Depreciation Account to record depreciation every month.',
  'tour.add_fixed_asset.step7':
    'Select Depreciation Expense Account to relocate depreciation accumulation.',
  'tour.add_fixed_asset.step8': 'Set rate depreciation every year.',
  'tour.add_fixed_asset.step9':
    "When all filling is complete, click this button to save. for futher fixed assets feature tutorial or article on, please visit video tutorial or <a href='https://kledo.com/cara-menambah-aset-tetap/' class='text-primary' target='_blank'>artikel tutorial</a>.",
  'tour.add_invoice.step1':
    'You can choose Invoices Feature when you ready to collect payment to customer for the product you sell. <br />Successfully sales invoice will automatically recorded on Manual Journal then the product stock will be automatically reduce.',
  'tour.add_invoice.step2':
    "Select customer's name which you ready to collect his payment, you also can add a new customer data.",
  'tour.add_invoice.step3':
    'Invoice number will be automatically create, but you also can edit it here.',
  'tour.add_invoice.step4':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_invoice.step5':
    'To make transaction category you can use Tag. you also able to make report based on this Tag.',
  'tour.add_invoice.step6': 'select the product which sold, you can also add new product here',
  'tour.add_invoice.step7':
    "you can write a note to be shown when customer's invoice printed. You also able to attach file here.",
  'tour.add_invoice.step8':
    "When all filling is complete, click this button to save. Please visit: <a href='https://kledo.com/cara-membuat-tagihan-invoice/' class='text-primary' target='_blank'>artikel tutorial</a>.",
  'tour.add_manual_journal.step1': 'Manual journal used as a manual recording on Sales feature.',
  'tour.add_manual_journal.step2':
    'Transaction number will automatically recorded but you also able to edit it here.',
  'tour.add_manual_journal.step3':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_manual_journal.step4':
    'To make transaction category you can use Tag. you also able to make report based on this Tag.',
  'tour.add_manual_journal.step5': 'Select COA/ account here and set amount Credit or Debit.',
  'tour.add_manual_journal.step6': 'Click Add More to add new line COA /account.',
  'tour.add_manual_journal.step7':
    'System will automatically validate balance between the same credit and debit.',
  'tour.add_manual_journal.step8':
    "When all filling is complete, click this button to save. For further Manual Journal Feature tutorial or <a href='https://kledo.com/cara-menambah-jurnal-umum/' class='text-primary' target='_blank'>article tutorial</a>.",
  'tour.add_product_conversion.step1':
    'Product conversion is to switch from raw material product become finished product.',
  'tour.add_product_conversion.step2': 'Set amount of finished product which will made.',
  'tour.add_product_conversion.step3': 'Select inventory to keep finished product.',
  'tour.add_product_conversion.step4': 'You able to change quantity of each raw materials here.',
  'tour.add_product_conversion.step5': 'You able to change production cost in here.',
  'tour.add_product_conversion.step6': 'You able to change production cost in here.',
  'tour.add_product_conversion.step7':
    'When all filling is complete, click this button to save. for further Product conversion feature tutorial',
  'tour.add_product_manufacture.step1':
    'Products Manufacture Feature used when you make process of production from several raw material products become finished products.',
  'tour.add_product_manufacture.step2':
    'In addition to the production process you able to buy this product, add the purchase expenses. Otherwise, leave the purchase price blank.',
  'tour.add_product_manufacture.step3':
    'If this product is finished product, add sale price. But if it is semi-finished product, leave the sale price blank.',
  'tour.add_product_manufacture.step4':
    'Add some raw material product. raw material product needs to activated stock tracking.',
  'tour.add_product_manufacture.step5': 'You also able to add production expenses in here.',
  'tour.add_product_manufacture.step6':
    'Total cost of good sold for manufacture product will be shown in here.',
  'tour.add_product_manufacture.step7':
    'When all filling is complete, click this button to save. For further product manufacture feature tutorial.',
  'tour.add_product_package.step1':
    'Products Package feature used when you bundling several products become one package.',
  'tour.add_product_package.step2': 'Set Products package sell price',
  'tour.add_product_package.step3':
    'Select some products that will be packaged.Products which can be packaged only products which have activated stock tracking.',
  'tour.add_product_package.step4':
    'This button will shown total cost of goods sold for third products package.',
  'tour.add_product_package.step5':
    'When all filling is complete, click this button to save. for further product feature tutorial, please visit video tutorial.',
  'tour.add_product.step1':
    'SKU code is unique code for each product. Account code will generate automatically or you also able to edit it.',
  'tour.add_product.step2': 'Slide if you buy this product. Set product purchase price.',
  'tour.add_product.step3': 'Slide if you sell this product. Set Product sale price.',
  'tour.add_product.step4': 'Slide if you want to track this product stock.',
  'tour.add_product.step5':
    'Click here to set more detail about product purchase and sale account also product inventory accounts.',
  'tour.add_product.step6':
    "When all filling is complete, click this button to save. For further product feature video tutorial <a href='https://kledo.com/cara-menambah-produk/' class='text-primary' target='_blank'>or article tutorial</a>.",
  'tour.add_purchase_invoice.step1':
    'Purchase Invoice Feature will be applied when vendor ready to collect purchase invoice which you have to pay.<br/> Purchase Invoice will automatically recorded on Manual Journal then the product stock will automatically increase.',
  'tour.add_purchase_invoice.step2': 'Select vendor name or you can add new vendor data.',
  'tour.add_purchase_invoice.step3':
    'Purchase Invoice number will automatically create, but you also can edit it here.',
  'tour.add_purchase_invoice.step4':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_purchase_invoice.step5':
    'To make transaction category you can use Tag. you also able to make report based on this Tag.',
  'tour.add_purchase_invoice.step6':
    'Choose a product you will purchase or you able to add new product here.',
  'tour.add_purchase_invoice.step7':
    'You able to write a note which shown when purchase invoice printed. you also can attach invoice file over here.',
  'tour.add_purchase_invoice.step8':
    "When all filling is complete, click this button to save.<br/>for further Purchase Invoice video tutorial or, please visit video tutorial or <a href='https://kledo.com/cara-membuat-tagihan-pembelian-purchase-invoice/' class='text-primary' target='_blank'>article tutorial</a>.",
  'tour.add_purchase_order.step1':
    'Purchase order Feature will be used when you order the product that you will buy from vendor.<br/>Succesfully Purchase order will not affect to manual journal and product stock.',
  'tour.add_purchase_order.step2': 'Select vendor name or you also able to add vendor new data.',
  'tour.add_purchase_order.step3':
    'Purchase Order number will be automatically create, but you also can edit it here.',
  'tour.add_purchase_order.step4':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_purchase_order.step5':
    'To make transaction category you can use Tag. you also able to make report based on this Tag.',
  'tour.add_purchase_order.step6': 'Select ordered product or you can also add new product here.',
  'tour.add_purchase_order.step7':
    'You can write a note to be shown when purchase order printed. You also able to attach order file over here.',
  'tour.add_purchase_order.step8':
    "When all filling is complete, click this button to save.<br/>for further purchase order feature video tutorial, please visit video tutorial or <a href='https://kledo.com/cara-membuat-pesanan-pembelian-purchase-order/' class='text-primary' target='_blank'>article tutorial</a>.",
  'tour.add_quote.step1':
    'Purchase Quotation Feature will be used when you receive quotation from vendor for the product you will purchase.<br/>Succesfully purchase quotation will not affect to manual journal and product stock.',
  'tour.add_quote.step2':
    'Select the name of the customer to make a quotation or you also able to add customer new data.',
  'tour.add_quote.step3':
    'Quotation number will be automatically create, but you also can edit it here.',
  'tour.add_quote.step4':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_quote.step5':
    'To make transaction category you can use Tag. you also able to make report based on this Tag.',
  'tour.add_quote.step6':
    'Select the product that will be quotation or you can also add new product here.',
  'tour.add_quote.step7':
    "You can write a note to be shown when customer's invoice printed. you also able to attach quotation file over here.",
  'tour.add_quote.step8': 'When all filling is complete, click this button to save.',
  'tour.add_spend_money.step1':
    'Spend money used to send a fund from Cash & Bank account to receiver.',
  'tour.add_spend_money.step2': 'Select fund receiver.',
  'tour.add_spend_money.step3':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_spend_money.step4':
    'Tag able to use transaction category. You also able to make report based on this tag.',
  'tour.add_spend_money.step5': 'Select account and fund amount that will sended.',
  'tour.add_spend_money.step6':
    "For further how to record Cash & Bank Transaction tutorial or <a href='https://kledo.com/cara-mencatat-kirim-dana-kas-bank/' class='text-primary' target='_blank'> article tutorial</a>.",
  'tour.add_receive_money.step1':
    'Receive money used to receive a fund from receiver to Cash & Bank account.',
  'tour.add_receive_money.step2': 'Select fund sender',
  'tour.add_receive_money.step3':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode',
  'tour.add_receive_money.step4':
    'Tag able to use transaction category. You also able to make report based on this tag.',
  'tour.add_receive_money.step5': 'Select account and fund amount that will sended.',
  'tour.add_receive_money.step6':
    "When all filling is complete, click this button to save. For futher how to record Cash & Bank Transaction tutorial or <a href='https://kledo.com/cara-mencatat-terima-dana-kas-bank/' class='text-primary' target='_blank'> article tutorial</a>.",
  'tour.add_stockadjustment.step1':
    'Use stock adjusment to add and reduce stock on the warehouse or to manage stock opname.',
  'tour.add_stockadjustment.step2':
    'to manage stock opname, select stock account type. With this type product amount will be lock, so all stock activity before adjustment will be ignored.',
  'tour.add_stockadjustment.step3':
    'To add or reduce stock from warehouse, select stock in/ out type.',
  'tour.add_stockadjustment.step4':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_stockadjustment.step5': 'Select adjustment stock account to be record on journal.',
  'tour.add_stockadjustment.step6':
    'Choose product which its stock will be adjustment and set amount of the stock.',
  'tour.add_stockadjustment.step7': 'Average price is a purchase price.',
  'tour.add_stockadjustment.step8':
    'When all filling is complete, click this button to save. for further how to manage stock opname feature tutorial',
  'tour.add_transfer_money.step1':
    'Money transfer used to move a fund from one Cash & Bank account to another account.',
  'tour.add_transfer_money.step2': 'select the account from which the funds are from.',
  'tour.add_transfer_money.step3': 'select the destination account.',
  'tour.add_transfer_money.step4': 'Input total amount that will transferred.',
  'tour.add_transfer_money.step5':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_transfer_money.step6':
    'Tag able to use transaction category. You also able to make report based on this tag.',
  'tour.add_transfer_money.step7':
    "When all filling is complete, click this button to save. For futher how to record Cash & Bank Transaction tutorial or <a href='https://kledo.com/cara-mencatat-transfer-dana-kas-bank/' class='text-primary' target='_blank'>article tutorial</a>.",
  'tour.add_warehouse_transfer_in.step1':
    'Money transfer used to move a fund from one Cash & Bank account to another account.',
  'tour.add_warehouse_transfer_in.step2': 'select the account from which the funds are from.',
  'tour.add_warehouse_transfer_in.step3': 'select the destination account.',
  'tour.add_warehouse_transfer_in.step4':
    'Select the product whose stock will be transferred, and set the quantity to transfer after you choose the origin warehouse.',
  'tour.add_warehouse_transfer_in.step5':
    'Tag able to use transaction category. You also able to make report based on this tag.',
  'tour.add_warehouse_transfer_out.step1':
    'Use warehouse transfer move product stock from one warehouse to another.',
  'tour.add_warehouse_transfer_out.step2': 'Select warehouse here.',
  'tour.add_warehouse_transfer_out.step3':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_warehouse_transfer_out.step4':
    'Select the product whose stock will be transferred, and set the quantity to transfer after you choose the destination warehouse.',
  'tour.add_warehouse_transfer_out.step5':
    'When all filling is complete, click this button to save. For further how to manage warehouse transfer tutorial.',
  'tour.cash_bank.step1':
    'Use warehouse transfer move product stock from one warehouse to another.',
  'tour.cash_bank.step2': 'Select warehouse here.',
  'tour.cash_bank.step3':
    'This shows the ending balance of a bank account and its balance movement chart if you have fewer than 30 cash & bank accounts.',
  'tour.cash_bank.step4':
    'Select product that its stock will be moved and set stock amount that will be moved.',
  'tour.cash_bank.step5': 'Click add more to add another product.',
  'tour.contacts.step1':
    "Contact menu, used to save your company's contact data, like staff data, customers and vendors.",
  'tour.contacts.step2': 'Click add contact to add new contact.',
  'tour.contacts.step3':
    'Click import button to add multiple new contact at once from excel or export all data to excel.',
  'tour.contacts.step4': 'Use filter to filtering contact based on group or contact type.',
  'tour.contacts.step5': 'Use search button to searching contact data.',
  'tour.contacts.step6': 'for further contact Feature tutorial, please visit video tutorial.',
  'tour.conversion_balance.step1':
    "Contact menu, used to save your company's contact data, like staff data, customers and vendors.",
  'tour.conversion_balance.step2': 'Click add contact to add new contact.',
  'tour.conversion_balance.step3':
    'Click import button to add multiple new contact at once from excel or export all data to excel.',
  'tour.conversion_balance.step4':
    'Use filter to filtering contact based on group or contact type.',
  'tour.conversion_balance.step5': 'Use search button to searching contact data.',
  'tour.conversion_balance.step6':
    'for further contact Feature tutorial, please visit video tutorial.',
  'tour.detail_inventory.step1': 'Over here showed detail of warehouse.',
  'tour.detail_inventory.step2': 'Click stock adjustment to adjust the stock.',
  'tour.detail_inventory.step3':
    'Click here to transfer warehouse, or move goods from one warehouse to another.',
  'tour.detail_inventory.step4':
    'And, this is the list of all product which exist on this warehouse.',
  'tour.detail_inventory.step5': 'Here you can show or hide columns such as quantity and COGS.',
  'tour.detail_inventory.step6':
    'Click show transaction to look at transaction detail of all products in this warehouse.',
  'tour.detail_inventory.step7':
    ' for further Stock recorded flow tutorial, please visit video tutorial.',
  'tour.fixed_assets.step1':
    'Fixed Assets makes all company fixed assets more organize and depreciation will automatically running.',
  'tour.fixed_assets.step2':
    'Draft button is fixed assets which still in draft form. You able to add fixed assets draft from purchase invoice. Click here for futher video tutorial.',
  'tour.fixed_assets.step3': 'Registered Assets is fixed assets which still active.',
  'tour.fixed_assets.step4': 'Over here, is fixed assets which already sold/ disposed.',
  'tour.fixed_assets.step5': 'You able to add fixed assets on add fixed assets.',
  'tour.fixed_assets.step6':
    'To add multiple assets at once, click import button. You also able to export assets data to excel in here.',
  'tour.fixed_assets.step7': 'Click Run depreciation to running depreciation automatically.',
  'tour.inventory.step1': 'On inventory menu showed list of ware houses that belong to you.',
  'tour.inventory.step2': 'You able to add new warehouse on add warehouse button.',
  'tour.inventory.step3': 'Total quantity showed total products item or product in the warehouse.',
  'tour.inventory.step4': 'Total value is total COGS from all product.',
  'tour.inventory.step5':
    'for further How to manage warehouse tutorial, click on this video tutorial.',
  'tour.layout_invoice.step1':
    'Invoice layout used to change template from printout transaction, like invoice, label delivery, delivery slip, receipts etc.',
  'tour.layout_invoice.step2':
    'You able to upload company logo which will shown when printed successfully.',
  'tour.layout_invoice.step3': 'Click yellow icon to change the text.',
  'tour.layout_invoice.step4':
    'On this part you able to change configuration from layout, for example discount column will be showed or no.',
  'tour.layout_invoice.step5':
    'You able to change template here. more than 60 attractive templates are provided. After template has changed, template on web will not change too, it will change once you print.',
  'tour.layout_invoice.step6':
    'for further invoice layout setting feature tutorial, please visit this video tutorial.',
  'tour.invoices.step1':
    'Invoice Feature will be used when you collect payment to the customer for the product you sell.<br> Created successfully invoice will automatically written at manual journal and product stock will reduce automatically.',
  'tour.invoices.step2': 'Click here to make a new invoice.',
  'tour.invoices.step3':
    'On Import button you able to import a lot of data from excel or export data to excel.',
  'tour.invoices.step4':
    'Click this filter button to filtering invoice based on date, customer or tags.',
  'tour.invoices.step5': 'Employ this search enginee to searching invoice.',
  'tour.invoices.step6': 'Invoice collected by payment, from unpaid to paid.',
  'tour.invoices.step7': 'Click Others to see other statuses.',
  'tour.invoices.step8':
    'You able to make automatically reccuring invoice over here. For example, make an invoice to regular customer every month.',
  'tour.deliveries.step1':
    'Sales Deliveries Feature will be used when you send sales order products to customers.<br> Successfully delivery will automatically affect to manual journal and product stock will  reduce.',
  'tour.deliveries.step2':
    'To make deliveris, First, you need to order then make deliveries from detail order number.',
  'tour.deliveries.step3':
    'Click this filter button to filtering deliveries based on date, customer or tags.',
  'tour.deliveries.step4': 'Employ search enginee for searching delivery.',
  'tour.deliveries.step5': 'On Export button you able to export all delivery data to excel.',
  'tour.deliveries.step6':
    'Open Button over here inform that deliveries havent billed yet to the customer.',
  'tour.deliveries.step7': 'Billed button inform that deliveries have been billed to the customer.',
  'tour.deliveries.step8':
    'To change delivery status from open to billed, check onto delivery detail then click arrange invoice.',
  'tour.orders.step1':
    'Sales Order will be used when you receive selling order product from customer by the product you sell.<br> Successfully order will not affect to manual journal and product stock.',
  'tour.orders.step2': 'Click add orders to make a new order.',
  'tour.orders.step3':
    'On Import button you able to import a lot of data from excel or export data to excel.',
  'tour.orders.step4':
    'Click this filter button to filtering order based on date, customer or tags.',
  'tour.orders.step5': 'Employ this search engine to searching invoice.',
  'tour.orders.step6': 'Sales Order collected by payment, from unpaid to paid.',
  'tour.orders.step7': 'Click Others to see other statuses.',
  'tour.orders.step8':
    'You able to make automatically reccuring Purchase invoice sales order over here. For example, make a sales order to regular customer every month.',
  'tour.purchase_invoices.step1':
    'Purchase Invoice Feature will be used when vendor already request invoice that you have to pay.',
  'tour.purchase_invoices.step2': 'Click add purchase invoice to make a new Purchase Invoice.',
  'tour.purchase_invoices.step3':
    'On Import button you able to import a lot of data from excel or export data to excel.',
  'tour.purchase_invoices.step4':
    'Click this filter button to filtering purchase invoice based on date, customer or tags.',
  'tour.purchase_invoices.step5': 'Employ this search engine to searching invoice.',
  'tour.purchase_invoices.step6': 'Purchase Invoice collected by payment, from unpaid to paid.',
  'tour.purchase_invoices.step7': 'Click Others to see other statuses.',
  'tour.purchase_invoices.step8':
    'You able to make automatically recurring Purchase invoice over here. For example, make an invoice to regular vendor every month.',
  'tour.purchase_deliveries.step1':
    'Purchase Delivery Feature will be used when you receive order delivering product from vendor.<br> Successfully delivery will automatically affect to general journal and product inventory will increase.',
  'tour.purchase_deliveries.step2':
    'To compose purchase delivery, First, you need to order then compose delivery from detail order number.',
  'tour.purchase_deliveries.step3':
    'Click this filter button to filtering shipment based on date, customer or tags.',
  'tour.purchase_deliveries.step4': 'Employ search engine for searching delivery.',
  'tour.purchase_deliveries.step5': 'Over here you able to export all delivery data to excel.',
  'tour.purchase_deliveries.step6':
    "Open Button over here inform that shipment haven't billed yet to the customer.",
  'tour.purchase_deliveries.step7':
    'Delivery with close status inform that shipment have been billed by the vendor.',
  'tour.purchase_deliveries.step8':
    'To change status from open to close, check onto delivery detail then click arrange purchase invoice.',
  'tour.products.step1':
    'Click add product to add new product. You able to make products package and products manufacture.',
  'tour.products.step2':
    'Click import button to import multiple data at once from excel or export data to excel.',
  'tour.products.step3': 'Filtering product based on category ',
  'tour.products.step4': 'Use search engine to search product',
  'tour.cash_bank_transactions.step1':
    'Cash & Bank Feature used to record in -out bill from Cash / Bank.',
  'tour.cash_bank_transactions.step2':
    'Click here to make a new transaction, receive money, spend money or transfer money.',
  'tour.cash_bank_transactions.step3':
    'Click to import new transaction multiple datas from excel or you also able to export cash & bank data to excel.',
  'tour.cash_bank_transactions.step4':
    'Use filter to filtering transaction data based on date, transaction status or tags.',
  'tour.cash_bank_transactions.step5':
    "Transaction on Kledo is recorded transaction on Kledo's application.",
  'tour.cash_bank_transactions.step6':
    'Bank Transaction is mutation data on your bank account. You able to connect your internet banking with kledo, so mutation data automatically will set in Kledo.',
  'tour.cash_bank_transactions.step7':
    "Reconciliation used to compare Kledo transaction to Bank transaction, it's to make sure recorded transaction same with real transaction in Bank account.",
  'tour.cash_bank_transactions.step8':
    'You able to make automatically bank transaction at new transaction. For example, making fund receipts automatically on a regular basis every month.',
  'tour.cash_bank_transactions.step9':
    'Click here to connect your internet banking with Kledo, so automatically your mutation data on your bank account move to Kledo.',
  'tour.add_purchase_delivery.step1':
    'Purchase Deliveries Feature will be used when you receive product delivery which ordered by vendor.<br/>Successfully Purchase Deliveries will automatically affect to manual journal and product stock will increase.',
  'tour.add_purchase_delivery.step2':
    'Delivery number will be automatically create, but you also able to edit it here.',
  'tour.add_purchase_delivery.step3':
    'Reference is optionally to complete as an internal notes but it will useful for searching mode.',
  'tour.add_purchase_delivery.step4':
    'To make transaction category you can use Tag. you also able to make statement based on this Tag.',
  'tour.add_purchase_delivery.step5':
    'You able to add expedition delivery and receipt number here.',
  'tour.add_purchase_delivery.step6': 'Set amount of product which will delivered',
  'tour.add_purchase_delivery.step7':
    'You able to write a note and attach delivery file over here.',
  'tour.add_purchase_delivery.step8': 'Add shipping cost right here.',
  'tour.add_purchase_delivery.step9': 'When all filling is complete, click this button to save.',
  'tour.manual_journal.step1': 'Manual Journal used as a manual record on Journal.',
  'tour.manual_journal.step2': 'You able to add manual journal here on Add manual Journal.',
  'tour.manual_journal.step3':
    'Click import button to import multiple data at once from excel or export data to excel.',
  'tour.manual_journal.step4':
    'You able to make manual journal recurring transaction. For example make manual journal once a month.',
  'tour.manual_journal.step5':
    'Used filter to filtering manual journal data based on tag or transaction.',
  'tour.manual_journal.step6': 'On search column you able to search manual journal transaction.',
  'businessFlow.invoice_form_show_warehouse': 'Show Warehouse in Sales',
  'businessFlow.invoice_form_show_warehouse_desc':
    'Will the warehouse be displayed in sales transactions?',
  'businessFlow.purchase_form_show_warehouse': 'Show Warehouse in Purchase',
  'businessFlow.purchase_form_show_warehouse_desc':
    'Will the warehouse be displayed in the purchase transaction?',
  'businessFlow.invoice_payment_form_show_reference': 'Show {reference} in Receive Payment',
  'businessFlow.invoice_payment_form_show_reference_desc':
    'Whether {reference} input is shown on the sales invoice receive payment form. If disabled, {reference} will not be saved',
  'businessFlow.invoice_payment_form_show_tag': 'Show {tag} in Receive Payment',
  'businessFlow.invoice_payment_form_show_tag_desc':
    'Whether {tag} input is shown on the sales invoice receive payment form. If disabled, {tag} will not be saved',
  'businessFlow.invoice_payment_tag_required': 'Input {tag} is required in Receive Payment',
  'businessFlow.invoice_payment_tag_required_desc':
    'Is {tag} required on the sales invoice and sales order receive payment form?',
  'businessFlow.purchase_payment_form_show_reference': 'Show {reference} in Purchase Payment',
  'businessFlow.purchase_payment_form_show_reference_desc':
    'Whether {reference} input is shown on the purchase invoice payment form. If disabled, {reference} will not be saved',
  'businessFlow.purchase_payment_form_show_tag': 'Show {tag} in Purchase Payment',
  'businessFlow.purchase_payment_form_show_tag_desc':
    'Whether {tag} input is shown on the purchase invoice payment form. If disabled, {tag} will not be saved',
  'businessFlow.purchase_payment_tag_required': 'Input {tag} is required in Purchase Payment',
  'businessFlow.purchase_payment_tag_required_desc':
    'Is {tag} required on the purchase invoice and purchase order payment form?',
  'layoutInvoice.invoice_show_custom_field_item': 'Show Custom Columns Field Item',
  'layoutInvoice.invoice_show_custom_field': 'Show Transaction Custom Field',
  'layoutInvoice.invoice_custom_field_selected': 'Displayed Transaction Custom Field',
  'layoutInvoice.invoice_custom_field_selected_placeholder': 'All transaction custom fields',
  send_price_changes_notification_to_customer: 'Notification of billing price changes',
  still_has_past_due_bills_unpaid_on_this_vendor:
    'You still have past due bills that have not been paid at this {vendor}, {link} to see details!',
  'businessFlow.reject_purchase_if_overdue':
    'Reject new purchases if there are still outstanding past due invoices.',
  'businessFlow.reject_purchase_if_overdue_desc':
    'Decline new purchases if there are still unpaid past due invoices on the selected contact?',
  additional_discount_total: 'Additional Discount Total',
  'businessFlow.contact_auto_ref_number': 'Will the numbers in the contacts be auto-filled?',
  'businessFlow.contact_auto_ref_number_desc':
    'The number in the contacts will be auto-filled when creating a new contact based on the format in auto-numbering.',
  'financeBanks.mass_reconcile_note_1':
    'The selected transactions will be reconciled with the transactions at the bank.',
  'financeBanks.mass_reconcile_note_2':
    'If there is a matching transaction at the bank for the same date, it will be reconciled with that transaction.',
  'financeBanks.mass_reconcile_note_3':
    'However, if a matching transaction is not found, a transaction will be created at a new bank.',
  failed_to_get_relation: 'Failed to get relation',
  'businessFlow.invoice_proforma_desc':
    'Does your company create proforma as an initial document to split payments, both in orders and invoices?',
  update_order: 'Update Order',
  are_you_sure_to_delete_order: 'Are you sure to delete the order?',
  delete_confirmation: 'Delete Confirmation',
  'financeContacts.follow_these_steps_to_import_your_contact_payment_transaction':
    'Follow these steps to import {credit} {debit} Payments',
  'financeContacts.1_download_your_contact_payment_transaction_template_file':
    '1. Download the {credit} {debit} template file',
  'financeContacts.start_by_downloading_our_contact_payment_transaction_csv':
    'Start by downloading the template file in Excel format. This file contains the header columns Kledo needs to import your credit and debit payment details.',
  'financeContacts.2_copy_your_contact_payment_transaction_into_the_template':
    '2. Copy the payment details {credit} {debit} into the template',
  'financeContacts.import_contact_payment_transaction_using_excel_or_another_spreadsheet_editor':
    "Using Excel or other spreadsheet software, enter the {credit} {debit} payment details into the Kledo template file. Make sure the {credit} {debit} payment details match the template's header columns.",
  'financeContacts.import_contact_payment_transactions': 'Import {credit} {debit} Payment',
  'financeInvoices.delivery_order_number': 'Delivery Order Number',
  please_input_the_amount: 'Please input the amount',
  'notification.notification_import_success': 'Successful import notification',
  'notification.notification_finance_approval': 'Email approval notification',
  'notification.email_production_variance':
    'Email notification for conversion result below formula',
  'notification.push_production_variance':
    'Mobile notification for conversion result below formula',
  'notification.email_whatsapp_share_failed': 'Email notification for failed WhatsApp messages',
  'notification.push_whatsapp_share_failed': 'Mobile notification for failed WhatsApp messages',
  'notification.production_variance_tolerance': 'Conversion variance tolerance (%)',
  'notification.production_variance_tolerance_required': 'Variance tolerance is required',
  'notification.production_variance_tolerance_range': 'Enter a whole number from 0 to 100',
  'financeDelivery.insufficient_stock_warning':
    'Cannot add delivery, because there are products that have insufficient stock.',
  'reports.live_dashboard': 'Live Dashboard',
  'reports.live_dashboard_desc1':
    'Live Dashboard is used to display live statistics on monitor screens.',
  'reports.live_dashboard_desc2':
    'Live Dashboard makes it easy for the entire team to monitor company progress in real time.',
  scan_qr_code_to_make_payment: 'Scan QR Code to make payment',
  payment_total_amount: 'Total Payment',
  qr_code_will_be_updated_automatically_after_each_transaction:
    'QR Code will be updated automatically after each transaction',
  qr_code_has_expired: 'QR Code has expired',
  generate_new_qr_code: 'Generate New QR Code',
  time_remaining: 'Time Remaining',
  payment_with_qris_failed_please_try_again: 'Payment with QRIS failed. Please try again.',
  try_again: 'Try Again',
  qris_compatible_banking_ewallet: 'Compatible with all major banking and e-wallet apps',
  qris_print_qris: 'PRINT QRIS',
  qris_customer: 'CUSTOMER',
  qris_terminal: 'TERMINAL',
  qris_total_amount_due: 'TOTAL AMOUNT DUE',
  qris_payment_gateway_ready: 'Payment gateway is ready to receive transaction',
  qris_transaction_id: 'TRANSACTION ID',
  qris_payment: 'QRIS Payment',
  qris_pos_terminal: 'ENTERPRISE SAAS POS TERMINAL',
  qris_order: 'ORDER',
  qris_cancel_payment: 'CANCEL PAYMENT',
  qris_check_payment_status: 'CHECK PAYMENT STATUS',
  qris_scan_to_pay: 'Scan to Pay',
  ewallet_redirection_link: 'Redirection Link',
  ewallet_follow_link_description: 'Follow the link below to process the transaction securely.',
  ewallet_midtrans_xendit_url: 'MIDTRANS / XENDIT URL',
  ewallet_copy: 'Copy',
  ewallet_open_payment_page: 'Open Payment Page',
  ewallet_redirect_info:
    'Redirect the customer to complete payment on the provider portal. The status will update automatically once verified.',
  ewallet_link_redirect_info: 'This link will direct the customer to a secure payment portal.',
  ewallet_status_auto_update_info:
    'Order status will be updated automatically after successful payment.',
  ewallet_securely_processed_by: 'SECURELY PROCESSED BY',
  ewallet_order_summary: 'ORDER SUMMARY',
  ewallet_order_reference: 'Order Reference',
  ewallet_total_amount: 'Total Amount',
  ewallet_current_status: 'Current Status',
  ewallet_payment_pending: 'Payment Pending',
  ewallet_check_status_manually: 'Check Status Manually',
  ewallet_select_payment_method_first: 'Please select a payment method first',
  ewallet_check_status_missing_params: 'Payment data is incomplete. Please try again.',
  ewallet_check_status_failed: 'Failed to check payment status.',
  ewallet_payment_still_pending: 'Payment is still pending.',
  ewallet_payment_success: 'Payment Successful',
  ewallet_verified: 'VERIFIED',
  ewallet_secure_system: 'SECURE SYSTEM',
  ewallet_transaction_verified: 'Transaction has been verified by the payment system.',
  ewallet_transaction_id: 'TRANSACTION ID',
  ewallet_payment_summary: 'PAYMENT SUMMARY',
  ewallet_order_number: 'Order Number',
  ewallet_payment_method: 'Payment Method',
  ewallet_e_wallet: 'E-Wallet',
  ewallet_total_paid: 'Total Paid',
  ewallet_done: 'Done',
  ewallet_print_receipt: 'Print Receipt',
  ewallet_payment_url_not_available: 'Payment URL is not available',
  ewallet_url_copied: 'URL copied successfully',
  ewallet_checking_status: 'Checking payment status...',
  please_input_the_recipient_email_address: 'Please input the recipient email address',
  reciepent_email_address: 'Recipient Email Address',
  'layoutInvoice.invoice_vertical_align_item': 'Display Top Aligned Column Text',
  you_have_already_entered_serial_numbers:
    'You have already entered serial number, if you still want to continue then the existing serial number will be deleted.',
  show_all: 'Show all',
  if_checked_show_all_serial_numbers:
    'If checked, all serial numbers will be displayed — including those that are not available in the selected warehouse.',
  'billing.here': 'here',
  'billing.is_invoice_quota_exceeded':
    'Your invoice quota has been used up. Please add an invoice addon {here} to add another invoice.',
  'billing.is_invoice_quota_almost_full':
    'Your invoice quota is running out soon. Please add an invoice add-on {here} to increase your invoice limit.',
  sort_items_by_product_name_asc: 'Sort Items by {product} Name Ascending',
  'layoutInvoice.invoice_show_invoice_number': 'Show Number',
  'reports.live_dashboard_open_full_screen': 'Open Full Screen',
  fullscreen: 'Fullscreen',
  exitFullscreen: 'Exit Fullscreen',
  validity_without_time_limit: 'Valid without time limit',
  valid_period: 'Valid period {start} - {end}',
  percentage: 'Percentage',
  nominal: 'Nominal',
  min_transaction: 'Min. transaction',
  min_quantity: 'Min. quantity',
  promo_period: 'Promo Period',
  discount: 'Discount',
  quota: 'Quota {quota}',
  list_promo: 'List Promo',
  'financeContacts.opening_hour': 'Opening Hour',
  'financeContacts.closing_hour': 'Closing Hour',
  'zap.archive': 'Archive',
  'zap.view_geo_tagging': 'View Geo Tagging',
  'zap.fleet_name': 'Fleet Name',
  'zap.license_plate_number': 'License Plate Number',
  'zap.length': 'Length',
  'zap.width': 'Width',
  'zap.height': 'Height',
  'zap.weight': 'Weight',
  'zap.driver_desc': 'Drivers who can drive the fleet',
  'zap.helper_desc': 'Helper who can be a helper in the fleet',
  'zap.customer_desc': '{customer} who can use the fleet',
  'zap.all_drivers': 'All Drivers',
  'zap.all_helpers': 'All Helpers',
  'zap.all_customers': 'All {customer}',
  'zap.select_manual': 'Select Manual',
  'zap.select_driver': 'Select Driver',
  'zap.driver_help_text':
    'A contact is created automatically for the driver if no matching email or name exists. If more than one match is found, the system uses the top contact in the search results.',
  'zap.driver_label': 'Choose a driver who can drive the Fleet',
  'zap.helper_label': 'Select a helper who can be a helper in the fleet',
  'zap.helper_help_text': 'Helper is used like a backup driver or second driver',
  'zap.select_helper': 'Select Helper',
  'zap.select_customer': 'Select {customer}',
  'zap.customer_label': 'Select {customer} who can become customers in the fleet',
  'zap.fleet_name_is_required': 'Fleet name is required',
  'zap.license_plate_number_is_required': 'Plate number must be filled in',
  'zap.length_is_required': 'Length is required',
  'zap.width_is_required': 'Width is required',
  'zap.height_is_required': 'Height is required',
  'zap.weight_is_required': 'Weight is required',
  'zap.select_location_on_map': 'Select Location on Map',
  'zap.select_location': 'Select Location',
  'zap.center_to_marker': 'Center to marker',
  'zap.route_driver_label': 'Select Driver who can use Route',
  'zap.select_sales': 'Select Sales',
  'zap.all_sales': 'All Sales',
  'zap.sales_label': 'Select Sales who can use Route',
  'zap.route_name': 'Route Name',
  'zap.route_name_is_required': 'Route name is required',
  'zap.enter_route_name': 'Enter Route Name',
  'zap.hide_map': 'Hide Map',
  'zap.show_map': 'Show Map',
  'zap.selected_customers': 'Selected {customer}',
  'zap.routes_all_drivers': 'All Drivers Can Use This Route',
  'zap.routes_all_sales': 'All Sales Can Use This Route',
  'financeDelivery.delivery_recap': 'Delivery Recap',
  'financeDelivery.delivery_recap_confirm': 'Confirm Delivery',
  'zap.canvassing': 'Canvassing',
  'zap.canvassing_total_days': 'Total Days',
  'zap.canvassing_qty_item': 'Item Qty',
  'zap.canvassing_page_help':
    'In Canvassing, your canvasser team carries {product} stock to sell directly to {customer}.',
  'zap.canvassing_stock_taken': 'Stock taken',
  'zap.canvassing_stock_sold': 'Stock sold',
  'zap.canvassing_stock_remaining': 'Remaining stock',
  'zap.canvassing_detail_stock_returned_to_warehouse': 'Stock returned to warehouse',
  'zap.canvassing_detail_per_warehouse': 'Per Warehouse',
  'zap.canvassing_lock_stock': 'Lock Stock',
  'zap.canvassing_set_as_draft': 'Set as Draft',
  'zap.canvassing_cancel_lock_stock': 'Cancel Stock Lock',
  'zap.canvassing_start': 'Start Canvassing',
  'zap.canvassing_end': 'End Canvassing',
  'zap.canvassing_finish_stock': 'Complete Stock',
  'zap.canvassing_return_stock_modal_title': 'Complete canvassing stock {refNumber}',
  'zap.canvassing_return_stock_save': 'Save & return stock to warehouse',
  'zap.canvassing_complete_modal_title': 'End canvassing {refNumber}',
  'zap.canvassing_complete_confirm': 'Are you sure you want to end this canvassing?',
  'zap.canvassing_complete_block_unpaid_invoice':
    'Cannot end canvassing because there are invoices that are not fully paid.',
  'zap.settings_business_flow': 'Business Flow',
  'zap.settings_business_flow_desc': 'Set up the Zap canvassing and delivery recap flow.',
  'zap.settings_end_canvassing_with_unpaid_invoice': 'Allow ending canvassing with unpaid invoices',
  'zap.settings_end_canvassing_with_unpaid_invoice_note':
    'Can canvassing be ended while there are unpaid invoices?',
  'zap.settings_delivery_recap': 'Delivery Recap',
  'zap.settings_delivery_recap_fuel_used_required':
    'Require fuel used when confirming a delivery recap',
  'zap.settings_delivery_recap_fuel_used_required_note':
    'Is fuel used required when confirming a delivery recap with a company fleet?',
  'zap.settings_driver_accounts': 'Driver Accounts',
  'zap.settings_driver_delivery_recap_accounts': 'Accounts shown to drivers',
  'zap.settings_driver_delivery_recap_accounts_note':
    'These accounts are shown in the delivery recap on the driver mobile app.',
  'zap.canvassing_view_warehouse_transfers': 'View warehouse transfer list',
  'zap.canvassing_warehouse_transfers_modal_title': 'Warehouse transfer list',
  'zap.canvassing_warehouse_transfers_modal_subtitle':
    'These warehouse transfers were created automatically by canvassing transactions.',
  'zap.canvassing_add_start_date_required': 'Start date is required',
  'zap.canvassing_add_start_not_before_now': 'Start date and time cannot be in the past',
  'zap.canvassing_add_end_date_required': 'End date is required',
  'zap.canvassing_add_end_before_start': 'End date cannot be before start date',
  'zap.canvassing_add_qty_available': 'Qty available',
  'zap.canvassing_add_qty_required': 'Qty is required',
  'zap.canvassing_add_qty_product_unavailable': 'Product quantity is not available',
  'zap.canvassing_add_qty_insufficient': 'Insufficient quantity',
  'zap.canvassing_edit_qty_below_sold': 'Quantity cannot be less than the quantity already sold.',
  'zap.canvassing_add_min_one_product_qty': 'Add at least one product with quantity greater than 0',
  'zap.hour': 'Hour',
  'zap.hours': 'Hours',
  'zap.minute': 'Minute',
  'zap.minutes': 'Minutes',
  'zap.fleet': 'Fleet',
  'zap.start_warehouse': 'Starting from the Warehouse',
  'zap.start_warehouse_is_required': 'Starting from the warehouse is required',
  'zap.end_warehouse': 'Finished at the Warehouse',
  'zap.1_end_warehouse_help_text':
    'If finish at warehouse is not selected, then the last delivery location becomes the end point.',
  'zap.2_end_warehouse_help_text':
    'If selected then the finished warehouse must be the same as the starting warehouse',
  'zap.fleet_is_required': 'Fleet is required',
  'zap.driver_is_required': 'Driver is required',
  'zap.sales_is_required': 'Sales is required',
  'zap.select_fleet': 'Select Fleet',
  'zap.geo_tagging_is_not_set': 'Geo tagging is not set',
  'zap.add_delivery': 'Add Delivery',
  'zap.selected_delivery': 'Selected Delivery',
  'zap.route': 'Route',
  'zap.all_routes': 'All Routes',
  'zap.per_delivery': 'Per Delivery',
  'zap.weight_volume_exceeds_fleet_capacity': 'Weight/volume exceeds fleet capacity',
  'zap.weight_volume_exceeds_fleet_capacity_desc': 'Are you sure you want to continue?',
  'zap.mark_on_the_go': 'Mark On The Go',
  'zap.shipping_confirmation': 'Shipping Confirmation',
  'zap.deliveries': 'Deliveries',
  'zap.total_distance': 'Total Distance',
  'zap.total_time': 'Total Time',
  'zap.travel_document': 'Travel document',
  'zap.recorded': 'Recorded',
  'zap.capacity_used': 'Capacity Used',
  'zap.deliveries_completed': 'Deliveries Completed',
  'zap.products_sent': '{product} Sent',
  'zap.estimated_arrival': 'Estimated Arrival',
  'zap.travel_expenses': 'Travel Expenses',
  'zap.route_map': 'Route Map',
  'zap.start': 'Start',
  'zap.end': 'End',
  'zap.destination': 'Destination',
  'zap.stop': 'Stop {number}',
  'zap.route_destination_not_found': 'Route destination cannot be found',
  'zap.start_odometer_is_required': 'Start odometer is required',
  'zap.end_odometer_is_required': 'End odometer is required',
  'zap.enter_number': 'Enter Number',
  'zap.departure_time_is_required': 'Departure time is required',
  'zap.arrival_time_is_required': 'Arrival time is required',
  'zap.confirm_items_note':
    'Please fill in the items that have been sent by the driver and the items you want to send back for the next delivery.',
  'zap.time': 'Time',
  'zap.attachment_of_proof_of_payment': 'Attachment of proof of payment',
  'zap.description_is_required': 'Description is required',
  'zap.expenses': 'Expenses',
  'zap.time_to_arrive': 'Time to Arrive',
  'zap.order': 'Order',
  'zap.remains': 'Remains',
  'zap.resend': 'Resend',
  'zap.item_sent': 'Item Sent',
  'zap.distance_from_warehouse': 'Distance from Warehouse',
  'zap.view_delivery_recap': 'View Delivery Recap',
  'zap.map_still_processed': 'Your shipping map is being processed',
  'zap.warehouse_start': 'Warehouse Start',
  'zap.warehouse_end': 'Warehouse End',
  'zap.has_resend_confirm_title': 'A new shipment will be created',
  'zap.has_resend_confirm_desc':
    'Because there are items that will be sent back, the system will automatically create a new Delivery or Delivery Order.',
  'zap.minimum_1_delivery': 'Minimum 1 delivery',
  'zap.confirm_arrival_time_is_required': 'Arrival time is required',
  'zap.latitude_is_required': 'Latitude is required',
  'zap.longitude_is_required': 'Longitude is required',
  'zap.delivery_is_combined_into_delivery_recap': 'Delivery is combined into Delivery Recap',
  'manualJournal.max_character': 'maximum {amount} characters',
  address_empty_state: 'No address registered in this contact, you can add an address here.',
  no_address_yet: 'No Address Yet',
  adding_tag: 'Add Tag',
  'financeOrder.cancel_close_order': 'Cancel Close Order',
  'layoutInvoice.invoice_show_signature_image': 'Show Signature Image',
  'layoutInvoice.image_hidden': 'Image hidden',
  options: 'Options',
  'modifier.extra': 'Extra',
  'modifier.price_excludes_extra': 'Excludes extras of {value} per item',
  'modifier.group_name_label': 'Extra Product Name',
  'modifier.group_name_placeholder': 'e.g. Topping',
  'modifier.type_label': 'Extra Type',
  'modifier.type_optional': 'Optional',
  'modifier.type_optional_hint': 'Customers are not required to choose any available sub-extra.',
  'modifier.type_required': 'Required',
  'modifier.type_required_hint': 'Customers must choose at least one sub-extra.',
  'modifier.selection_label': 'Selection Mode',
  'modifier.selection_single': 'Choose One',
  'modifier.selection_single_hint': 'Customers can only choose one sub-extra.',
  'modifier.selection_multiple': 'Choose Several',
  'modifier.selection_multiple_hint': 'Customers can choose more than one sub-extra.',
  'modifier.allow_qty_hint':
    'Allow one sub-extra to be ordered more than once (e.g. Extra Shot ×2).',
  'modifier.sub_extra': 'Sub-extra',
  'modifier.sub_name_label': 'Sub-extra Name',
  'modifier.sub_name_placeholder': 'e.g. Small',
  'modifier.sub_price_label': 'Selling Price',
  'modifier.sub_product_label': '{product}',
  'modifier.sub_qty_label': 'Quantity',
  'modifier.without_product': 'No {product}',
  'modifier.product_qty_must_be_positive': 'Quantity must be greater than 0',
  'modifier.add_sub_extra': 'Add Sub-extra',
  'modifier.required_needs_active_sub': 'The "Required" type needs at least one active sub-extra.',
  'modifier.name_placeholder': 'e.g. Sugar Level, Add-ons',
  'modifier.min_selected': 'Min. Select',
  'modifier.min_selected_hint': 'Minimum number of options the customer must choose. 0 = optional.',
  'modifier.min_selected_invalid': 'Minimum select is invalid',
  'modifier.min_must_be_lte_max': 'Min. select cannot be greater than max. select',
  'modifier.min_must_be_lte_active_options':
    'Min. select cannot be greater than the number of active options',
  'modifier.max_selected': 'Max. Select',
  'modifier.max_selected_hint':
    'Maximum number of options that can be chosen. 1 = single choice (radio).',
  'modifier.max_selected_invalid': 'Max. select must be at least 1',
  'modifier.allow_quantities': 'Allow Qty',
  'modifier.allow_quantities_hint':
    'Allow one option to be ordered more than once (e.g. Extra Shot ×2).',
  'modifier.options_hint': 'Add options along with their additional price.',
  'modifier.option_name': 'Option Name',
  'modifier.option_price': 'Price',
  'modifier.option_is_required': 'Option name is required',
  'modifier.option_price_is_required': 'Price is required',
  'modifier.option_must_be_unique': 'Option name must be unique',
  'modifier.active': 'Active',
  'modifier.inactive': 'Inactive',
  'modifier.status': 'Status',
  'modifier.free': 'Free',
  'modifier.rules': 'Rules',
  'modifier.required': 'Required',
  'modifier.single_choice': 'Choose 1',
  'modifier.max_n': 'Max. {n}',
  'modifier.qty': 'Qty',
  'modifier.confirm_delete': 'Are you sure you want to delete this extra?',
  'modifier.delete_blocked_title': 'Cannot be deleted',
  'modifier.delete_blocked_used':
    'This extra is already used on a product or transaction, so it cannot be deleted.',
  'modifier.deactivate_instead': 'Deactivate instead',
  'modifier.product_assign_hint': 'Choose extra groups to offer when this product is ordered.',
  'modifier.product_assign_tooltip':
    'Extras are add-on choices on a product that can be selected when placing an order, such as toppings, sizes, or other options.',
  'modifier.select_groups_placeholder': 'Select extra groups',
  'modifier.assign_failed': 'Failed to save product extras',
  'modifier.assign_title_add': 'Add Extra',
  'modifier.assign_title_update': 'Update Extra',
  'modifier.assign_empty': 'No extras yet. Create one from the Extra menu in the product list.',
  'modifier.assign_saved': 'Product extras updated successfully.',
  'modifier.detach_confirm': 'Remove this extra from the product?',
  'modifier.choose_extra': 'Choose Extra',
  'modifier.line_total': 'Total',
  'modifier.below_min_selected': 'Group "{group}" requires at least {n} option(s).',
  'modifier.above_max_selected': 'Group "{group}" allows at most {n} option(s).',
  variant_option_is_required: 'Variant option is required!',
  variant: 'Variant',
  are_you_sure_you_want_to_delete_this_variant: 'Are you sure you want to delete this variant?',
  add_product_variant: 'Add {title} Variant',
  duplicate_product_variant: 'Duplicate {title} Variant',
  all_variant: 'All Variant',
  select_options: 'Select Options',
  set_price_for_all_variants: 'Set Price for All Selected Variants',
  select_variant: 'Select Variant',
  max_options_count: 'Maximum {count} options can be selected',
  max_variants_count: 'Maximum {count} variants can be added',
  please_select_variant: 'Please select variant',
  please_select_option: 'Please select option',
  variant_only: 'Variant Only',
  variant_with_title: 'Variant {title}',
  this_option_is_used_in: 'This option is used in {count} products',
  this_option_is_not_used_in: 'This option is not used in any product',
  main_product_variant: 'Main Product Variant',
  main_product: 'Main Product',
  main_product_variant_tooltip: 'If checked, only show main product',
  edit_product_variant: 'Edit {title} Variant',
  variant_option_must_be_unique: 'Variant option must be unique!',
  'product_variant.option_limit_title': 'Upgrade your plan',
  'product_variant.option_limit_message':
    'The {plan} plan supports up to {count} variant options. Upgrade to {nextPlan} to add up to {nextCount} options.',
  'product_variant.option_limit_pill': '{plan}: {count} options',
  'report.total_return': 'Total Return',
  'report.return_amount': 'Return Amount',
  'layoutInvoice.return_print_delivery': 'Return Print Delivery',
  'layoutInvoice.purchase_return_print_delivery': 'Purchase Return Print Delivery',
  'financeInvoices.print_return_delivery': 'Print Return Delivery',
  'financeInvoices.print_purchase_return_delivery': 'Print Purchase Return Delivery',
  'businessFlow.invoice_lock_future_transaction_date': 'Reject Future Transaction Date',
  'businessFlow.invoice_lock_future_transaction_date_desc':
    'Reject transactions that have a date after today',
  'businessFlow.invoice_payment_sync': 'Synchronize Invoice and Payment Tags',
  'businessFlow.invoice_payment_sync_desc':
    'When invoice tags are changed, the tags in payment details will be updated automatically, so users only need to make changes once in the invoice.',
  'businessFlow.quote_auto_delete_enabled': 'Automatically Delete Old {quote}',
  'businessFlow.quote_auto_delete_enabled_desc':
    'Every month, {quote} older than the threshold will be deleted automatically. Completed or partially ordered {quote} will not be deleted.',
  'businessFlow.quote_auto_delete_months': '{quote} Age to Delete (Months)',
  'businessFlow.quote_auto_delete_months_desc':
    'Counted from the date the {quote} was created. Enter a value between 1 and 60 months.',
  'businessFlow.quote_auto_delete_months_validation': 'Enter a value between 1 and 60 months.',
  'businessFlow.price_forecast': 'Raw Material Price Forecast',
  'businessFlow.price_forecast_desc':
    'Project raw material costs based on price increase scenarios when creating a quote, so the offered selling price stays in line with the estimated future cost.',
  'businessFlow.purchase_invoice_lock_future_transaction_date': 'Reject Future Transaction Date',
  'businessFlow.purchase_invoice_lock_future_transaction_date_desc':
    'Reject transactions that have a date after today',
  'businessFlow.purchase_invoice_payment_sync': 'Synchronize Invoice and Payment Tags',
  'businessFlow.purchase_invoice_payment_sync_desc':
    'When invoice tags are changed, the tags in payment details will be updated automatically, so users only need to make changes once in the invoice.',
  can_not_select_future_transaction_date: 'Cannot select future transaction date',
  total_transactions_found: 'Total {count} data found',
  confirmation: 'Confirmation!',
  variant_already_added_will_be_deleted_are_you_sure:
    'The variant that has already been added will be deleted, are you sure?',
  please_select_all_variants_to_continue: 'Please select all variants to continue',
  variant_not_available: 'Variant not available',
  cash_in_out: 'Cash In/Out',
  are_you_sure_you_want_to_delete_this_data: 'Are you sure you want to delete this data?',
  manual_cash_payment: 'Manual Cash Payment',
  'table.min_two_column': 'Minimum show two column',
  'button.print_approval': 'Print Approval',
  total_cash_cashier: 'Total Cashier Cash',
  payment_details: 'Payment Details',
  success_transaction: 'Success Transaction!',
  payment_successful: 'Payment Successful',
  order_ref: 'Order Ref',
  change_due: 'CHANGE DUE',
  total_paid: 'Total Paid',
  order_total: 'Order Total',
  payment_method: 'Payment Method',
  receipt_summary: 'Receipt Summary',
  share_receipt: 'SHARE RECEIPT',
  print_receipt: 'Print Receipt',
  new_transaction: 'New Transaction',
  unit: 'unit',
  units: 'units',
  additional_fee: 'Additional Fee',
  e_wallet: 'E-Wallet',
  online_delivery: 'Online Delivery',
  edc: 'EDC',
  e_commerce: 'E-Commerce',
  other: 'Other',
  transfer_bank: 'Bank Transfer',
  bank_transfer_payment_title: 'Bank Transfer',
  edc_payment_title: 'EDC Payment',
  process_enterprise_transaction_details:
    'Process enterprise transaction details for incoming settlement',
  customer_bank_details: 'Customer Bank Details',
  payment_and_destination: 'Payment & Destination',
  transfer_bank_remember_title: 'Use {bank} for Transfer from now on?',
  transfer_bank_remember_desc:
    'Upcoming transactions paid by Transfer will be recorded to {bank} right away without opening this form. You can change it anytime from the icon on the Transfer button or POS Settings.',
  transfer_bank_remember_answer: 'Remember my answer',
  transfer_bank_remember_yes: 'Yes, keep using it',
  transfer_bank_remember_no: 'No, ask me later',
  transfer_bank_auto_to: 'Auto to {bank}',
  transfer_bank_stop_auto: 'Stop auto',
  transfer_bank_stop_auto_confirm: 'Stop using {bank} automatically?',
  transfer_bank_auto_bank_missing:
    'The saved destination bank is no longer active, please select again',
  transfer_bank_auto_setting_title: 'Auto Transfer',
  transfer_bank_auto_setting_note:
    'When enabled, clicking Transfer at the cashier records the payment to the destination bank below without opening the form. This setting is stored on this device only.',
  total_payable_amount: 'TOTAL PAYABLE AMOUNT',
  deposit: 'Deposit',
  qris: 'QRIS',
  printer_setting: 'Setting Printer',
  printer_name: 'Printer Name',
  printer_variant: 'Variant Printer',
  printer_type: 'Printer Type',
  printer_connection: 'Printer Connection',
  please_select_print_method: 'please_select_print_method',
  please_select_printer: 'please_select_printer',
  please_select_variant_printer: 'please_select_variant_printer',
  please_select_connection: 'please_select_connection_printer',
  print_method: 'Print Method',
  add_printer: 'Add Printer',
  edit_printer: 'Edit Printer',
  select_printer: 'Select Printer',
  cashier_printer: 'Cashier Printer',
  kitchen_printer: 'Kitchen Printer',
  label_printer: 'Label Printer',
  loading_printer_list: 'Loading printer list...',
  no_printer_detected_make_sure_qztray_is_running:
    'No printer detected, make sure QZ Tray is running.',
  already_used: 'Already used',
  selected: 'Selected',
  esc_pos_command_thermal_printer_type: 'ESC/POS command thermal printer type',
  pixel_printer_type_that_uses_pixel_printer:
    'Pixel printer type (printer that uses pixel printing)',
  print_type: 'Printer Type',
  please_select_type_printer: 'Please select printer type',
  print_command: 'Print Command',
  please_select_print_command: 'Please select print command',
  paper_size: 'Paper Size',
  kitchen: 'Kitchen',
  printer_added_successfully: 'Printer added successfully',
  printer_updated_successfully: 'Printer updated successfully',
  please_select_paper_size: 'Please select paper size',
  print_function: 'Print Function',
  print_function_desc: 'Adjust the printer usage according to your needs',
  auto_print_invoice: 'Auto Print Invoice',
  number_of_copies: 'Number of Copies',
  printer_deleted_successfully: 'Printer deleted successfully',
  printer_deleted_failed: 'Failed to delete printer',
  'report.opening_stock': 'Opening Stock',
  'report.closing_stock': 'Closing Stock',
  'report.avg_stock': 'Average Stock',
  'report.sold_qty': 'Sold Qty',
  'report.turnover_ratio': 'Turnover Ratio',
  'report.storing_duration': 'Storing Duration',
  search_transaction: 'Search transaction ...',
  globalSearch_find_everything: 'Find Everything',
  globalSearch_find_everything_desc: 'Quick access to all your business data in one simple search.',
  globalSearch_data_search: 'DATA SEARCH',
  globalSearch_what_are_you_looking_for: 'What are you looking for today?',
  globalSearch_search_placeholder: 'Start typing to search across all data',
  globalSearch_search_hint: 'Type product name, contact or transaction number',
  globalSearch_no_data: 'No data',
  globalSearch_no_data_with_keyword: 'No data found according to your search "{keyword}"',
  globalSearch_reset_search: 'Reset search',
  globalSearch_esc_to_close: 'ESC to close',
  'appSetting.token_name': 'Token Name',
  'appSetting.token_name_help_text':
    'Enter the token name associated with the application that uses the token or the purpose of the token.',
  'appSetting.please_input_token_name': 'Please enter the token name',
  'appSetting.expiration_date': 'Expiration Date',
  'appSetting.add_token': 'Add Token',
  'appSetting.expires_in_days_help_text': 'Maximum expiration date of the token',
  'appSetting.successfully_copied_token': 'Successfully copied token',
  'appSetting.your_personal_access_token': 'Your Personal Access Token',
  'appSetting.please_copy_and_save_the_token_above':
    'Please copy and save the token code above, this token code can only be accessed once',
  'appSetting.page_desc':
    'You can create a personal access token for each application that requires a token when integrated with Kledo.',
  'appSetting.app_code': 'App Code',
  'appSetting.token': 'Token',
  'appSetting.last_used_at': 'Last Used',
  'appSetting.never_used': 'Never used',
  'appSetting.status': 'Status',
  'appSetting.expired': 'Expired',
  'appSetting.active': 'Active',
  'appSetting.active_tokens': 'Active tokens',
  'appSetting.expired_tokens': 'Expired tokens',
  'appSetting.token_never_used': 'Token never used',
  'zap.address_is_required': 'Address is required',
  'zap.search_fleet_placeholder': 'Search by fleet name or license plate number',
  'zap.departure_odometer': 'Departure Odometer',
  'zap.odometer_back': 'Odometer Back',
  'zap.departure_time': 'Departure Time',
  'zap.arrival_time': 'Arrival Time',
  'zap.fleet_name_has_been_used': 'Fleet name has been used',
  'zap.fail_check_unique_fleet_name': 'Fleet unique name check failed',
  'zap.license_plate_number_has_been_used': 'License plate number has been used',
  'zap.fail_check_unique__license_plate_number': 'Unique license plate number check failed',
  please_wait: 'Please wait...',
  'zap.recap_per_shipment': 'Recap per Shipment',
  'zap.recap_per_product': 'Recap per {product}',
  'zap.all_print_delivery': 'All Print Delivery',
  'zap.already_geo_tagged': 'Already Geo Tagged',
  'zap.no_geo_tagging': 'No Geo Tagging',
  'zap.warning_fleet_company_map_not_available_1':
    'The shipping route map is inactive in this recap delivery. Do the following to activate the shipping route:',
  'zap.warning_fleet_company_map_not_available_2':
    '- Make sure all shipping addresses and warehouses have geo tagging.',
  'zap.warning_fleet_company_map_not_available_3':
    '- Make sure the driver and fleet are included in this recap delivery.',
  all_items_volume_total: 'Total {product} volume',
  'financeContacts.sales_person_help_text':
    'In the Zap app, only customers whose sales person matches will appear.',
  'zap.confirmation': 'Confirmation',
  'zap.fuel_consumption': 'Fuel Consumption',
  'zap.fuel_consumption_is_required': 'Fuel consumption is required',
  'zap.fuel_used': 'Fuel Used',
  'zap.fuel_used_is_required': 'Fuel used is required',
  'zap.travel_data': 'Travel Data',
  'zap.estimation': 'Estimation',
  'zap.difference': 'Difference',
  'zap.fuel': 'Fuel',
  'zap.faster': 'Faster',
  'zap.slower': 'Slower',
  'zap.more_fuel_used': 'More fuel used',
  'zap.less_fuel_used': 'Less fuel used',
  'zap.performance': 'Performance',
  'zap.route_name_has_been_used': 'Route name has been used',
  'zap.fail_check_unique_route_name': 'Unique route name check failed',
  'zap.this_expense_is_automatically_created_from_delivery_recap':
    'This expense is automatically created from the delivery recap transaction.',
  'zap.search_by_route_name': 'Search by route name',
  total_weight: 'Total Weight',
  total_qty: 'Total Quantity',
  'financeDelivery.mark_as_delivered': 'Mark as Delivered',
  'financeDelivery.mark_as_not_delivered': 'Mark as Not Delivered',
  'zap.minimum_1_customer': 'Minimal 1 {customer}',
  'zap.invoice_is_combined_into': 'Invoice is combined into {target}',
  'zap.invoice_is_combined_into_canvassing_and_recap':
    'Invoice is combined into {canvassing} & {invoiceRecap}',
  'zap.warehouse_is_combined_into_canvassing': 'Warehouse is combined into Canvassing',
  'zap.warehouse_is_combined_into_group': 'Warehouse is combined into Combined Transfer',
  collector: 'Collector',
  collector_2: 'Collector',
  start_date_is_required: 'Start date is required',
  end_date_is_required: 'End date is required',
  select_collector: 'Select Collector',
  collector_is_required: 'Collector is required',
  add_invoice: 'Add Invoice',
  selected_invoice: 'Selected Invoice',
  mark_as_completed: 'Mark as Completed',
  payment_received: 'Payment received',
  search_for_invoice_number: 'Search for Invoice Number',
  zap_balance_due_help_text: 'Remaining balance that needs to be billed to {customer}',
  accepted: 'Accepted',
  accepted_help_text: 'Total payments received by collectors',
  other_payments: 'Other Payments',
  other_payments_help_text: 'Payments that do not go through this collector',
  cash_or_bank: 'Cash/Bank',
  'zap.delivery_recap_help_text_1':
    'With shipping recap, you can combine multiple shipments from different {customer} into one shipping recap.',
  'zap.delivery_recap_help_text_2':
    'This summary can be used as a combined delivery for fleet drivers.',
  'zap.delivery_recap_help_text_3': 'and start using the delivery recap feature!',
  'zap.invoice_recap_help_text_1':
    'With Invoice Recap, you can combine multiple Invoices from different {customer} into one Invoice Recap.',
  'zap.invoice_recap_help_text_2':
    'This summary can be used as a collection assignment letter for {sales_person} and canvasser.',
  'zap.invoice_recap_help_text_3': 'and start using the invoice recap feature!',
  add_invoice_recap: 'Add Invocie Recap',
  minimum_1_invoice_selected: 'Minimum 1 invoice selected',
  'appSetting.last_used_date': 'Last Used Date',
  'appSetting.example_script': 'Example Script',
  'appSetting.download_example_script':
    'Download examples of using the Kledo API in various programming languages. Replace the API_HOST and ACCESS_TOKEN with your own values.',
  'appSetting.successfully_copied_code': '{name} code has been copied',
  'appSetting.successfully_downloaded_code': '{name} code has been downloaded',
  'appSetting.postman_collection': 'Postman Collection',
  'appSetting.download_postman_collection': 'Download Postman Collection',
  'financeOrder.close_order': 'Close Order',
  'report.asc': 'Oldest',
  'report.desc': 'Newest',
  'report.order_by': 'Order By',
  'report.pricelist_unit_conversion_search_placeholder': 'Search by product name or SKU code',
  'report.only_unit_conversion': 'Only products with unit conversion',
  'report.qty_base_unit': 'Qty (Base Unit)',
  'report.product_created_date': 'Product Created Date',
  failed_to_download_file: 'Failed to download file',
  file_has_been_downloaded: 'File has been downloaded',
  refund_all_items: 'Refund all items',
  otorisation: 'Otorisation',
  select_otorisation: 'Select otorisation',
  input_otorisation_pin_code: 'Input otorisation pin code',
  please_input_otorisation_pin_code: 'Please input otorisation pin code',
  approval_otorization_note:
    'If enabled, when processing a refund, authorization from management is required',
  is_auto_apply_product_discount: 'Auto Apply Product Discount',
  is_auto_apply_product_discount_note:
    'When enabled, product promos/discounts are applied automatically when an item is added to the cart. When disabled, the cashier can still choose a promo manually per item',
  print_style_show_product_price_title: 'Show product price',
  print_style_show_product_price_note:
    'When enabled, product prices and discount per item are shown when printing struk and bill',
  print_style_show_witholding_title: 'Show withholding',
  print_style_show_witholding_note:
    'When disabled, withholding lines are not printed on the receipt and e-receipt, and totals are shown as if there were no withholding',
  is_manual_tax_item_title: 'Manual Tax per Item',
  is_manual_tax_item_note: 'Enable to edit tax on each item in the cashier',
  queue_number: 'Queue No.',
  queue_number_title: 'Queue Number',
  queue_number_active_label: 'Enable Queue Number',
  queue_number_note:
    'When enabled, every new transaction automatically gets a queue number. Changes only apply to subsequent transactions',
  queue_number_reset_daily: 'Daily reset',
  queue_number_prefix: 'Prefix',
  queue_number_suffix: 'Suffix',
  queue_number_padding: 'Leading Zeros (0-12)',
  queue_number_padding_note: 'Example: set 1 → queue number becomes 01, 02, 03, etc.',
  no_data_selected_yet_please_select_first:
    'No data selected yet, please select first to display detail',
  receipt_and_fee: 'Receipt & Expense',
  outlet_address: 'Outlet Address',
  outlet_phone: 'Outlet Phone',
  outlet_name: 'Outlet Name',
  main: 'Main',
  hardware: 'Hardware',
  shift_history: 'Shift History',
  shift_detail: 'Shift Detail',
  shift_history_subtitle: 'Ongoing and closed shifts',
  shift_status_open: 'Ongoing',
  shift_status_closed: 'Closed',
  shift_until_now: 'Now',
  no_open_shift: 'No ongoing shifts',
  shift_running_since: 'Shift ongoing · {duration} since {time}',
  shift_close_owner_only: 'Only the shift owner can close this shift',
  please_select_outlet_to_continue: 'Please select outlet to continue',
  open_shift: 'Open Shift',
  please_open_shift_first: 'Please open shift first',
  shift_not_found: 'Shift Not Found',
  shift_not_found_on_database:
    'Shift not found in the database. Are you sure you want to reset the shift and open a new one?',
  active_session: 'ACTIVE SESSION',
  welcome_back: 'Welcome back, {name}!',
  lets_provide_best_service: "Let's provide the best service today!",
  employee_id: 'EMPLOYEE ID',
  ready_to_start_transactions: 'Ready to start your transactions',
  opening_balance: 'Opening Balance',
  quick_select_amounts: 'QUICK SELECT AMOUNTS',
  start_shift: 'Start Shift',
  logout_account: 'Logout Account',
  help: 'Help',
  close_shift_success: 'Close Shift Success',
  close_shift_message:
    'Thank you very much for your hard work today, you have made the transaction process run smoothly. We are very proud of you.',
  please_input_the_last_cashier_balance: 'Please input the last cashier balance',
  shift_duration: 'Shift duration',
  payment_name: 'Payment Name',
  cashless_payment: 'Cashless Payment',
  please_select_payment_type: 'Please select payment type',
  payment_type: 'Payment Type',
  select_payment_type: 'Select payment type',
  please_select_provider: 'Please select provider',
  select_provider: 'Select provider',
  please_input_payment_name: 'Please input payment name',
  input_payment_name: 'Input payment name',
  please_select_a_account: 'Please select a account',
  mdr_fee: 'MDR Fee',
  account_coa: 'Account COA',
  select_account_coa: 'Select account COA',
  outlet_availability: 'Outlet Availability',
  specific_outlets: 'Specific Outlets',
  applies_at_outlet: 'Available at Outlet',
  please_select_min_one_outlet: 'Select at least one outlet',
  outlet_availability_hint: 'Payment only appears in the cashier of the selected outlets',
  input_nominal: 'Input nominal',
  total_after_mdr_fee: 'Total after MDR fee',
  input_note: 'Input note',
  customer_bank: 'Customer Bank',
  select_customer_bank: 'Select customer bank',
  input_customer_card_number: 'Input customer card number',
  input_customer_account_number: 'Input customer account number',
  customer_account_holder: 'Customer account holder',
  input_customer_account_holder: 'Input customer account holder',
  please_select_destination_bank: 'Please select destination Bank',
  select_destination_bank: 'Select destination Bank',
  destination_bank: 'Destination Bank',
  exact_money: 'Exact Money',
  select_customer: 'Select customer',
  please_input_the_nominal: 'Please input the nominal',
  'crm.hash_tag': '#GetBetter serve your business customers',
  'crm.head_title_1': 'Boost Customer Retention and',
  'crm.head_title_2': 'Business Sales with',
  'crm.head_title_3': 'CRM.ID',
  'crm.head_title_description':
    'An official and trusted WhatsApp API solution, designed for better communication management and customer retention without the risk of number blocking. Unlimited features at an affordable price.',
  'crm.signup': 'Sign Up for CRM.ID',
  'crm.sales_contact': 'Contact Sales',
  'crm.feat_1_sub_title': 'Unlimited MAU',
  'crm.feat_1_description': 'Serve unlimited customers without worrying about ',
  'crm.feat_1_description_2': 'Monthly Active Users ',
  'crm.feat_1_description_3':
    '(MAU). Just focus on providing excellent customer service and improving your product.',
  'crm.feat_2_sub_title': 'Number Masking & Green Badge',
  'crm.feat_2_description':
    'Get an official number masking from WhatsApp. And if your business qualifies, you will also receive the WhatsApp green badge at no extra cost.',
  'crm.feat_3_sub_title': 'Multi Agent',
  'crm.feat_3_description':
    'Have multiple customer service agents? With CRM.ID, you only need one WhatsApp number to serve many customers simultaneously.',
  'crm.feat_4_sub_title': 'Quick Search and Data Filtering',
  'crm.feat_4_description':
    'Conversation history is automatically saved and easily searchable. Conversations can also be filtered for accurate results.',
  'crm.feat_5_sub_title': 'Unlimited 1 on 1 Support',
  'crm.feat_5_description':
    'Get free 1-on-1 Zoom support sessions with no limits. The CRM.ID team will assist with onboarding, employee training, and ongoing support throughout your usage.',
  'crm.feat_6_sub_title': 'Transparent Pricing',
  'crm.feat_6_description': 'Pay as you go. ',
  'crm.feat_6_description_2':
    'Honest pricing with no hidden fees. Only Rp40/message, including 1,000 free WhatsApp conversations per month. No feature limitations.',
  'crm.footer_note':
    'Boost customer loyalty and sales more effectively through WhatsApp API integration with CRM.ID. Try it now.',
  'crm.feat_title_1': 'What Will',
  'crm.feat_title_2': 'You Get',
  'crm.feat_title_3': 'When Using CRM.ID?',
  'crm.crm': 'CRM.ID',
  'crm.integrating_success_1': 'Yeaah!, The',
  'crm.integrating_success_2': 'Kledo',
  'crm.integrating_success_3': 'account has been successfully connected to the CRM.ID Software',
  'crm.integrating_success_4': 'CRM.ID.',
  'crm.go-to-crm': 'Go to CRM.ID',
  please_select_reason_to_close_order: 'Please select reason to close order',
  change_pin: 'Change PIN',
  lock_screen: 'Lock Screen',
  close_shift: 'Close Shift',
  update_your_current_pin: 'Update your current PIN',
  old_pin: 'Old PIN',
  new_pin: 'New PIN',
  confirm_new_pin: 'Confirm New PIN',
  input_your_old_pin: 'Enter Old PIN',
  input_your_new_pin: 'Enter New PIN',
  input_your_confirm_new_pin: 'Enter Confirm New PIN',
  pin_must_be_6_characters: 'PIN must be 6 characters',
  pin_does_not_match: 'PIN does not match',
  please_input_your_old_pin: 'Please enter old PIN',
  please_input_your_new_pin: 'Please enter new PIN',
  please_input_your_confirm_new_pin: 'Please enter confirm new PIN',
  pin_changed_successfully: 'PIN changed successfully',
  web_order: 'Web Order',
  with_the_web_order_feature_you_can_now_easily_sell_products_online_using_the_qrcode_and_web_link_below:
    'With the Web Order feature, you can now easily sell products online using the QR code and web link below.',
  web_order_preview: 'Web Order Preview',
  see_web_order: 'See Web Order',
  web_order_link: 'Web Order Link',
  web_order_qrcode: 'Web Order QR Code',
  see_qrcode: 'See QR Code',
  scan_qrcode_to_view_the_menu: 'Scan QR code to view the menu',
  printer_connection_type: 'Choose the type of printer to use:',
  printer_network_lan_wifi: 'Printer Network (LAN / WiFi)',
  printer_network_recommended: 'Recommended for POS, Fast & stable',
  printer_usb_pc: 'Printer USB / PC',
  printer_usb_pc_desc: 'Printer connected to PC',
  scan_automatic: 'Automatic Scan',
  scan_automatic_desc: 'Search for thermal printers on your local network',
  search_automatic_printer: 'Search Automatic Printer',
  printer_selected_ip_port_filled:
    'Printer "{printerName}" selected. IP and Port have been filled.',
  printer_selected_manual_input:
    'Printer "{printerName}" selected. Please enter IP and Port manually below.',
  or: 'or',
  manual_setup: 'Manual Setup',
  ip_address: 'IP Address',
  ip_address_placeholder: 'IP Address',
  enter_ip_address: 'Enter IP address',
  invalid_ip_format: 'Invalid IP format',
  port: 'Port',
  port_placeholder: 'Port',
  enter_port: 'Enter port',
  port_must_be_number: 'Port must be a number',
  ensure_printer_pc_same_network: 'Ensure printer & PC are on the same network',
  qz_tray_not_installed: 'QZ Tray Not Installed/Running',
  qz_tray_required_for_printer:
    'QZ Tray is required to use the printer feature. Please install QZ Tray first.',
  download_qz_tray: 'Download QZ Tray',
  download_qz_tray_from_official_website: 'Download QZ Tray from official website',
  install_qz_tray: 'Install QZ Tray',
  install_qz_tray_on_computer: 'Install QZ Tray application on your computer',
  run_qz_tray: 'Run QZ Tray',
  open_qz_tray_and_ensure_running: 'Open QZ Tray application and ensure it is running',
  refresh_page: 'Refresh Page',
  refresh_page_to_check_status: 'Refresh this page to check status',
  installation_steps: 'Installation Steps:',
  click_download_qz_tray_button: 'Click the Download QZ Tray button below',
  or_visit: 'Or visit',
  select_version_for_your_os:
    'Select the version that matches your operating system (Windows/macOS/Linux)',
  open_installer_file: 'Open the downloaded installer file',
  follow_installation_steps: 'Follow the installation steps',
  ensure_qz_tray_installed_correctly: 'Ensure QZ Tray is installed correctly',
  open_qz_tray_from_start_menu:
    'Open QZ Tray application from Start menu (Windows) or Applications (macOS)',
  qz_tray_icon_will_appear: 'QZ Tray icon will appear in system tray (Windows) or menu bar (macOS)',
  ensure_qz_tray_status_running: 'Ensure QZ Tray status shows "Running" or "Connected"',
  after_qz_tray_running_refresh: 'After QZ Tray is running, refresh this page',
  system_will_auto_detect_qz_tray: 'The system will automatically detect QZ Tray',
  you_can_start_using_printer: 'You can start using the printer feature',
  important_note: 'Important Note',
  qz_tray_must_run_every_time: 'QZ Tray must be running every time you use the printer feature',
  ensure_qz_tray_not_blocked: 'Ensure QZ Tray is not blocked by firewall or antivirus',
  macos_permission_note:
    'If using macOS, you may need to grant permission in System Preferences → Security & Privacy',
  qz_tray_certificate_section_title: 'Remove Certificate Dialog (Optional)',
  qz_tray_certificate_section_desc:
    'After QZ Tray is installed, a confirmation dialog may appear every time you print. To avoid this, add the digital certificate to Site Manager.',
  qz_tray_download_certificate: 'Download Digital Certificate',
  qz_tray_download_certificate_desc:
    'Download the digital-certificate.txt file to your computer. This file is required to authorize Kledo site in QZ Tray.',
  qz_tray_open_site_manager: 'Open Site Manager',
  qz_tray_open_site_manager_desc:
    'Run QZ Tray if not already running. Click QZ Tray icon in system tray/menu bar → select Advanced → Site Manager',
  qz_tray_add_certificate: 'Add Certificate',
  qz_tray_add_certificate_desc:
    'In the Site Manager window, click the + (plus) icon button at the bottom, then select "Browse..." and choose the downloaded digital-certificate.txt file.',
  qz_tray_refresh_and_try: 'Refresh & Try Again',
  qz_tray_refresh_and_try_desc:
    'After adding the certificate, close Site Manager, refresh this page, then try printing again. The confirmation dialog will no longer appear.',
  qz_tray_img_caption_advanced: 'Advanced → Site Manager',
  qz_tray_img_caption_site_manager: 'Click + → Browse... → Select digital-certificate.txt',
  summary_detail: 'Summary Detail',
  reset_your_current_pin: 'Reset your current PIN',
  pin_reset_successfully: 'PIN successfully reset',
  please_input_your_password_to_reset_pin: 'Please enter your password to reset PIN',
  forgot_pin: 'Forgot PIN',
  refund_description: 'Refund Description',
  refund_reason_other: 'Refund Reason Other',
  refund_reason: 'Refund Reason',
  please_select_refund_reason: 'Please select refund reason',
  refund_method: 'Refund Method',
  please_select_refund_method: 'Please select refund method',
  amount_after_tax_must_be_greater_than_0: 'Amount after tax must be greater than 0',
  open_cashier: 'Open Cashier',
  initial_capital: 'Determine Initial Capital',
  initial_capital_note: 'Default entering initial capital every time the cashier is opened',
  close_cashier: 'Close Cashier',
  close_cashier_capital: 'Determine Initial Capital',
  close_cashier_capital_note: 'Default entering initial capital every time the cashier is closed',
  auto_close: 'Auto Close Cashier',
  auto_close_note: 'Auto close cashier after a certain time',
  auto_close_time: 'Auto Close Cashier Time',
  auto_close_shift_time: 'Shift Closing Time',
  auto_close_shift_min_open_hour: 'Minimum Shift Open Duration',
  auto_close_shift_min_open_hour_note:
    'A shift is only closed automatically after it has been open at least this long',
  auto_close_time_note: 'Auto close cashier after a certain time',
  auto_close_time_help_text: 'Auto close cashier after a certain time',
  auto_close_time_help_text_note: 'Auto close cashier after a certain time',
  cash_out_limit: 'Determine Cash Out Limit',
  cash_out_limit_note: 'Allow the cashier to withdraw cash according to the specified amount',
  activate_to_add_service_fees_when_paying_at_the_cashier:
    'Activate to add service fees when paying at the cashier',
  additional_discount_note: 'If enabled, you can add direct discounts in the cashier as needed',
  service_charge: 'Service Charge',
  service_charge_note: 'Activate to add service fees when paying at the cashier',
  manual_product_price: 'Manual Product Price',
  manual_product_price_note:
    'If enabled, you can change the price directly in the cashier as needed',
  input_product_name: 'Input product name',
  please_input_product_name: 'Please input product name',
  add_custom_product: 'Add Custom Product',
  print_recap: 'Print Recap',
  print_product_sold: 'Print Sold Products',
  print_payment_detail: 'Print Payment Details',
  shift_report: 'CASHIER CLOSING SALES REPORT',
  products: 'Products Sold',
  refund: 'Refund',
  total_cashless: 'Total Non Cash',
  products_sold: 'Products Sold',
  please_input_printer_name: 'Please input printer name',
  input_printer_name: 'Input printer name',
  invoice_successfully_refunded: 'Invoice successfully refunded',
  invoice_failed_to_refund: 'Invoice failed to refund',
  please_select_tax_to_use_in_pos:
    "Please select tax according to the company's regulations. The tax selected will be used for all transactions in your POS.",
  tax_value: 'Tax Value (%)',
  'billing.upgrade_with_3_year_or_3_month':
    '{clickHere} to upgrade with 3 year or 3 month contract.',
  custom_paper_width: 'Width (mm)',
  custom_paper_height: 'Height (mm)',
  custom_paper_width_required: 'Width must be filled',
  custom_paper_height_required: 'Height must be filled',
  custom_paper_width_placeholder: 'Width',
  custom_paper_height_placeholder: 'Height',
  'date.next_2_years': '2 Years Next',
  'date.next_3_years': '3 Years Next',
  'financeOrder.close_reason': 'Order closing reason',
  'financeOrder.all_closed': 'All Completed',
  'financeOrder.reason_cancel_order': 'Order Cancelled',
  'financeOrder.reason_wrong_process': 'Incorrect Processing',
  'financeOrder.reason_other': 'Other',
  please_enter_refund_reason_other: 'Please enter refund reason other',
  promo_title: 'Promo',
  promo_subtitle:
    'Use promos to give discounts to customers according to the applicable conditions.',
  promo_empty: 'No promos available yet',
  promo_show_disabled: 'Show promos that cannot be selected yet',
  promo_hide_disabled: 'Hide promos that cannot be selected yet',
  markup_title: 'Markup',
  markup_subtitle:
    'Use markup to increase the selling price in certain conditions without filling the discount field.',
  markup_empty: 'No markups available yet',
  markup_show_disabled: 'Show markups that cannot be selected yet',
  markup_hide_disabled: 'Hide markups that cannot be selected yet',
  badge_markup: 'Markup',
  badge_promo: 'Promo',
  promo_recommended: 'Recommended',
  promo_delete_title: 'Remove Promo',
  promo_apply_title: 'Apply Promo',
  promo_cancel: 'Cancel',
  print_invoice_successfully: '{printFunction} successfully printed',
  close_order_successfully: 'Order successfully closed',
  cancel_order: 'Cancel Order',
  are_you_sure_to_cancel_order: 'Are you sure you want to cancel this order?',
  reset_selected_tax: 'Reset Selected Tax',
  'report.sku_code': 'Kode SKU',
  'report.sell_price_history_search_placeholder': 'Search by product name, code or number',
  'dueReminder.send_email_to_customer': 'Send Email to {customer}',
  'dueReminder.send_email_to_admin': 'Send Email to Admin',
  'dueReminder.send_whatsapp_to_customer': 'Send Whatsapp to {customer}',
  no_templates: 'No templates',
  purchase_join_invoice: 'Purchase Join Invoice',
  invoice_thank_you: 'Email Thank You',
  customer_birthday_setting: 'Customer Birthday Setting',
  minimum_1_delivery_selected: 'Minimum 1 delivery selected',
  'zap.payment_invoice_is_combined_into_invoice_recap':
    'Payment invoice is combined into Invoice Recap',
  invoice_recap: 'Invoice Recap',
  delivery_recap_alert_message:
    'With the delivery summary, you can combine several different deliveries from {customer} into one delivery summary, this summary can be used as a combined delivery note for fleet drivers.',
  cc_email_address: 'CC Email Address',
  'emails.cc_email_desc':
    "When you send an email, it will automatically be CC'd to the following email addresses:",
  loading_more: 'Loading more...',
  old_email_otp_code: 'Old Email OTP Code',
  new_email_otp_code: 'New Email OTP Code',
  sub_category_from: 'Sub Category From',
  'layoutInvoice.invoice_show_number_invoice': 'Show Invoice Number',
  'layoutInvoice.show_receipt_signature_made_by': 'Show Made By Signature',
  'layoutInvoice.show_receipt_signature_checked_by': 'Show Checked By Signature',
  'layoutInvoice.show_receipt_signature_approved_by': 'Show Approved By Signature',
  'layoutInvoice.show_receipt_signature_received_by': 'Show Received By Signature',
  'financeInvoices.select_email': 'Select email',
  'financeInvoices.select_sending_method': 'Select sending method for your customer',
  'financeInvoices.quick_response': 'Quick Response',
  'financeInvoices.formal_professional': 'Formal & Professional',
  'financeInvoices.whatsapp_destination_number': 'WhatsApp Destination Number',
  'financeInvoices.phone_number_helper_text': 'This number will receive invoice message',
  'financeInvoices.phone_number_invalid': 'Phone number can only contain + and numbers',
  'financeInvoices.phone_number_min': 'Phone number must be at least {min} characters',
  'financeInvoices.phone_number_max': 'Phone number must be at most {max} characters',
  'financeInvoices.email_sent_successfully': 'Email sent successfully',
  'financeInvoices.whatsapp_sent_successfully': 'WhatsApp message sent successfully',
  'financeInvoices.invoice_will_be_sent_via': 'Invoice will be sent via',
  'financeInvoices.send_now': 'Send Now',
  'financeInvoices.add_email': 'Add email',
  'financeInvoices.send_via_personal_number': 'Send via Personal Number',
  'financeInvoices.send_via_personal_number_desc':
    "Increase your customer's trust with your official number.",
  'financeInvoices.send_whatsapp': 'Send WhatsApp',
  'financeInvoices.whatsapp_template_info':
    "This WhatsApp message template has been optimized according to kledo.com's professional standards to ensure optimal readability",
  'salesCommission.commissions_help_text_1':
    'If using a percentage, the commission amount is the percentage multiplied by the sales amount. For example, if sales of at least IDR 100 million are sold, the commission is 10%. Then, in that month, sales reach IDR 150 million, so the commission earned is 10% x IDR 150 million = IDR 15 million.',
  'salesCommission.commissions_help_text_2':
    'If using IDR, the commission amount remains fixed, regardless of sales volume. For example, if sales of at least IDR 100 million are sold, you receive a commission of IDR 1 million. Then, if sales exceed IDR 150 million that month, the commission earned by that salesperson is IDR 1 million.',
  'salesCommission.commissions_help_text_excess_over_target':
    'The commission is calculated from the percentage multiplied by the sales amount above the minimum target, not from the total sales amount. For example, a minimum target of IDR 1 million earns a 5% commission. Then, in that month, the sales person sells IDR 1.2 million, so the commission earned is 5% x (IDR 1.2 million - IDR 1 million) = IDR 10 thousand. If the sales amount has not reached the minimum target, the commission is IDR 0.',
  'salesCommission.applies_to_the_following_products_help_text':
    'If the commission applies to only a select few {products}, the minimum monthly transaction calculation will only be based on the applicable {products}. The commission amount will also be calculated based on the sales value of those {products}.',
  'cashier.edit_item': 'Edit Item: {name}',
  'cashier.product_layout_grid': 'Grid product view',
  'cashier.product_layout_list': 'List product view',
  'cashier.inventory_id': 'INVENTORY ID',
  'cashier.select_promotion': 'Select Promotion',
  'cashier.calculation_breakdown': 'Summary',
  'cashier.units': 'units',
  'cashier.incl_taxes': '(incl. taxes)',
  'cashier.update_item': 'Update Item',
  'cashier.driver_online_detail.title': 'Driver Online Detail',
  'cashier.driver_online_detail.panel_title': 'Driver Online',
  'cashier.driver_online_detail.panel_description':
    'Record driver and order information for online order transactions.',
  'cashier.driver_online_detail.form_description':
    'Complete the following information to process the transaction.',
  'cashier.driver_online_detail.select_driver_service': 'Select Driver Service',
  'cashier.driver_online_detail.driver_service_placeholder':
    'Select Platform (GoFood, ShopeeFood, etc)',
  'cashier.driver_online_detail.select_driver_service_required': 'Please select driver service',
  'cashier.driver_online_detail.driver_name': 'Driver Name',
  'cashier.driver_online_detail.driver_name_placeholder': 'Enter driver full name',
  'cashier.driver_online_detail.driver_name_required': 'Driver name is required',
  'cashier.driver_online_detail.online_order_number': 'Online Order Number',
  'cashier.driver_online_detail.online_order_number_placeholder': 'Example: INV-99283-X',
  'cashier.driver_online_detail.online_order_number_required': 'Online order number is required',
  'cashier.driver_online_detail.optional': 'Optional',
  'cashier.driver_online_detail.confirm_driver': 'Confirm Driver',
  'membership.members_title': 'Members',
  'membership.status': 'Status',
  'membership.outlet': 'Outlet',
  'membership.addon_photo': 'Photo',
  'membership.member_name': 'Name',
  'membership.email': 'Email',
  'membership.phone': 'Phone',
  'membership.join_date': 'Join Date',
  'membership.search_member': 'Search member name',
  'membership.detail_title': 'Member Detail',
  'membership.profile': 'Profile',
  'membership.transactions': 'Transactions',
  'membership.transactions_title': 'Membership Transactions',
  'membership.number': 'Number',
  'membership.type': 'Type',
  'membership.date': 'Date',
  'membership.month': 'Month',
  'membership.total': 'Total',
  'membership.settings': 'Settings',
  'membership.settings_paid_membership_activated': 'Membership has been activated.',
  'membership.settings_paid_membership_deactivated': 'Membership has been deactivated.',
  'membership.landing_title': 'Membership',
  'membership.landing_hash_tag': '#bemoreloyal — easy and practical.',
  'membership.landing_hero_title': 'Grow Customer Loyalty with a Membership Program',
  'membership.landing_hero_description':
    'Run a membership program with monthly fees, award points automatically on every transaction, and offer rewards customers can redeem. Every activity is tracked neatly to help boost loyalty and repeat purchases.',
  'membership.landing_cta': 'Activate Membership, Free!',
  'membership.landing_features_title': 'What Do You Get from the Membership Feature?',
  'membership.landing_video_title': 'Get to Know Membership in Minutes',
  'membership.landing_feat_1_title': 'Paid membership program',
  'membership.landing_feat_1_description':
    'Create membership tiers from free to monthly plans that fit your business and manage everything in one system.',
  'membership.landing_feat_2_title': 'Automatic points on every transaction',
  'membership.landing_feat_2_description':
    'Customers earn points automatically on each transaction—no manual calculation.',
  'membership.landing_feat_3_title': 'Redeem points for rewards',
  'membership.landing_feat_3_description':
    'Offer attractive benefits and rewards that customers can redeem with the points they collect.',
  'membership.landing_feat_4_title': 'Outlet check-in',
  'membership.landing_feat_4_description':
    'Drive engagement with check-in at your outlet and keep attendance activity organized.',
  'membership.landing_feat_5_title': 'Complete customer data & activity',
  'membership.landing_feat_5_description':
    'See transaction history, points, and member activity in one easy-to-read dashboard.',
  'membership.landing_feat_6_title': 'Stronger loyalty & repeat orders',
  'membership.landing_feat_6_description':
    'Build long-term relationships and encourage more repeat purchases with a structured loyalty system.',
  'membership.landing_footer_note':
    'Build customer loyalty and grow repeat orders more easily with Membership & Loyalty Program—start now.',
  'membership.points': 'Points',
  'membership.check_in': 'Check In',
  'membership.check_out': 'Check Out',
  'membership.auto_out': 'Auto Out',
  'membership.branch': 'Branch',
  'membership.name': 'Name',
  'membership.yes': 'Yes',
  'membership.no': 'No',
  'membership.not_checked_out_yet': 'Not checked out yet',
  'membership.done': 'Done',
  'membership.not_done_yet': 'Not done yet',
  'membership.check_in_info': 'Check-in Information',
  'membership.edit_check_in_title': 'Edit Check-in',
  'membership.check_out_placeholder': 'Select check-out date & time',
  'membership.automatic': 'Automatic',
  'membership.duration_auto_hint':
    'Duration is calculated automatically from check-in & check-out time',
  'membership.add_check_in': 'Add',
  'membership.method': 'Method',
  'membership.auto_check_out': 'Auto Check Out',
  'membership.check_in_date_required': 'Please select check-in date and time',
  'membership.check_in_detail_title': 'Check-in details',
  'membership.check_out_now': 'Check out now',
  'membership.duration_label': 'Duration',
  'membership.duration_hours_minutes': '{hours} h {minutes} min',
  'membership.duration_minutes_only': '{minutes} min',
  'membership.check_out_success': 'Checked out successfully',
  'membership.check_out_failed': 'Check-out failed',
  'membership.attendance_updated_success': 'Attendance updated successfully',
  'membership.attendance_update_failed': 'Failed to update attendance',
  'membership.attendance_deleted_success': 'Attendance deleted successfully',
  'membership.attendance_delete_failed': 'Failed to delete attendance',
  'membership.points_accumulated': 'Accumulated',
  'membership.expired': 'Expired',
  'membership.days_left': 'Days left',
  'membership.validity_period': 'Validity Period',
  'membership.forever': 'Forever',
  'membership.streak': 'Streak',
  'membership.consecutive_days': 'Consecutive days',
  'membership.member_info': 'Member Information',
  'membership.full_name': 'Full Name',
  'membership.address': 'Address',
  'membership.package': 'Package',
  'membership.paid_customer_since': 'Paid Customer Since',
  'membership.expired_date': 'Expiry Date',
  'membership.point_balance': 'Point Balance',
  'membership.amount': 'Amount',
  'membership.benefit': 'Benefit',
  'membership.balance': 'Balance',
  'membership.add_points_title': 'Add points',
  'membership.add_points_failed': 'Failed to add points',
  'membership.point_adjustment_type': 'Adjustment type',
  'membership.point_adjustment_placeholder': 'Select adjustment type',
  'membership.point_adjustment_required': 'Please select adjustment type',
  'membership.point_adjustment_add': 'Add points',
  'membership.point_adjustment_subtract': 'Subtract points',
  'membership.add_points_amount_label': 'Point amount',
  'membership.add_points_amount_required': 'Please enter point amount',
  'membership.add_points_amount_placeholder': 'Enter point amount',
  'membership.add_points_trans_date_label': 'Transaction date',
  'membership.add_points_trans_date_required': 'Please select transaction date',
  'membership.add_points_description_placeholder': 'Enter description',
  'membership.registration_location': 'Registration Location',
  'membership.member_card': 'Member Card',
  'membership.remaining': 'Remaining',
  'membership.premium': 'Premium',
  'membership.member_number': 'Member Number',
  'membership.status_active': 'Active',
  'membership.status_inactive': 'Inactive',
  'membership.benefit_archived_banner': 'Archived',
  'membership.archive_benefit': 'Archive',
  'membership.unarchive_benefit': 'Unarchive',
  'membership.popconfirm_archive_benefit': 'Archive this benefit? It will become inactive.',
  'membership.popconfirm_unarchive_benefit': 'Unarchive this benefit? It will become active again.',
  'membership.archive_benefit_success': 'Benefit archived',
  'membership.unarchive_benefit_success': 'Benefit unarchived',
  'membership.archive_benefit_error': 'Failed to archive benefit',
  'membership.unarchive_benefit_error': 'Failed to unarchive benefit',
  'membership.benefit_image_invalid_type': 'Only JPG, JPEG, PNG, or GIF files are allowed',
  'membership.benefit_image_too_large': 'Image must be at most {maxMb} MB',
  'membership.benefit_validity_forever': 'Forever',
  'membership.pagination_total': 'Total {total} entries',
  'membership.benefit_validity_period': 'Validity period',
  'membership.benefit_point_price': 'Point price',
  'membership.benefit_max_qty': 'Max qty',
  'membership.benefit_max_qty_unlimited': 'Unlimited',
  'membership.show_archived_benefits': 'Show archived',
  'membership.benefit_name_label': 'Benefit name',
  'membership.benefit_name_required': 'Please enter benefit name',
  'membership.benefit_name_placeholder': 'Enter benefit name',
  'membership.benefit_name_max_length': 'Benefit name must be at most 150 characters',
  'membership.benefit_redeem_packages_hint': 'Redeemable by members with these packages',
  'membership.benefit_max_qty_heading': 'Maximum quantity per member',
  'membership.benefit_exchange_point_price': 'Points required for redemption',
  'membership.benefit_exchange_point_required': 'Please enter points required for redemption',
  'membership.benefit_exchange_point_min': 'Minimum value is 1',
  'membership.benefit_description_placeholder': 'Enter description',
  'membership.benefit_description_max_length': 'Description must be at most 3000 characters',
  'membership.benefit_validity_dates_required': 'Please select a date range',
  'membership.benefit_date_start_placeholder': 'Start date',
  'membership.benefit_date_end_placeholder': 'End date',
  'membership.benefit_added_success': 'Benefit added successfully',
  'membership.benefit_photo_upload_failed': 'Photo upload failed',
  'membership.benefit_add_failed': 'Failed to add benefit',
  'membership.benefit_deleted_success': 'Benefit deleted successfully',
  'membership.benefit_delete_failed': 'Failed to delete benefit',
  'membership.benefit_updated_success': 'Benefit updated successfully',
  'membership.benefit_update_failed': 'Failed to update benefit',
  'membership.benefit_photo_sync_failed': 'Photos could not be synced',
  'membership.benefit_redeem_chart_title': 'Monthly redemptions',
  'membership.benefit_stat_total_redeemed': 'Total redeemed',
  'membership.benefit_stat_total_redeemed_sub': 'All time',
  'membership.benefit_stat_redemptions': 'Redemptions',
  'membership.benefit_stat_last_30_days': 'Last 30 days',
  'membership.benefit_stat_total_points': 'Total points',
  'membership.benefit_stat_current_points': 'Current points',
  'membership.benefit_stat_new_points': 'New points',
  'membership.benefit_detail_card_title': 'Benefit details',
  'membership.benefit_detail_photos': 'Photo',
  'membership.benefit_detail_validity': 'Validity',
  'membership.benefit_validity_range': '{start} – {end}',
  'membership.benefit_points_display': '{count} points',
  'membership.benefit_chart_dataset_label': 'Redemptions',
  'membership.benefit_chart_tooltip': 'Redeem: {count}',
  'membership.benefit_chart_empty': 'No redemption data yet',
  'membership.benefit_redeem_title': 'Redeem',
  'membership.benefit_redeem_col_name': 'Name',
  'membership.benefit_redeem_col_date': 'Date',
  'membership.benefit_redeem_col_qty': 'Redeem count',
  'membership.benefit_redeem_col_points': 'Points',
  'membership.edit_benefit_title': 'Edit benefit',
  'membership.benefit_detail_page_title': 'Benefit Detail',
  'membership.days_remaining': '{count} Days',
  'membership.edit_member': 'Edit Member',
  'membership.more_actions': 'More actions',
  'membership.member_number_short': 'Member no.',
  'membership.registered_at': 'Registered at',
  'membership.last_30_days': 'Last 30 days',
  'membership.view_contact': 'View contact',
  'membership.contact_section': 'Contact',
  'membership.membership_section': 'Membership',
  'membership.not_yet': 'Not yet',
  'membership.no_expiry': 'No limit',
  'membership.days_overdue': '{count} days overdue',
  'membership.days_left_count': '{count} days left',
  'membership.card_preview_note': 'This is how the member sees their card in the app',
  'membership.view_member_detail': 'View member details',
  'membership.name_required': 'Please enter name',
  'membership.email_required': 'Please enter email',
  'membership.email_invalid': 'Invalid email format',
  'membership.phone_required': 'Please enter phone number',
  'membership.enter_name': 'Enter Name',
  'membership.enter_email': 'Enter Email',
  'membership.enter_phone': 'Enter Phone Number',
  'membership.enter_address': 'Enter Address',
  'membership.select_plan': 'Select Plan',
  'membership.select_status': 'Select Status',
  'membership.select_start_paid_date': 'Select Start Paid Date',
  'membership.select_expiry_date': 'Select Expiry Date',
  'membership.select_register_branch': 'Select Registration Branch',
  'membership.add_transaction_title': 'Add Membership Transaction',
  'membership.select_member': 'Select member',
  'membership.select_transaction_type': 'Select transaction type',
  'membership.next': 'Next',
  'membership.create_transaction': 'Create Transaction',
  'membership.back': 'Back',
  'membership.transaction_type_register': 'Registration',
  'membership.transaction_type_addon': 'Addon',
  'membership.transaction_type_perpanjangan': 'Renewal',
  'membership.transaction_type_upgrade': 'Upgrade',
  'membership.registration_fee': 'Registration Fee',
  'membership.select_package': 'Select Package',
  'membership.select_subscription_duration': 'Select Subscription Duration',
  'membership.select_addon': 'Select Addon',
  'membership.per_month': '/mo',
  'membership.upgrade_note': 'When upgrading, only display packages above the current one.',
  'membership.current_package': 'Current package',
  'membership.renew_package_note':
    'Renewal uses your current member package. The package cannot be changed here.',
  'membership.upgrade_cannot_highest':
    'You cannot upgrade because this member is already on the highest available package.',
  'membership.upgrade_per_month_difference': '/mo (difference)',
  'membership.upgrade_only': 'Upgrade Only',
  'membership.upgrade_only_price_hint': 'Prorated for remaining period',
  'membership.term_discount_badge': 'Save {percent}%',
  'membership.cost_breakdown': 'Cost Breakdown',
  'membership.line_discount_hint': '{gross} − {percent}% discount ({amount})',
  'membership.prorata_line_label': 'Upgrade {name} coverage',
  'membership.prorata_line_note': 'For remaining active period',
  'membership.duration_1_month': '1 Month',
  'membership.duration_2_months': '2 Months',
  'membership.status_membership': 'Enable Membership?',
  'membership.paid_membership_question':
    'This is a loyalty program for your customers.\nApplying point bonus for each transaction, applying monthly membership fees, and many more.',
  'membership.paid_membership_yes': 'Yes',
  'membership.paid_membership_no': 'No',
  'membership.paid_membership_note': "If On, then display what's below",
  'membership.package_config_title': 'Membership Package Configuration',
  'membership.membership_packages_question': 'What packages are available for membership?',
  'membership.add_package_new': 'Add New Package',
  'membership.sorted_by_cheapest': 'sorted by cheapest price',
  'membership.add_package': 'Add package',
  'membership.cannot_create_transaction_title': 'Cannot create transaction',
  'membership.no_paid_plan_cannot_create_transaction':
    'You do not have any paid membership packages, so you cannot create transactions.',
  'membership.no_packages': 'No packages yet',
  'membership.package_archived_badge': 'Archived',
  'membership.package_name': 'Package Name',
  'membership.monthly_fee': 'Monthly Fee',
  'membership.registration_fee_label': 'Registration Fee',
  'membership.description': 'Description',
  'membership.can_check_in': 'Can Check In / Attendance',
  'membership.plan_description_placeholder': 'Describe this package for members (optional)',
  'membership.plan_image_label': 'Package Image',
  'membership.plan_image_upload': 'Upload',
  'membership.plan_image_hint': 'JPG, PNG, or GIF. Max {size} MB.',
  'membership.plan_image_invalid_type': 'Only JPG, PNG, or GIF files are allowed.',
  'membership.plan_image_too_large': 'Image must be {max} MB or smaller.',
  'membership.plan_image_upload_failed': 'Failed to upload image.',
  'membership.edit_package': 'Edit Package',
  'membership.add_package_title': 'Membership Package',
  'membership.delete_package': 'Delete',
  'membership.delete_package_confirm': 'Are you sure you want to delete this package?',
  'membership.archive_package': 'Archive',
  'membership.unarchive_package': 'Unarchive',
  'membership.archive_package_confirm':
    'Archive this package? It will no longer be available for new subscriptions.',
  'membership.unarchive_package_confirm': 'Restore this package and make it available again?',
  'membership.package_name_required': 'Please enter package name',
  'membership.settings_plan_updated_success': 'Package updated successfully',
  'membership.settings_plan_updated_error': 'Failed to update package',
  'membership.settings_plan_created_success': 'Package added successfully',
  'membership.settings_plan_created_error': 'Failed to add package',
  'membership.plan_max_reached':
    'You can have at most 5 packages. Remove an existing package before adding a new one.',
  'membership.free_plan_already_exists':
    'Only one free package is allowed (0 monthly fee and 0 registration fee). Change the existing free package or set a price on this one.',
  'membership.settings_saved_success': 'Changes saved successfully',
  'membership.add_member_empty_plans_body':
    'No active package yet. You can still create the member without one, or add a package.',
  'membership.add_member_empty_plans_link': 'Add package',
  'membership.add_member_empty_terms_body':
    "You don't have any subscription terms yet. Please add a term first.",
  'membership.add_member_empty_terms_link': 'Add term',
  'membership.add_member_empty_branches_body':
    "You don't have any branches yet. Please add a branch first.",
  'membership.add_member_empty_branches_link': 'Add branch',
  'membership.add_member_segment_new': 'Add new',
  'membership.add_member_segment_new_hint': "Fill in a new member's details",
  'membership.add_member_segment_from_customer': 'Add from customer',
  'membership.add_member_segment_from_customer_hint': 'Pick from existing customers',
  'membership.revert_phone_to_default': 'Restore default phone number',
  'membership.select_customer': 'Select customer',
  'membership.select_customer_required': 'Please select a customer first',
  'membership.placeholder_full_name': 'Enter full name',
  'membership.placeholder_email_input': 'Enter email',
  'membership.placeholder_address_input': 'Enter address',
  'membership.name_required_first': 'Please enter name first',
  'membership.name_min_two_chars': 'Name must be at least 2 characters',
  'membership.email_required_first': 'Please enter email first',
  'membership.address_required_first': 'Please enter address first',
  'membership.address_min_ten_chars': 'Address must be at least 10 characters',
  'membership.add_member_term_field': 'Term',
  'membership.registration_branch': 'Registration branch',
  'membership.select_branch': 'Select branch',
  'membership.term_years_display': '{count} year',
  'membership.term_years_display_plural': '{count} years',
  'membership.untitled_plan': 'Untitled',
  'membership.open_membership_settings': 'Open membership settings',
  'membership.subscription_terms': 'Subscription Terms',
  'membership.add_term': 'Add term',
  'membership.no_terms': 'No terms yet',
  'membership.add_term_title': 'Add Term',
  'membership.edit_term': 'Edit Term',
  'membership.delete_term': 'Delete',
  'membership.delete_term_confirm': 'Are you sure you want to delete this term?',
  'membership.term_months': 'Duration (months)',
  'membership.term_months_required': 'Please enter duration in months',
  'membership.term_months_min': 'Minimum 1 month',
  'membership.term_months_max': 'Maximum 36 months',
  'membership.term_months_already_exists': 'This duration already exists',
  'membership.term_months_display': '{count} Month',
  'membership.term_months_display_plural': '{count} Months',
  'membership.transaction_detail_title': 'Transaction Detail',
  'membership.subscription_duration': 'Subscription Duration',
  'membership.accept_payment': 'Accept Payment',
  'membership.payment_select_bank': 'Bank account',
  'membership.payment_paid_date': 'Payment date',
  'membership.payment_recorded_success': 'Payment recorded successfully',
  'membership.payment_recorded_error': 'Failed to record payment',
  'membership.payment_no_bank_accounts':
    'No bank accounts available. Add one in finance settings first.',
  'membership.view_invoice': 'View Invoice',
  'membership.edit_transaction': 'Edit',
  'membership.edit_transaction_title': 'Edit transaction',
  'membership.transaction_updated_success': 'Transaction updated successfully',
  'membership.transaction_updated_error': 'Failed to update transaction',
  'membership.void_transaction': 'Void',
  'membership.void_transaction_confirm': 'Are you sure you want to void this transaction?',
  'membership.transaction_voided_success': 'Transaction voided successfully',
  'membership.transaction_voided_error': 'Failed to void transaction',
  'membership.delete_transaction': 'Delete',
  'membership.delete_transaction_confirm': 'Are you sure you want to delete this transaction?',
  'membership.transaction_deleted_success': 'Transaction deleted successfully',
  'membership.transaction_deleted_error': 'Failed to delete transaction',
  'membership.addon_label': 'Addon',
  'membership.order_created_success': 'Transaction created successfully',
  'membership.order_created_error': 'Failed to create transaction',
  'membership.load_transaction_detail_error': 'Failed to load transaction details',
  'membership.subscription_discounts': 'Subscription Discounts',
  'membership.add_discount': 'Add discount',
  'membership.no_discounts': 'No discounts yet',
  'membership.add_discount_title': 'Add Discount',
  'membership.edit_discount': 'Edit Discount',
  'membership.delete_discount': 'Delete',
  'membership.delete_discount_confirm': 'Are you sure you want to delete this discount?',
  'membership.discount_min_months': 'Minimum months',
  'membership.discount_min_months_required': 'Please enter minimum months',
  'membership.discount_min_months_min': 'Minimum 1 month',
  'membership.discount_percent': 'Discount (%)',
  'membership.discount_percent_required': 'Please enter discount percentage',
  'membership.discount_percent_range': 'Must be between 0 and 100',
  'membership.discount_label': 'Min {months} months {discount}% discount',
  'membership.discount_min_display': 'Min. {months} months',
  'membership.discount_percent_display': 'Discount {discount}%',
  'membership.discounts_sorted_by': 'sorted by largest discount',
  'membership.addon_section_title': 'Additional Services (Add-on)',
  'membership.addon_subscription': 'Subscription Addon',
  'membership.addon_price_per_month': 'Monthly Fee',
  'membership.addon_price_per_month_2': '{price}/month',
  'membership.addon_price_per_time': '{price}',
  'membership.addon_one_time': 'One-time Addon',
  'membership.addon_one_time_hint': '(one-time payment)',
  'membership.add_addon': 'Add addon',
  'membership.no_addons': 'No addons yet',
  'membership.add_addon_title': 'Add Addon',
  'membership.edit_addon': 'Edit Addon',
  'membership.addon_view_related_product': 'View related product',
  'membership.delete_addon': 'Delete',
  'membership.delete_addon_confirm': 'Are you sure you want to delete this addon?',
  'membership.archive_addon': 'Archive',
  'membership.unarchive_addon': 'Unarchive',
  'membership.archive_addon_confirm':
    'Archive this add-on? It will no longer be offered for new subscriptions.',
  'membership.unarchive_addon_confirm': 'Restore this add-on and make it available again?',
  'membership.addon_name': 'Addon Name',
  'membership.addon_name_required': 'Please enter addon name',
  'membership.addon_price': 'Price',
  'membership.add_addon_subscription_title': 'Add Subscription Addon',
  'membership.add_addon_one_time_title': 'Add One-time Addon',
  'membership.edit_addon_subscription_title': 'Edit Subscription Addon',
  'membership.edit_addon_one_time_title': 'Edit One-time Addon',
  'membership.addon_label_per_month': '{title} Rp {price}.-/mo',
  'membership.addon_label_one_time': '{title} Rp {price}.-',
  'membership.operational_rules_title': 'Operational Rules',
  'membership.effective_date_renew_on_title':
    'When a member renews late, how is their active period calculated?',
  'membership.effective_date_renew_on_paid': 'Active period is calculated from the payment time',
  'membership.effective_date_renew_on_expired_date':
    'Active period is calculated from the expiration date',
  'membership.effective_date_renew_on_tooltip':
    "For example, Member A expires on January 10 and renews for 1 month on January 20.\n\nIf the active period is calculated from the payment time, Member A's membership will end on February 19.\n\nIf the active period is calculated from the expiration date, Member A's membership will end on February 9.",
  'membership.effective_date_renew_on_tooltip_aria':
    'Help: example of active period when renewing late',
  'membership.point_rules': 'Point Rules',
  'membership.point_rules_spending_prefix': 'Every transaction multiple of spending',
  'membership.point_rules_points_suffix': 'gets',
  'membership.point_rules_points_unit': 'points',
  'membership.attendance_rules': 'Attendance Rules',
  'membership.attendance_rules_auto_checkout_prefix':
    'Every check-in will automatically checkout after',
  'membership.attendance_rules_hours_unit': 'hours',
  'membership.branches_title': 'Branch / Outlet',
  'membership.add_branch': 'Add branch',
  'membership.add_branch_new': 'Add new branch',
  'membership.no_branches': 'No branches yet',
  'membership.add_branch_title': 'Add Branch',
  'membership.edit_branch_title': 'Edit Branch',
  'membership.branch_name': 'Branch Name',
  'membership.branch_name_required': 'Please enter branch name',
  'membership.branch_photo': 'Photo',
  'membership.branch_photo_placeholder': 'Photo URL',
  'membership.branch_photo_select': 'Select photo',
  'membership.branch_photo_upload_hint':
    'Formats: JPG, JPEG, PNG, or GIF. Photo is uploaded after the branch is saved successfully.',
  'membership.branch_photo_remove': 'Remove photo',
  'membership.branch_photo_delete_confirm': 'Remove this branch photo from the server?',
  'membership.branch_photo_deleted': 'Branch photo removed',
  'membership.branch_photo_invalid_type': 'Only JPG, JPEG, PNG, or GIF files are allowed',
  'membership.branch_address': 'Address',
  'membership.branch_address_placeholder': 'Enter address',
  'membership.branch_latitude': 'Latitude',
  'membership.branch_longitude': 'Longitude',
  'membership.branch_latitude_placeholder': 'e.g., -6.2088',
  'membership.branch_longitude_placeholder': 'e.g., 106.8456',
  'membership.branch_latitude_required': 'Latitude is required',
  'membership.branch_longitude_required': 'Longitude is required',
  'membership.branch_latitude_invalid': 'Please enter a valid latitude (-90 to 90)',
  'membership.branch_longitude_invalid': 'Please enter a valid longitude (-180 to 180)',
  'membership.branch_pick_on_map': 'Pick on Map',
  'membership.branch_is_active': 'Active',
  'membership.delete_branch': 'Delete',
  'membership.delete_branch_confirm': 'Are you sure you want to delete this branch?',
  'membership.branch_search_placeholder': 'Search branches',
  'membership.add_location': 'Add Location',
  'membership.map_type_map': 'Map',
  'membership.map_type_satellite': 'Satellite',
  'membership.map_fullscreen': 'Full screen',
  'membership.branch_filter_all': 'All',
  'membership.branch_filter_active': 'Active',
  'membership.branch_filter_archived': 'Archived',
  'membership.branch_map_preview': 'Location preview',
  'membership.branch_status_archived': 'Archived',
  'membership.branch_status_active_short': 'Active',
  'membership.branch_archive': 'Archive',
  'membership.branch_unarchive': 'Unarchive',
  'membership.branch_archive_confirm': 'Archive this branch?',
  'membership.branch_unarchive_confirm': 'Restore this branch from archive?',
  'membership.add_location_branch': 'Add branch location',
  'membership.branch_phone_label': 'Phone',
  'membership.branch_created_label': 'Created',
  'membership.branch_menu_loading': 'Loading…',
  'membership.news_coming_soon': 'News settings - coming soon',
  'membership.news_title_column': 'Title',
  'membership.news_display_from_column': 'Display From',
  'membership.news_display_until_column': 'Display Until',
  'membership.news_status_column': 'Status',
  'membership.news_status_active': 'Active',
  'membership.news_status_inactive': 'Inactive',
  'membership.news_filter_all': 'All',
  'membership.news_search_placeholder': 'Search',
  'membership.news_add_button': 'Add',
  'membership.news_total': 'Total {total} items',
  'membership.news_title': 'Title',
  'membership.news_title_required': 'Title is required',
  'membership.news_title_placeholder': 'Enter title',
  'membership.news_description': 'Description',
  'membership.news_description_placeholder': 'Enter description',
  'membership.news_display_from': 'Display From',
  'membership.news_display_from_required': 'Display from is required',
  'membership.news_display_until': 'Display Until',
  'membership.news_display_until_required': 'Display until is required',
  'membership.news_start_date': 'Start Date',
  'membership.news_start_date_required': 'Start date is required',
  'membership.news_end_date': 'End Date',
  'membership.news_end_date_required': 'End date is required',
  'membership.news_airing_label': 'Display',
  'membership.news_date_range_separator': 'to',
  'membership.news_date_range_required': 'Start and end dates are required',
  'membership.news_date_range_invalid': 'Start date cannot be after end date',
  'membership.news_is_active': 'Active',
  'membership.news_photos_label': 'Images',
  'membership.news_photos_upload': 'Upload',
  'membership.news_photos_upload_hint': 'JPG, PNG, or GIF. Max {max} images, {size} MB per file.',
  'membership.news_photos_invalid_type': 'Only JPG, PNG, or GIF files are allowed.',
  'membership.news_photos_max_count': 'You can upload at most {max} images.',
  'membership.news_photos_too_large': 'Each file must be {max} MB or smaller.',
  'membership.add_news_title': 'Add News',
  'membership.edit_news_title': 'Edit News',
  'membership.delete_news': 'Delete',
  'membership.delete_news_confirm': 'Are you sure you want to delete this news?',
  'membership.archive_news': 'Archive',
  'membership.archive_news_confirm': 'Archive this news?',
  'membership.unarchive_news': 'Unarchive',
  'membership.unarchive_news_confirm': 'Restore this news from archive?',
  'membership.settings_tab_appearance': 'App Appearance',
  'membership.settings_tab_branch_locations': 'Branch Locations',
  'membership.settings_tab_news': 'News',
  'membership.appearance_general_settings': 'General Settings',
  'membership.appearance_website_url': 'Website Address',
  'membership.appearance_website_subdomain_placeholder': 'subdomain',
  'membership.appearance_website_open': 'Open website',
  'membership.appearance_download_app': 'Download Member App',
  'membership.appearance_upload_logo': 'Upload Logo',
  'membership.appearance_upload': 'Upload',
  'membership.appearance_main_color': 'Main Color',
  'membership.appearance_secondary_color': 'Secondary Color',
  'membership.appearance_qr_checkin': 'QR Code Check In',
  'membership.appearance_profile': 'Profile',
  'membership.appearance_menu_app': 'Menu Application',
  'membership.appearance_home_layout': 'Home Layout',
  'membership.appearance_statistik': 'Statistics',
  'membership.appearance_live_preview': 'Live Preview',
  'membership.appearance_logo_hint': 'PNG/JPG/GIF format, max {size}MB',
  'membership.appearance_logo_invalid_type': 'Unsupported logo format',
  'membership.appearance_logo_too_large': 'Logo must be at most {size}MB',
  'membership.appearance_logo_upload_success': 'Logo uploaded successfully',
  'membership.appearance_logo_upload_failed': 'Failed to upload logo',
  'membership.appearance_logo_delete_success': 'Logo deleted successfully',
  'membership.appearance_logo_delete_failed': 'Failed to delete logo',
  'membership.member': 'Member',
  'membership.free': 'Free',
  'membership.register_fee': 'Registration fee {price}',
  'membership.no_register_fee': 'No registration fee',
  'membership.plan_required': 'Please select a plan',
  'membership.free_plan_only': 'Free plan',
  'membership.free_plan_only_hint':
    'Without Membership access, members are registered on the free plan.',
  'membership.expiry_optional_hint': 'Optional. Leave empty to follow the plan.',
  'membership.already_member': 'Already a member',
  'membership.join_title': 'Make a member',
  'membership.join_desc':
    'Register this contact as a member right away so every transaction earns points.',
  'membership.add_to_membership': 'Add to membership',
  'membership.add_to_membership_confirm': 'Make {name} a member?',
  'membership.add_to_membership_desc':
    'Make sure the data below is correct. The phone number is used by the member to sign in.',
  'membership.complete_required_data': 'Complete the empty data before registering the member.',
  'membership.not_member_yet': 'Not a member yet',
  'membership.not_member_yet_desc':
    'Add this contact to membership so their transactions earn points.',
  'membership.expiry_forever': 'Forever',
  'membership.points_count': '{count} points',
  'membership.valid_until': 'until {date}',
  'membership.point_movement': 'Point Movement',
  'membership.member_list': 'Member List',
  'membership.point_in': 'Points In',
  'membership.point_out': 'Points Out',
  'membership.point_net': 'Net Points',
  'membership.sales_only': 'Sales only',
  'membership.source': 'Source',
  'membership.trans_number': 'Transaction No.',
  'membership.nominal': 'Amount',
  'membership.all_members': 'All members',
  'settings.membership': 'Set up membership flow',
  'cashier.table_detail.title': 'Select Table',
  'cashier.table_detail.panel_title': 'Table Order',
  'cashier.table_detail.panel_description':
    'Set the table, guest count, and order name for dine in transactions.',
  'cashier.table_detail.form_description':
    'Select a floor then an available table to continue the transaction.',
  'cashier.table_detail.select_floor': 'Select Floor',
  'cashier.table_detail.select_table': 'Select Table',
  'cashier.table_detail.table_empty': 'No table on this floor yet',
  'cashier.table_detail.floor_empty': 'No floor on this outlet yet',
  'cashier.table_detail.guest_count': 'Guest Count',
  'cashier.table_detail.guest_count_max': 'Maximum {max} guests',
  'cashier.table_detail.guest_count_required': 'Guest count is required',
  'cashier.table_detail.order_name': 'Order Name (optional)',
  'cashier.table_detail.order_name_placeholder': 'Example: John / Meeting 2nd Floor',
  'cashier.table_detail.occupied': 'Occupied',
  'cashier.table_detail.capacity': '{count} guests',
  'cashier.table_detail.confirm_table': 'Confirm Table',
  'cashier.table_detail.table_fallback': 'Table #{id}',
  'cashier.table_detail.reset_table': 'Reset Table',
  'cashier.table_detail.reset_selected_table': 'Reset Selected Table',
  'cashier.table_detail.reset_all_tables': 'Reset All Tables',
  'cashier.table_detail.reset_table_confirm': 'Reset table {name}?',
  'cashier.table_detail.reset_table_description':
    'The order occupying this table will be detached. The order itself is not deleted.',
  'cashier.table_detail.reset_all_tables_confirm': 'Reset all tables on this floor?',
  'cashier.table_detail.reset_all_tables_description':
    '{count} occupied tables on {floor} will be detached from their orders.',
  'cashier.table_detail.reset_success': 'Table has been reset',
  'cashier.table_detail.reset_failed': 'Failed to reset table',
  'cashier.current_shift_prompt.title': 'Your Shift Is Still Open',
  'cashier.current_shift_prompt.message':
    'We detected an active shift for you at this outlet. Continue the previous shift to keep transactions in order, or open a new one.',
  'cashier.current_shift_prompt.use': 'Continue Shift',
  'cashier.current_shift_prompt.open_new': 'Open New Shift',
  'cashier.current_shift_prompt.label_employee': 'Employee',
  'cashier.current_shift_prompt.label_outlet': 'Outlet',
  'cashier.current_shift_prompt.label_start': 'Started',
  'cashier.current_shift_prompt.label_opening_balance': 'Opening Balance',
  'cashier.current_shift_prompt.open_new_confirm':
    'Open shift #{id} will be closed automatically when the new shift is opened. Continue?',
  'cashier.current_shift_prompt.open_new_confirm_ok': 'Yes, Open New Shift',
  'cashier.shift_check_failed_title': 'Could not check shift',
  'cashier.shift_check_failed_message':
    'Unable to reach the server to check for an open shift. Check your connection and try again.',
  'cashier.shift_check_retry': 'Try again',
  'cashier.insufficient_stock.title': 'Insufficient Stock',
  'cashier.insufficient_stock.message_order':
    'The order cannot be saved because some products have insufficient stock.',
  'cashier.insufficient_stock.message_invoice':
    'The bill cannot be saved because some products have insufficient stock.',
  'cashier.insufficient_stock.requested': 'Requested',
  'cashier.receipt_ojol_name': 'Ojek provider',
  'cashier.receipt_ojol_order_no': 'Order number',
  'cashier.receipt_table': 'Table',
  'cashier.receipt_served_by': 'Staff',
  'cashier.served_by.title': 'Served By',
  'cashier.served_by.subtitle':
    'Select the staff who served this transaction, more than one is allowed.',
  'cashier.served_by.panel_title': 'Serving Staff',
  'cashier.served_by.panel_description':
    'Record who served the customer so staff performance is easy to track.',
  'cashier.served_by.search': 'Search or type a staff name',
  'cashier.served_by.add_manual': 'Add "{name}"',
  'cashier.served_by.add_manual_hint': 'Name outside the staff list',
  'cashier.served_by.manual_badge': 'Manual',
  'cashier.served_by.empty': 'No staff data yet',
  'cashier.served_by.not_found': 'Staff not found',
  'cashier.served_by.selected_empty': 'No staff selected yet',
  'cashier.served_by.save_count': 'Save ({count})',
  'cashier.served_by.required': 'Please select the staff who served first',
  'cashier.served_by.fallback_info': 'Showing staff of this outlet.',
  'cashier.served_by.retry': 'Try again',
  'cashier.receipt_table_order_name': 'Order Name',
  'cashier.receipt_table_guests': 'Guests',
  enter_format: 'Enter format',
  'layoutInvoice.invoice_show_termin_summary': 'Show Order Termin',
  please_select_product_to_refund: 'Please select product to refund',
  payment_information: 'Payment Information',
  'sendEmail.email_to_is_required': 'Email To is required',
  'sendEmail.phone_number_is_required': 'Phone number is required',
  'sendEmail.enter_phone_number': 'Enter phone number',
  'financeInvoices.save_and_send': 'Save & Send',
  'financeInvoices.mass_whatsapp_and_email': 'Mass Send WhatsApp & Email',
  'report.qty_return': 'Quantity Return',
  'report.qty_net': 'Quantity (NET)',
  'report.total_after_vat': 'Total After VAT',
  'report.avg_after_vat': 'Avg After VAT',
  'financeInvoices.email_is_not_available_in_demo': 'Fitur kirim email tidak tersedia di akun demo',
  new_badge_text: 'NEW!',
  'appOnboarding.paymentGateway.view_more': 'See more details',
  'appOnboarding.paymentGateway.detail_modal_title': 'Payment Connect',
  'appOnboarding.paymentGateway.dismiss_modal_title': 'Confirmation',
  'appOnboarding.paymentGateway.dismiss_warning_title':
    'Are you sure you do not want to improve your paid invoice ratio?',
  'appOnboarding.paymentGateway.detail_paragraph_1':
    'By enabling Payment Connect, your paid invoice ratio can increase by up to 50%.',
  'appOnboarding.paymentGateway.detail_paragraph_2':
    'Your customers can pay invoices via QRIS, bank transfer, credit card, GoPay, ShopeePay, Indomaret, paylater, and many other methods.',
  'appOnboarding.paymentGateway.detail_confirm_question': 'Enable Payment Connect?',
  'appOnboarding.paymentGateway.btn_activate_payment_connect': 'Enable Payment Connect',
  'appOnboarding.paymentGateway.btn_do_not_activate': 'Do not enable',
  'appOnboarding.paymentGateway.btn_yes_activate': 'Yes, enable',
  'appOnboarding.paymentGateway.btn_no': 'No',
  'appOnboarding.paymentGateway.success_modal_title': 'Kledo Payment Connect is active',
  'appOnboarding.paymentGateway.success_modal_body':
    'Kledo Payment Connect is ready for your transactions. Customers can pay invoices using multiple payment methods.',
  'appOnboarding.paymentGateway.success_modal_link': 'Open Kledo Payment Connect settings',
  'appOnboarding.paymentGateway.success_modal_hint':
    'You can adjust payment methods and other details anytime on the settings page.',
  'appOnboarding.paymentGateway.success_modal_btn': 'Got it',
  'appOnboarding.paymentGateway.activate_error_fallback':
    'Could not activate Payment Connect. Please try again.',
  'appOnboarding.paymentGateway.info.section1_title': 'Accept multiple payment methods',
  'appOnboarding.paymentGateway.info.section1_body':
    'Invoice payments can now be made through various methods including Bank Transfer, E-Wallet, QRIS, Over The Counter, Debit/Credit Card, and PayLater.',
  'appOnboarding.paymentGateway.info.section2_title': 'Payment Gateway Transaction Fees',
  'appOnboarding.paymentGateway.info.section2_body':
    'Each payment transaction is subject to an administration fee based on the payment method used. Below is the fee breakdown per method.',
  'appOnboarding.paymentGateway.info.section2_fee_charged_to_title':
    'Transaction fees can be configured to be charged to:',
  'appOnboarding.paymentGateway.info.section2_fee_to_buyer':
    'Buyer / customer — fee is added on top of the invoice total.',
  'appOnboarding.paymentGateway.info.section2_fee_to_seller':
    'Seller / company — fee is deducted from the disbursement amount.',
  'appOnboarding.paymentGateway.info.section2_fee_settings_hint':
    'This setting is available on the Kledo Payment Connect page under the “Fee charged to” field.',
  'appOnboarding.paymentGateway.info.section3_title': 'Fund Disbursement Process',
  'appOnboarding.paymentGateway.info.section3_body':
    'To disburse payment funds to your destination account, you need to first input your disbursement bank account and complete the required verification data.',
  'appOnboarding.paymentGateway.info.section3_step1_title': 'Input disbursement account',
  'appOnboarding.paymentGateway.info.section3_step1':
    'Enter the destination bank account for disbursement. Make sure the account holder name matches your company or personal data.',
  'appOnboarding.paymentGateway.info.section3_step2_title': 'Complete verification data',
  'appOnboarding.paymentGateway.info.section3_step2':
    'Upload supporting documents (ID card/business deed matching the account holder) and a selfie photo with your company location as background.',
  'appOnboarding.paymentGateway.info.section3_step3_title': 'Funds ready for disbursement',
  'appOnboarding.paymentGateway.info.section3_step3':
    'Once verification is approved, funds from each transaction can be disbursed according to Kledo Payment Connect terms.',
  'appOnboarding.paymentGateway.info.section3_footnote':
    'Our team will contact you if there is any verification data that needs to be completed.',
  'appOnboarding.paymentGateway.info.fee_unavailable':
    'Transaction fee details are not available at the moment.',
  'appOnboarding.paymentGateway.info.dont_show_again': "Don't show this information again",
  'layoutInvoice.orientation': 'Orientation',
  'shopify.connect_heading': 'Connect your Shopify store with Kledo',
  'shopify.connect_subtitle': 'Automatically sync orders, products, and payments to save your time',
  'shopify.connect_button': 'Connect Shopify Store',
  'shopify.feature_sync_title': 'Auto Sync',
  'shopify.feature_sync_desc': 'Data updated in real-time across platforms.',
  'shopify.feature_invoice_title': 'Instant Invoice',
  'shopify.feature_invoice_desc': 'Create invoices directly from orders.',
  'shopify.feature_stock_title': 'Stock Management',
  'shopify.feature_stock_desc': 'Stock controlled in one dashboard.',
  'shopify.footer_note': "Don't have a Shopify store? Register first to start syncing.",
  'shopify.modal_title': 'Connect Shopify Store',
  'shopify.modal_store_name_label': 'Store Name',
  'shopify.modal_store_name_placeholder': 'Enter store name',
  'shopify.modal_store_name_help': 'Enter your Shopify store subdomain.',
  'shopify.modal_store_name_required': 'Store name is required',
  'shopify.modal_client_id_label': 'Client ID',
  'shopify.modal_client_id_placeholder': 'Enter Client ID (API key)',
  'shopify.modal_client_id_required': 'Client ID is required',
  'shopify.modal_client_secret_label': 'Client Secret',
  'shopify.modal_client_secret_placeholder': 'Enter Client Secret (API secret key)',
  'shopify.modal_client_secret_required': 'Client Secret is required',
  'shopify.modal_alert':
    'Make sure your store is active before connecting. Create a store first on Shopify.',
  'shopify.modal_cancel': 'Cancel',
  'shopify.modal_connect': 'Connect',
  'shopify.connect_success': 'Shopify store connected successfully.',
  'shopify.connecting_title': 'Connecting to Shopify...',
  'shopify.connecting_subtitle':
    'You will be redirected to the Shopify page to authorize access. Please wait a moment.',
  'shopify.callback_modal_title': 'Notification',
  'shopify.callback_success_title': 'Successfully Connected!',
  'shopify.callback_success_desc':
    'Your Shopify store has been successfully integrated with Kledo. You can now start syncing your data.',
  'shopify.callback_error_title': 'Failed to Connect',
  'shopify.callback_error_desc_default':
    'An error occurred while trying to connect to Shopify. Make sure the store domain is correct and you have the required access permissions.',
  'shopify.callback_close': 'Close',
  'shopify.callback_try_again': 'Try Again',
  'shopify.tutorial_video': 'Video Tutorial',
  'shopify.store_list_title': 'Store Connection List',
  'shopify.status_connected': 'Connected',
  'shopify.status_disconnected': 'Disconnected',
  'shopify.created_at': 'Created',
  'shopify.last_updated': 'Last Updated',
  'shopify.disconnected_since': 'Disconnected since',
  'shopify.sync_schedule': 'Sync Schedule',
  'shopify.manage': 'Manage',
  'shopify.delete_connection': 'Delete Connection',
  'shopify.delete_success': 'Connection deleted successfully',
  'shopify.reconnect': 'Reconnect',
  'shopify.detail_tab_payment': 'Payment Account',
  'shopify.detail_tab_webhook': 'Webhook',
  'shopify.detail_payment_title': 'Payment Account Code Setup',
  'shopify.detail_payment_subtitle':
    'Map Shopify payment methods for accurate automatic bookkeeping.',
  'shopify.detail_account_sales': 'Sales Account',
  'shopify.detail_account_sales_placeholder': 'Select sales account...',
  'shopify.detail_account_sales_help': 'This account will be used to record incoming sales.',
  'shopify.detail_account_sales_required': 'Sales account is required',
  'shopify.detail_account_receivable': 'Receivable Account',
  'shopify.detail_account_receivable_placeholder': 'Select receivable account...',
  'shopify.detail_account_receivable_required': 'Receivable account is required',
  'shopify.detail_account_discount': 'Discount Account',
  'shopify.detail_account_discount_placeholder': 'Select discount account...',
  'shopify.detail_account_shipping': 'Shipping Account',
  'shopify.detail_account_shipping_placeholder': 'Select shipping account...',
  'shopify.detail_account_tax': 'Tax Account',
  'shopify.detail_account_tax_placeholder': 'Select tax account...',
  'shopify.detail_save': 'Save',
  'shopify.detail_save_success': 'Settings saved',
  'shopify.detail_webhook_title': 'Webhook Topics',
  'shopify.detail_webhook_subtitle': 'Select events to sync from Shopify.',
  'shopify.detail_webhook_info':
    'Changes are applied immediately when you check or uncheck any box.',
  'shopify.detail_webhook_subscribe_success': 'Webhook topic subscribed.',
  'shopify.detail_webhook_unsubscribe_success': 'Webhook topic unsubscribed.',
  'shopify.detail_webhook_update_failed': 'Failed to update webhook topic.',
  'shopify.detail_group_orders': 'Orders',
  'shopify.detail_group_products': 'Products',
  'shopify.detail_group_customers': 'Customers',
  'shopify.detail_topic_orders_create_desc': 'Triggered when a new order is created.',
  'shopify.detail_topic_orders_updated_desc': 'Triggered when an order is updated.',
  'shopify.detail_topic_orders_cancelled_desc': 'Triggered when an order is cancelled.',
  'shopify.detail_topic_orders_fulfilled_desc': 'Triggered when an order is fulfilled.',
  'shopify.detail_topic_products_create_desc': 'Triggered when a new product is created.',
  'shopify.detail_topic_products_update_desc': 'Triggered when a product is updated.',
  'shopify.detail_topic_products_delete_desc': 'Triggered when a product is deleted.',
  'shopify.detail_topic_customers_create_desc': 'Triggered when a new customer is created.',
  'shopify.detail_topic_customers_update_desc': 'Triggered when a customer is updated.',
  'shopify.detail_disconnect_title': 'Disconnect',
  'shopify.detail_disconnect_desc':
    'Disconnecting stops all synchronization. Access token will be removed and re-authentication is required to connect again.',
  'shopify.detail_disconnect_button': 'Disconnect',
  'shopify.detail_disconnect_confirm': 'Are you sure you want to disconnect this store?',
  'shopify.detail_disconnect_info': 'Disconnect action is frontend-only in this phase.',
  'shopify.detail_payment_account_required': 'Payment account is required',
  'shopify.detail_payment_account_help':
    'This account will be used to record each incoming payment.',
  'shopify.detail_payment_account_placeholder': 'Select payment account...',
  in_second_value: 'in {value} seconds.',
  'layoutInvoice.show_shipping_address': 'Show Shipping Address',
  'businessFlow.product_conversion_formula_lock':
    'Lock raw material quantity on {product} conversion',
  'businessFlow.product_conversion_formula_lock_desc':
    'Should the raw material quantity be locked when the {product} conversion is created?',
  'businessFlow.production_plan_show_formula': 'Show Production Formula in Production Plan',
  'businessFlow.production_plan_show_formula_desc':
    'Should the Production Formula panel (raw material estimate) be shown on the Production Plan form?',
  'businessFlow.modifier_product_enabled': 'Modifier options linked to {product}',
  'businessFlow.modifier_product_enabled_desc':
    '{product} stock & cost are recorded when the option is selected in a transaction.',
  'businessFlow.production_plan_stock_warning_enabled':
    'Raw material stock warning in Production Plan',
  'businessFlow.production_plan_stock_warning_enabled_desc':
    'Show raw material availability on production plans and record shortages at realization.',
  'businessFlow.production_plan_stock_priority': 'Prioritize earlier created plans',
  'businessFlow.production_plan_stock_priority_desc':
    'When several plans compete for the same material, prioritize the plan created earlier. When off, the priority order in the list is used.',
  'zap.warehouse_is_required': 'Warehouse is required',
  select_sales_driver: 'Select Sales/Driver',
  'settings.discord_connect': 'Get transaction notifications in your Office Discord',
  'settings.shopify_connect': 'Automatically sync Shopify to Kledo',
  change_outlet: 'Change Outlet',
  'businessFlow.sale_hide_product_empty_quantity':
    'Hide {products} with empty quantity in invoice detail',
  'businessFlow.sale_hide_product_empty_quantity_desc':
    'Are {products} with empty quantity hidden in invoice detail?',
  'businessFlow.purchase_hide_product_empty_quantity':
    'Hide {products} with empty quantity in invoice detail',
  'businessFlow.purchase_hide_product_empty_quantity_desc':
    'Are {products} with empty quantity hidden in invoice detail?',
  'businessFlow.purchase_manufacture_product': 'Manufactured products can be purchased',
  'businessFlow.purchase_manufacture_product_desc':
    'If turned off, manufactured products cannot be selected in purchase transactions. Existing transactions do not change.',
  'report.total_price_product': 'Total Price {title}',
  'report.partial_paid': 'Partial Paid',
  'layoutInvoice.this_template': 'This template',
  'approval.purchase_delivery': 'Purchase Delivery',
  'approval.budget_management': 'Budget Management',
  'approval.section.transaction_desc':
    'Approvals for sales, purchase, and cash & bank transactions',
  'approval.section.warehouse_transfer_desc': 'Approvals for moving goods between warehouses',
  'approval.section.stock_adjustment_desc': 'Approvals for stock quantity adjustments',
  'approval.section.material_request_desc': 'Approvals for material requests from warehouse',
  'approval.section.purchase_request_desc': 'Approvals for internal purchase requests',
  'approval.section.material_issue_desc': 'Approvals for material issues from warehouse',
  'approval.section.budget_management_desc': 'Approvals for budgets and financial plans',
  'approval.section.warehouse_transfer_group_desc':
    'Approvals for combined warehouse transfer groups',
  'layoutInvoice.invoice_show_receipt_signature_made_checked':
    'Show Made By and Checked By Signature',
  'financeProduct.import_regular_product_2': 'Import {title} Regular',
  'financeProduct.import_package_product_2': 'Import {title} Package',
  'financeProduct.import_manufacturing_product_2': 'Import {title} Manufacturing',
  'financeProduct.import_conversion_product_2': 'Import {title} Conversion',
  'financeProduct.import_variant_product_2': 'Import Variant {title}',
  'financeProduct.import_variant.new_variants_title':
    'New variants & options to be created automatically',
  'financeProduct.import_variant.new_variant_axis': 'New variant axis',
  'financeProduct.import_variant.new_variant_option': 'New option on existing variant',
  'financeProduct.import_variant.combination_title': 'Combinations completed automatically',
  'financeProduct.import_variant.combination_note':
    'The system adds combinations outside the file so each {product} is complete.',
  'financeProduct.import_variant.combination_badge': '+{auto} automatic',
  'financeProduct.import_variant.col_variant': 'Variant',
  'financeProduct.import_variant.col_option': 'Option',
  'financeProduct.import_variant.col_note': 'Note',
  'financeProduct.import_variant.col_parent_code': 'Parent code',
  'financeProduct.import_variant.col_variant_code': 'Variant code',
  'financeProduct.import_variant.col_row_number': 'Row',
  'financeProduct.import_variant.total_combination': 'Total combinations',
  'financeProduct.import_variant.from_file': 'From file',
  'financeProduct.import_variant.auto': 'Automatic',
  'financeProduct.import_variant.completed_by_system': 'Completed by system',
  'financeProduct.import_variant.max_rows_hint':
    'A maximum of 3000 rows can be imported at a time.',
  'financeProduct.export_regular_product_2': 'Export {title} Regular',
  'financeProduct.export_package_product_2': 'Export {title} Package',
  'financeProduct.export_manufacturing_product_2': 'Export {title} Manufacturing',
  'zap.canvassing_add_product_required': '{product} is required',
  'financeBanks.expense_withholding': 'Expense Witholding',
  'financeBanks.expense_payment_withholding': 'Expense Payment Witholding',
  'financeBanks.receive_join_invoice_payment': 'Receive Join Invoice Payment',
  'financeBanks.join_invoice_payment_withholding': 'Join Invoice Payment Witholding',
  'financeBanks.purchase_join_invoice_payment': 'Purchase Join Invoice Payment',
  'financeBanks.purchase_join_invoice_payment_withholding':
    'Purchase Join Invoice Payment Witholding',
  'financeProduct.mass_edit': 'Mass Edit',
  'financeProduct.save_mass_edit': 'Save Mass Changes',
  'financeProduct.can_be_updated': 'Can be updated',
  'financeProduct.cannot_be_updated': 'Cannot be updated',
  'financeProduct.mass_patch_confirm': 'Are you sure you want to update {count} {title}(s)?',
  'financeProduct.mass_patch_marketplace_question':
    'Some of the products you are updating are linked to the marketplaces below. Apply these changes to the marketplace listings as well?',
  'financeProduct.mass_patch_progress_title': 'Mass product update in progress',
  'financeProduct.mass_patch_progress_desc':
    'Product updates are running in the background. You can close this window.',
  'financeProduct.mass_patch_complete_title': 'Yay! Mass product update succeeded!!',
  'financeProduct.mass_patch_complete_subtitle': 'Product updates have been completed.',
  'financeProduct.mass_roles_step_review': 'Review',
  'financeProduct.mass_roles_step_process': 'Process',
  'financeProduct.mass_roles_step_done': 'Done',
  'financeProduct.mass_roles_intro': '{count} {title}(s) selected. Who may access them?',
  'financeProduct.mass_roles_replace_warning': 'Existing access rights will be replaced',
  'financeProduct.mass_roles_replace_warning_desc':
    'The roles you pick replace all existing roles on the selected {title}(s); they are not added to them.',
  'financeProduct.mass_roles_invalid_reason':
    'Parent variant {title}(s) cannot have their access rights changed. Set access on each variant instead.',
  'financeProduct.mass_roles_public_warning': 'Everyone will have access',
  'financeProduct.mass_roles_public_warning_desc':
    'Access rights are cleared. Every user in this company can see the selected {title}(s).',
  'financeProduct.mass_roles_confirm': 'Change access rights for {count} {title}(s) now?',
  'financeProduct.mass_roles_no_valid':
    'None of the selected {title}(s) can have their access rights changed.',
  'financeProduct.mass_roles_progress_desc':
    'The process runs in the background. Do not close this window.',
  'financeProduct.mass_roles_progress_count': '{count} of {total} {title}(s) updated',
  'financeProduct.mass_roles_complete_title': 'Access rights changed',
  'financeProduct.mass_roles_skipped': 'Skipped',
  'financeProduct.mass_roles_chunk_failed': '{count} {title}(s) failed to process: {message}',
  'financeProduct.mass_description': 'Change Description',
  'financeProduct.mass_description_intro':
    '{count} {title}(s) selected. The new description will replace the old one.',
  'financeProduct.mass_description_placeholder': 'Write the new description',
  'financeProduct.mass_description_variant_info':
    'The description of a variant parent {title} is also applied to all of its variants.',
  'financeProduct.mass_description_marketplace_question':
    'Some selected {title}(s) are connected to the following marketplace stores. Send the new description to the checked stores too?',
  'financeProduct.mass_description_confirm': 'Change the description of {count} {title}(s) now?',
  'financeProduct.mass_description_no_valid':
    'None of the selected {title}(s) can have their description changed.',
  'financeProduct.mass_description_complete_title': 'Description changed successfully',
  'financeProduct.no_mp_count_warning':
    '{count} products are not connected to one or more marketplaces.',
  'financeProduct.data_progress_updated':
    '{count} out of {total} products were successfully synced',
  'financeProduct.data_has_been_updated': 'Total {count} data has been updated',
  'financeProduct.cannot_mass_update': 'Cannot mass update',
  'financeProduct.mass_update_info': '**Some products may not be updatable',
  'zap.canvas_warehouse': 'Canvas Warehouse',
  'financeInvoices.apply_tag_to_all_rows': 'Apply tag to all rows',
  'financeInvoices.max_tags': 'Maximum {value} tags',
  'marketplace.overview_page_title': 'Marketplace overview',
  'marketplace.landing_page_title': 'Marketplace',
  'marketplace.landing_eyebrow': '#JadiLebihBaik kelola bisnis omnichannel-mu',
  'marketplace.landing_hero_title_1': 'Manage Orders Across Many Channels',
  'marketplace.landing_hero_title_highlight': 'More Easily',
  'marketplace.landing_hero_title_2': 'with Rig.id',
  'marketplace.landing_hero_sub':
    'The best solution for centralized order management across marketplaces, real-time stock sync, and sales performance analysis in one integrated platform.',
  'marketplace.landing_cta_primary': 'Connect Marketplace',
  'marketplace.landing_meta_1': 'Real-time stock sync',
  'marketplace.landing_meta_2': 'No app switching',
  'marketplace.landing_meta_3': 'Connected to Kledo accounting',
  'marketplace.landing_mock_sales_title': 'Sales per marketplace',
  'marketplace.landing_mock_shops_title': 'My Marketplace',
  'marketplace.landing_mock_shops_synced': 'Synced',
  'marketplace.landing_mock_linked_title': 'Linked products per marketplace',
  'marketplace.landing_mock_products_title': 'Marketplace Products',
  'marketplace.landing_mock_add_marketplace': 'Add Marketplace',
  'marketplace.landing_mock_view_products': 'View Products',
  'marketplace.landing_mock_unconnected_notice':
    '{count} products not yet connected to marketplace',
  'marketplace.landing_mock_channels_connected': 'Connected Channels',
  'marketplace.landing_mock_channel_unit': 'Channels',
  'marketplace.landing_mock_manage': 'Manage',
  'marketplace.landing_mock_connected': 'Connected',
  'marketplace.landing_mock_stock_sync_title': 'Stock Sync',
  'marketplace.landing_mock_configure': 'Configure',
  'marketplace.landing_mock_sales_per_channel': 'Sales per Channel',
  'marketplace.landing_mock_period_7days': '7 days',
  'marketplace.landing_mock_finance_title': 'Financial Summary',
  'marketplace.landing_mock_period_month': 'This month',
  'marketplace.landing_mock_fin_col_post': 'Account',
  'marketplace.landing_mock_fin_col_value': 'Value',
  'marketplace.landing_mock_fin_gross_sales': 'Gross sales all channels',
  'marketplace.landing_mock_fin_channel_cost': 'Channel & shipping fees',
  'marketplace.landing_mock_fin_gross_profit': 'Gross profit auto-recorded',
  'marketplace.landing_mock_fin_journal': 'Journal sent to Kledo',
  'marketplace.landing_mock_synced_auto': 'Auto-synced',
  'marketplace.landing_logos_label': 'Connect with the sales channels you use.',
  'marketplace.landing_channel_online_store': 'Online Store',
  'marketplace.landing_features_title_1': 'One App For All',
  'marketplace.landing_features_title_2': 'Sales Channels',
  'marketplace.landing_features_sub':
    'From incoming orders and warehouse stock to bookkeeping — everything connected in one workflow.',
  'marketplace.landing_feature_1_title': 'Integration with various marketplaces',
  'marketplace.landing_feature_1_desc':
    'Connect product data from various marketplaces such as TikTok Shop, Shopee, Tokopedia and your own online store in one platform. You can edit product data, analyze orders and stock across channels without switching apps.',
  'marketplace.landing_feature_2_title': 'Integrated stock management',
  'marketplace.landing_feature_2_desc':
    'From warehouse data to products reaching customers, sync stock data in real-time across all sales channels and branches. Reduce the risk of overselling and underselling with always-accurate inventory data.',
  'marketplace.landing_feature_3_title': 'Better sales data analysis',
  'marketplace.landing_feature_3_desc':
    'Out-of-sync data makes business decisions less accurate. With Rig.id you get complete sales reports from all channels in one dashboard. Analyze business performance faster to help make better decisions.',
  'marketplace.landing_feature_4_title': 'Integrated automatic accounting system',
  'marketplace.landing_feature_4_desc':
    'Hard to know the profit from all sales channels? Now every sales transaction connects directly to the Kledo accounting system so bookkeeping is faster, more accurate, and requires less manual work.',
  'marketplace.landing_banner_title': 'Sell on Many Channels, Monitor in One App.',
  'marketplace.landing_banner_sub': 'Easier Omnichannel Management with Rig.id',
  'marketplace.landing_banner_card_stock_title': 'Stock',
  'marketplace.landing_banner_card_stock_desc': 'Stock synced automatically to all channels.',
  'marketplace.landing_banner_card_stock_pill': 'Accurate',
  'marketplace.landing_banner_card_order_title': 'Orders',
  'marketplace.landing_banner_card_order_desc': 'Orders from all channels on one board.',
  'marketplace.landing_banner_card_order_pill': 'Monitored',
  'marketplace.landing_banner_card_sales_title': 'Sales',
  'marketplace.landing_banner_card_sales_desc': 'Reports from all channels in one dashboard.',
  'marketplace.landing_banner_card_sales_pill': 'Real-time',
  'marketplace.landing_closing_text':
    'Easily monitor all orders, stock, and sales data in one integrated dashboard. Try it now.',
  'marketplace.marketplace_products_title': 'Marketplace Products',
  'marketplace.shopee_category': 'Shopee Category',
  'marketplace.tiktok_category': 'TikTok Category',
  'marketplace.manage_price_title': 'Manage Price',
  'marketplace.kledo_price': 'Kledo Price',
  'marketplace.marketplace_price': 'Marketplace Price',
  'marketplace.sync_stock': 'Sync Stock',
  'marketplace.price_linked': 'Price follows the Kledo price',
  'marketplace.price_unlinked': 'Price is set manually',
  'marketplace.sync_stock_updated': 'Sync stock setting updated',
  'marketplace.price_updated': 'Price updated successfully',
  'marketplace.relink_price_confirm': 'Link the marketplace price to the Kledo price?',
  'marketplace.boost_settings_title': 'Boost Product Settings',
  'marketplace.boost_select_store': 'Select a Shopee store to manage boosted products',
  'marketplace.boost_no_shopee_store': 'No Shopee store connected yet',
  'marketplace.boost_store': 'Store',
  'marketplace.boost_manage': 'Manage',
  'marketplace.boost_time': 'Time',
  'marketplace.boost_current_time': 'Current product boost time',
  'marketplace.boost_next_time': 'Next product boost time',
  'marketplace.boost_boosted_at': 'Boosted Time',
  'marketplace.boost_pinned': 'Pinned',
  'marketplace.boost_pin': 'Pin',
  'marketplace.boost_pin_limit': 'You can pin up to {limit} products',
  'marketplace.boost_pin_success': 'Pin updated',
  'marketplace.boost_reorder_success': 'Product order updated',
  'marketplace.boost_delete_success': 'Product removed from the list',
  'marketplace.boost_save_failed': 'Failed to save changes',
  'marketplace.boost_info_max_products': 'Each store can boost up to 5 products at a time',
  'marketplace.boost_info_duration': 'Boosted products stay active for 4 hours',
  'marketplace.boost_info_max_pin': 'Up to 5 products can be pinned',
  'marketplace.boost_info_drag': 'Rearrange the product order by dragging and dropping',
  'marketplace.boost_add_product': 'Add Product',
  'marketplace.boost_max_products_info': 'You can boost up to {max} products',
  'marketplace.boost_search_placeholder': 'Search product',
  'marketplace.boost_already_added': 'Already added',
  'marketplace.boost_add_success': 'Products added successfully',
  'marketplace.boost_add_failed': 'Failed to add products',
  'marketplace.boosted_view_button': 'Boosted Products',
  'marketplace.boosted_modal_title': 'Currently Boosted Products',
  'marketplace.boosted_empty': 'No products are being boosted right now',
  'marketplace.boosted_cooldown': 'Cooldown {value}',
  'marketplace.action_boost_product': 'Boost Product',
  'marketplace.action_pull_from_marketplace': 'Pull from Marketplace',
  'marketplace.action_view_master_product': 'View Master Product',
  'marketplace.action_link_product': 'Link to Kledo product',
  'marketplace.action_change_link_product': 'Change linked product',
  'marketplace.action_unlink_product': 'Unlink product',
  'marketplace.action_generate_product': 'Generate Kledo product',
  'marketplace.manual_link_badge': 'Manual',
  'marketplace.manual_link_title': 'Linked Manually',
  'marketplace.manual_link_marker_tooltip':
    'Linked manually. Automatic sync will not overwrite this link.',
  'marketplace.link_product_title': 'Link to Kledo product',
  'marketplace.change_link_product_title': 'Change linked Kledo product',
  'marketplace.link_product_for_mp_item': 'Marketplace product: {name}',
  'marketplace.link_product_pick_label': 'Kledo product',
  'marketplace.link_product_pick_required': 'Please select a Kledo product',
  'marketplace.link_product_success': 'Product linked successfully.',
  'marketplace.link_product_failed': 'Failed to link product.',
  'marketplace.unlink_product_success': 'Product unlinked successfully.',
  'marketplace.unlink_product_failed': 'Failed to unlink product.',
  'marketplace.unlink_product_confirm_title': 'Unlink product?',
  'marketplace.unlink_product_confirm_message':
    'The link will be removed. The next sync may link this product again automatically.',
  'marketplace.generate_product_success': 'Kledo product created successfully.',
  'marketplace.generate_product_failed': 'Failed to create Kledo product.',
  'marketplace.generate_product_confirm_title': 'Create Kledo product?',
  'marketplace.generate_product_confirm_message_flat':
    'A Kledo product will be created from this marketplace product and linked manually. Continue?',
  'marketplace.generate_product_confirm_message_parent':
    'Kledo products will be created for every variant on this marketplace product and linked manually. Continue?',
  'marketplace.bulk_generate_confirm_title': 'Generate Kledo products in bulk?',
  'marketplace.bulk_generate_confirm_message':
    'Kledo products will be created for {count} selected marketplace products and linked manually. The job runs in the background. Continue?',
  'marketplace.bulk_generate_scheduled':
    'Product creation has been scheduled. Refresh the list in a moment to see the new links.',
  'marketplace.bulk_generate_failed': 'Failed to schedule Kledo product creation.',
  'marketplace.linking_strategy_override_label': 'Product Linking Strategy',
  'marketplace.linking_strategy_override_use_connection': 'Use connection setting',
  'marketplace.linking_strategy_override_helper':
    'Leave empty to follow the Product Linking Strategy setting on the Marketplace Connection settings page.',
  'marketplace.status_available': 'Available',
  'marketplace.status_out_of_stock': 'Out of Stock',
  'marketplace.status_archive': 'Archive',
  'marketplace.status_draft': 'Draft',
  'marketplace.status_pending': 'Pending',
  'marketplace.status_failed': 'Failed',
  'marketplace.active': 'Active',
  'marketplace.item_status_normal': 'Active',
  'marketplace.item_status_banned': 'Banned',
  'marketplace.item_status_unlist': 'Archived',
  'marketplace.item_status_seller_delete': 'Deleted by seller',
  'marketplace.item_status_inactive': 'Inactive',
  'marketplace.item_status_shopee_delete': 'Deleted by Shopee',
  'marketplace.item_status_tiktok_delete': 'Deleted by TikTok',
  'marketplace.item_status_marketplace_delete': 'Deleted by Marketplace',
  'marketplace.item_status_reviewing': 'Under review',
  'marketplace.stock_available_yes': 'Available',
  'marketplace.stock_available_no': 'Out of stock',
  'marketplace.my_marketplace_title': 'My Marketplace',
  'marketplace.add_marketplace': 'Add Marketplace',
  'marketplace.connected_stores': 'Connected Stores',
  'marketplace.store_error': 'Marketplace connection lost',
  'marketplace.store_synced': 'Marketplace synced',
  'marketplace.store_setting_title': '{name} Settings',
  'marketplace.setting_saved': 'Settings saved',
  'marketplace.setting_section_product_sync': 'Product Sync',
  'marketplace.setting_sync_stock_question':
    'Is the product stock in the marketplace automatically synchronized with the stock in Kledo?',
  'marketplace.setting_section_transaction_sync': 'Transaction Sync',
  'marketplace.setting_warehouse_label': 'Which warehouse is the stock recorded in?',
  'marketplace.setting_tag_label': 'What tags to attach to each transaction?',
  'marketplace.setting_tag_tooltip':
    'Used to create transaction categories. You can also create reports based on these tags.',
  'marketplace.setting_record_transaction_label':
    'When should transactions be recorded in Kledo based on marketplace status?',
  'marketplace.setting_record_transaction_tooltip':
    'If recorded when item is shipped, an order and delivery transaction will be created in Kledo. When done, a sales invoice and payment will be created. If recorded when transaction is done, transactions will only be added when the marketplace status is complete.',
  'marketplace.setting_return_sync_label': 'Create automatic returns from marketplace',
  'marketplace.setting_return_sync_helper':
    'If turned off, returns/refunds completed on the marketplace will not automatically create a Sales Return in Kledo.',
  'marketplace.setting_connected_since': 'Connected since {date}',
  'marketplace.setting_show_advanced': 'show advanced settings',
  'marketplace.setting_hide_advanced': 'hide advanced settings',
  'marketplace.setting_payment_bank_label':
    'Which bank account will transaction payments be recorded in?',
  'marketplace.setting_admin_cost_label':
    'Which COA account will marketplace admin fees be recorded in?',
  'marketplace.setting_admin_cost_tooltip':
    'Every transaction with admin fees charged by the marketplace will automatically create an expense transaction.',
  'marketplace.setting_pph22_label':
    'Which COA account will marketplace PPh 22 withholding (0.5%) be recorded in?',
  'marketplace.setting_pph22_tooltip':
    'Account to record PPh 22 withholding deducted by marketplace from sales revenue. Leave empty to use the default account.',
  'marketplace.setting_record_shipping_label': 'Should shipping costs be recorded in Kledo?',
  'marketplace.setting_shipping_cost_label':
    'Which COA account will marketplace shipping costs be recorded in?',
  'marketplace.setting_shipping_cost_tooltip':
    'Every transaction where the customer pays shipping cost to the marketplace will automatically create an expense transaction.',
  'marketplace.reconnect_modal_title': 'Marketplace connection lost',
  'marketplace.reconnect_modal_desc':
    'The connection to {shopName} has been disconnected. Please reconnect to continue syncing data.',
  'marketplace.reconnect_btn': 'Reconnect',
  'marketplace.sync_products': 'Sync Products',
  'marketplace.sync_transactions': 'Sync Transactions',
  'marketplace.sync_log': 'Sync Log',
  'marketplace.sync_history_status_processed': 'Processed',
  'marketplace.sync_history_status_processing': 'Processing',
  'marketplace.sync_history_status_pending': 'Pending',
  'marketplace.sync_history_status_failed': 'Failed',
  'marketplace.sync_history_products_count': '{processed} / {total} products processed',
  'marketplace.failed_sync_log': 'Failed Sync Log',
  'marketplace.failed_sync_action_label': 'Action',
  'marketplace.failed_sync_item_id_label': 'Item ID',
  'marketplace.failed_sync_action_push': 'Push product',
  'marketplace.failed_sync_action_push_stock': 'Push stock',
  'marketplace.failed_sync_action_push_price': 'Push price',
  'marketplace.failed_sync_action_push_boost': 'Boost product',
  'marketplace.failed_sync_action_pull': 'Pull product',
  'marketplace.failed_sync_action_pull_model': 'Pull product variant',
  'marketplace.failed_sync_action_apply_stock_to_kledo': 'Apply stock to Kledo',
  'marketplace.apply_stock_apply_to_marketplace': 'Apply stock to marketplace',
  'marketplace.apply_stock_apply_to_kledo': 'Apply stock to Kledo',
  'marketplace.menu_setting': 'Settings',
  'marketplace.menu_view_products': 'View Products',
  'marketplace.menu_visit_marketplace': 'Visit Marketplace',
  'marketplace.menu_sync_log': 'Sync Log',
  'marketplace.menu_delete': 'Delete',
  'marketplace.sales_per_marketplace': 'Sales per marketplace',
  'marketplace.linked_pos_product_per_marketplace': 'Linked products per marketplace',
  'marketplace.linked_pos_product': 'Linked products',
  'financeProduct.description_required': 'Description is required',
  'financeProduct.add_product_to_marketplace_brand_required': 'Brand is required',
  'financeProduct.add_product_from_marketplace': 'Add Product from Marketplace',
  'financeProduct.connect_marketplace_modal_title': 'Connect Your Marketplace with Kledo',
  'financeProduct.connect_marketplace_modal_line1':
    'Connect your marketplace with Kledo to automatically sync all marketplace products to Kledo.',
  'financeProduct.connect_marketplace_modal_line2':
    'Product stock will also be updated automatically!',
  'financeProduct.marketplace_label_shopee': 'Shopee',
  'financeProduct.marketplace_dropdown_button': 'Marketplace',
  'financeProduct.marketplace_add_to_marketplace': 'Add to Marketplace',
  'financeProduct.marketplace_view_on_shopee': 'View on {marketplace}',
  'financeProduct.marketplace_view_marketplace_product': 'View Marketplace Product',
  'financeProduct.marketplace_edit_price_shopee': 'Edit price on {marketplace}',
  'financeProduct.marketplace_edit_stock_shopee': 'Edit stock on {marketplace}',
  'financeProduct.marketplace_edit_detail_shopee': 'Edit details on {marketplace}',
  'financeProduct.marketplace_boost_shopee': 'Boost on Shopee',
  'financeProduct.marketplace_boost_shopee_success': 'Boost request sent to Shopee.',
  'financeProduct.marketplace_boost_shopee_failed': 'Could not boost product on Shopee.',
  'financeProduct.marketplace_delete_shopee': 'Remove from {marketplace}',
  'financeProduct.marketplace_delete_listing_success': 'Listing removed from Shopee.',
  'financeProduct.marketplace_delete_listing_failed': 'Could not remove listing from Shopee.',
  'financeProduct.marketplace_delete_choice_title': 'Delete marketplace product',
  'financeProduct.marketplace_delete_choice_description':
    'Choose how to delete. "Delete from Kledo only" removes the data in Kledo (marketplace product menu) only. "Delete on marketplace too" also removes the listing on the marketplace.',
  'financeProduct.marketplace_delete_kledo_only': 'Delete from Kledo only',
  'financeProduct.marketplace_delete_with_marketplace': 'Delete on marketplace too',
  'financeProduct.marketplace_delete_kledo_only_success': 'Product removed from Kledo.',
  'financeProduct.marketplace_delete_kledo_only_failed': 'Could not remove product from Kledo.',
  'financeProduct.marketplace_archive_shopee': 'Archive',
  'financeProduct.marketplace_archive_listing_success': 'Product archived on Shopee.',
  'financeProduct.marketplace_archive_listing_failed': 'Could not archive product on Shopee.',
  'financeProduct.marketplace_unarchive_shopee': 'Unarchive',
  'financeProduct.marketplace_unarchive_listing_success': 'Product unarchived on Shopee.',
  'financeProduct.marketplace_unarchive_listing_failed': 'Could not unarchive product on Shopee.',
  'financeProduct.marketplace_push_to_marketplace': 'Push to Marketplace',
  'financeProduct.marketplace_pull_from_marketplace': 'Pull from Marketplace',
  'financeProduct.marketplace_pull_confirm_description':
    'Data in Kledo will be aligned with the marketplace listing.',
  'financeProduct.marketplace_pull_confirm_which': 'Which marketplace do you want to pull from?',
  'financeProduct.marketplace_pull_confirm_action': 'Pull now',
  'financeProduct.marketplace_pull_only': 'Pull only',
  'financeProduct.marketplace_pull_apply_to_master': 'Pull & update master product',
  'financeProduct.marketplace_pull_failed': 'Could not pull product detail from marketplace.',
  'financeProduct.marketplace_pull_no_connection':
    'No marketplace connection found for this product.',
  'financeProduct.marketplace_push_confirm_description':
    'Marketplace listing data will be aligned with Kledo. This includes: image, weight, size, description, and price.',
  'financeProduct.marketplace_push_confirm_action': 'Push now',
  'financeProduct.marketplace_push_failed': 'Could not start sync to marketplace.',
  'financeProduct.marketplace_push_no_connection':
    'No marketplace connection found for this product.',
  'financeProduct.marketplace_label_tiktok_shop': 'TikTok Shop',
  'financeProduct.marketplace_coming_soon': 'Coming soon',
  'financeProduct.connect_marketplace_success_title': "You're connected!",
  'financeProduct.connect_marketplace_success_desc':
    'Your marketplace has been successfully connected to Kledo.',
  'financeProduct.connect_marketplace_start_sync': 'Start product sync',
  'financeProduct.connect_marketplace_start_add_product_to_marketplace':
    'Start adding product to Marketplace',
  'financeProduct.add_product_to_marketplace_title': 'Add product to Marketplace',
  'financeProduct.add_product_to_marketplace_cancel': 'Cancel',
  'financeProduct.add_product_to_marketplace_save_draft': 'Save draft',
  'financeProduct.add_product_to_marketplace_submit': 'Add to Marketplace',
  'financeProduct.save_and_upload_to_marketplace': 'Save and Upload to Marketplace',
  'financeProduct.add_product_to_marketplace_stores': 'Connected stores',
  'financeProduct.add_product_to_marketplace_store_hint':
    'Select a store to configure listing. Stores already listed on the marketplace are disabled.',
  'financeProduct.add_product_to_marketplace_select_store':
    'Check at least one connected store on the left to show the form.',
  'financeProduct.add_product_to_marketplace_already_listed': 'Already listed',
  'financeProduct.add_product_to_marketplace_form_coming':
    'Category, description, shipping, and other fields will be added in the next iteration.',
  'financeProduct.add_product_to_marketplace_brand': 'Brand',
  'financeProduct.add_product_to_marketplace_no_brand': 'No brand',
  'financeProduct.add_product_to_marketplace_size_chart': 'Size Chart',
  'financeProduct.add_product_to_marketplace_size_chart_required': 'Size chart is required',
  'financeProduct.add_product_to_marketplace_size_chart_template': 'Pick registered chart',
  'financeProduct.add_product_to_marketplace_size_chart_image': 'Upload image',
  'financeProduct.add_product_to_marketplace_size_chart_choose_template':
    'Select a registered size chart',
  'financeProduct.add_product_to_marketplace_size_chart_fallback': 'Size chart',
  'financeProduct.add_product_to_marketplace_size_chart_unsupported':
    'This category does not support a size chart',
  'financeProduct.add_product_to_marketplace_size_chart_hint':
    'Choose one: a registered size chart or an uploaded image.',
  'financeProduct.add_product_to_marketplace_material': 'Material',
  'financeProduct.add_product_to_marketplace_choose_brand': 'Select brand',
  'financeProduct.add_product_to_marketplace_choose_material': 'Select material',
  'financeProduct.add_product_to_marketplace_product_weight': 'Product weight',
  'financeProduct.add_product_to_marketplace_product_weight_required': 'Product weight is required',
  'financeProduct.add_product_to_marketplace_images': 'Product images (Shopee)',
  'financeProduct.add_product_to_marketplace_images_required': 'Product images are required',
  'financeProduct.add_product_to_marketplace_select_store_to_upload':
    'Select at least one store on the left before uploading images.',
  'financeProduct.add_product_to_marketplace_shipping': 'Shipping',
  'financeProduct.add_product_to_marketplace_shipping_pick_logistics':
    'Select at least one logistics option.',
  'financeProduct.add_product_to_marketplace_shipping_instant': 'Instant',
  'financeProduct.add_product_to_marketplace_shipping_instant_priority': 'Instant Prioritas',
  'financeProduct.add_product_to_marketplace_shipping_hemat_kargo': 'Hemat Kargo',
  'financeProduct.add_product_to_marketplace_shipping_reguler': 'Reguler (Cashless)',
  'financeProduct.add_product_to_marketplace_shipping_carrier_grab':
    'GrabExpress Instant ( max 20000g)',
  'financeProduct.add_product_to_marketplace_shipping_carrier_gosend':
    'Gosend Instant ( max 20000g)',
  'financeProduct.add_product_to_marketplace_shipping_carrier_spx':
    'SPX Instant (min 1g max 20000g)',
  'financeProduct.add_product_to_marketplace_preorder': 'Pre order',
  'financeProduct.add_product_to_marketplace_preorder_no': 'No',
  'financeProduct.add_product_to_marketplace_preorder_yes': 'Yes',
  'financeProduct.add_product_to_marketplace_condition': 'Condition',
  'financeProduct.add_product_to_marketplace_choose_condition': 'Select condition',
  'financeProduct.add_product_to_marketplace_condition_new': 'New',
  'financeProduct.add_product_to_marketplace_condition_used': 'Used',
  'financeProduct.add_product_to_marketplace_days_to_ship': 'Pre-order days to ship',
  'financeProduct.add_product_to_marketplace_days_to_ship_required': 'Days to ship is required',
  'financeProduct.add_product_to_marketplace_parcel_size': 'Parcel size',
  'financeProduct.add_product_to_marketplace_package_length': 'Length',
  'financeProduct.add_product_to_marketplace_package_width': 'Width',
  'financeProduct.add_product_to_marketplace_package_height': 'Height',
  'financeProduct.add_product_to_marketplace_package_length_required': 'Length is required',
  'financeProduct.add_product_to_marketplace_package_width_required': 'Width is required',
  'financeProduct.add_product_to_marketplace_package_height_required': 'Height is required',
  'financeProduct.add_product_to_marketplace_courier_over_axis':
    'Package exceeds this courier max dimension ({length}×{width}×{height} {unit})',
  'financeProduct.add_product_to_marketplace_courier_over_sum':
    'Package total dimension (L+W+H) exceeds this courier max of {sum} {unit}',
  'financeProduct.add_product_to_marketplace_price': 'Price',
  'financeProduct.add_product_to_marketplace_price_required': 'Price is required',
  'financeProduct.add_product_to_marketplace_price_min': 'Price must be greater than 0',
  'financeProduct.add_product_to_marketplace_days': 'days',
  'financeProduct.add_product_to_marketplace_dangerous_product': 'Dangerous product',
  'financeProduct.add_product_to_marketplace_dangerous_no': 'No',
  'financeProduct.add_product_to_marketplace_dangerous_yes':
    'Contains batteries / magnets / liquids / flammable materials',
  'financeProduct.add_product_to_marketplace_no_couriers': 'No couriers available',
  'financeProduct.add_product_to_marketplace_no_delivery_options': 'No delivery options available',
  'financeProduct.add_product_to_marketplace_priced_manually_label': 'Manual price',
  'financeProduct.add_product_to_marketplace_priced_manually_help':
    'Enable to set the marketplace price independently from the Kledo product price. If disabled, the price follows the Kledo product price.',
  'financeProduct.add_product_to_marketplace_minimum_order_quantity': 'Minimum order quantity',
  'financeProduct.add_product_to_marketplace_minimum_order_quantity_min': 'Minimum {value}',
  'financeProduct.add_product_to_marketplace_cod_allowed': 'COD allowed',
  'financeProduct.add_product_to_marketplace_pre_owned': 'Pre-owned',
  'financeProduct.add_product_to_marketplace_unit_placeholder': 'Unit',
  'financeProduct.add_product_to_marketplace_attribute_placeholder': 'Enter attribute',
  'financeProduct.add_product_to_marketplace_attribute_required': '{attr} is required',
  'financeProduct.add_product_to_marketplace_loading': 'Loading...',
  'financeProduct.add_product_to_marketplace_submit_success':
    'Product successfully published to marketplace',
  'financeProduct.add_product_to_marketplace_submit_error':
    'Failed to publish product to marketplace',
  'financeProduct.add_product_to_marketplace_review_modal':
    'Your product will be reviewed by the marketplace first before it can be displayed. You can also view your product from the product list in Seller Center, then select the "Under Review" tab.',
  'financeProduct.add_product_to_marketplace_review_modal_back_to_product': 'Back to product',
  'financeProduct.connect_sync_title': 'Pull marketplace products with Kledo',
  'financeProduct.connect_sync_desc_1':
    'All products in the marketplace will be downloaded and added to Kledo.',
  'financeProduct.connect_sync_desc_2':
    'If a product SKU exists in both the marketplace and Kledo, the product data will be updated.',
  'financeProduct.connect_sync_marketplace_selected_label': 'Marketplace being synced',
  'financeProduct.connect_sync_tiktok_active_notice':
    "Because of how TikTok's system works, products that are inactive in the marketplace will automatically become active when the sync runs.",
  'financeProduct.connect_sync_demo_store': 'Toko Baru Biru',
  'financeProduct.connect_sync_product_filter': 'Download all products or only active ones?',
  'financeProduct.connect_sync_filter_all': 'All',
  'financeProduct.connect_sync_filter_active': 'Active only',
  'financeProduct.connect_sync_filter_help':
    'If you choose all products, archived products will be downloaded as well.',
  'financeProduct.connect_sync_stock_title': 'How should product stock be synchronized?',
  'financeProduct.connect_sync_stock_marketplace_source':
    'Match stock in Kledo to the stock in the marketplace',
  'financeProduct.connect_sync_stock_kledo_source':
    'Match stock in the marketplace to the stock in Kledo',
  'financeProduct.connect_sync_stock_kledo_source_help':
    'If you change the stock in Kledo, the stock change in the marketplace will sync within about 10 minutes.',
  'financeProduct.connect_sync_stock_as_is': 'Keep stock as is',
  'financeProduct.connect_sync_stock_as_is_help':
    'The marketplace product will be created as a master product without stock tracking.',
  'financeProduct.connect_sync_add_products': 'Add products',
  'financeProduct.connect_sync_progress_title': 'Synchronization in progress',
  'financeProduct.connect_sync_progress_desc':
    'Product sync is running in the background. You can close this window.',
  'financeProduct.connect_sync_progress_status':
    '{synced} of {total} products synchronized successfully',
  'financeProduct.connect_sync_complete_title': 'Product sync completed!',
  'financeProduct.connect_sync_complete_subtitle': 'Product synchronization has finished.',
  'financeProduct.connect_sync_complete_row_success': 'Succeeded',
  'financeProduct.connect_sync_complete_row_failed': 'Failed',
  'financeProduct.connect_sync_go_to_products': 'Go to products',
  'marketplace.edit_product': 'Edit Marketplace Product',
  'marketplace.edit_review_modal':
    'Your product changes are being processed by the marketplace and may take a moment to appear.',
  'marketplace.product_detail_title': 'Marketplace Product Detail',
  'marketplace.detail_images': 'Product Images',
  'marketplace.detail_basic_info': 'Basic Information',
  'marketplace.detail_shop': 'Store',
  'marketplace.detail_current_price': 'Current Price',
  'marketplace.detail_logistics': 'Logistics',
  'marketplace.detail_attributes': 'Attributes',
  'marketplace.detail_delivery_options': 'Delivery Options',
  'marketplace.detail_yes': 'Yes',
  'marketplace.detail_no': 'No',
  'marketplace.detail_variants': 'Variants',
  'marketplace.detail_variant': 'Variant',
  'marketplace.variant_section_title': 'Variants',
  'marketplace.variant_name': 'Variation',
  'marketplace.variant_name_placeholder': 'e.g. Color, Size',
  'marketplace.variant_option_placeholder': 'Option name',
  'marketplace.variant_add_variation': 'Add Variation',
  'marketplace.variant_add_option': 'Add Option',
  'marketplace.variant_required': 'Add at least one variation with its options',
  'message.edit_product_save_success': 'Marketplace product updated successfully',
  'report.cogs_percentage': 'COGS Percentage',

  'ecsysConnect.title': 'ECSys Integration',
  'ecsysConnect.tab_connect': 'Connection',
  'ecsysConnect.tab_stores': 'Store Mapping',
  'ecsysConnect.tab_syncs': 'Delivery History',
  'ecsysConnect.tabs_locked_hint':
    'Save your credentials to unlock the Store Mapping and Delivery History tabs.',
  'ecsysConnect.group_credentials': 'Credentials',
  'ecsysConnect.group_push': 'Delivery',
  'ecsysConnect.password_help': 'Leave blank to keep the current password.',
  'ecsysConnect.active': 'Active',
  'ecsysConnect.active_help': 'Invoices are sent automatically on schedule.',
  'ecsysConnect.sync_interval': 'Delivery schedule',
  'ecsysConnect.sync_interval_unit': 'hours',
  'ecsysConnect.last_sync': 'Last sync',
  'ecsysConnect.please_input_base_url': 'Please input Base URL',
  'ecsysConnect.please_input_username': 'Please input Username',
  'ecsysConnect.please_input_password': 'Please input Password',
  'ecsysConnect.store_entity': 'Store Mapping',
  'ecsysConnect.store_no_outlet': 'No outlet',
  'ecsysConnect.airport_code': 'Airport Code',
  'ecsysConnect.airport_code_placeholder': 'e.g. CGK',
  'ecsysConnect.store_is_default_checkbox': 'Set as default store',
  'ecsysConnect.store_is_default_help':
    'Invoices not tied to any outlet are sent to this store. Without a default store, those invoices are never sent to ECSys.',
  'ecsysConnect.store_edit_title': 'Edit Store Mapping',
  'ecsysConnect.store_delete_confirm': 'Invoices using this mapping will stop being sent to ECSys.',
  'ecsysConnect.store_delete_default_warning':
    'This row is the default store. Once deleted, no default store remains — invoices not tied to any outlet will stop being sent to ECSys.',
  'ecsysConnect.store_uncheck_default_warning':
    'Once saved, no default store will remain. Invoices not tied to any outlet will stop being sent to ECSys until you set a new default store.',
  'ecsysConnect.please_input_store_id': 'Please input ECSys Store ID',
  'ecsysConnect.sync_entity': 'Delivery History',
  'ecsysConnect.sync_ref_number': 'Invoice No.',
  'ecsysConnect.sync_trans_date': 'Transaction Date',
  'ecsysConnect.sync_pushed_at': 'Sent At',
  'ecsysConnect.sync_description': 'Description',
  'ecsysConnect.sync_status_success': 'Sent',
  'ecsysConnect.sync_status_pending': 'Pending',
  'ecsysConnect.sync_status_failed_transient': 'Failed, retrying',
  'ecsysConnect.sync_status_failed_permanent': 'Failed',
  'ecsysConnect.sync_filter_all': 'All',
  'ecsysConnect.sync_retry_at': 'Retrying {at}',
  'ecsysConnect.sync_empty_filtered_desc': 'No deliveries match this filter.',
  // ECSys Connect landing page
  'ecsysConnect.lp_cta': 'Integrate ECSys Connect',
  'ecsysConnect.lp_action_config': 'Configure',
  'ecsysConnect.lp_status_active': 'Active',
  'ecsysConnect.lp_status_saved': 'Saved',
  'ecsysConnect.lp_status_verified': 'Verified',
  'ecsysConnect.lp_status_success': 'Success',
  'ecsysConnect.lp_status_sent': 'Sent',
  'ecsysConnect.lp_status_waiting': 'Waiting',
  'ecsysConnect.lp_hero_eyebrow': '#BeBetter send transaction data to ECSys',
  'ecsysConnect.lp_hero_title_1': 'Now You Can Send Kledo Transaction Data to ECSys',
  'ecsysConnect.lp_hero_title_2': 'Without Re-entering',
  'ecsysConnect.lp_hero_sub':
    'Connect Kledo with the ECSys Angkasa Pura system to send all transaction data automatically, without re-entering transactions manually, through ECSys Connect integration.',
  'ecsysConnect.lp_hero_strip_1': 'No Re-entry',
  'ecsysConnect.lp_hero_strip_2': 'Store Mapping',
  'ecsysConnect.lp_hero_strip_3': 'Delivery History',
  'ecsysConnect.lp_hero_tile_payment': 'Payment',
  'ecsysConnect.lp_hero_tile_store': 'ECSys Store',
  'ecsysConnect.lp_hero_tile_validation': 'Validation',
  'ecsysConnect.lp_hero_tile_history': 'History',
  'ecsysConnect.lp_about_title_1': 'What Is',
  'ecsysConnect.lp_about_title_2': 'ECSys Angkasa Pura',
  'ecsysConnect.lp_about_title_3': '?',
  'ecsysConnect.lp_about_sub':
    'ECSys (E-POS Data Collection System) is an application by PT Angkasa Pura Indonesia used to collect transaction data from business partners e-POS in an integrated way.',
  'ecsysConnect.lp_about_card_1':
    'Transaction data from business partners e-POS systems is sent to PT Angkasa Pura Indonesia so it can be monitored and validated without manually re-entering the transaction data.',
  'ecsysConnect.lp_about_card_2':
    'Through the Kledo and ECSys integration, transaction data such as invoice number, transaction time, product information, quantity, price, tax, payment method, and transaction total can be sent in the format defined by PT Angkasa Pura Indonesia.',
  'ecsysConnect.lp_about_tag_1': 'Invoice No.',
  'ecsysConnect.lp_about_tag_2': 'Transaction Time',
  'ecsysConnect.lp_about_tag_3': 'Product Information',
  'ecsysConnect.lp_about_tag_4': 'Quantity & Price',
  'ecsysConnect.lp_about_tag_5': 'Tax',
  'ecsysConnect.lp_about_tag_6': 'Payment Method',
  'ecsysConnect.lp_about_tag_7': 'Transaction Total',
  'ecsysConnect.lp_features_title_1': 'One Integration to Send',
  'ecsysConnect.lp_features_title_2': 'Transaction Data to ECSys',
  'ecsysConnect.lp_features_sub':
    'From account connection, store mapping, transaction delivery, to delivery history — all in a single workflow.',
  'ecsysConnect.lp_feat1_title': 'Connected Directly to ECSys',
  'ecsysConnect.lp_feat1_desc':
    'Connect your Kledo account with ECSys Angkasa Pura using the provided connection configuration. Once connected, transaction data from Kledo can be sent to ECSys without manual re-entry.',
  'ecsysConnect.lp_feat1_mock_title': 'ECSys Connection Status',
  'ecsysConnect.lp_feat1_mock_hint': 'connected',
  'ecsysConnect.lp_feat1_row1': 'Endpoint URL',
  'ecsysConnect.lp_feat1_row2': 'Client ID',
  'ecsysConnect.lp_feat1_row3': 'Secret Key',
  'ecsysConnect.lp_feat1_row4': 'Connection Test',
  'ecsysConnect.lp_feat2_title': 'Easier Store Mapping',
  'ecsysConnect.lp_feat2_desc':
    'Define the relationship between stores, warehouses, or locations in Kledo and the stores in ECSys. Set the mapping according to your business locations so transaction data is sent to the right destination.',
  'ecsysConnect.lp_feat2_mock_title': 'Store Mapping',
  'ecsysConnect.lp_feat2_mock_tag': 'Kledo · Terminal 3 Warehouse',
  'ecsysConnect.lp_feat2_mock_target': 'Mapped to ECSys · Store ST-CGK-T3',
  'ecsysConnect.lp_feat2_mock_note': '3 of 4 Kledo locations mapped to ECSys stores',
  'ecsysConnect.lp_feat2_mock_add': 'Add store mapping',
  'ecsysConnect.lp_feat3_title': 'Send Transaction Data Without Re-entry',
  'ecsysConnect.lp_feat3_desc':
    'Transactions already recorded in Kledo can be sent to ECSys in an integrated way. No need to re-enter transaction data one by one, making administration more practical.',
  'ecsysConnect.lp_feat3_mock_title': 'Transactions Sent',
  'ecsysConnect.lp_feat3_picker': 'Today',
  'ecsysConnect.lp_feat3_row2_meta': '98 transactions',
  'ecsysConnect.lp_feat3_row3_title': 'Delivery queue',
  'ecsysConnect.lp_feat3_row3_meta': '1 transaction',
  'ecsysConnect.lp_feat4_title': 'Monitor Delivery History',
  'ecsysConnect.lp_feat4_desc':
    'Review the history of transactions sent from Kledo to ECSys through the Delivery History tab. Use that information to check transactions and trace the data delivery process.',
  'ecsysConnect.lp_feat4_mock_title': 'Delivery History',
  'ecsysConnect.lp_feat4_picker': 'This month',
  'ecsysConnect.lp_feat4_head_status': 'Delivery Status',
  'ecsysConnect.lp_feat4_head_count': 'Count',
  'ecsysConnect.lp_feat4_row1': 'Transactions sent to ECSys',
  'ecsysConnect.lp_feat4_row2': 'Waiting for delivery',
  'ecsysConnect.lp_feat4_row3': 'Needs re-delivery',
  'ecsysConnect.lp_feat4_row4': 'Last delivery to ECSys',
  'ecsysConnect.lp_banner_title': 'More Practical, Without Re-entering Transactions.',
  'ecsysConnect.lp_banner_sub': 'Use ECSys Connect Now.',
  'ecsysConnect.lp_cta_text':
    'Send transaction data from Kledo to ECSys without manual re-entry. Connect Kledo with ECSys and manage the transaction delivery process more practically.',
  'settings.ecsys_connect': 'Automatically send sales invoices to ECSys',
  'zap.landing_title': 'Distribution',
  'zap.landing_hash_tag': '#Bebetter at managing your business distribution',
  'zap.landing_head_title': 'More Optimal Distribution Management Delivers Maximum Profit with',
  'zap.landing_head_desc':
    'Zap helps companies manage distribution efficiently through route management, monitoring of sales canvassing activities, and real-time operational reporting so that every process stays under control.',
  'zap.landing_phone_alt': 'The Zap application on a smartphone',
  'zap.landing_banner_alt': 'Distribution management from warehouse to customer with Zap',
  'zap.landing_start_free': 'Start Free Now',
  'zap.landing_feat_title_1': 'What Will',
  'zap.landing_feat_title_2': 'You Get',
  'zap.landing_feat_title_3': 'by Using Zap?',
  'zap.landing_feat_route_title': 'Smart Route Feature for Optimal Route Management',
  'zap.landing_feat_route_desc':
    "With Zap's smart route feature, the system automatically finds the most efficient route for drivers and salespeople, so visit flows are more optimal, operational costs go down, and more customers can be served every day.",
  'zap.landing_feat_canvassing_title': 'Canvassing Application from a Smartphone',
  'zap.landing_feat_canvassing_desc':
    'Manage field sales activities in a more structured way using the Zap canvassing application. Schedule customer visits, monitor canvassing results, and make sure every activity is recorded automatically without any manual work.',
  'zap.landing_feat_tracking_title': 'Real-Time Driver Tracking',
  'zap.landing_feat_tracking_desc':
    'Monitor driver locations and movements directly through the Zap system. Know the status of every trip, make sure deliveries run as planned, and coordinate more easily with your field team.',
  'zap.landing_feat_accounting_title': 'Integrated with the Accounting System',
  'zap.landing_feat_accounting_desc':
    'All distribution and sales transactions can be connected to the Kledo accounting system, so financial records become faster and more accurate, and it is easier for you to make better business decisions.',
  'zap.landing_feat_fleet_title': 'Centralized Fleet Management',
  'zap.landing_feat_fleet_desc':
    'Manage your entire distribution fleet in a single dashboard. Monitor which vehicles are operating, their usage schedules, the drivers using them, and fleet performance so operations keep running optimally.',
  'zap.landing_feat_transparency_title': 'More Transparent Sales and Warehouse System',
  'zap.landing_feat_transparency_desc':
    'Every sales transaction and stock movement is recorded in real time so you can monitor inventory, goods distribution, and sales performance more accurately.',
  'zap.landing_footer_note':
    "Optimize your distribution operations and boost your field team's productivity with Zap. Try it now.",
  'report.material_no_project': 'No tag',
  'report.material_no_project_only': 'No tag only',
  'report.material_deleted_tag': 'Tag #{id} (deleted)',
  'report.material_value_pending': 'Pending calculation',
  'report.material_adhoc_no_request': 'Ad-hoc (no MR)',
  'report.material_request_status_draft': 'Draft',
  'report.material_request_status_submitted': 'Submitted',
  'report.material_request_status_processing': 'Processing',
  'report.material_request_status_partial_fulfilled': 'Partially fulfilled',
  'report.material_request_status_fully_fulfilled': 'Fully fulfilled',
  'report.material_request_status_rejected': 'Rejected',
  'report.material_request_status_cancelled': 'Cancelled',
  'report.material_status': 'Status',
  'report.material_status_all_active': 'All active',
  'report.material_warehouse': 'Warehouse',
  'report.material_project': 'Tag',
  'report.material_subtotal_tag': 'Tag Subtotal',
  'report.material_only_outstanding': 'Outstanding only',
  'report.material_request_filter': 'Material request',
  'report.material_date': 'Date',
  'report.material_requested_qty': 'Requested',
  'report.material_issued_qty': 'Issued',
  'report.material_outstanding_qty': 'Outstanding',
  'report.material_issue_number': 'Material Issue Number',
  'report.material_source_request_number': 'Material Source Request Number',
  'report.material_qty': 'Qty',
  'report.material_value_cogs': 'Value (COGS)',
  'report.material_quantity': 'Quantity',
  'report.material_value': 'Value',
  'report.material_search_request_placeholder': 'Search material request number or {product}',
  'report.material_search_usage_placeholder': 'Search material issue number or {product}',
  'priceForecast.title': 'Price Forecast Settings',
  'priceForecast.page_subtitle':
    'Set up price increase scenarios and the monthly percentage for each material product.',
  'priceForecast.target_production_finish': 'Production Completion Target',
  'priceForecast.target_production_finish_help':
    'Number of months until production finishes. Used as the basis for material price projection.',
  'priceForecast.month_option': '{months, plural, one {# month} other {# months}} · ± {date}',
  'priceForecast.tab_scenario': 'Scenarios',
  'priceForecast.tab_percentage': 'Product Percentage',
  'priceForecast.scenario_name': 'Scenario name',
  'priceForecast.scenario_name_required': 'Scenario name is required.',
  'priceForecast.scenario_name_length_error': 'Scenario name must be {min}–{max} characters.',
  'priceForecast.scenario_name_duplicate_error':
    'The name "{name}" is already used by another scenario.',
  'priceForecast.add_scenario': 'Add scenario',
  'priceForecast.edit_scenario': 'Edit scenario',
  'priceForecast.delete_scenario_title': 'Delete scenario "{name}"?',
  'priceForecast.delete_scenario_warning_percentage':
    'All product percentages for this scenario will also be deleted and cannot be restored.',
  'priceForecast.delete_scenario_warning_snapshot':
    'Forecast snapshots on existing quotes remain intact (unchanged).',
  'priceForecast.delete_scenario_ok': 'Delete scenario',
  'priceForecast.empty_title': 'No scenarios yet',
  'priceForecast.empty_desc':
    'A scenario is a price increase assumption (for example optimistic, normal, or pessimistic). Start from the common suggestions below, or create your own.',
  'priceForecast.create_suggested_scenarios': 'Create 3 suggested scenarios',
  'priceForecast.create_own_scenario': 'Create your own scenario',
  'priceForecast.suggested_scenarios_created': '3 suggested scenarios created successfully.',
  'priceForecast.suggestion_best': 'Best Case',
  'priceForecast.suggestion_normal': 'Normal',
  'priceForecast.suggestion_worst': 'Worst Case',
  'priceForecast.percentage_no_scenario':
    'Create a scenario in the Scenario tab before filling in product percentages.',
  'priceForecast.percentage_search_placeholder': 'Search material product',
  'priceForecast.percentage_product_empty': 'No matching product.',
  'priceForecast.percentage_select_product':
    'Select a product on the left to fill in its percentages.',
  'priceForecast.percentage_panel_hint':
    'Monthly price increase percentage. Leave empty to clear the value for that scenario.',
  'priceForecast.percentage_not_set': '- not set',
  'priceForecast.percentage_invalid': 'Percentage must be a number.',
  // Bounds are written into the text: react-intl formats number arguments with
  // Intl.NumberFormat (3 decimals max), which would render -99.9999 as -100.
  'priceForecast.percentage_range_error': 'Percentage must be between -99.9999 and 999.9999.',
  'priceForecast.percentage_decimal_error': 'Percentage allows at most {max} decimal places.',
  'priceForecast.percentage_load_error': 'Failed to load percentages for this product.',
  'priceForecast.panel_title': 'Material cost forecast',
  'priceForecast.panel_basis_current': 'Currently {value}',
  'priceForecast.panel_basis_months': 'projected {months} mo',
  'priceForecast.panel_basis_margin': 'margin against {value}',
  'priceForecast.col_scenario': 'Scenario',
  'priceForecast.col_percentage_month': '% / mo',
  'priceForecast.col_projected_unit': 'Projected material / unit',
  'priceForecast.col_margin': 'Margin',
  'priceForecast.margin_safe': 'Healthy margin',
  'priceForecast.margin_thin': 'Thin margin',
  'priceForecast.margin_critical': 'Critical margin',
  'priceForecast.banner_incomplete':
    'Estimate is incomplete. Some components have no forecast percentage yet — they count as 0%, so the projection may be lower than reality.',
  'priceForecast.banner_incomplete_count':
    'Estimate is incomplete. {count} components have no forecast percentage yet — they count as 0%, so the projection may be lower than reality.',
  'priceForecast.banner_truncated':
    'Recipe depth is capped at 10 levels — deeper components are excluded. The projection below may be slightly under the full value.',
  'priceForecast.margin_minus_blocked':
    'Forecast profit margin is minus in the {scenarios} scenario',
  'priceForecast.calculate_error': 'Failed to load the estimate.',
  'priceForecast.retry': 'Retry',
  'priceForecast.panel_expand': 'View detail',
  'priceForecast.panel_collapse': 'Collapse',
  'priceForecast.panel_updating': 'Updating…',
  'priceForecast.panel_updating_months': 'Updating to {months} mo',
  'priceForecast.updating_progress': 'Updating projections… {done}/{total}',
  'priceForecast.detail_card_title': 'Material price forecast - {product}',
  'priceForecast.detail_card_qty': '× {qty}',
  'priceForecast.detail_snapshot_date': 'Snapshot {date}',
  'priceForecast.detail_snapshot_months': 'production target {months} mo',
  'priceForecast.detail_snapshot_source': 'basis {source}',
  'priceForecast.source_inventory_avg': 'inventory average',
  'priceForecast.source_inventory_fifo': 'inventory FIFO',
  'priceForecast.source_last_purchase': 'last purchase',
  'priceForecast.source_base_price': 'product base price',
  'priceForecast.basis_snapshot': 'Basis (snapshot)',
  'priceForecast.col_material_unit_cost': 'Material cost / unit',
  'priceForecast.col_total_qty': 'Total (× {qty})',
  'priceForecast.live_label': "Today's estimate · {date}",
  'priceForecast.live_per_unit': '{value} / unit',
  'priceForecast.live_delta': '{value} from snapshot',
  'priceForecast.live_exceeds_badge': 'Exceeds the highest scenario',
  'priceForecast.live_note_exceed':
    "Today's material cost is already above the {scenario} projection ({value}). Consider revising the quote or securing the material purchase earlier.",
  'priceForecast.live_note_normal': 'Still below {scenario}.',
  'priceForecast.live_margin': "Today's margin:",
  'priceForecast.bom_toggle': 'Component breakdown (BOM) - {count} materials',
  'priceForecast.bom_col_component': 'Component',
  'priceForecast.bom_col_qty_per_unit': 'Qty / unit',
  'priceForecast.bom_col_snapshot_price': 'Snapshot price',
  'priceForecast.bom_missing_percentage': '· no % yet',
  'materialRequest.title': 'Material Request',
  'materialRequest.add': 'Add Material Request',
  'materialRequest.edit': 'Edit Material Request',
  'materialRequest.duplicate': 'Duplicate Material Request',
  'materialRequest.detail': 'Material Request Detail',
  'materialRequest.ref_number': 'Request Number',
  'materialRequest.number': 'Number',
  'materialRequest.trans_date': 'Request Date',
  'materialRequest.location': 'Location',
  'materialRequest.location_placeholder': 'e.g. Menara A',
  'materialRequest.warehouse': 'Warehouse',
  'materialRequest.contact': 'Requester / Field PIC',
  'materialRequest.contact_required': 'Requester / Field PIC is required',
  'materialRequest.memo': 'Message',
  'materialRequest.item_count': 'Item Count',
  'materialRequest.total_qty': 'Total Qty',
  'materialRequest.status': 'Status',
  'materialRequest.status_draft': 'Draft',
  'materialRequest.status_submitted': 'Submitted',
  'materialRequest.status_processing': 'Processing',
  'materialRequest.status_partial_fulfilled': 'Partially Fulfilled',
  'materialRequest.status_fully_fulfilled': 'Fully Fulfilled',
  'materialRequest.status_rejected': 'Rejected',
  'materialRequest.status_cancelled': 'Cancelled',
  'materialRequest.submit': 'Submit',
  'materialRequest.approve': 'Approve',
  'materialRequest.reject': 'Reject',
  'materialRequest.cancel': 'Cancel',
  'materialRequest.issue_material': 'Issue Material',
  'materialRequest.reject_reason': 'Rejection Reason',
  'materialRequest.reject_reason_required': 'Rejection reason is required',
  'materialRequest.reject_reason_placeholder': 'Write the reason for rejecting this request',
  'materialRequest.reviewed_by': 'Reviewed by',
  'materialRequest.reviewed_at': 'Reviewed at',
  'materialRequest.confirm_submit': 'Submit this material request for review?',
  'materialRequest.confirm_approve': 'Approve this material request?',
  'materialRequest.confirm_cancel': 'Cancel this material request?',
  'materialRequest.revert_to_draft': 'Revert to draft',
  'materialRequest.confirm_revert_to_draft': 'Revert this material request to draft?',
  'materialRequest.confirm_delete': 'Delete this material request?',
  'materialRequest.qty': 'Requested Qty',
  'materialRequest.issued_qty': 'Issued Qty',
  'materialRequest.remaining_qty': 'Remaining',
  'materialRequest.unit': 'Unit',
  'materialRequest.tag': 'Tag',
  'materialRequest.tag_max': 'Maximum {value} tags per row',
  'materialRequest.tag_doc_max':
    'Maximum {value} unique tags across all rows. Reduce tags on row {row}.',
  'materialRequest.item_desc': 'Note',
  'materialRequest.select_product': 'Select product',
  'materialRequest.product_required': 'Product is required',
  'materialRequest.qty_required': 'Qty is required',
  'materialRequest.qty_must_be_positive': 'Qty must be greater than 0',
  'materialRequest.items_required': 'At least one item is required',
  'materialRequest.empty_list': 'No material requests yet',

  purchase_request: 'Purchase Request',
  'purchaseRequest.title': 'Purchase Request',
  'purchaseRequest.add': 'Add Purchase Request',
  'purchaseRequest.edit': 'Edit Purchase Request',
  'purchaseRequest.duplicate': 'Duplicate Purchase Request',
  'purchaseRequest.detail': 'Purchase Request Detail',
  'purchaseRequest.import': 'Import Purchase Request',
  'purchaseRequest.number': 'Number',
  'purchaseRequest.trans_date': 'Transaction Date',
  'purchaseRequest.due_date': 'Needed By',
  'purchaseRequest.due_date_placeholder': 'Select date',
  'purchaseRequest.due_date_after_trans_date': 'Needed By cannot be earlier than Transaction Date',
  'purchaseRequest.requested_by': 'Requested by',
  'purchaseRequest.tag': 'Tag',
  'purchaseRequest.reference': 'Reference',
  'purchaseRequest.reference_max': 'Reference must be at most {value} characters',
  'purchaseRequest.message': 'Message',
  'purchaseRequest.item_desc': 'Description',
  'purchaseRequest.item_source': 'Source',
  'purchaseRequest.qty': 'Quantity',
  'purchaseRequest.remaining_qty': 'Remaining Qty',
  'purchaseRequest.qty_required': 'Quantity is required',
  'purchaseRequest.qty_must_be_positive': 'Quantity must be greater than 0',
  'purchaseRequest.qty_exceeds_remaining': 'Quantity exceeds remaining ({remaining})',
  'purchaseRequest.unit': 'Unit',
  'purchaseRequest.reference_price': 'Reference Price',
  'purchaseRequest.estimation': 'Estimation',
  'purchaseRequest.estimation_total': 'Estimated Value',
  'purchaseRequest.select_product': 'Select product',
  'purchaseRequest.product_required': 'Product is required',
  'purchaseRequest.save_and_submit': 'Save & Submit',
  'purchaseRequest.pull_from_material_request': 'Pull from Material Request',
  'purchaseRequest.search_placeholder': 'Search number / reference / requester',
  'purchaseRequest.empty_list': 'No purchase requests yet',
  'purchaseRequest.status': 'Status',
  'purchaseRequest.status_open': 'Open',
  'purchaseRequest.status_partial_ordered': 'Partially Ordered',
  'purchaseRequest.status_closed': 'Closed',
  'purchaseRequest.create_purchase_order': 'Create Purchase Order',
  'purchaseRequest.confirm_close': 'Close this purchase request?',
  'purchaseRequest.confirm_delete': 'Delete this purchase request?',
  'purchaseRequest.create_purchase_request': 'Create Purchase Request',
  'purchaseRequest.mr_number': 'MR Number',
  'purchaseRequest.mr_date': 'Date',
  'purchaseRequest.mr_add': 'Add',
  'purchaseRequest.mr_search_placeholder': 'Search MR number',
  'purchaseRequest.mr_select_required': 'Select at least one Material Request',
  'purchaseRequest.mr_max_100': 'Maximum 100 Material Requests per pull',
  'purchaseRequest.mr_all_fulfilled':
    'All Material Request items are already covered by material issues.',
  'purchaseRequest.import_done': 'Purchase Request import done',
  'purchaseRequest.go_to_list': 'Go to Purchase Request list',
  'purchaseRequest.pr_search_placeholder': 'Search Purchase Request number',
  'purchaseRequest.pr_skipped': 'Some Purchase Requests were skipped: {refs}',

  'materialIssue.title': 'Material Issue',
  'materialIssue.add': 'Add Material Issue',
  'materialIssue.detail': 'Material Issue Detail',
  'materialIssue.ref_number': 'Issue Number',
  'materialIssue.number': 'Number',
  'materialIssue.trans_date': 'Issue Date',
  'materialIssue.warehouse': 'Source Warehouse',
  'materialIssue.warehouse_required': 'Source warehouse is required',
  'materialIssue.account': 'Expense Account',
  'materialIssue.account_required': 'Expense account is required',
  'materialIssue.account_help': 'The expense account this material usage is charged to',
  'materialIssue.contact': 'Recipient',
  'materialIssue.memo': 'Message',
  'materialIssue.status_posted': 'Posted',
  'materialIssue.status_void': 'Void',
  'materialIssue.void': 'Void Issue',
  'materialIssue.confirm_void':
    'Void this material issue? Stock will be restored and its journal removed.',
  'materialIssue.void_cannot_be_undone':
    'A material issue cannot be edited. To correct it, void this document and create a new one.',
  'materialIssue.from_mr': 'From {refNumber}',
  'materialIssue.already_fulfilled': 'Already fulfilled',
  'materialIssue.skipped': 'Skipped',
  'materialIssue.qty_exceeds_remaining': 'Qty exceeds the remaining requested amount ({remaining})',
  'materialIssue.qty_fulfilled': 'Fulfilled Qty',
  'materialIssue.serial_number': 'Serial Number',
  'materialIssue.empty_list': 'No material issues yet',
  'productionPlan.title': 'Production Plan',
  'productionPlan.status_not_started': 'Not started',
  'productionPlan.status_partial': 'Partial',
  'productionPlan.status_completed': 'Completed',
  'productionPlan.transaction_status': 'Production Plan Status',
  'productionPlan.transaction_numbers': 'Production Plan Numbers',
  'productionPlan.column_stock_status': 'Material Status',
  'productionPlan.stock_status_enough': 'Sufficient',
  'productionPlan.stock_status_short': 'Insufficient',
  'productionPlan.material_stock_title': 'Raw Material Availability',
  'productionPlan.material_stock_empty': 'No remaining raw material needs',
  'productionPlan.material_stock_note':
    'Stock = total of all warehouses, today. This is recalculated every time the page is opened.',
  'productionPlan.material_stock_product': 'Material',
  'productionPlan.material_stock_need': 'Needed',
  'productionPlan.material_stock_stock': 'Stock',
  'productionPlan.material_stock_used_by_other_plans': 'Used by other plans',
  'productionPlan.material_stock_available': 'Available',
  'productionPlan.material_stock_shortage': 'Shortage',
  'productionPlan.column_realization_shortage': 'Shortage at realization',
  'productionPlan.shortage_chip': '{name} short {shortage} {unit}',
  'productionPlan.column_ref_number': 'Number',
  'productionPlan.column_name': 'Name',
  'productionPlan.column_plan_date': 'Plan Date',
  'productionPlan.column_status': 'Status',
  'productionPlan.column_actions': 'Actions',
  'productionPlan.column_priority': 'Priority',
  'productionPlan.move_success': 'Production plan priority updated successfully',
  'productionPlan.move_error': 'Failed to update production plan priority',
  'productionPlan.show_archived': 'Show archived',
  'productionPlan.filter_archive': 'Archive',
  'productionPlan.filter_archive_info': 'Check to also show archived production plans.',
  'productionPlan.field_name_placeholder': 'Enter plan name',
  'productionPlan.notes_placeholder': 'Notes (optional)',
  'productionPlan.qty_placeholder': 'Enter qty',
  'productionPlan.date_placeholder': 'Select date',
  'productionPlan.delete_confirm': 'Are you sure you want to delete this production plan?',
  'productionPlan.delete_success': 'Production Plan deleted successfully',
  'productionPlan.delete_error': 'Production Plan cannot be deleted',
  'productionPlan.field_name': 'Plan Name',
  'productionPlan.field_name_required': 'Name is required',
  'productionPlan.field_plan_date': 'Plan Date',
  'productionPlan.field_plan_date_required': 'Plan date is required',
  'productionPlan.field_notes': 'Notes',
  'productionPlan.add_item': 'Add Product Row',
  'productionPlan.item_product': 'Manufacture Product',
  'productionPlan.item_product_placeholder': 'Select Manufacture Product',
  'productionPlan.pull_from_so': 'Pull data from Sales Order',
  'productionPlan.from_sales_order': 'From Sales Order',
  'productionPlan.from_sales_order_with_ref': 'From Sales Order {ref}',
  'productionPlan.so_number': 'SO Number',
  'productionPlan.so_date': 'Date',
  'productionPlan.so_customer': 'Customer',
  'productionPlan.so_qty_order': 'Order Qty',
  'productionPlan.so_already_pulled': 'Already Pulled',
  'productionPlan.so_description': 'Description',
  'productionPlan.so_remaining': 'Remaining',
  'productionPlan.so_add': 'Add',
  'productionPlan.so_picker_instruction':
    'Please select the orders to be included in the production plan.',
  'productionPlan.help_what':
    'What: A Production Plan is manufacturing planning - a list of products to produce with quantity, date, and priority.',
  'productionPlan.help_flow':
    'Flow: Create a plan (manual or pull from Sales Order) -> set priority -> run Production Realization per row or all at once.',
  'productionPlan.help_effect':
    'Effect on transactions: Realization creates a Product Conversion transaction - reduces raw material stock, adds finished-goods stock, and records the journal.',
  'productionPlan.so_search_placeholder': 'Search SO number, product, or customer',
  'productionPlan.so_select_required': 'Select at least one row',
  'productionPlan.item_product_required': 'Product is required',
  'productionPlan.item_planned_qty': 'Planned Qty',
  'productionPlan.item_planned_qty_required': 'Planned qty is required',
  'productionPlan.item_planned_qty_gt_zero': 'Qty must be greater than 0',
  'productionPlan.item_planned_qty_min_realized': 'Qty cannot be less than realized qty ({qty})',
  'productionPlan.item_target_date': 'Target Date',
  'productionPlan.item_notes': 'Notes',
  'productionPlan.item_realized_qty': 'Realized Qty',
  'productionPlan.remaining': 'Remaining',
  'productionPlan.formula_title': 'Production Formula (estimated raw materials)',
  'productionPlan.formula_material': 'Raw Material',
  'productionPlan.formula_needed_qty': 'Estimated Need',
  'productionPlan.formula_empty': 'No bill of materials',
  'productionPlan.save_success': 'Production Plan saved successfully',
  'productionPlan.save_error': 'Failed to save Production Plan',
  'productionPlan.add_title': 'Add Production Plan',
  'productionPlan.edit_title': 'Edit Production Plan',
  'productionPlan.detail_title': 'Production Plan Detail',
  'productionPlan.print_error':
    'The print link is no longer valid or the production plan was not found. Reload the page and try again.',
  'productionPlan.print_per_item': 'Print per product',
  'productionPlan.print_material_summary': 'Print overall raw materials',
  'productionPlan.archive': 'Archive',
  'productionPlan.unarchive': 'Unarchive',
  'productionPlan.conversion_ref': 'Conversion Number',
  'productionPlan.item_warehouse': 'Warehouse',
  'productionPlan.realize_title': 'Realize Production',
  'productionPlan.realize_submit': 'Realize',
  'productionPlan.realize_success': 'Realization successful',
  'productionPlan.realize_error': 'Realization failed',
  'productionPlan.realize_summary':
    'Planned: {planned} • Realized: {realized} • Remaining: {remaining}',
  'productionPlan.realize_sn_unsupported':
    'This product uses serial numbers. Serial number input is not yet supported in this modal and will follow.',
  'productionPlan.realize_sn_material_unsupported':
    "This product's raw materials use serial numbers — realizing via this modal is not supported yet and will follow.",
  'productionPlan.output_sn_section': 'Finished Product Serial Numbers',
  'productionPlan.output_sn_hint':
    'Serial number rows are generated automatically from the realized quantity. Fill in the code for each serial number.',
  'productionPlan.output_sn_code': 'Serial Number Code',
  'productionPlan.output_sn_code_required': 'Serial number code is required',
  'productionPlan.output_sn_add': 'Add Serial Number',
  'productionPlan.output_sn_fill': 'Fill Serial Numbers',
  'productionPlan.output_sn_count': '{filled} of {total} filled',
  'productionPlan.output_sn_incomplete': 'Finished product serial number codes are incomplete',
  'productionPlan.output_sn_qty_mismatch':
    'Total serial number quantity must equal the realized quantity ({qty})',
  'productionPlan.sn_material_section': 'Raw Material Serial Numbers',
  'productionPlan.sn_needed': 'need {qty}',
  'productionPlan.sn_available': 'avail',
  'productionPlan.sn_select': 'Select serial number',
  'productionPlan.sn_pick_warehouse_first':
    'Select a warehouse first to see available serial numbers',
  'productionPlan.item_sn_qty_mismatch': 'Total serial numbers for {name} must be {qty}',
  'productionPlan.realize_qty': 'Realize Qty',
  'productionPlan.realize_trans_date': 'Transaction Date',
  'productionPlan.realize_warehouse_equal': 'All materials from one warehouse',
  'productionPlan.realize_qty_over': 'Qty cannot exceed remaining ({remaining})',
  'productionPlan.batch_realize_title': 'Realize All',
  'productionPlan.batch_realize_submit': 'Realize All',
  'productionPlan.batch_select_required': 'Select at least one row',
  'productionPlan.batch_item_excluded': 'Not included in realization',
  'productionPlan.cancel_success': 'Realization cancelled',
  'productionPlan.cancel_error': 'Failed to cancel realization',
  'productionPlan.cancel_confirm': 'Cancel this realization? Stock and journal will be reverted.',
  'productionPlan.cancel_confirm_delivery_plan':
    'If this realization has active delivery schedules, cancel them first.',
  'productionPlan.cancel_realization': 'Cancel',
  'productionPlan.materials_title': 'Raw materials used',
  'productionPlan.materials_hint':
    'Pre-filled from the recipe. Edit if actual usage differs — changes apply to this realization only.',
  'productionPlan.materials_empty': 'No raw materials',
  'productionPlan.material_col_name': 'Material',
  'productionPlan.material_col_recipe': 'Per recipe',
  'productionPlan.material_col_used': 'Used',
  'productionPlan.material_col_sn': 'Serial no.',
  'productionPlan.material_badge_added': 'added',
  'productionPlan.material_badge_edited': 'edited',
  'productionPlan.material_sn_below': 'fill below',
  'productionPlan.material_add': 'Add material',
  'productionPlan.material_add_placeholder': 'Search product (stock-tracked)',
  'productionPlan.material_qty_required':
    'Quantity for {name} must be greater than 0. Update the value or remove the row.',
  'productionPlan.material_qty_inline_error': 'Must be greater than 0',
  'deliveryPlan.section_title': 'Automatic Delivery Schedule',
  'deliveryPlan.status_waiting': 'Waiting',
  'deliveryPlan.status_published': 'Published',
  'deliveryPlan.status_failed': 'Failed',
  'deliveryPlan.status_cancelled': 'Cancelled',
  'deliveryPlan.column_plan_date': 'Delivery Date',
  'deliveryPlan.column_qty': 'Quantity',
  'deliveryPlan.column_order': 'Order',
  'deliveryPlan.column_customer': 'Customer',
  'deliveryPlan.column_status': 'Status',
  'deliveryPlan.column_notes': 'Notes',
  'deliveryPlan.column_actions': 'Actions',
  'deliveryPlan.add': 'Schedule Delivery',
  'deliveryPlan.edit_title': 'Edit Delivery Schedule',
  'deliveryPlan.add_title': 'Schedule Delivery',
  'deliveryPlan.cancel_action': 'Cancel',
  'deliveryPlan.retry_action': 'Retry',
  'deliveryPlan.delete_action': 'Delete',
  'deliveryPlan.view_delivery': 'View Delivery Order',
  'deliveryPlan.field_qty': 'Quantity',
  'deliveryPlan.field_qty_placeholder': 'Enter quantity',
  'deliveryPlan.field_qty_required': 'Quantity is required',
  'deliveryPlan.field_qty_gt_zero': 'Quantity must be greater than 0',
  'deliveryPlan.field_qty_over_realization': 'Quantity exceeds realization amount ({remaining})',
  'deliveryPlan.field_plan_date': 'Delivery Date',
  'deliveryPlan.field_plan_date_required': 'Delivery date is required',
  'deliveryPlan.field_plan_date_min': 'Cannot be earlier than production plan date ({date})',
  'deliveryPlan.sn_disabled_hint':
    'Products with serial numbers cannot be auto-scheduled. Use manual delivery order creation.',
  'deliveryPlan.field_notes': 'Notes',
  'deliveryPlan.field_notes_placeholder': 'Notes (optional)',
  'deliveryPlan.hint_realization_qty': 'Realization qty: {qty}',
  'deliveryPlan.header_summary': 'Scheduled {scheduled} · remaining {remaining}',
  'deliveryPlan.confirm_cancel': 'Cancel this delivery schedule?',
  'deliveryPlan.confirm_delete': 'Delete this delivery schedule?',
  'deliveryPlan.confirm_retry': 'Retry publishing the delivery order?',
  'deliveryPlan.add_success': 'Delivery schedule created',
  'deliveryPlan.add_error': 'Failed to create delivery schedule',
  'deliveryPlan.edit_success': 'Delivery schedule updated',
  'deliveryPlan.edit_error': 'Failed to update delivery schedule',
  'deliveryPlan.cancel_success': 'Delivery schedule cancelled',
  'deliveryPlan.cancel_error': 'Failed to cancel delivery schedule',
  'deliveryPlan.retry_success': 'Delivery schedule retried',
  'deliveryPlan.retry_error': 'Failed to retry delivery schedule',
  'deliveryPlan.delete_success': 'Delivery schedule deleted',
  'deliveryPlan.delete_error': 'Failed to delete delivery schedule',
  'deliveryPlan.empty': 'No delivery schedule yet for this realization',
  'deliveryPlan.failure_reason_label': 'Failure reason',
  'report.receivables_transaction_details': 'Receivables Transaction Details',
  'layoutInvoice.invoice_show_contact_bank_account': 'Show Contact Bank Account',
  'notification.approval_requested': 'Mobile notification approval request',
  'notification.invoice_created': 'Mobile notification sales invoice created',
  'notification.delivery_created': 'Mobile notification sales delivery created',
  'notification.order_created': 'Mobile notification sales order created',
  'notification.quote_created': 'Mobile notification sales quotation created',
  'notification.push_prompt_title': 'Turn on browser notifications',
  'notification.push_prompt_description':
    'Get notified about approval requests, new transactions, and important business activity right away, even when the Kledo tab is closed.',
  'notification.push_enabled_success': 'Browser notifications are on for this device.',
  'notification.push_enable_failed': 'Failed to turn on browser notifications. Please try again.',
  'notification.push_denied_hint':
    'Notifications are blocked by your browser. Allow them from the lock icon next to the site address, then reload the page.',
  'notification.push_view_detail': 'View detail',
  'pinProduct.pin_to_warehouse': 'Pin to Warehouse',
  'pinProduct.badge_pinned': 'Pinned',
  'pinProduct.badge_archived': 'Archived',
  'pinProduct.modal_title': 'Pin to Warehouse',
  'pinProduct.select_warehouse': 'Select warehouse',
  'pinProduct.pin_success': '{title} successfully pinned to warehouse',
  'pinProduct.unpin_success': '{title} pin removed',
  'pinProduct.partial_result': '{success} succeeded, {failed} failed',
  'salesOverview.last_updated': 'Updated {time}',
  'salesOverview.realtime_start': 'Start live update',
  'salesOverview.realtime_stop': 'Stop live update',
  'businessFlow.contact_id_required': 'Contact ID is required',
  'businessFlow.contact_id_required_desc':
    'If enabled, the Contact ID (Contact Number) column on the purchase and sales invoice import templates becomes mandatory. Contacts are matched by Contact Number and contact type, so rows with an unregistered Contact ID are rejected instead of creating a new contact.',
  'financeInvoices.import_contact_id_is_required':
    'The Contact ID column is required and must contain the Contact Number. The contact is matched by Contact Number and contact type, so a row with an unregistered Contact ID will be rejected and no new contact will be created.',
  'financeInvoices.import_contact_id_is_optional':
    'The Contact ID column is optional and ignored. The contact is still matched by contact name.',
  'posMaterialRequest.action.cancel': 'Cancel',
  'posMaterialRequest.action.delete': 'Delete request',
  'posMaterialRequest.action.draft': 'Back to draft',
  'posMaterialRequest.action.edit': 'Edit',
  'posMaterialRequest.action.resubmit': 'Resubmit',
  'posMaterialRequest.action.submit': 'Submit',
  'posMaterialRequest.champion.ask_admin':
    'Contact the account owner or company admin to upgrade the plan.',
  'posMaterialRequest.champion.badge': 'CHAMPION PLAN',
  'posMaterialRequest.champion.current_plan': 'Your current plan:',
  'posMaterialRequest.champion.title': '{feature} is available on the Champion plan',
  'posMaterialRequest.champion.upgrade': 'Upgrade Plan',
  'posMaterialRequest.confirm.cancel_message': 'Head office will not process request {ref}.',
  'posMaterialRequest.confirm.cancel_title': 'Cancel this request?',
  'posMaterialRequest.confirm.delete_message': 'Request {ref} will be permanently deleted.',
  'posMaterialRequest.confirm.delete_title': 'Delete this request?',
  'posMaterialRequest.confirm.keep': 'No',
  'posMaterialRequest.count.processed': 'Processing',
  'posMaterialRequest.count.waiting': 'Waiting',
  'posMaterialRequest.create_short': 'Request',
  'posMaterialRequest.date_from': 'From date',
  'posMaterialRequest.date_to': 'To date',
  'posMaterialRequest.detail.back_to_list': 'Back to list',
  'posMaterialRequest.detail.date': 'Date',
  'posMaterialRequest.detail.empty_subtitle': 'Request details will appear here.',
  'posMaterialRequest.detail.empty_title': 'Select a request',
  'posMaterialRequest.detail.history': 'History',
  'posMaterialRequest.detail.issued': 'Sent',
  'posMaterialRequest.detail.items': 'Requested items',
  'posMaterialRequest.detail.location': 'Location',
  'posMaterialRequest.detail.memo_attachment': 'Memo & attachments',
  'posMaterialRequest.detail.no_history': 'No history yet',
  'posMaterialRequest.detail.no_memo': 'No memo',
  'posMaterialRequest.detail.not_found_desc':
    'This document may have been deleted, or it belongs to another outlet.',
  'posMaterialRequest.detail.not_found_title': 'Request not found',
  'posMaterialRequest.detail.number': 'Request number',
  'posMaterialRequest.detail.outlet': 'Outlet',
  'posMaterialRequest.detail.product': 'Product',
  'posMaterialRequest.detail.reload': 'Reload',
  'posMaterialRequest.detail.requested': 'Requested',
  'posMaterialRequest.detail.warehouse': 'Destination warehouse',
  'posMaterialRequest.empty.desc':
    'Request supplies from the central warehouse right from the cashier.',
  'posMaterialRequest.empty.filtered_desc': 'Try another keyword, status, or date range.',
  'posMaterialRequest.empty.filtered_title': 'No matching requests',
  'posMaterialRequest.empty.first': 'Create the first request',
  'posMaterialRequest.empty.title': 'No requests yet',
  'posMaterialRequest.export': 'Export',
  'posMaterialRequest.export_failed': 'Failed to export data',
  'posMaterialRequest.filter.all': 'All',
  'posMaterialRequest.filter.canceled': 'Canceled',
  'posMaterialRequest.filter.fulfilled': 'Fulfilled',
  'posMaterialRequest.filter.processed': 'Processing',
  'posMaterialRequest.filter.rejected': 'Rejected',
  'posMaterialRequest.filter.waiting': 'Waiting',
  'posMaterialRequest.form.add_file': 'Add file',
  'posMaterialRequest.form.add_item': 'Add item',
  'posMaterialRequest.form.attachment': 'Attachments',
  'posMaterialRequest.form.cancel': 'Cancel',
  'posMaterialRequest.form.create_title': 'New Request',
  'posMaterialRequest.form.destination': 'Items will be sent to',
  'posMaterialRequest.form.destination_hint': 'Set automatically from the active outlet',
  'posMaterialRequest.form.discard': 'Discard changes',
  'posMaterialRequest.form.discard_message': 'Unsaved changes will be lost.',
  'posMaterialRequest.form.discard_title': 'Leave without saving?',
  'posMaterialRequest.form.edit_title': 'Edit Request',
  'posMaterialRequest.form.file_too_large': 'Maximum file size is {max} MB',
  'posMaterialRequest.form.items': 'Requested items',
  'posMaterialRequest.form.items_empty': 'No items yet. Add the items this outlet needs.',
  'posMaterialRequest.form.items_required': 'Add at least 1 product with quantity greater than 0',
  'posMaterialRequest.form.location': 'Location',
  'posMaterialRequest.form.location_placeholder': 'E.g. kitchen, bar, front cart',
  'posMaterialRequest.form.memo': 'Memo for head office',
  'posMaterialRequest.form.memo_placeholder': 'Add extra details for head office',
  'posMaterialRequest.form.note_placeholder': 'Note for this item',
  'posMaterialRequest.form.outlet_warehouse': '{name} outlet warehouse',
  'posMaterialRequest.form.remove_file': 'Remove attachment',
  'posMaterialRequest.form.remove_item': 'Remove product',
  'posMaterialRequest.form.save': 'Save Changes',
  'posMaterialRequest.form.save_draft': 'Save Draft',
  'posMaterialRequest.form.submit_only': 'Submit Request',
  'posMaterialRequest.form.saved_generic': 'Request saved',
  'posMaterialRequest.form.save_submit': 'Save & Submit',
  'posMaterialRequest.form.saved': 'Request saved as draft',
  'posMaterialRequest.form.submitted': 'Request submitted to head office',
  'posMaterialRequest.form.total_qty': 'Total qty',
  'posMaterialRequest.form.trans_date': 'Request date',
  'posMaterialRequest.form.trans_date_required': 'Please select the request date',
  'posMaterialRequest.form.updated': 'Request changes saved',
  'posMaterialRequest.form.upload_failed': 'Failed to upload attachment',
  'posMaterialRequest.from_outlet': 'Requests from outlet',
  'posMaterialRequest.info.canceled': 'This request has been canceled.',
  'posMaterialRequest.info.draft':
    'This request is still a draft. Submit it so head office can process it.',
  'posMaterialRequest.info.fulfilled': 'All items have been sent from the central warehouse.',
  'posMaterialRequest.info.partial':
    'Some items have been sent. The rest are still being processed.',
  'posMaterialRequest.info.processed':
    'Approved by head office and being prepared by the warehouse.',
  'posMaterialRequest.info.rejected': 'Rejected by head office. Edit and resubmit if needed.',
  'posMaterialRequest.info.waiting':
    'Waiting for head office approval in Kledo. Status refreshes when you reopen this page.',
  'posMaterialRequest.items_count': '{count} items',
  'posMaterialRequest.load_failed': 'Failed to load the request',
  'posMaterialRequest.picker.add': 'Add ({count})',
  'posMaterialRequest.picker.empty': 'No products found',
  'posMaterialRequest.picker.hint': 'Only products with tracked stock can be requested.',
  'posMaterialRequest.picker.in_form': 'Already added',
  'posMaterialRequest.picker.search': 'Search products',
  'posMaterialRequest.picker.selected_summary': '{count} items · {qty} qty',
  'posMaterialRequest.picker.title': 'Select Products',
  'posMaterialRequest.search_placeholder': 'Search number or memo',
  'posMaterialRequest.status.canceled': 'Canceled',
  'posMaterialRequest.status.draft': 'Draft',
  'posMaterialRequest.status.fulfilled': 'Fulfilled',
  'posMaterialRequest.status.partial': 'Partially fulfilled',
  'posMaterialRequest.status.processed': 'Processing at warehouse',
  'posMaterialRequest.status.rejected': 'Rejected',
  'posMaterialRequest.status.waiting': 'Waiting for approval',
  'posMaterialRequest.step.canceled': 'Canceled',
  'posMaterialRequest.step.draft': 'Draft',
  'posMaterialRequest.step.fulfilled': 'Fulfilled',
  'posMaterialRequest.step.processed': 'Processing',
  'posMaterialRequest.step.rejected': 'Rejected',
  'posMaterialRequest.step.submitted': 'Submitted',
  'posMaterialRequest.success.cancel': 'Request canceled',
  'posMaterialRequest.success.delete': 'Request deleted',
  'posMaterialRequest.success.draft': 'Request moved back to draft',
  'posMaterialRequest.success.submit': 'Request submitted',
  'posMaterialRequest.title': 'Material Requests',
  'posMaterialRequest.upgrade.benefit_1': 'Request items right from the cashier',
  'posMaterialRequest.upgrade.benefit_2':
    'Track head office approval and warehouse delivery in real time',
  'posMaterialRequest.upgrade.benefit_3':
    'Linked automatically to warehouse transfers and delivery notes in Kledo',
  'posMaterialRequest.upgrade.desc':
    'Upgrade your plan to request materials from your outlet straight to the central warehouse.',
}

export default {
  locale: 'en-US',
  antdData,
  // localeData,
  messages,
}
